(function () {
  // Owner decision 2026-10-11: re-enable only after customer-account enforcement.
  // See docs/decisions/guest-checkout-ai-account-policy.md.
  var CUSTOMIZER_AI_ENABLED = false;
  function customizerAiDisabledError() {
    var error = new Error('customizer-ai-disabled');
    error.code = 'CUSTOMIZER_AI_DISABLED';
    return error;
  }
  var GENERATION_INCLUDED_TOTAL = 10;
  var GENERATION_CONTRACT_VERSION = '1.2';
  var PRIVATE_PILOT_TEMPLATE_SUFFIX = 'clairabord-personnalisation-privee';
  var PRIVATE_PILOT_PRODUCT_HANDLE = 'clairabord-sticker-voiture-bebe-a-bord-personnalisable-priv';
  var GENERATION_STATUS = {
    IDLE: 'idle',
    QUEUED: 'queued',
    PROCESSING: 'processing',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed'
  };
  var LEGACY_GENERATION_STORAGE_KEY = 'clairatier.stickerGenerations.v1';
  var GENERATION_STORAGE_KEY = 'clairatier.stickerGenerations.v2';
  var GENERATION_STORAGE_VERSION = 2;
  var GENERATION_UNSELECTED_RETENTION_MONTHS = 24;
  var GENERATION_FINALIZED_RETENTION_MONTHS = 36;
  var GENERATION_SELECTION_STATES = ['unselected', 'selected'];
  var GENERATION_STORAGE_STYLES = ['signature', 'hero', 'prince-princess', 'manga', 'cartoon', 'watercolor'];
  var GENERATION_ATTEMPTS_KEY = 'clairatier.stickerAttempts.v1.';
  var GENERATION_SESSION_KEY = 'clairatier.generationSession.v1';
  var GENERATION_SESSION_EXPIRY_SAFETY_MS = 60 * 1000;
  var GENERATION_SESSION_CLAIM_EXPIRY_SAFETY_MS = 5 * 60 * 1000;
  var MAX_PHOTO_SIZE = 15 * 1024 * 1024;
  var PHOTO_NORMALIZATION_TARGET_SIZE = 14 * 1024 * 1024;
  var MAX_PHOTO_SOURCE_SIZE = 64 * 1024 * 1024;
  var MAX_PHOTO_PIXELS = 20 * 1000 * 1000;
  var MAX_PHOTO_DIMENSION = 8192;
  var MAX_PHOTO_DECODE_MEMORY = 160 * 1024 * 1024;
  var PHOTO_MEMORY_SURFACE_COUNT = 2;
  var PHOTO_HEADER_INSPECTION_BYTES = 512 * 1024;
  var PHOTO_WEBP_MAX_CHUNKS = 1024;
  var PHOTO_NORMALIZATION_MAX_ATTEMPTS = 8;
  var PHOTO_NORMALIZATION_QUALITY_FLOOR = 0.72;
  var PHOTO_ACCEPTED_MIME_TYPES = [
    'image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif', 'image/avif'
  ];
  var PHOTO_PREVIEW_MAX_EDGE = 720;
  var PHOTO_PREFLIGHT_ERROR_CODE = 'PHOTO_PREFLIGHT_NEEDS_USER_ACTION';
  var PHOTO_PREFLIGHT_REASON_TRANSLATIONS = {
    analysis_unavailable: 'photoPreflightUnavailable',
    no_visible_person: 'photoPreflightNoVisiblePerson',
    unsupported_person_count: 'photoPreflightUnsupportedPersonCount',
    unsupported_child_count: 'photoPreflightUnsupportedChildCount',
    person_count_uncertain: 'photoPreflightPersonCountUncertain',
    child_count_uncertain: 'photoPreflightChildCountUncertain',
    face_not_visible: 'photoPreflightFaceNotVisible',
    subject_too_cropped: 'photoPreflightSubjectTooCropped',
    image_blurry: 'photoPreflightImageBlurry',
    image_too_dark: 'photoPreflightImageTooDark',
    image_overexposed: 'photoPreflightImageOverexposed'
  };
  var PHOTO_DIAGNOSTIC_CODES = [
    'PHOTO_DIAGNOSTIC_UNAVAILABLE',
    'PHOTO_FILE_VALIDATION_FAILED',
    'PHOTO_PICKER_API_FAILED',
    'PHOTO_PREVIEW_FINAL_DISPLAY_FAILED',
    'PHOTO_PREVIEW_ALL_STRATEGIES_FAILED'
  ];
  var PHOTO_DIAGNOSTIC_PICKER_SOURCES = ['file-system-access', 'native-file-input', 'unknown'];
  var PHOTO_DIAGNOSTIC_STRATEGIES = [
    'immediate-file-capture',
    'local-normalization-jpeg',
    'normalized-file-object-url'
  ];
  var PHOTO_DIAGNOSTIC_STATUSES = ['failed', 'success'];
  var GENERATION_DIAGNOSTIC_CODES = [
    'GENERATION_ENQUEUE_FAILED',
    'GENERATION_FAILED',
    'GENERATION_NETWORK_ERROR',
    'GENERATION_QUOTA_EXCEEDED',
    'IDEMPOTENCY_CONFLICT',
    'INVALID_IMAGE',
    'INVALID_PAYLOAD',
    'MODERATION_BLOCKED_HARASSMENT',
    'MODERATION_BLOCKED_HATE',
    'MODERATION_BLOCKED_ILLICIT',
    'MODERATION_BLOCKED_SELF_HARM',
    'MODERATION_BLOCKED_SEXUAL',
    'MODERATION_BLOCKED_SEXUAL_MINORS',
    'MODERATION_BLOCKED_VIOLENCE',
    'MODERATION_FAILED',
    'MODERATION_NOT_CONFIGURED',
    'OPENAI_GENERATION_FAILED',
    'OPENAI_NOT_CONFIGURED',
    'OPENAI_SAFETY_BLOCKED',
    'PHOTO_METADATA_MISMATCH',
    'PHOTO_PREFLIGHT_NEEDS_USER_ACTION',
    'UNKNOWN',
    'UNSUPPORTED_IMAGE'
  ];
  var GUIDED_CONTRACT_VERSION = 1;
  var GUIDED_CONTEXT_KEY = 'clairatier.guidedContext.v1.';
  var GUIDED_ACTIONS = [
    'set_choice',
    'attach_photo',
    'request_generation',
    'open_full_options',
    'return_to_guided',
    'request_human_help'
  ];
  var GUIDED_CHOICE_CATEGORIES = ['style', 'color', 'garment'];
  var GUIDED_MINIMUM_INPUTS = ['style', 'color', 'photo'];
  var GUIDED_PRIMARY_CHOICE_LIMIT = 4;
  var GUIDED_REFINEMENT_TOPICS = ['garment', 'symbol', 'avatar_preferences'];
  var GUIDED_CONTEXTUAL_TOPICS = ['text'];
  var GUIDED_ACTION_HISTORY_LIMIT = 50;
  var ASSISTANT_TURN_CONTRACT_VERSION = '1.1';
  var ASSISTANT_V12_CONTRACT_VERSION = '1.2';
  var ASSISTANT_V12_ACTIONS = [
    'set_choice', 'attach_photo', 'decline_photo', 'generate_now', 'show_control',
    'accept_result', 'compare_results', 'open_full_options', 'return_to_guided', 'request_human_help'
  ];
  var ASSISTANT_V12_CHOICE_CATEGORIES = ['style', 'color', 'garment', 'hairstyle', 'mode'];
  var ASSISTANT_V12_STYLES = ['signature', 'hero', 'prince-princess'];
  var MIA_HAIRSTYLE_IDS = [
    'hair-soft-crop', 'hair-side-swept-crop', 'hair-textured-curl-crop', 'hair-rounded-coil-crop',
    'hair-classic-bob', 'hair-curly-bob', 'hair-shoulder-waves', 'hair-shoulder-coils',
    'hair-half-up-soft', 'hair-low-ponytail', 'hair-twin-braids', 'hair-two-strand-twists'
  ];
  var MIA_HAIRSTYLE_GROUPS = {
    'hair-short': MIA_HAIRSTYLE_IDS.slice(0, 4),
    'hair-medium': MIA_HAIRSTYLE_IDS.slice(4, 8),
    'hair-styled': MIA_HAIRSTYLE_IDS.slice(8, 12)
  };
  var MIA_GARMENT_IDS = [
    'garment-crew-tee', 'garment-henley', 'garment-fine-knit-cardigan', 'garment-a-line-dress',
    'garment-pique-polo', 'garment-chambray-shirt', 'garment-yoke-blouse-dress', 'garment-short-overalls'
  ];
  var MIA_GARMENT_GROUPS = {
    'garment-first': MIA_GARMENT_IDS.slice(0, 4),
    'garment-next': MIA_GARMENT_IDS.slice(4, 8)
  };
  var MIA_GARMENT_METADATA = {
    'garment-crew-tee': { colorSlots: 1, finish: '' },
    'garment-henley': { colorSlots: 1, finish: 'buttons' },
    'garment-fine-knit-cardigan': { colorSlots: 1, finish: 'buttons' },
    'garment-a-line-dress': { colorSlots: 1, finish: 'piping' },
    'garment-pique-polo': { colorSlots: 1, finish: 'buttons' },
    'garment-chambray-shirt': { colorSlots: 1, finish: 'buttons' },
    'garment-yoke-blouse-dress': { colorSlots: 2, finish: '' },
    'garment-short-overalls': { colorSlots: 1, finish: 'buttons' }
  };
  var ASSISTANT_V12_CONTROLS = {
    'mode-selector': { selector: '[data-mia-choice="mode"]', focusTarget: 'mode', focusTargets: ['mode'], topic: 'mode' },
    'hairstyle-selector': { selector: '[data-mia-choice="hair"]', focusTarget: 'hair', focusTargets: ['hair'], topic: 'hairstyle' },
    'garment-selector': { selector: '[data-mia-choice="garment"]', focusTarget: 'garment', focusTargets: ['garment'], topic: 'garment' },
    'background-editor': {
      selector: '[data-mia-choice="background"]', focusTarget: 'background', topic: 'background',
      focusTargets: ['background', 'background-zoom-in', 'background-zoom-out', 'background-up',
        'background-down', 'background-left', 'background-right', 'background-move', 'background-reset', 'background-crop']
    },
    'fade-selector': { selector: '[data-mia-choice="fade"]', focusTarget: 'fade', focusTargets: ['fade'], topic: 'fade' },
    'avatar-editor': {
      selector: '[data-sticker-photo-adjust]', focusTarget: 'avatar', topic: 'avatar-transform',
      focusTargets: ['avatar', 'avatar-zoom-in', 'avatar-zoom-out', 'avatar-up', 'avatar-down',
        'avatar-move', 'avatar-reset', 'avatar-crop']
    }
  };
  var ASSISTANT_V12_TOPIC_STATUSES = ['available', 'completed', 'skipped', 'unavailable', 'not-applicable'];
  var ASSISTANT_TRANSCRIPT_STORAGE_VERSION = 1;
  var ASSISTANT_TRANSCRIPT_KEY = 'clairatier.assistantTranscript.v1.';
  var ASSISTANT_TRANSCRIPT_LIMIT = 16;
  var ASSISTANT_RECENT_TURN_LIMIT = 8;
  var ASSISTANT_RESPONSE_TEXT_LIMIT = 1200;
  var ASSISTANT_REQUEST_TIMEOUT_MS = 12000;
  var BACKGROUND_DEFAULT_FADE_ID = 'fade-calm-halo-v1';
  var BACKGROUND_TRANSFORM_DEFAULT = { scale: 1, x: 0, y: 0 };
  var BACKGROUND_TRANSFORM_SCALE_STEP = 0.1;
  var BACKGROUND_TRANSFORM_PAN_STEP = 0.1;
  // Reserved integration event name: clairatier:assistant-free-text. Raw customer text is never emitted.
  var ANALYTICS_EVENT_SCHEMAS = {
    clairatier_assistant_opened: {
      source_surface: ['product_customizer']
    },
    clairatier_step_completed: {
      step_id: ['style', 'color', 'photo']
    },
    clairatier_classic_fallback_selected: {
      step_id: ['style', 'color', 'photo', 'ready'],
      reason_code: ['customer_selected']
    },
    clairatier_generation_started: {
      style_key: ['manga', 'hero', 'cartoon', 'watercolor'],
      attempt_bucket: ['1', '2-3', '4-plus']
    },
    clairatier_generation_succeeded: {
      style_key: ['manga', 'hero', 'cartoon', 'watercolor'],
      duration_bucket: ['under-10s', '10-30s', '30-120s', '120s-plus']
    },
    clairatier_generation_failed: {
      reason_code: ['authorization', 'rate-limited', 'server', 'network', 'unknown']
    },
    clairatier_refinement_selected: {
      category_code: ['garment', 'symbol', 'avatar_preferences', 'text']
    },
    clairatier_cart_add_started: {
      source_step_id: ['generated_result']
    },
    clairatier_cart_add_succeeded: {
      source_step_id: ['generated_result']
    },
    clairatier_cart_add_failed: {
      reason_code: ['request_failed']
    }
  };
  var roots = [];
  var generationSessionPromise = null;

  function isAnalyticsProcessingAllowed() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!customerPrivacy || typeof customerPrivacy.analyticsProcessingAllowed !== 'function') return false;
    try {
      return customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function getPrivacySafeAnalyticsPayload(name, properties) {
    var schema = ANALYTICS_EVENT_SCHEMAS[name];
    var payload = {};

    if (!schema) return null;
    Object.keys(schema).forEach(function (key) {
      var value = properties && properties[key];
      if (schema[key].indexOf(value) !== -1) payload[key] = value;
    });
    if (Object.keys(payload).length !== Object.keys(schema).length) return null;
    return payload;
  }

  function emitAnalyticsEvent(name, properties) {
    var payload;

    if (!isAnalyticsProcessingAllowed() || !window.dataLayer || typeof window.dataLayer.push !== 'function') {
      return false;
    }
    payload = getPrivacySafeAnalyticsPayload(name, properties);
    if (!payload) return false;
    window.dataLayer.push({
      event: name,
      clairatier: payload
    });
    return true;
  }

  function getAttemptBucket(attempt) {
    if (attempt <= 1) return '1';
    if (attempt <= 3) return '2-3';
    return '4-plus';
  }

  function getDurationBucket(startedAt) {
    var duration = Math.max(0, Date.now() - (startedAt || Date.now()));

    if (duration < 10000) return 'under-10s';
    if (duration < 30000) return '10-30s';
    if (duration < 120000) return '30-120s';
    return '120s-plus';
  }

  function getGenerationFailureCode(error) {
    var status = error && parseInt(error.status, 10);

    if (status === 401 || status === 403) return 'authorization';
    if (status === 429) return 'rate-limited';
    if (status >= 500) return 'server';
    if (error && error.name === 'TypeError') return 'network';
    return 'unknown';
  }

  function emitStepCompleted(root, stepId) {
    var state = root && root._stickerState;

    if (!state || ['style', 'color', 'photo'].indexOf(stepId) === -1) return;
    if (state.analyticsCompletedSteps[stepId]) return;
    if (emitAnalyticsEvent('clairatier_step_completed', { step_id: stepId })) {
      state.analyticsCompletedSteps[stepId] = true;
    }
  }

  function getTranslations(root) {
    var owner = root || document.documentElement;
    var source;

    if (owner._clairatierTranslations) return owner._clairatierTranslations;
    source = root && root.querySelector('[data-clairatier-translations]');
    if (!source) source = document.querySelector('[data-clairatier-translations]');
    try {
      owner._clairatierTranslations = source ? JSON.parse(source.textContent || '{}') : {};
    } catch (error) {
      owner._clairatierTranslations = {};
    }
    return owner._clairatierTranslations;
  }

  function formatTranslation(template, variables) {
    var value = String(template || '');
    Object.keys(variables || {}).forEach(function (name) {
      value = value.split('{' + name + '}').join(String(variables[name]));
    });
    return value;
  }

  function translate(root, key, variables, fallback) {
    var messages = getTranslations(root).messages || {};
    return formatTranslation(messages[key] || fallback || key, variables);
  }

  function getStyleGuide(root, style) {
    var styles = getTranslations(root).styles || {};
    return styles[style] || styles.manga || { title: '', description: '', summary: '' };
  }

  function getStyleKey(styleControl) {
    if (!styleControl) return '';
    return (styleControl.getAttribute('data-sticker-style-key') || '').trim();
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function normalizeBackgroundTransform(value) {
    var source = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    var scale = Number(source.scale);
    var x = Number(source.x);
    var y = Number(source.y);
    var normalizedScale = Math.round(clamp(Number.isFinite(scale) ? scale : 1, 1, 3) * 10000) / 10000;
    var coverPanLimit = Math.round(((normalizedScale - 1) / (2 * normalizedScale)) * 10000) / 10000;
    return {
      scale: normalizedScale,
      x: Math.round(clamp(Number.isFinite(x) ? x : 0, -coverPanLimit, coverPanLimit) * 10000) / 10000 || 0,
      y: Math.round(clamp(Number.isFinite(y) ? y : 0, -coverPanLimit, coverPanLimit) * 10000) / 10000 || 0
    };
  }

  function resetBackgroundTransform(state) {
    if (!state) return;
    state.backgroundTransform = normalizeBackgroundTransform(BACKGROUND_TRANSFORM_DEFAULT);
  }

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function getGuidedContextKey(root) {
    return GUIDED_CONTEXT_KEY +
      (root.getAttribute('data-product-id') || root.getAttribute('data-product-handle') || 'product');
  }

  function readGuidedPreferences(root) {
    var parsed;

    try {
      parsed = JSON.parse(window.sessionStorage.getItem(getGuidedContextKey(root)) || 'null');
    } catch (error) {
      return null;
    }

    if (!parsed || parsed.version !== GUIDED_CONTRACT_VERSION) return null;
    return parsed;
  }

  function buildGuidedPreferenceRecord(context, processedActionIds, state) {
    var record = {
      version: GUIDED_CONTRACT_VERSION,
      experience: context.experience === 'full' ? 'full' : 'guided',
      choices: {
        style: context.current && context.current.style || context.validated.style || '',
        color: context.current && context.current.color || context.validated.color || '',
        garment: context.assistantV12 && state && MIA_GARMENT_IDS.indexOf(state.approvedAvatarGarmentId) !== -1
          ? state.approvedAvatarGarmentId
          : context.optional.garment || ''
      },
      processedActionIds: (processedActionIds || []).slice(-GUIDED_ACTION_HISTORY_LIMIT)
    };
    if (state) {
      record.choices.backgroundId = state.selectedBackgroundId || 'background-none-white';
      record.choices.fadePresetId = state.selectedFadeId || '';
      record.choices.backgroundTransform = normalizeBackgroundTransform(state.backgroundTransform);
    }
    if (context.assistantV12) {
      var photoSessionOnly = context.subject && context.subject.sourceType === 'photo';
      record.assistantV12 = {
        contextRevision: context.contextRevision,
        optionalPhotoOfferState: photoSessionOnly ? 'unavailable' : context.optionalPhotoOfferState,
        refinementTopics: context.refinementTopics,
        hasUngeneratedChanges: photoSessionOnly ? false : !!context.hasUngeneratedChanges,
        contextFingerprint: photoSessionOnly ? '' : context.contextFingerprint || '',
        generatedContextFingerprint: photoSessionOnly ? '' : context.generatedContextFingerprint || ''
      };
    }
    if (context.current) {
      record.validatedChoices = {
        style: !!context.validated.style,
        color: !!context.validated.color
      };
    }
    return record;
  }

  function getAssistantTranscriptKey(root) {
    return ASSISTANT_TRANSCRIPT_KEY +
      (root.getAttribute('data-product-id') || root.getAttribute('data-product-handle') || 'product');
  }

  function isAssistantTurnId(value) {
    return typeof value === 'string' &&
      /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
  }

  function normalizeAssistantTranscriptEntry(entry) {
    var roles = ['user', 'assistant', 'receipt', 'error'];
    var text;

    if (!entry || typeof entry !== 'object' || roles.indexOf(entry.role) === -1) return null;
    if (typeof entry.id !== 'string' || !/^[A-Za-z0-9._:-]{1,140}$/.test(entry.id)) return null;
    text = typeof entry.text === 'string'
      ? entry.text.trim().slice(0, ASSISTANT_RESPONSE_TEXT_LIMIT)
      : '';
    if (!text) return null;
    return {
      id: entry.id,
      role: entry.role,
      text: text,
      turnId: isAssistantTurnId(entry.turnId) ? entry.turnId : '',
      code: typeof entry.code === 'string' && /^[A-Z_]{1,60}$/.test(entry.code)
        ? entry.code
        : ''
    };
  }

  function readAssistantConversation(root) {
    var parsed;
    var entries;
    var recentTurnIds;

    try {
      parsed = JSON.parse(window.sessionStorage.getItem(getAssistantTranscriptKey(root)) || 'null');
    } catch (error) {
      return { entries: [], recentTurnIds: [] };
    }
    if (!parsed || parsed.version !== ASSISTANT_TRANSCRIPT_STORAGE_VERSION) {
      return { entries: [], recentTurnIds: [] };
    }
    entries = Array.isArray(parsed.entries)
      ? parsed.entries.map(normalizeAssistantTranscriptEntry).filter(Boolean).slice(-ASSISTANT_TRANSCRIPT_LIMIT)
      : [];
    recentTurnIds = Array.isArray(parsed.recentTurnIds)
      ? parsed.recentTurnIds.filter(isAssistantTurnId).slice(-ASSISTANT_RECENT_TURN_LIMIT)
      : [];
    return { entries: entries, recentTurnIds: recentTurnIds };
  }

  function persistAssistantConversation(root) {
    var state = root && root._stickerState;
    if (!state || root._localResetting) return;
    try {
      window.sessionStorage.setItem(getAssistantTranscriptKey(root), JSON.stringify({
        version: ASSISTANT_TRANSCRIPT_STORAGE_VERSION,
        entries: state.assistantTranscript.slice(-ASSISTANT_TRANSCRIPT_LIMIT),
        recentTurnIds: state.assistantRecentTurnIds.slice(-ASSISTANT_RECENT_TURN_LIMIT)
      }));
    } catch (error) {}
  }

  function isAssistantV12Enabled(root) {
    return !!root && (root.getAttribute('data-sticker-assistant-v12-enabled') === 'true' ||
      isMiaPrivatePilotReady(root)) &&
      root.getAttribute('data-sticker-assistant-v12-contract') === ASSISTANT_V12_CONTRACT_VERSION;
  }

  function getAssistantV12Control(root, controlId) {
    var definition = ASSISTANT_V12_CONTROLS[controlId];
    var element = definition && root ? qs(root, definition.selector) : null;
    if ((controlId === 'hairstyle-selector' || controlId === 'garment-selector') && root && root._stickerState &&
        root._stickerState.subjectSource === 'photo') return null;
    return element && !element.disabled ? { definition: definition, element: element } : null;
  }

  function inferAssistantControlFocusTarget(root, controlId, requestedTarget) {
    var message = normalizeAssistantContextText(root && root._stickerState && root._stickerState.assistantPendingMessage, 800).toLowerCase();
    var prefix = controlId === 'avatar-editor' ? 'avatar-' : 'background-';
    if (requestedTarget && requestedTarget !== 'background' && requestedTarget !== 'avatar') return requestedTarget;
    if (/\b(reset|recenter|centre|center|réinitialiser|reinitialiser|recentrer)\b/.test(message)) return prefix + 'reset';
    if (/\b(crop|recadrer|recadre|cadrer|cadre)\b/.test(message)) return prefix + 'crop';
    if (/\b(enlarge|zoom in|agrandir|zoomer)\b/.test(message)) return prefix + 'zoom-in';
    if (/\b(reduce|zoom out|réduire|reduire|dézoomer|dezoomer)\b/.test(message)) return prefix + 'zoom-out';
    if (/\b(up|haut|monter|remonter)\b/.test(message)) return prefix + 'up';
    if (/\b(down|bas|descendre)\b/.test(message)) return prefix + 'down';
    if (/\b(left|gauche)\b/.test(message)) return prefix + 'left';
    if (/\b(right|droite)\b/.test(message)) return prefix + 'right';
    if (/\b(move|moving|déplacer|deplacer|bouger)\b/.test(message)) return prefix + 'move';
    return requestedTarget;
  }

  function getAssistantControlFocusElement(root, controlId, focusTarget) {
    var selectors = {
      'background-zoom-in': '[data-sticker-background-adjust="scale"][data-sticker-step="1"]',
      'background-zoom-out': '[data-sticker-background-adjust="scale"][data-sticker-step="-1"]',
      'background-up': '[data-sticker-background-adjust="y"][data-sticker-step="-1"]',
      'background-down': '[data-sticker-background-adjust="y"][data-sticker-step="1"]',
      'background-left': '[data-sticker-background-adjust="x"][data-sticker-step="-1"]',
      'background-right': '[data-sticker-background-adjust="x"][data-sticker-step="1"]',
      'background-move': '[data-sticker-background-position-title]',
      'background-reset': '[data-sticker-background-adjust="reset"]',
      'avatar-zoom-in': '[data-sticker-photo-adjust="scale"][data-sticker-step="1"]',
      'avatar-zoom-out': '[data-sticker-photo-adjust="scale"][data-sticker-step="-1"]',
      'avatar-up': '[data-sticker-photo-adjust="vertical"][data-sticker-step="-1"]',
      'avatar-down': '[data-sticker-photo-adjust="vertical"][data-sticker-step="1"]',
      'avatar-move': '[data-sticker-photo-position-title]'
    };
    if (selectors[focusTarget]) return qs(root, selectors[focusTarget]);
    if (controlId === 'background-editor') {
      return qs(root, '[data-sticker-background-option][aria-pressed="true"]') || qs(root, '[data-sticker-background-editor] h4');
    }
    if (controlId === 'fade-selector') {
      return qs(root, '[data-sticker-fade-option][aria-pressed="true"]') || qs(root, '[data-sticker-fade-picker] h5');
    }
    if (controlId === 'avatar-editor') {
      return qs(root, '[data-sticker-photo-controls] [data-sticker-photo-adjust]:not(:disabled)') ||
        qs(root, '[data-sticker-photo-picker]');
    }
    return null;
  }

  function resolveAssistantControlHandoff(root, controlId, requestedTarget) {
    var definition = ASSISTANT_V12_CONTROLS[controlId];
    var focusTarget;
    var target;
    var fallback = false;
    if (!definition || !root || !root._stickerState) return null;
    focusTarget = inferAssistantControlFocusTarget(root, controlId, requestedTarget || definition.focusTarget);
    if (definition.focusTargets.indexOf(focusTarget) === -1) return null;
    if ((controlId === 'hairstyle-selector' || controlId === 'garment-selector') &&
        root._stickerState.subjectSource === 'photo') return null;
    if (['mode-selector', 'hairstyle-selector', 'garment-selector'].indexOf(controlId) !== -1 &&
        !getAssistantV12Control(root, controlId)) return null;
    if (controlId === 'background-editor' || controlId === 'fade-selector') {
      if (!isAssistantVisualCardsReady(root) || !qs(root, '[data-sticker-background-editor]')) return null;
      if (controlId === 'fade-selector' && root._stickerState.selectedBackgroundId === 'background-none-white') {
        controlId = 'background-editor';
        definition = ASSISTANT_V12_CONTROLS[controlId];
        focusTarget = 'background';
        fallback = true;
      }
      if (focusTarget === 'background-crop') {
        focusTarget = 'background';
        fallback = true;
      }
    }
    if (controlId === 'avatar-editor' &&
        (focusTarget === 'avatar-crop' || focusTarget === 'avatar-reset')) {
      focusTarget = 'avatar';
      fallback = true;
    }
    if (focusTarget === 'background-move' || focusTarget === 'avatar-move') fallback = true;
    if (controlId === 'avatar-editor' && root._stickerState.subjectSource !== 'photo') fallback = true;
    target = getAssistantControlFocusElement(root, controlId, focusTarget);
    if (target && (target.disabled || target.hidden)) {
      target = getAssistantControlFocusElement(root, controlId, definition.focusTarget);
      focusTarget = definition.focusTarget;
      fallback = true;
    }
    if (!target && ['background-editor', 'fade-selector', 'avatar-editor'].indexOf(controlId) !== -1) {
      target = getAssistantControlFocusElement(root, controlId, definition.focusTarget);
      focusTarget = definition.focusTarget;
      fallback = true;
    }
    if (!target && controlId === 'avatar-editor') return null;
    return { controlId: controlId, definition: definition, focusTarget: focusTarget, target: target, fallback: fallback };
  }

  function isExplicitAssistantRevisit(root, topic) {
    var message = normalizeAssistantContextText(root && root._stickerState && root._stickerState.assistantPendingMessage, 800).toLowerCase();
    var revisit = /\b(change|edit|modify|revisit|again|changer|modifier|revoir|encore)\b/;
    var aliases = {
      mode: /\b(mode|incognito|standard)\b/,
      hairstyle: /\b(hair|hairstyle|cheveux|coiffure)\b/,
      garment: /\b(garment|clothes|outfit|vêtement|vetement|tenue)\b/,
      background: /\b(background|fond)\b/,
      fade: /\b(fade|fondu)\b/,
      'avatar-transform': /\b(avatar|photo|mia|transform|transformer)\b/
    };
    return !!(revisit.test(message) && aliases[topic] && aliases[topic].test(message));
  }

  function validateGuidedActionEnvelope(envelope) {
    var args;
    if (!envelope || typeof envelope !== 'object' || Array.isArray(envelope)) return { ok: false, code: 'invalid-envelope' };
    if (typeof envelope.id !== 'string' || !/^[A-Za-z0-9._:-]{1,100}$/.test(envelope.id)) return { ok: false, code: 'invalid-action-id' };
    if (GUIDED_ACTIONS.indexOf(envelope.action) === -1) return { ok: false, code: 'action-not-allowed' };
    args = envelope.args == null ? {} : envelope.args;
    if (!args || typeof args !== 'object' || Array.isArray(args)) return { ok: false, code: 'invalid-action-arguments' };
    if (envelope.action === 'set_choice') {
      if (GUIDED_CHOICE_CATEGORIES.indexOf(args.category) === -1) return { ok: false, code: 'choice-category-not-allowed' };
      if (typeof args.value !== 'string' || !args.value || args.value.length > 100) return { ok: false, code: 'invalid-choice-value' };
    } else if (Object.keys(args).length) {
      return { ok: false, code: 'unexpected-action-arguments' };
    }
    return { ok: true, args: args };
  }

  function validateGuidedActionEnvelopeV12(envelope, root) {
    var args;
    var actions = ASSISTANT_V12_ACTIONS;

    if (!envelope || typeof envelope !== 'object' || Array.isArray(envelope)) {
      return { ok: false, code: 'invalid-envelope' };
    }
    if (typeof envelope.id !== 'string' || !/^[A-Za-z0-9._:-]{1,100}$/.test(envelope.id)) {
      return { ok: false, code: 'invalid-action-id' };
    }
    if (actions.indexOf(envelope.action) === -1) {
      return { ok: false, code: 'action-not-allowed' };
    }

    args = envelope.args == null ? {} : envelope.args;
    if (!args || typeof args !== 'object' || Array.isArray(args)) {
      return { ok: false, code: 'invalid-action-arguments' };
    }
    if (envelope.action === 'set_choice') {
      if (ASSISTANT_V12_CHOICE_CATEGORIES.indexOf(args.category) === -1) {
        return { ok: false, code: 'choice-category-not-allowed' };
      }
      if (typeof args.value !== 'string' || !args.value || args.value.length > 100) {
        return { ok: false, code: 'invalid-choice-value' };
      }
      if (root && args.category === 'style' && ASSISTANT_V12_STYLES.indexOf(args.value) === -1) {
        return { ok: false, code: 'choice-not-available' };
      }
      if (root && !getGuidedChoiceElement(root, args.category, args.value)) {
        return { ok: false, code: 'choice-not-available' };
      }
    } else if (envelope.action === 'show_control') {
      var definition = ASSISTANT_V12_CONTROLS[args.controlId];
      if (!definition || (args.focusTarget != null && definition.focusTargets.indexOf(args.focusTarget) === -1)) {
        return { ok: false, code: 'control-not-available' };
      }
      if (!resolveAssistantControlHandoff(root, args.controlId, args.focusTarget || definition.focusTarget)) {
        return { ok: false, code: 'control-not-available' };
      }
      var topicState = root._stickerState.assistantRefinementTopics.filter(function (entry) {
        return entry.topic === ASSISTANT_V12_CONTROLS[args.controlId].topic;
      })[0];
      if (topicState && topicState.status !== 'available' && !isExplicitAssistantRevisit(root, topicState.topic)) {
        return { ok: false, code: 'terminal-topic-not-revisited' };
      }
      if (Object.keys(args).some(function (key) { return ['controlId', 'focusTarget'].indexOf(key) === -1; })) {
        return { ok: false, code: 'unexpected-action-arguments' };
      }
      args = { controlId: args.controlId, focusTarget: args.focusTarget || definition.focusTarget };
    } else if (Object.keys(args).length) {
      return { ok: false, code: 'unexpected-action-arguments' };
    }
    if (root && envelope.action === 'attach_photo') {
      if (isMiaPrivatePilotReady(root)) return { ok: false, code: 'photo-unavailable' };
      if (!qs(root, '[data-sticker-photo-picker]')) return { ok: false, code: 'photo-picker-unavailable' };
    }
    if (root && envelope.action === 'decline_photo' &&
        (root._stickerState.subjectSource !== 'approved-avatar' || !isMiaRuntimeReady(root))) {
      return { ok: false, code: 'subject-source-mismatch' };
    }
    if (root && envelope.action === 'generate_now' && !isAssistantV12GenerationEligible(root)) {
      return { ok: false, code: root._stickerState.isGenerating ? 'generation-in-progress' : 'generation-requirements-not-met' };
    }
    if (root && ['accept_result', 'compare_results'].indexOf(envelope.action) !== -1 && !getSelectedGeneration(root)) {
      return { ok: false, code: 'result-not-available' };
    }

    return { ok: true, args: args };
  }

  function removeBrowserStorageItem(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {}
  }

  function getStoredTimestamp(value) {
    var timestamp = typeof value === 'string' ? Date.parse(value) : NaN;
    return isNaN(timestamp) ? '' : new Date(timestamp).toISOString();
  }

  function addRetentionMonths(value, months) {
    var timestamp = Date.parse(value);
    var date;
    var originalDay;
    var targetMonthLastDay;
    if (isNaN(timestamp)) return '';
    date = new Date(timestamp);
    originalDay = date.getUTCDate();
    date.setUTCDate(1);
    date.setUTCMonth(date.getUTCMonth() + months);
    targetMonthLastDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
    date.setUTCDate(Math.min(originalDay, targetMonthLastDay));
    return date.toISOString();
  }

  function getEarliestTimestamp(left, right) {
    if (!left) return right;
    if (!right) return left;
    return Date.parse(left) <= Date.parse(right) ? left : right;
  }

  function getGenerationRecordExpiry(record) {
    var createdAt = getStoredTimestamp(record.createdAt);
    var selectedAt = getStoredTimestamp(record.selectedAt);
    var serverExpiresAt = getStoredTimestamp(record.serverExpiresAt);
    // The browser has no trusted authenticated-login signal. It therefore uses
    // an explicit server-provided selected state plus selectedAt for the
    // conservative 36-month local ceiling. finalizedAt alone is not proof of
    // authenticated selection. Only the server owns login renewal, and an
    // earlier server expiry always takes precedence.
    var policyExpiresAt = record.selectionState === 'selected' && selectedAt
      ? addRetentionMonths(selectedAt, GENERATION_FINALIZED_RETENTION_MONTHS)
      : addRetentionMonths(createdAt, GENERATION_UNSELECTED_RETENTION_MONTHS);
    return getEarliestTimestamp(policyExpiresAt, serverExpiresAt);
  }

  function getStoredTechnicalValue(value, maxLength) {
    var normalized = typeof value === 'string' ? value : '';
    return normalized && normalized.length <= maxLength && /^[A-Za-z0-9][A-Za-z0-9._:-]*$/.test(normalized)
      ? normalized
      : '';
  }

  function getStoredAssetUrl(value) {
    var normalized = typeof value === 'string' ? value.trim() : '';
    var parsed;
    if (!normalized || normalized.length > 2048) return '';
    try {
      parsed = new URL(normalized, window.location.href);
      if (
        (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') ||
        parsed.username || parsed.password || parsed.search || parsed.hash
      ) return '';
      return normalized;
    } catch (error) {
      return '';
    }
  }

  function serializeGenerationRecord(record, nowMs) {
    var id;
    var status;
    var createdAt;
    var finalizedAt;
    var selectedAt;
    var serverExpiresAt;
    var expiresAt;
    var attempt;
    var cart;
    var serialized;
    if (!record || typeof record !== 'object' || Array.isArray(record)) return null;
    id = getStoredTechnicalValue(record.id, 128);
    status = ['queued', 'processing', 'succeeded', 'failed', 'retry_requested'].indexOf(record.status) > -1
      ? record.status
      : '';
    createdAt = getStoredTimestamp(record.createdAt);
    finalizedAt = record.finalizedAt ? getStoredTimestamp(record.finalizedAt) : '';
    selectedAt = record.selectedAt ? getStoredTimestamp(record.selectedAt) : '';
    serverExpiresAt = record.serverExpiresAt ? getStoredTimestamp(record.serverExpiresAt) : '';
    attempt = parseInt(record.attempt, 10);
    if (!id || !status || !createdAt || (record.finalizedAt && !finalizedAt) ||
      (record.selectedAt && !selectedAt) ||
      (record.serverExpiresAt && !serverExpiresAt) || isNaN(attempt) || attempt < 0 || attempt > 999) return null;

    serialized = {
      schemaVersion: GENERATION_STORAGE_VERSION,
      id: id,
      status: status,
      style: GENERATION_STORAGE_STYLES.indexOf(record.style) > -1 ? record.style : '',
      selectionState: GENERATION_SELECTION_STATES.indexOf(record.selectionState) > -1
        ? record.selectionState
        : 'unselected',
      attempt: attempt,
      createdAt: createdAt,
      updatedAt: getStoredTimestamp(record.updatedAt) || createdAt,
      finalizedAt: finalizedAt,
      selectedAt: selectedAt,
      serverExpiresAt: serverExpiresAt,
      cart: { added: false, addedAt: '', removedAt: '' }
    };
    expiresAt = getGenerationRecordExpiry(serialized);
    if (!expiresAt || Date.parse(expiresAt) <= (typeof nowMs === 'number' ? nowMs : Date.now())) return null;
    serialized.expiresAt = expiresAt;
    cart = record.cart && typeof record.cart === 'object' && !Array.isArray(record.cart) ? record.cart : {};
    serialized.cart = {
      added: cart.added === true,
      addedAt: cart.addedAt ? getStoredTimestamp(cart.addedAt) : '',
      removedAt: cart.removedAt ? getStoredTimestamp(cart.removedAt) : ''
    };
    return serialized;
  }

  function readGenerationStore() {
    var emptyStore = { version: GENERATION_STORAGE_VERSION, records: {} };
    var parsed;
    var sanitized = emptyStore;

    removeBrowserStorageItem(window.localStorage, LEGACY_GENERATION_STORAGE_KEY);

    try {
      parsed = JSON.parse(window.localStorage.getItem(GENERATION_STORAGE_KEY) || 'null');
      if (!parsed) return emptyStore;
      if (
        typeof parsed !== 'object' || Array.isArray(parsed) ||
        parsed.version !== GENERATION_STORAGE_VERSION ||
        !parsed.records || typeof parsed.records !== 'object' || Array.isArray(parsed.records)
      ) {
        removeBrowserStorageItem(window.localStorage, GENERATION_STORAGE_KEY);
        return emptyStore;
      }
      Object.keys(parsed.records).forEach(function (key) {
        var record = serializeGenerationRecord(parsed.records[key]);
        if (record && record.id === key) sanitized.records[key] = record;
      });
      if (Object.keys(sanitized.records).length) {
        if (JSON.stringify(parsed) !== JSON.stringify(sanitized)) writeGenerationStore(sanitized);
      } else {
        removeBrowserStorageItem(window.localStorage, GENERATION_STORAGE_KEY);
      }
      return sanitized;
    } catch (error) {
      removeBrowserStorageItem(window.localStorage, GENERATION_STORAGE_KEY);
      return emptyStore;
    }
  }

  function writeGenerationStore(store) {
    var sanitized = { version: GENERATION_STORAGE_VERSION, records: {} };
    try {
      Object.keys(store && store.records || {}).forEach(function (key) {
        var record = serializeGenerationRecord(store.records[key]);
        if (record && record.id === key) sanitized.records[key] = record;
      });
      if (!Object.keys(sanitized.records).length) {
        window.localStorage.removeItem(GENERATION_STORAGE_KEY);
        return true;
      }
      window.localStorage.setItem(GENERATION_STORAGE_KEY, JSON.stringify(sanitized));
      return true;
    } catch (error) {
      return false;
    }
  }

  function listGenerationRecords() {
    var records = readGenerationStore().records;
    return Object.keys(records).map(function (id) {
      return records[id];
    }).sort(function (left, right) {
      return String(right.updatedAt || '').localeCompare(String(left.updatedAt || ''));
    });
  }

  function saveGenerationRecord(result, overrides) {
    var store = readGenerationStore();
    var existing = store.records[result.id] || {};
    var now = new Date().toISOString();
    var record = Object.assign({}, existing, {
      schemaVersion: GENERATION_STORAGE_VERSION,
      id: result.id,
      status: result.status || GENERATION_STATUS.SUCCEEDED,
      style: result.style || existing.style || '',
      attempt: result.attempt || existing.attempt || 0,
      imageUrl: result.imageUrl || existing.imageUrl || '',
      previewUrl: result.previewUrl || result.imageUrl || existing.previewUrl || '',
      clientPdfUrl: result.clientPdfUrl || existing.clientPdfUrl || '',
      printPdfUrl: result.printPdfUrl || existing.printPdfUrl || '',
      selectionState: result.selectionState || existing.selectionState || 'unselected',
      selectedAt: result.selectedAt || existing.selectedAt || '',
      finalizedAt: result.finalizedAt || existing.finalizedAt || '',
      serverExpiresAt: result.serverExpiresAt || result.expiresAt || existing.serverExpiresAt || '',
      createdAt: existing.createdAt || result.createdAt || now,
      updatedAt: now,
      cart: existing.cart || { added: false, addedAt: '', removedAt: '' }
    }, overrides || {});

    record = serializeGenerationRecord(record);
    if (!record) return null;
    store.records[result.id] = record;
    writeGenerationStore(store);
    return record;
  }

  function updateGenerationRecord(id, changes) {
    var store = readGenerationStore();
    var record = store.records[id];

    if (!record) return null;
    store.records[id] = serializeGenerationRecord(Object.assign({}, record, changes || {}, {
      updatedAt: new Date().toISOString()
    }));
    if (!store.records[id]) {
      delete store.records[id];
      writeGenerationStore(store);
      return null;
    }
    writeGenerationStore(store);
    return store.records[id];
  }

  function clearGenerationStore() {
    try {
      window.localStorage.removeItem(GENERATION_STORAGE_KEY);
      return true;
    } catch (error) {
      return false;
    }
  }

  function reconcileGenerationCartState() {
    if (!window.fetch) return Promise.resolve(listGenerationRecords());

    return window.fetch(getCartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(parseCartAddResponse)
      .then(function (cart) {
        var ids = {};
        var store = readGenerationStore();
        var now = new Date().toISOString();

        (cart.items || []).forEach(function (item) {
          var id = item.properties && (item.properties['_clairatier_generation_id'] || item.properties['_ID génération']);
          if (id) ids[id] = true;
        });

        Object.keys(store.records).forEach(function (id) {
          var record = store.records[id];
          var wasAdded = !!(record.cart && record.cart.added);
          var isAdded = !!ids[id];
          if (wasAdded === isAdded) return;
          record.cart = Object.assign({}, record.cart || {}, {
            added: isAdded,
            addedAt: isAdded ? record.cart && record.cart.addedAt || now : record.cart && record.cart.addedAt || '',
            removedAt: !isAdded && wasAdded ? now : record.cart && record.cart.removedAt || ''
          });
          record.updatedAt = now;
        });
        writeGenerationStore(store);
        return listGenerationRecords();
      })
      .catch(function () {
        return listGenerationRecords();
      });
  }

  function setStoredGenerationCartState(result, added) {
    var existing = saveGenerationRecord(result);
    var now = new Date().toISOString();
    return updateGenerationRecord(result.id, {
      cart: {
        added: added,
        addedAt: added ? now : existing.cart.addedAt || '',
        removedAt: added ? '' : now
      }
    });
  }

  function getGenerationAttemptsKey(root) {
    return GENERATION_ATTEMPTS_KEY + (root.getAttribute('data-product-id') || root.getAttribute('data-product-handle') || 'product');
  }

  function readGenerationAttempts(root) {
    var parsed;
    var attempts = {};
    try {
      parsed = JSON.parse(window.sessionStorage.getItem(getGenerationAttemptsKey(root)) || '{}') || {};
      Object.keys(parsed).forEach(function (style) {
        var value = parseInt(parsed[style], 10);
        if (!isNaN(value)) attempts[style] = Math.max(0, value);
      });
      return attempts;
    } catch (error) {
      return {};
    }
  }

  function writeGenerationAttempts(root) {
    try {
      window.sessionStorage.setItem(getGenerationAttemptsKey(root), JSON.stringify(root._stickerState.generationAttempts));
    } catch (error) {}
  }

  function getGenerationAttemptsTotal(state) {
    return Object.keys(state.generationAttempts || {}).reduce(function (total, style) {
      var value = parseInt(state.generationAttempts[style], 10);
      return total + (isNaN(value) ? 0 : Math.max(0, value));
    }, 0);
  }

  function getFirstSymbol(value) {
    var text = (value || '').trim().toUpperCase();
    var segmenter;
    var segments;
    var firstPoint;
    var symbol;
    var nextPoint;
    if (!text) return '';
    if (window.Intl && window.Intl.Segmenter) {
      segmenter = new window.Intl.Segmenter('fr', { granularity: 'grapheme' });
      segments = segmenter.segment(text)[Symbol.iterator]().next();
      if (!segments.done) return segments.value.segment;
    }
    firstPoint = text.codePointAt(0);
    symbol = String.fromCodePoint(firstPoint);
    nextPoint = text.codePointAt(symbol.length);
    if (nextPoint === 0xfe0e || nextPoint === 0xfe0f) {
      symbol += String.fromCodePoint(nextPoint);
    }
    return symbol;
  }

  function getForm(root) {
    var form = root.closest('form');
    if (form) return form;
    var formId = root.getAttribute('data-product-form-id');
    return formId ? document.getElementById(formId) : null;
  }

  function setFieldsEnabled(root, enabled) {
    qsa(root, '[name^="properties["]').forEach(function (input) {
      input.disabled = !enabled;
    });
  }

  function setTab(root, name) {
    if (name === 'photo' && isMiaPrivatePilotReady(root)) name = 'style';
    root._stickerState.activeTab = name;
    qsa(root, '[data-sticker-tab]').forEach(function (tab) {
      var active = tab.getAttribute('data-sticker-tab') === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    qsa(root, '[data-sticker-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-sticker-panel') === name;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    updatePrimaryAction(root);
  }

  function updateTryon(root) {
    var state = root._stickerState;
    var panel = qs(root, '[data-sticker-panel="tryon"]');
    var selectedColor;
    var selectedGarment;
    var imageSource;
    var summaryTemplate;
    var summary;

    if (!panel) return;

    qsa(panel, '[data-sticker-tryon-color]').forEach(function (button) {
      var active = button.getAttribute('data-sticker-tryon-color') === state.tryonColor;
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) selectedColor = button;
    });

    qsa(panel, '[data-sticker-tryon-garment]').forEach(function (button) {
      var active = button.getAttribute('data-sticker-tryon-garment') === state.tryonGarment;
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) selectedGarment = button;
    });

    if (selectedColor) {
      imageSource = selectedColor.getAttribute('data-tryon-src');
      qsa(panel, '[data-sticker-tryon-image]').forEach(function (image) {
        if (imageSource && image.getAttribute('src') !== imageSource) {
          image.setAttribute('src', imageSource);
        }
      });
    }

    summary = qs(panel, '[data-sticker-tryon-summary]');
    summaryTemplate = panel.getAttribute('data-sticker-tryon-summary-template') || '{color} · {garment}';
    if (summary && selectedColor && selectedGarment) {
      summary.textContent = summaryTemplate
        .replace('{color}', selectedColor.getAttribute('data-tryon-label') || '')
        .replace('{garment}', selectedGarment.getAttribute('data-sticker-tryon-garment') || '');
    }
    publishGuidedContext(root);
  }

  function updatePhoto(root) {
    var state = root._stickerState;
    var photo = qs(root, '[data-sticker-photo]');
    var sample = qs(root, '[data-sticker-sample-photo]');
    var transform = 'translate(calc(-50% + ' + state.photoX + 'px), calc(-50% + ' + state.photoY + 'px)) scale(' + state.photoScale + ')';

    if (photo) photo.style.transform = transform;
    if (sample) sample.style.transform = transform;
    if (localJourneyEnabled(root)) {
      var approved = qs(root, '[data-sticker-approved-avatar-preview]');
      var backing = getLocalWhiteBacking(root);
      var geometry = localWhiteBackingGeometry({ imageScale: state.photoScale, imageOffsetX: state.photoX, imageOffsetY: state.photoY }, backing,
        !hasNoTextChoice(root, 'top') && !!getTextValue(root, 'top').trim(), !hasNoTextChoice(root, 'bottom') && !!getTextValue(root, 'bottom').trim());
      if (state.sunEnabled === true) geometry = eclatAvatarGeometry(1, 0, state, approved && localImageAlpha(root, approved), backing);
      if ((state.proofAvatars || []).length <= 1 && state.sunEnabled !== true) {
        state.photoScale = geometry.imageScale;
        state.photoX = geometry.imageOffsetX;
        state.photoY = geometry.imageOffsetY;
      }
      var frame = qs(root, '[data-sticker-photo-frame]');
      if (frame) {
        frame.style.width = geometry.diameter / 10 + '%';
        frame.style.height = geometry.diameter / 10 + '%';
        frame.style.left = geometry.centerX / 10 + '%';
        frame.style.top = geometry.centerY / 10 + '%';
        frame.style.background = backing.enabled && backing.avatar && (!backing.style || backing.style === 'band') ? '#fff' : 'transparent';
        frame.style.borderRadius = '50%';
        frame.style.transform = 'translate(-50%, -50%)';
      }
      [approved, photo, sample].forEach(function (element) {
        if (!element) return;
        var alpha = localImageAlpha(root, element);
        var content = state.sunEnabled === true ? 100 : backing.style ? localWhiteContentRatio(alpha.radius, backing) * 100 : 100;
        element.style.width = content + '%'; element.style.height = content + '%';
        element.style.left = '50%'; element.style.top = '50%';
        element.style.objectFit = 'contain'; element.style.transform = 'translate(-50%, -50%)';
        element.style.filter = backing.enabled && backing.avatar && backing.style && backing.style !== 'band' && localImageAlpha(root, element).transparent ? localWhiteFilter(root, backing.style, 'avatar', 1) : '';
      });
    }
    updatePhotoAdjustmentButtons(root);
    syncMultiAvatarPreview(root);
  }

  function updatePhotoAdjustmentButtons(root) {
    var state = root._stickerState;

    qsa(root, '[data-sticker-photo-adjust]').forEach(function (button) {
      var type = button.getAttribute('data-sticker-photo-adjust');
      var step = parseInt(button.getAttribute('data-sticker-step'), 10) || 0;
      if (type === 'scale') {
        button.disabled = (step < 0 && state.photoScale <= 0.75) || (step > 0 && state.photoScale >= 1.2);
      }
      if (type === 'vertical') {
        button.disabled = (step < 0 && state.photoY <= -48) || (step > 0 && state.photoY >= 48);
      }
      if (type === 'center') {
        button.disabled = state.photoX === 0 && state.photoY === 0;
      }
    });
  }

  function adjustPhoto(root, type, step) {
    var state = root._stickerState;
    if (!hasPhoto(root)) return;

    if (type === 'scale') {
      state.photoScale = Math.round(clamp(state.photoScale + step * 0.1, 0.75, 1.2) * 100) / 100;
    }
    if (type === 'vertical') {
      state.photoY = clamp(state.photoY + step * 8, -48, 48);
    }
    if (type === 'center') {
      state.photoX = 0;
      state.photoY = 0;
    }
    updatePhoto(root);
    if (!getSelectedGeneration(root)) resetGeneration(root);
    updateConfig(root);
  }

  function hideToast(root) {
    var toast = qs(root, '[data-sticker-toast]');
    if (root._stickerToastTimer) {
      window.clearInterval(root._stickerToastTimer);
      root._stickerToastTimer = null;
    }
    if (toast) toast.hidden = true;
  }

  function showPhotoToast(root) {
    var toast = qs(root, '[data-sticker-toast]');
    var message = qs(root, '[data-sticker-toast-message]');
    var remaining = 12;

    if (!toast || !message) return;
    hideToast(root);

    function render() {
      message.textContent = translate(root, 'photoAdded', { seconds: remaining });
    }

    render();
    toast.hidden = false;
    root._stickerToastTimer = window.setInterval(function () {
      remaining -= 1;
      if (remaining <= 0) {
        hideToast(root);
        return;
      }
      render();
    }, 1000);
  }

  function getStyleLabel(root) {
    var checked = qs(root, '[data-sticker-style]:checked');
    if (checked) return checked.value;
    return getStyleGuide(root, 'manga').title;
  }

  function hasPhoto(root) {
    var fileInput = qs(root, '[data-sticker-photo-input]');
    return !!root._stickerPhotoFile || !!(fileInput && fileInput.files && fileInput.files.length > 0);
  }

  function hasUsablePhoto(root) {
    return hasPhoto(root) && !!root._stickerUploadedPreviewSrc;
  }

  function isApprovedAvatarRuntimeReady(root) {
    return !!root && root.getAttribute('data-approved-avatar-runtime-enabled') === 'true' &&
      root.getAttribute('data-approved-avatar-production-approved') === 'true' &&
      root.getAttribute('data-approved-avatar-commercial-clearance') === 'true';
  }

  function isMiaRuntimeReady(root) {
    return isApprovedAvatarRuntimeReady(root) || isMiaPrivatePilotReady(root);
  }

  function areMiaPrivatePilotPaidActionsBlocked(root) {
    return isMiaPrivatePilotReady(root) || typeof hasCastPreviewSelection === 'function' && hasCastPreviewSelection(root);
  }

  function hasUsableSubject(root) {
    return !!(root && root._stickerState && root._stickerState.subjectSource === 'approved-avatar' &&
      isMiaRuntimeReady(root)) || hasUsablePhoto(root);
  }

  function getPhotoValidationError(file) {
    if (!file) return translate(null, 'selectImage');
    if (!isSupportedPhotoFile(file)) {
      return translate(null, 'photoUnsupportedType');
    }
    if (file.size > MAX_PHOTO_SOURCE_SIZE) {
      return translate(null, 'photoSourceTooLarge');
    }
    return '';
  }

  function isSupportedPhotoFile(file) {
    var type = String(file && file.type || '').toLowerCase();
    var name = String(file && file.name || '').toLowerCase();

    if (type === 'image/jpg') type = 'image/jpeg';
    if (PHOTO_ACCEPTED_MIME_TYPES.indexOf(type) !== -1) return true;
    if (type) return false;
    return /\.(jpe?g|png|webp|heic|heif|avif)$/.test(name);
  }

  function clearPhotoPreview(root) {
    var photo = qs(root, '[data-sticker-photo]');
    var sample = qs(root, '[data-sticker-sample-photo]');
    var controls = qs(root, '[data-sticker-photo-controls]');
    var status = qs(root, '[data-sticker-photo-status]');
    var referencePhoto = getCurrentPhoto(root);
    var status = qs(root, '[data-sticker-photo-status]');
    var referencePhoto = getCurrentPhoto(root);
    var uploadText = qs(root, '[data-sticker-upload-text]');

    bumpAssistantPhotoSelectionRevision(root);

    if (root._stickerPhotoUrl) {
      URL.revokeObjectURL(root._stickerPhotoUrl);
      root._stickerPhotoUrl = '';
    }
    revokePendingPhotoSource(root);
    root._stickerPhotoFile = null;
    root._stickerPhotoOriginalFile = null;
    root._stickerUploadedPreviewSrc = '';
    root._stickerPhotoCapturePromise = null;
    root._stickerPhotoNormalizationId = (root._stickerPhotoNormalizationId || 0) + 1;
    root._stickerPhotoPickerSource = '';
    if (photo) {
      photo.removeAttribute('src');
      photo.hidden = true;
    }
    if (sample) sample.hidden = false;
    if (controls) controls.hidden = true;
    if (uploadText) uploadText.textContent = translate(root, 'addPhoto');
    setPhotoDebug(root, null, '', null);
    updateGenerationSummary(root);
    publishGuidedContext(root);
  }

  function revokePendingPhotoSource(root, source) {
    var pending = root._stickerPhotoPendingSource;
    if (!pending || (source && pending !== source)) return;
    URL.revokeObjectURL(pending);
    root._stickerPhotoPendingSource = '';
  }

  function getPhotoPreviewMimeType(file) {
    var type = String(file && file.type || '').toLowerCase();
    var name = String(file && file.name || '').toLowerCase();

    if (type === 'image/jpg') return 'image/jpeg';
    if (type.indexOf('image/') === 0) return type;
    if (/\.jpe?g$/.test(name)) return 'image/jpeg';
    if (/\.png$/.test(name)) return 'image/png';
    if (/\.webp$/.test(name)) return 'image/webp';
    if (/\.heic$/.test(name)) return 'image/heic';
    if (/\.heif$/.test(name)) return 'image/heif';
    if (/\.avif$/.test(name)) return 'image/avif';
    return type || 'image/jpeg';
  }

  function getTypedPhotoBlob(file) {
    return file.slice(0, file.size, getPhotoPreviewMimeType(file));
  }

  function createPhotoNormalizationError(code) {
    var error = new Error(code);
    error.code = code;
    return error;
  }

  function getPhotoFormat(file) {
    var type = getPhotoPreviewMimeType(file);
    if (type === 'image/jpeg') return 'jpeg';
    if (type === 'image/png') return 'png';
    if (type === 'image/webp') return 'webp';
    if (type === 'image/heic') return 'heic';
    if (type === 'image/heif') return 'heif';
    if (type === 'image/avif') return 'avif';
    return '';
  }

  function getPhotoSignatureFormat(buffer) {
    var view = new DataView(buffer);
    var brand;
    var offset;
    var boxSize;
    if (view.byteLength >= 3 && view.getUint8(0) === 0xff && view.getUint8(1) === 0xd8 && view.getUint8(2) === 0xff) {
      return 'jpeg';
    }
    if (view.byteLength >= 8 && view.getUint32(0, false) === 0x89504e47 && view.getUint32(4, false) === 0x0d0a1a0a) {
      return 'png';
    }
    if (
      view.byteLength >= 12 && view.getUint32(0, false) === 0x52494646 &&
      view.getUint32(8, false) === 0x57454250
    ) return 'webp';
    if (view.byteLength >= 16 && view.getUint32(4, false) === 0x66747970) {
      boxSize = view.getUint32(0, false);
      if (boxSize < 16 || boxSize > view.byteLength) return '';
      for (offset = 8; offset + 3 < boxSize; offset += 4) {
        brand = String.fromCharCode(view.getUint8(offset), view.getUint8(offset + 1), view.getUint8(offset + 2), view.getUint8(offset + 3));
        if (brand === 'avif' || brand === 'avis') return 'avif';
      }
      for (offset = 8; offset + 3 < boxSize; offset += 4) {
        brand = String.fromCharCode(view.getUint8(offset), view.getUint8(offset + 1), view.getUint8(offset + 2), view.getUint8(offset + 3));
        if (['heic', 'heix', 'hevc', 'hevx', 'heim', 'heis', 'mif1', 'msf1'].indexOf(brand) > -1) return 'heif';
      }
    }
    return '';
  }

  function getUint24LittleEndian(view, offset) {
    return view.getUint8(offset) | (view.getUint8(offset + 1) << 8) | (view.getUint8(offset + 2) << 16);
  }

  function getWebPDimensions(view) {
    var offset = 12;
    var riffEnd;
    var chunk;
    var chunkSize;
    var dataOffset;
    var bits;
    var extendedDimensions = null;
    var codedDimensions = null;
    var codedChunk = '';
    var codedOffset = -1;
    var nextOffset;
    var candidateDimensions;
    if (view.byteLength < 20) throw createPhotoNormalizationError('photo-normalization-dimensions');
    riffEnd = view.getUint32(4, true) + 8;
    if (riffEnd < 20) throw createPhotoNormalizationError('photo-normalization-dimensions');
    while (offset + 8 <= Math.min(riffEnd, view.byteLength)) {
      chunk = String.fromCharCode(view.getUint8(offset), view.getUint8(offset + 1), view.getUint8(offset + 2), view.getUint8(offset + 3));
      chunkSize = view.getUint32(offset + 4, true);
      dataOffset = offset + 8;
      if (chunkSize > riffEnd - dataOffset) throw createPhotoNormalizationError('photo-normalization-dimensions');
      nextOffset = dataOffset + chunkSize + (chunkSize % 2);
      if (nextOffset > riffEnd) throw createPhotoNormalizationError('photo-normalization-dimensions');
      if (chunk === 'ANIM' || chunk === 'ANMF') {
        throw createPhotoNormalizationError('photo-normalization-signature');
      }
      if (chunk === 'VP8X') {
        if (
          extendedDimensions || offset !== 12 || chunkSize !== 10 ||
          dataOffset + 10 > view.byteLength || (view.getUint8(dataOffset) & 0x02) !== 0
        ) {
          throw createPhotoNormalizationError('photo-normalization-signature');
        }
        extendedDimensions = validatePhotoDimensions({
          width: 1 + getUint24LittleEndian(view, dataOffset + 4),
          height: 1 + getUint24LittleEndian(view, dataOffset + 7)
        });
      }
      if (
        chunk === 'VP8 ' && chunkSize >= 10 && dataOffset + 10 <= view.byteLength && view.getUint8(dataOffset + 3) === 0x9d &&
        view.getUint8(dataOffset + 4) === 0x01 && view.getUint8(dataOffset + 5) === 0x2a
      ) {
        candidateDimensions = validatePhotoDimensions({
          width: view.getUint16(dataOffset + 6, true) & 0x3fff,
          height: view.getUint16(dataOffset + 8, true) & 0x3fff
        });
        if (codedChunk) throw createPhotoNormalizationError('photo-normalization-signature');
        codedChunk = chunk;
        codedOffset = offset;
        codedDimensions = candidateDimensions;
      }
      if (chunk === 'VP8L' && chunkSize >= 5 && dataOffset + 5 <= view.byteLength && view.getUint8(dataOffset) === 0x2f) {
        bits = view.getUint32(dataOffset + 1, true);
        candidateDimensions = validatePhotoDimensions({
          width: 1 + (bits & 0x3fff),
          height: 1 + ((bits >>> 14) & 0x3fff)
        });
        if (codedChunk) throw createPhotoNormalizationError('photo-normalization-signature');
        codedChunk = chunk;
        codedOffset = offset;
        codedDimensions = candidateDimensions;
      }
      if (nextOffset > view.byteLength && nextOffset !== riffEnd) {
        throw createPhotoNormalizationError('photo-normalization-dimensions');
      }
      offset = nextOffset;
    }
    if (offset !== riffEnd || !codedDimensions) throw createPhotoNormalizationError('photo-normalization-dimensions');
    if (
      extendedDimensions &&
      (extendedDimensions.width !== codedDimensions.width || extendedDimensions.height !== codedDimensions.height)
    ) throw createPhotoNormalizationError('photo-normalization-dimensions');
    if (!extendedDimensions && codedOffset !== 12) {
      throw createPhotoNormalizationError('photo-normalization-signature');
    }
    return codedDimensions;
  }

  function inspectWebPFile(file, declaredFormat) {
    var offset = 12;
    var riffEnd;
    var chunkCount = 0;
    var extendedDimensions = null;
    var codedDimensions = null;
    var codedChunk = '';
    var codedOffset = -1;

    function readExact(start, length) {
      if (start < 0 || length < 1 || start + length > file.size) {
        return Promise.reject(createPhotoNormalizationError('photo-normalization-dimensions'));
      }
      return readBlobAsArrayBuffer(file.slice(start, start + length)).then(function (buffer) {
        if (buffer.byteLength !== length) throw createPhotoNormalizationError('photo-normalization-dimensions');
        return new DataView(buffer);
      });
    }

    function finish() {
      if (!codedDimensions) throw createPhotoNormalizationError('photo-normalization-dimensions');
      if (
        extendedDimensions &&
        (extendedDimensions.width !== codedDimensions.width || extendedDimensions.height !== codedDimensions.height)
      ) throw createPhotoNormalizationError('photo-normalization-dimensions');
      if (!extendedDimensions && codedOffset !== 12) {
        throw createPhotoNormalizationError('photo-normalization-signature');
      }
      return { format: declaredFormat, dimensions: codedDimensions };
    }

    function inspectNextChunk() {
      if (offset === riffEnd) return Promise.resolve(finish());
      if (offset + 8 > riffEnd || chunkCount >= PHOTO_WEBP_MAX_CHUNKS) {
        return Promise.reject(createPhotoNormalizationError('photo-normalization-dimensions'));
      }
      chunkCount += 1;
      return readExact(offset, 8).then(function (header) {
        var chunk = String.fromCharCode(header.getUint8(0), header.getUint8(1), header.getUint8(2), header.getUint8(3));
        var chunkSize = header.getUint32(4, true);
        var dataOffset = offset + 8;
        var nextOffset;
        var requiredBytes = 0;
        if (chunkSize > riffEnd - dataOffset) throw createPhotoNormalizationError('photo-normalization-dimensions');
        nextOffset = dataOffset + chunkSize + (chunkSize % 2);
        if (nextOffset > riffEnd) throw createPhotoNormalizationError('photo-normalization-dimensions');
        if (chunk === 'ANIM' || chunk === 'ANMF') {
          throw createPhotoNormalizationError('photo-normalization-signature');
        }
        if (chunk === 'VP8X') {
          if (extendedDimensions || offset !== 12 || chunkSize !== 10) {
            throw createPhotoNormalizationError('photo-normalization-signature');
          }
          requiredBytes = 10;
        } else if (chunk === 'VP8 ') {
          if (chunkSize < 10 || codedChunk) throw createPhotoNormalizationError('photo-normalization-signature');
          requiredBytes = 10;
        } else if (chunk === 'VP8L') {
          if (chunkSize < 5 || codedChunk) throw createPhotoNormalizationError('photo-normalization-signature');
          requiredBytes = 5;
        }
        return (requiredBytes ? readExact(dataOffset, requiredBytes) : Promise.resolve(null)).then(function (payload) {
          var bits;
          if (chunk === 'VP8X') {
            if ((payload.getUint8(0) & 0x02) !== 0) {
              throw createPhotoNormalizationError('photo-normalization-signature');
            }
            extendedDimensions = validatePhotoDimensions({
              width: 1 + getUint24LittleEndian(payload, 4),
              height: 1 + getUint24LittleEndian(payload, 7)
            });
          } else if (chunk === 'VP8 ') {
            if (payload.getUint8(3) !== 0x9d || payload.getUint8(4) !== 0x01 || payload.getUint8(5) !== 0x2a) {
              throw createPhotoNormalizationError('photo-normalization-signature');
            }
            codedDimensions = validatePhotoDimensions({
              width: payload.getUint16(6, true) & 0x3fff,
              height: payload.getUint16(8, true) & 0x3fff
            });
            codedChunk = chunk;
            codedOffset = offset;
          } else if (chunk === 'VP8L') {
            if (payload.getUint8(0) !== 0x2f) throw createPhotoNormalizationError('photo-normalization-signature');
            bits = payload.getUint32(1, true);
            codedDimensions = validatePhotoDimensions({
              width: 1 + (bits & 0x3fff),
              height: 1 + ((bits >>> 14) & 0x3fff)
            });
            codedChunk = chunk;
            codedOffset = offset;
          }
          offset = nextOffset;
          return inspectNextChunk();
        });
      });
    }

    return readExact(0, 12).then(function (header) {
      if (
        declaredFormat !== 'webp' || header.getUint32(0, false) !== 0x52494646 ||
        header.getUint32(8, false) !== 0x57454250
      ) throw createPhotoNormalizationError('photo-normalization-signature');
      riffEnd = header.getUint32(4, true) + 8;
      if (riffEnd < 20 || riffEnd > file.size) throw createPhotoNormalizationError('photo-normalization-dimensions');
      return inspectNextChunk();
    });
  }

  function getBmffDimensions(view) {
    var expectedPath = ['meta', 'iprp', 'ipco', 'ispe'];
    var dimensions = [];
    var malformed = false;

    function fourcc(offset) {
      return String.fromCharCode(view.getUint8(offset), view.getUint8(offset + 1), view.getUint8(offset + 2), view.getUint8(offset + 3));
    }

    function inspectBoxes(start, end, depth) {
      var offset = start;
      var size;
      var type;
      var headerSize;
      var boxEnd;
      var childStart;
      if (depth >= expectedPath.length) return;
      while (offset + 8 <= end) {
        size = view.getUint32(offset, false);
        type = fourcc(offset + 4);
        headerSize = 8;
        if (size === 1) {
          if (offset + 16 > end || view.getUint32(offset + 8, false) !== 0) {
            malformed = true;
            return;
          }
          size = view.getUint32(offset + 12, false);
          headerSize = 16;
        } else if (size === 0) {
          size = end - offset;
        }
        if (size < headerSize) {
          malformed = true;
          return;
        }
        if (offset + size > end) {
          if (type !== 'mdat') malformed = true;
          return;
        }
        boxEnd = offset + size;
        if (type === expectedPath[depth]) {
          if (type === 'ispe') {
            if (offset + headerSize + 12 > boxEnd) {
              malformed = true;
              return;
            }
            dimensions.push(validatePhotoDimensions({
              width: view.getUint32(offset + headerSize + 4, false),
              height: view.getUint32(offset + headerSize + 8, false)
            }));
          } else {
            childStart = offset + headerSize + (type === 'meta' ? 4 : 0);
            if (childStart <= boxEnd) inspectBoxes(childStart, boxEnd, depth + 1);
          }
        }
        offset = boxEnd;
      }
      if (offset !== end) malformed = true;
    }

    inspectBoxes(0, view.byteLength, 0);
    if (malformed || !dimensions.length) return null;
    return dimensions.reduce(function (largest, candidate) {
      return candidate.width * candidate.height > largest.width * largest.height ? candidate : largest;
    });
  }

  function getJpegDimensionsFromView(view) {
    var length = view.byteLength;
    var offset = 2;
    var marker;
    var segmentLength;
    var orientation = 1;
    var width;
    var height;
    while (offset + 9 < length) {
      if (view.getUint8(offset) !== 0xff) {
        offset += 1;
        continue;
      }
      marker = view.getUint8(offset + 1);
      if (offset + 4 > length) break;
      segmentLength = view.getUint16(offset + 2, false);
      if (marker === 0xe1) orientation = getJpegOrientation(view, offset, segmentLength);
      if (
        marker === 0xc0 || marker === 0xc1 || marker === 0xc2 || marker === 0xc3 ||
        marker === 0xc5 || marker === 0xc6 || marker === 0xc7 || marker === 0xc9 ||
        marker === 0xca || marker === 0xcb || marker === 0xcd || marker === 0xce || marker === 0xcf
      ) {
        if (segmentLength < 8 || offset + 2 + segmentLength > length) {
          throw createPhotoNormalizationError('photo-normalization-dimensions');
        }
        width = view.getUint16(offset + 7, false);
        height = view.getUint16(offset + 5, false);
        return orientation >= 5 && orientation <= 8
          ? { width: height, height: width }
          : { width: width, height: height };
      }
      if (marker === 0xd8 || marker === 0xd9 || marker === 0x01 || (marker >= 0xd0 && marker <= 0xd7)) {
        offset += 2;
        continue;
      }
      if (segmentLength < 2 || offset + 2 + segmentLength > length) break;
      offset += 2 + segmentLength;
    }
    throw createPhotoNormalizationError('photo-normalization-dimensions');
  }

  function inspectPhotoHeaderBuffer(buffer, declaredFormat) {
    var view = new DataView(buffer);
    var signatureFormat = getPhotoSignatureFormat(buffer);
    var compatibleHeif = (declaredFormat === 'heic' || declaredFormat === 'heif') && signatureFormat === 'heif';
    var dimensions;
    if (!signatureFormat || (declaredFormat !== signatureFormat && !compatibleHeif)) {
      throw createPhotoNormalizationError('photo-normalization-signature');
    }
    if ((signatureFormat === 'avif' || signatureFormat === 'heif') && view.byteLength >= 16) {
      var ftypSize = Math.min(view.getUint32(0, false), view.byteLength);
      for (var brandOffset = 8; brandOffset + 3 < ftypSize; brandOffset += 4) {
        var sequenceBrand = String.fromCharCode(view.getUint8(brandOffset), view.getUint8(brandOffset + 1), view.getUint8(brandOffset + 2), view.getUint8(brandOffset + 3));
        if (sequenceBrand === 'avis' || sequenceBrand === 'msf1') {
          throw createPhotoNormalizationError('photo-normalization-signature');
        }
      }
    }
    if (signatureFormat === 'png') {
      if (
        view.byteLength < 24 || view.getUint32(8, false) !== 13 ||
        view.getUint32(12, false) !== 0x49484452
      ) throw createPhotoNormalizationError('photo-normalization-dimensions');
      dimensions = { width: view.getUint32(16, false), height: view.getUint32(20, false) };
    } else if (signatureFormat === 'jpeg') {
      dimensions = getJpegDimensionsFromView(view);
    } else if (signatureFormat === 'webp') {
      dimensions = getWebPDimensions(view);
    } else {
      dimensions = getBmffDimensions(view);
      if (!dimensions) throw createPhotoNormalizationError('photo-normalization-dimensions');
    }
    return { format: declaredFormat, dimensions: validatePhotoDimensions(dimensions) };
  }

  function inspectPhotoHeader(file) {
    var declaredFormat = getPhotoFormat(file);
    if (declaredFormat === 'webp') return inspectWebPFile(file, declaredFormat);
    return readBlobAsArrayBuffer(file.slice(0, Math.min(file.size, PHOTO_HEADER_INSPECTION_BYTES)))
      .then(function (buffer) { return inspectPhotoHeaderBuffer(buffer, declaredFormat); });
  }

  function getPhotoPeakMemoryBytes(dimensions) {
    return dimensions.width * dimensions.height * 4 * PHOTO_MEMORY_SURFACE_COUNT;
  }

  function validatePhotoDimensions(dimensions) {
    var width = dimensions && parseInt(dimensions.width, 10);
    var height = dimensions && parseInt(dimensions.height, 10);
    if (
      !width || !height || width > MAX_PHOTO_DIMENSION || height > MAX_PHOTO_DIMENSION ||
      width * height > MAX_PHOTO_PIXELS ||
      getPhotoPeakMemoryBytes({ width: width, height: height }) > MAX_PHOTO_DECODE_MEMORY
    ) throw createPhotoNormalizationError('photo-normalization-dimensions');
    return { width: width, height: height };
  }

  function decodePhotoWithImage(file, format) {
    return createPhotoObjectUrl(getTypedPhotoBlob(file)).then(function (source) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        image.onload = function () {
          image.onload = null;
          image.onerror = null;
          URL.revokeObjectURL(source);
          resolve({ image: image, width: image.naturalWidth, height: image.naturalHeight, close: function () {
            image.src = '';
          } });
        };
        image.onerror = function () {
          image.onload = null;
          image.onerror = null;
          image.src = '';
          URL.revokeObjectURL(source);
          reject(createPhotoNormalizationError(format === 'heic' || format === 'heif' || format === 'avif'
            ? 'photo-normalization-native-codec'
            : 'photo-normalization-decode'));
        };
        image.src = source;
      });
    });
  }

  function decodePhotoForNormalization(file, format) {
    if (typeof window.createImageBitmap !== 'function') return decodePhotoWithImage(file, format);
    return window.createImageBitmap(getTypedPhotoBlob(file), { imageOrientation: 'from-image' })
      .then(function (bitmap) {
        return { image: bitmap, width: bitmap.width, height: bitmap.height, close: function () {
          if (bitmap.close) bitmap.close();
        } };
      })
      .catch(function () {
        return decodePhotoWithImage(file, format);
      });
  }

  function encodeNormalizedPhoto(canvas, attempt) {
    var qualitySteps = [0.92, 0.86, 0.80, 0.74, PHOTO_NORMALIZATION_QUALITY_FLOOR];
    var quality = qualitySteps[Math.min(attempt, qualitySteps.length - 1)];
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        var nextWidth;
        var nextHeight;
        var resized;
        var context;
        if (!blob) {
          canvas.width = 1;
          canvas.height = 1;
          reject(createPhotoNormalizationError('photo-normalization-encode'));
          return;
        }
        if (blob.size <= PHOTO_NORMALIZATION_TARGET_SIZE || (attempt + 1 >= PHOTO_NORMALIZATION_MAX_ATTEMPTS && blob.size < MAX_PHOTO_SIZE)) {
          canvas.width = 1;
          canvas.height = 1;
          resolve(blob);
          return;
        }
        if (attempt + 1 >= PHOTO_NORMALIZATION_MAX_ATTEMPTS) {
          canvas.width = 1;
          canvas.height = 1;
          reject(createPhotoNormalizationError('photo-normalization-reduction'));
          return;
        }
        if (attempt < qualitySteps.length - 1) {
          encodeNormalizedPhoto(canvas, attempt + 1).then(resolve, reject);
          return;
        }
        nextWidth = Math.max(1, Math.floor(canvas.width * 0.82));
        nextHeight = Math.max(1, Math.floor(canvas.height * 0.82));
        resized = document.createElement('canvas');
        resized.width = nextWidth;
        resized.height = nextHeight;
        context = resized.getContext('2d');
        if (!context) {
          reject(createPhotoNormalizationError('photo-normalization-canvas'));
          return;
        }
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, nextWidth, nextHeight);
        context.drawImage(canvas, 0, 0, nextWidth, nextHeight);
        canvas.width = 1;
        canvas.height = 1;
        encodeNormalizedPhoto(resized, attempt + 1).then(resolve, reject);
      }, 'image/jpeg', quality);
    });
  }

  function createNormalizedPhotoFile(blob) {
    var options = { type: 'image/jpeg', lastModified: Date.now() };
    var normalized = typeof File === 'function'
      ? new File([blob], 'clairatier-photo.jpg', options)
      : new Blob([blob], { type: options.type });
    if (!normalized.name) {
      try {
        Object.defineProperty(normalized, 'name', { value: 'clairatier-photo.jpg' });
        Object.defineProperty(normalized, 'lastModified', { value: options.lastModified });
      } catch (ignore) {}
    }
    return normalized;
  }

  function normalizePhotoFile(file) {
    var format;
    var decoded;
    if (!file || file.size > MAX_PHOTO_SOURCE_SIZE) {
      return Promise.reject(createPhotoNormalizationError('photo-normalization-source-size'));
    }
    return inspectPhotoHeader(file)
      .then(function (inspection) {
        format = inspection.format;
        return inspection.dimensions;
      })
      .then(function () {
        return decodePhotoForNormalization(file, format);
      })
      .then(function (decodedPhoto) {
        var dimensions = validatePhotoDimensions(decodedPhoto);
        var canvas = document.createElement('canvas');
        var context;
        decoded = decodedPhoto;
        canvas.width = dimensions.width;
        canvas.height = dimensions.height;
        context = canvas.getContext('2d');
        if (!context) throw createPhotoNormalizationError('photo-normalization-canvas');
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(decoded.image, 0, 0, canvas.width, canvas.height);
        decoded.close();
        decoded = null;
        return encodeNormalizedPhoto(canvas, 0);
      })
      .then(function (blob) {
        return createNormalizedPhotoFile(blob);
      })
      .catch(function (error) {
        if (decoded) decoded.close();
        throw error && error.code ? error : createPhotoNormalizationError('photo-normalization-decode');
      });
  }

  function getPhotoNormalizationErrorMessage(error) {
    var code = error && error.code;
    if (code === 'photo-normalization-source-size') return translate(null, 'photoSourceTooLarge');
    if (code === 'photo-normalization-signature') return translate(null, 'photoSignatureMismatch');
    if (code === 'photo-normalization-dimensions') return translate(null, 'photoDimensionsTooLarge');
    if (code === 'photo-normalization-native-codec') return translate(null, 'photoNativeCodecUnavailable');
    if (code === 'photo-normalization-reduction') return translate(null, 'photoReductionFailed');
    return translate(null, 'photoNormalizationFailed');
  }

  function getPhotoPreviewFailureMessage(file) {
    var type = String(file && file.type || '').toLowerCase();
    var name = String(file && file.name || '').toLowerCase();
    var isHeic = type === 'image/heic' || type === 'image/heif' || /\.(heic|heif)$/.test(name);

    if (isHeic) {
      return translate(null, 'heicUnsupported');
    }
    return translate(null, 'androidReadFailure');
  }

  function getPhotoDebugContext(code, pickerSource, attempts) {
    var safeAttempts = [];

    (Array.isArray(attempts) ? attempts : []).slice(0, 4).forEach(function (attempt) {
      var strategy = String(attempt && attempt.strategy || '');
      var status = String(attempt && attempt.status || '');

      if (PHOTO_DIAGNOSTIC_STRATEGIES.indexOf(strategy) === -1) return;
      if (PHOTO_DIAGNOSTIC_STATUSES.indexOf(status) === -1) return;
      safeAttempts.push({ strategy: strategy, status: status });
    });

    return {
      code: PHOTO_DIAGNOSTIC_CODES.indexOf(code) === -1 ? 'PHOTO_DIAGNOSTIC_UNAVAILABLE' : code,
      pickerSource: PHOTO_DIAGNOSTIC_PICKER_SOURCES.indexOf(pickerSource) === -1 ? 'unknown' : pickerSource,
      attempts: safeAttempts,
      capabilities: {
        createImageBitmap: typeof window.createImageBitmap === 'function',
        fileReader: typeof window.FileReader === 'function',
        blobArrayBuffer: typeof Blob !== 'undefined' && typeof Blob.prototype.arrayBuffer === 'function',
        canvasToBlob: typeof HTMLCanvasElement !== 'undefined' && typeof HTMLCanvasElement.prototype.toBlob === 'function',
        objectUrl: !!(window.URL && typeof window.URL.createObjectURL === 'function'),
        showOpenFilePicker: typeof window.showOpenFilePicker === 'function',
        secureContext: window.isSecureContext === true
      }
    };
  }

  function setPhotoDebug(root, file, code, error, attempts, extra) {
    var debug = qs(root, '[data-sticker-photo-debug]');
    var details;

    if (!debug) return;
    if (!code) {
      debug.textContent = '';
      debug.hidden = true;
      return;
    }

    details = getPhotoDebugContext(code, root._stickerPhotoPickerSource || 'unknown', attempts);
    debug.textContent = translate(root, 'photoDiagnosticHeading') + '\n' + JSON.stringify(details, null, 2);
    debug.hidden = false;
  }

  function createPhotoObjectUrl(blob) {
    return new Promise(function (resolve, reject) {
      try {
        resolve(URL.createObjectURL(blob));
      } catch (error) {
        reject(error);
      }
    });
  }

  function createCapturedPhotoFile(buffer, file) {
    var options = {
      type: getPhotoPreviewMimeType(file),
      lastModified: file.lastModified || Date.now()
    };
    var captured = typeof File === 'function'
      ? new File([buffer], file.name || 'photo.jpg', options)
      : new Blob([buffer], { type: options.type });

    if (!captured.name) {
      try {
        Object.defineProperty(captured, 'name', { value: file.name || 'photo.jpg' });
        Object.defineProperty(captured, 'lastModified', { value: options.lastModified });
      } catch (ignore) {}
    }
    return captured;
  }

  function capturePhotoWithFileReader(file) {
    return new Promise(function (resolve, reject) {
      var reader;

      if (!window.FileReader) {
        reject(new Error('file-reader-unavailable'));
        return;
      }

      reader = new FileReader();
      reader.onload = function () {
        try {
          resolve(createCapturedPhotoFile(reader.result, file));
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = function () {
        reject(reader.error || new Error('photo-capture-read-failed'));
      };
      reader.onabort = function () {
        reject(new Error('photo-capture-read-aborted'));
      };

      // Starting the read inside the input event preserves access to temporary Android camera files.
      reader.readAsArrayBuffer(file);
    });
  }

  function capturePhotoWithObjectUrl(file, source) {
    if (!source || !window.fetch) return Promise.reject(new Error('object-url-fetch-unavailable'));
    return window.fetch(source)
      .then(function (response) {
        if (!response.ok) throw new Error('object-url-fetch-' + response.status);
        return response.arrayBuffer();
      })
      .then(function (buffer) {
        return createCapturedPhotoFile(buffer, file);
      });
  }

  function capturePhotoFile(file, source) {
    var failures = [];
    return capturePhotoWithFileReader(file)
      .then(function (capturedFile) {
        return { file: capturedFile, method: 'file-reader', failures: failures };
      })
      .catch(function () {
        failures.push({ method: 'file-reader', status: 'failed' });
        return capturePhotoWithObjectUrl(file, source)
          .then(function (capturedFile) {
            return { file: capturedFile, method: 'object-url-fetch', failures: failures };
          })
          .catch(function () {
            var captureError = new Error('photo-capture-all-methods-failed');
            failures.push({ method: 'object-url-fetch', status: 'failed' });
            captureError.failures = failures;
            throw captureError;
          });
      });
  }

  function replacePhotoInputFile(fileInput, file) {
    var transfer;

    if (
      !fileInput ||
      typeof DataTransfer !== 'function' ||
      typeof File !== 'function' ||
      !(file instanceof File)
    ) return false;
    try {
      transfer = new DataTransfer();
      transfer.items.add(file);
      fileInput.files = transfer.files;
      return fileInput.files && fileInput.files[0] === file;
    } catch (error) {
      return false;
    }
  }

  function isCurrentPhotoRequest(root, file, requestId) {
    return root._stickerPhotoRequestId === requestId && root._stickerPhotoFile === file;
  }

  function readBlobAsArrayBuffer(blob) {
    return new Promise(function (resolve, reject) {
      var reader;

      if (blob.arrayBuffer) {
        blob.arrayBuffer().then(resolve, reject);
        return;
      }
      if (!window.FileReader) {
        reject(new Error('file-reader-unavailable'));
        return;
      }

      reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error || new Error('file-reader-failed'));
      };
      reader.onabort = function () {
        reject(new Error('file-reader-aborted'));
      };
      reader.readAsArrayBuffer(blob);
    });
  }

  function getJpegOrientation(view, segmentOffset, segmentLength) {
    var exifOffset = segmentOffset + 4;
    var tiffOffset;
    var littleEndian;
    var directoryOffset;
    var entryCount;
    var entryOffset;
    var index;

    if (
      segmentLength < 16 ||
      exifOffset + segmentLength - 2 > view.byteLength ||
      view.getUint32(exifOffset, false) !== 0x45786966 ||
      view.getUint16(exifOffset + 4, false) !== 0
    ) {
      return 1;
    }

    tiffOffset = exifOffset + 6;
    littleEndian = view.getUint16(tiffOffset, false) === 0x4949;
    if (!littleEndian && view.getUint16(tiffOffset, false) !== 0x4d4d) return 1;
    if (view.getUint16(tiffOffset + 2, littleEndian) !== 42) return 1;

    directoryOffset = tiffOffset + view.getUint32(tiffOffset + 4, littleEndian);
    if (directoryOffset + 2 > view.byteLength) return 1;
    entryCount = view.getUint16(directoryOffset, littleEndian);

    for (index = 0; index < entryCount; index += 1) {
      entryOffset = directoryOffset + 2 + index * 12;
      if (entryOffset + 12 > view.byteLength) break;
      if (view.getUint16(entryOffset, littleEndian) === 0x0112) {
        return view.getUint16(entryOffset + 8, littleEndian) || 1;
      }
    }
    return 1;
  }

  function getPhotoDimensions(file) {
    var header = file.slice(0, Math.min(file.size, 512 * 1024));

    return readBlobAsArrayBuffer(header).then(function (buffer) {
      var view = new DataView(buffer);
      var length = view.byteLength;
      var offset;
      var marker;
      var segmentLength;
      var orientation = 1;
      var width;
      var height;

      if (
        length >= 24 &&
        view.getUint32(0, false) === 0x89504e47 &&
        view.getUint32(4, false) === 0x0d0a1a0a
      ) {
        return {
          width: view.getUint32(16, false),
          height: view.getUint32(20, false)
        };
      }

      if (length < 4 || view.getUint16(0, false) !== 0xffd8) {
        throw new Error('dimensions-unavailable');
      }

      offset = 2;
      while (offset + 9 < length) {
        if (view.getUint8(offset) !== 0xff) {
          offset += 1;
          continue;
        }
        marker = view.getUint8(offset + 1);
        if (offset + 4 > length) break;
        segmentLength = view.getUint16(offset + 2, false);
        if (marker === 0xe1) {
          orientation = getJpegOrientation(view, offset, segmentLength);
        }
        if (
          marker === 0xc0 || marker === 0xc1 || marker === 0xc2 ||
          marker === 0xc3 || marker === 0xc5 || marker === 0xc6 ||
          marker === 0xc7 || marker === 0xc9 || marker === 0xca ||
          marker === 0xcb || marker === 0xcd || marker === 0xce ||
          marker === 0xcf
        ) {
          width = view.getUint16(offset + 7, false);
          height = view.getUint16(offset + 5, false);
          if (orientation >= 5 && orientation <= 8) {
            return { width: height, height: width };
          }
          return {
            width: width,
            height: height
          };
        }
        if (marker === 0xd8 || marker === 0xd9 || marker === 0x01 || (marker >= 0xd0 && marker <= 0xd7)) {
          offset += 2;
          continue;
        }
        if (segmentLength < 2) break;
        offset += 2 + segmentLength;
      }

      throw new Error('dimensions-unavailable');
    });
  }

  function getPreviewDimensions(width, height) {
    var largestEdge = Math.max(width, height);
    var ratio = largestEdge > PHOTO_PREVIEW_MAX_EDGE ? PHOTO_PREVIEW_MAX_EDGE / largestEdge : 1;

    return {
      width: Math.max(1, Math.round(width * ratio)),
      height: Math.max(1, Math.round(height * ratio))
    };
  }

  function canvasToPreviewUrl(canvas) {
    return new Promise(function (resolve, reject) {
      if (!canvas.toBlob) {
        reject(new Error('canvas-blob-unavailable'));
        return;
      }
      canvas.toBlob(function (blob) {
        canvas.width = 1;
        canvas.height = 1;
        if (!blob) {
          reject(new Error('canvas-encode-failed'));
          return;
        }
        createPhotoObjectUrl(blob).then(resolve, reject);
      }, 'image/jpeg', 0.86);
    });
  }

  function createBitmapPhotoPreview(file) {
    var typedBlob = getTypedPhotoBlob(file);

    if (!window.createImageBitmap) return Promise.reject(new Error('bitmap-unavailable'));
    return getPhotoDimensions(file).then(function (dimensions) {
      var preview = getPreviewDimensions(dimensions.width, dimensions.height);
      return window.createImageBitmap(typedBlob, {
        imageOrientation: 'from-image',
        resizeWidth: preview.width,
        resizeHeight: preview.height,
        resizeQuality: 'medium'
      });
    }).then(function (bitmap) {
      var canvas = document.createElement('canvas');
      var context;

      canvas.width = bitmap.width;
      canvas.height = bitmap.height;
      context = canvas.getContext('2d');
      if (!context) {
        if (bitmap.close) bitmap.close();
        throw new Error('canvas-unavailable');
      }
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(bitmap, 0, 0);
      if (bitmap.close) bitmap.close();
      return canvasToPreviewUrl(canvas);
    });
  }

  function createImagePhotoPreview(file, existingSource) {
    var typedBlob = getTypedPhotoBlob(file);
    var sourcePromise = existingSource
      ? Promise.resolve(existingSource)
      : createPhotoObjectUrl(typedBlob);

    return sourcePromise.then(function (source) {
      return new Promise(function (resolve, reject) {
        var image = new Image();

        image.onload = function () {
          try {
            var preview = getPreviewDimensions(image.naturalWidth, image.naturalHeight);
            var canvas = document.createElement('canvas');
            var context;

            image.onload = null;
            image.onerror = null;
            URL.revokeObjectURL(source);
            canvas.width = preview.width;
            canvas.height = preview.height;
            context = canvas.getContext('2d');
            if (!context) {
              reject(new Error('canvas-unavailable'));
              return;
            }
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.drawImage(image, 0, 0, preview.width, preview.height);
            image.src = '';
            canvasToPreviewUrl(canvas).then(resolve, reject);
          } catch (error) {
            image.onload = null;
            image.onerror = null;
            image.src = '';
            URL.revokeObjectURL(source);
            reject(error);
          }
        };
        image.onerror = function () {
          image.onload = null;
          image.onerror = null;
          image.src = '';
          URL.revokeObjectURL(source);
          reject(new Error('preview-decode'));
        };
        image.src = source;
      });
    });
  }

  function validatePhotoPreviewSource(root, file, source, requestId) {
    return new Promise(function (resolve, reject) {
      var image = new Image();

      if (!isCurrentPhotoRequest(root, file, requestId)) {
        if (/^blob:/.test(source)) URL.revokeObjectURL(source);
        reject(new Error('preview-cancelled'));
        return;
      }

      image.onload = function () {
        image.onload = null;
        image.onerror = null;
        image.src = '';
        if (!isCurrentPhotoRequest(root, file, requestId)) {
          URL.revokeObjectURL(source);
          reject(new Error('preview-cancelled'));
          return;
        }
        resolve(source);
      };
      image.onerror = function () {
        image.onload = null;
        image.onerror = null;
        image.src = '';
        URL.revokeObjectURL(source);
        reject(new Error('preview-decode'));
      };
      image.src = source;
    });
  }

  function completePhotoPreview(root, file, source, requestId) {
    var photo = qs(root, '[data-sticker-photo]');
    var sample = qs(root, '[data-sticker-sample-photo]');
    var status = qs(root, '[data-sticker-photo-status]');
    var error = qs(root, '[data-sticker-error="photo"]');
    var uploadLabel = qs(root, '[data-sticker-photo-picker]');
    var controls = qs(root, '[data-sticker-photo-controls]');
    var uploadText = qs(root, '[data-sticker-upload-text]');

    if (!photo || !isCurrentPhotoRequest(root, file, requestId)) return;
    if (root._stickerPhotoUrl && root._stickerPhotoUrl !== source) {
      URL.revokeObjectURL(root._stickerPhotoUrl);
    }
    root._stickerPhotoUrl = /^blob:/.test(source) ? source : '';
    root._stickerUploadedPreviewSrc = source;
    photo.onload = null;
    photo.onerror = function () {
      var displayError = new Error('visible-image-decode-failed');
      photo.onerror = null;
      photo.removeAttribute('src');
      photo.hidden = true;
      if (root._stickerPhotoUrl === source) {
        URL.revokeObjectURL(source);
        root._stickerPhotoUrl = '';
      }
      if (sample) sample.hidden = false;
      if (controls) controls.hidden = true;
      root._stickerUploadedPreviewSrc = '';
      root._stickerPhotoFile = null;
      if (error) {
        error.textContent = getPhotoPreviewFailureMessage(file);
        error.hidden = false;
      }
      setPhotoDebug(root, file, 'PHOTO_PREVIEW_FINAL_DISPLAY_FAILED', displayError, root._stickerPhotoDebugAttempts || [], {
        requestId: requestId,
        sourceProtocol: String(source).split(':')[0]
      });
      updateConfig(root);
      publishGuidedContext(root);
    };
    photo.src = source;
    photo.hidden = false;
    if (sample) sample.hidden = true;
    if (status) status.textContent = file.name;
    if (error) error.hidden = true;
    if (uploadLabel) uploadLabel.classList.remove('is-error');
    if (controls) controls.hidden = false;
    if (uploadText) uploadText.textContent = translate(root, 'changePhoto');
    setPhotoDebug(root, file, '', null);
    root._stickerState.photoScale = 1;
    root._stickerState.photoX = 0;
    root._stickerState.photoY = 0;
    resetGeneration(root);
    updatePhoto(root);
    updateConfig(root);
    updatePrimaryAction(root);
    updateGenerationSummary(root);
    showPhotoToast(root);
    emitStepCompleted(root, 'photo');
  }

  function loadPhotoPreview(root, file, initialAttempts) {
    var requestId = (root._stickerPhotoRequestId || 0) + 1;
    var photo = qs(root, '[data-sticker-photo]');
    var sample = qs(root, '[data-sticker-sample-photo]');
    var status = qs(root, '[data-sticker-photo-status]');
    var controls = qs(root, '[data-sticker-photo-controls]');
    var error = qs(root, '[data-sticker-error="photo"]');
    var uploadLabel = qs(root, '[data-sticker-photo-picker]');
    var attempts = initialAttempts ? initialAttempts.slice() : [];

    root._stickerPhotoFile = file;
    root._stickerUploadedPreviewSrc = '';
    root._stickerPhotoRequestId = requestId;
    root._stickerPhotoDebugAttempts = attempts;
    if (root._stickerPhotoUrl) {
      URL.revokeObjectURL(root._stickerPhotoUrl);
      root._stickerPhotoUrl = '';
    }
    if (photo) {
      photo.onload = null;
      photo.onerror = null;
      photo.removeAttribute('src');
      photo.hidden = true;
    }
    if (sample) sample.hidden = false;
    if (status) status.textContent = translate(root, 'preparingPreview');
    if (controls) controls.hidden = true;
    if (error) error.hidden = true;
    setPhotoDebug(root, file, '', null);
    if (uploadLabel) uploadLabel.classList.remove('is-error');
    root._stickerState.photoScale = 1;
    root._stickerState.photoX = 0;
    root._stickerState.photoY = 0;
    resetGeneration(root);
    updateConfig(root);
    updatePrimaryAction(root);
    publishGuidedContext(root);

    createPhotoObjectUrl(file)
      .then(function (source) {
        return validatePhotoPreviewSource(root, file, source, requestId);
      })
      .then(function (source) {
        attempts.push({ strategy: 'normalized-file-object-url', status: 'success' });
        completePhotoPreview(root, file, source, requestId);
      })
      .catch(function (previewError) {
        var currentStatus = qs(root, '[data-sticker-photo-status]');
        var currentError = qs(root, '[data-sticker-error="photo"]');

        if (previewError && previewError.message === 'preview-cancelled') return;
        root._stickerPhotoSelectionFile = null;
        if (currentStatus) currentStatus.textContent = file.name;
        if (currentError) {
          currentError.textContent = getPhotoPreviewFailureMessage(file);
          currentError.hidden = false;
        }
        publishGuidedContext(root);
        attempts.push({ strategy: 'normalized-file-object-url', status: 'failed' });
        setPhotoDebug(root, file, 'PHOTO_PREVIEW_ALL_STRATEGIES_FAILED', previewError, attempts, {
          requestId: requestId,
          dimensionStatus: 'validated-before-decode'
        });
      });
  }

  function hasRequiredSymbol(root) {
    var state = root._stickerState;
    return state.symbolChoice === 'no' || !!state.symbol;
  }

  function hasRequiredAvatarInstructions(root) {
    var state = root._stickerState;
    return state.avatarInstructionsChoice === 'no' || !!state.avatarInstructions;
  }

  function hasNoTextChoice(root, position) {
    var selected = qs(root, '[data-sticker-text-choice="' + position + '"]:checked');
    return !!(selected && selected.value === 'no');
  }

  function hasRequiredText(root, position) {
    return hasNoTextChoice(root, position) || !!getTextValue(root, position);
  }

  function hasRequiredTexts(root) {
    return hasRequiredText(root, 'top') && hasRequiredText(root, 'bottom');
  }

  function updateTextChoice(root, position) {
    var choices = qsa(root, '[data-sticker-text-choice="' + position + '"]');
    var selected = choices.filter(function (choice) { return choice.checked; })[0];
    var input = qs(root, '[data-sticker-text="' + position + '"]');
    var options = qs(root, '[data-sticker-text-options="' + position + '"]');
    var error = qs(root, '[data-sticker-error="text-' + position + '"]');
    var withoutText = !!(selected && selected.value === 'no');

    if (!input) return;
    if (withoutText) input.value = '';
    if (options) options.hidden = withoutText;
    choices.forEach(function (choice) {
      var label = choice.closest('.sticker-customizer__choice');
      if (label) label.classList.toggle('is-selected', choice === selected);
    });
    if (error && (withoutText || input.value.trim())) error.hidden = true;
    updateText(root, position);
    resetGeneration(root);
  }

  function getStyleResults(root, style) {
    var state = root._stickerState;
    return state.generationResults[style] || [];
  }

  function getSelectedGeneration(root) {
    var state = root._stickerState;
    if (isAssistantV12Enabled(root)) {
      return state.selectedGenerationId ? getGenerationById(root, state.selectedGenerationId) : null;
    }
    return getStyleResults(root, state.style).filter(function (result) {
      return result.id === state.selectedGenerationId;
    })[0] || null;
  }

  function getGenerationById(root, generationId) {
    var state = root._stickerState;
    var styles = Object.keys(state.generationResults);
    var found = null;

    styles.some(function (style) {
      return state.generationResults[style].some(function (result) {
        if (result.id !== generationId) return false;
        found = result;
        return true;
      });
    });

    return found;
  }

  function isGenerationInCart(root, generationId) {
    return !!root._stickerState.cartGenerationIds[generationId];
  }

  function getGenerationDisplayLabel(root, result) {
    if (!result) return translate(root, 'avatarNotGenerated');
    if (!result.style || !result.attempt) return result.label || translate(root, 'avatarNotGenerated');
    return translate(root, 'generationLabel', {
      style: getStyleGuide(root, result.style).title,
      attempt: result.attempt
    });
  }

  function getGenerationImageAlt(root, result) {
    var styles = getTranslations(root).styles || {};
    if (!result || typeof result.style !== 'string' || !Object.prototype.hasOwnProperty.call(styles, result.style) ||
        !Number.isSafeInteger(result.attempt) || result.attempt < 1 || result.attempt > 9999) {
      return root.getAttribute('data-generation-image-alt') || translate(root, 'avatarExample');
    }
    return translate(root, 'generationLabel', { style: styles[result.style].title, attempt: result.attempt });
  }

  function getGenerationPropertyValue(root, result) {
    return result ? getGenerationDisplayLabel(root, result) + ' - ID ' + result.id : translate(root, 'avatarNotGenerated');
  }

  function freezeAcceptedSnapshotValue(value) {
    if (!value || typeof value !== 'object' || Object.isFrozen(value)) return value;
    Object.keys(value).forEach(function (key) {
      freezeAcceptedSnapshotValue(value[key]);
    });
    return Object.freeze(value);
  }

  function freezeAcceptedDesignSnapshot(root, result) {
    var state = root._stickerState;
    var payload = result && result.payload && typeof result.payload === 'object' ? result.payload : {};
    var subject = payload.subject && typeof payload.subject === 'object' ? payload.subject : {};
    var personalization = payload.personalization && typeof payload.personalization === 'object'
      ? payload.personalization
      : {};
    var composition = payload.composition && typeof payload.composition === 'object' ? payload.composition : {};
    var textTop = getTextValue(root, 'top');
    var textBottom = getTextValue(root, 'bottom');
    var properties;
    var finalizationPayload;
    var config;

    if (!result || !result.id) return null;
    config = JSON.stringify({
      v: 2,
      g: result.id,
      a: result.attempt || 0,
      st: result.style || '',
      m: subject.presentationMode || state.presentationMode || 'standard',
      h: personalization.hairstyleId || state.approvedAvatarHairstyleId || '',
      ga: personalization.garmentId || state.approvedAvatarGarmentId || state.tryonGarment || '',
      co: personalization.color || state.tryonColor || '',
      bg: state.selectedBackgroundId || composition.backgroundId || '',
      f: state.selectedBackgroundId === 'background-none-white'
        ? ''
        : state.selectedFadeId || composition.fadePresetId || composition.fadeId || '',
      bt: normalizeBackgroundTransform(state.backgroundTransform),
      ts: state.topSize,
      bs: state.bottomSize,
      tc: normalizeTextColor(state.textColor),
      s: state.photoScale,
      x: state.photoX,
      y: state.photoY,
      te: !hasNoTextChoice(root, 'top'),
      be: !hasNoTextChoice(root, 'bottom')
    });
    properties = {
      'Style': result.styleLabel || getStyleGuide(root, result.style).title || result.style || '',
      'Texte haut': textTop,
      'Texte bas': textBottom,
      'Symbole vêtement': personalization.symbolChoice === 'no' ? '' : personalization.symbol || state.symbol || '',
      '_Configuration personnalisation': config,
      'Génération image': getGenerationPropertyValue(root, result),
      '_ID génération': result.id,
      'numgen': result.id,
      '_Image générée': result.imageUrl || '',
      '_PDF client': result.clientPdfUrl || '',
      '_PDF impression': result.printPdfUrl || '',
      'Instructions avatar': personalization.avatarInstructionsEnabled === false
        ? ''
        : personalization.avatarInstructions || state.avatarInstructions || '',
      'Taille texte haut': String(state.topSize),
      'Taille texte bas': String(state.bottomSize),
      '_clairatier_config': config,
      '_clairatier_generation_label': getGenerationPropertyValue(root, result),
      '_clairatier_generation_id': result.id,
      '_clairatier_generated_image_url': result.imageUrl || '',
      '_clairatier_client_pdf_url': result.clientPdfUrl || '',
      '_clairatier_print_pdf_url': result.printPdfUrl || '',
      '_clairatier_style': result.style || '',
      '_clairatier_subject': subject.avatarId || subject.sourceType || '',
      '_clairatier_mode': subject.presentationMode || state.presentationMode || 'standard',
      '_clairatier_accessory': personalization.accessoryId || state.selectedAccessoryId || '',
      '_clairatier_hairstyle': personalization.hairstyleId || state.approvedAvatarHairstyleId || '',
      '_clairatier_garment': personalization.garmentId || state.approvedAvatarGarmentId || state.tryonGarment || '',
      '_clairatier_primary_color': personalization.requestedPrimaryColor || state.requestedPrimaryColor || '',
      '_clairatier_secondary_color': personalization.requestedSecondaryColor || state.requestedSecondaryColor || '',
      '_clairatier_accent_color': personalization.requestedAccentColor || state.requestedAccentColor || '',
      '_clairatier_background': state.selectedBackgroundId || composition.backgroundId || '',
      '_clairatier_fade': state.selectedBackgroundId === 'background-none-white'
        ? ''
        : state.selectedFadeId || composition.fadePresetId || composition.fadeId || '',
      '_clairatier_text_top': textTop,
      '_clairatier_text_bottom': textBottom,
      '_clairatier_text_top_size': String(state.topSize),
      '_clairatier_text_bottom_size': String(state.bottomSize),
      '_clairatier_symbol': personalization.symbolChoice === 'no' ? '' : personalization.symbol || state.symbol || '',
      '_clairatier_avatar_instructions': personalization.avatarInstructionsEnabled === false
        ? ''
        : personalization.avatarInstructions || state.avatarInstructions || ''
    };
    finalizationPayload = freezeAcceptedSnapshotValue(JSON.parse(JSON.stringify(buildFinalizationPayload(root, result))));
    return freezeAcceptedSnapshotValue({
      generationId: result.id,
      finalizationPayload: finalizationPayload,
      properties: properties
    });
  }

  function getAcceptedDesignSnapshot(result) {
    var snapshot = result && result.acceptedCartSnapshot;
    return snapshot && snapshot.generationId === result.id ? snapshot : null;
  }

  function refreshAcceptedResultReferences(snapshot, result) {
    var properties;
    if (!snapshot || !result || snapshot.generationId !== result.id) return null;
    properties = Object.assign({}, snapshot.properties, {
      numgen: result.id,
      '_Image générée': result.imageUrl || '',
      '_PDF client': result.clientPdfUrl || '',
      '_PDF impression': result.printPdfUrl || '',
      '_clairatier_generated_image_url': result.imageUrl || '',
      '_clairatier_client_pdf_url': result.clientPdfUrl || '',
      '_clairatier_print_pdf_url': result.printPdfUrl || ''
    });
    return freezeAcceptedSnapshotValue(Object.assign({}, snapshot, { properties: properties }));
  }

  function resetGeneration(root) {
    var state = root._stickerState;
    var preservedResults = {};
    var preservedStyles = {};
    if (!state) return;
    // An edit invalidates the generated context, not the honest image already
    // returned by the backend. Keep history, the selected result and its
    // in-memory snapshot available while the customer refines or compares.
    if (isAssistantV12Enabled(root)) {
      updateGeneration(root);
      return;
    }
    Object.keys(state.generationResults).forEach(function (style) {
      var results = state.generationResults[style].filter(function (result) {
        return isGenerationInCart(root, result.id);
      });
      if (!results.length) return;
      preservedResults[style] = results;
      preservedStyles[style] = true;
    });
    state.generatedStyles = preservedStyles;
    state.generationResults = preservedResults;
    state.generatedStyle = '';
    state.selectedGenerationId = '';
    state.selectedGenerationLabel = '';
    state.selectedGenerationIdsByStyle = {};
    state.lastGenerationPayload = {};
    state.isGenerating = false;
    state.generationStatus = GENERATION_STATUS.IDLE;
    state.activeGenerationRequestId = '';
    state.lastGenerationError = '';
    updateGeneration(root);
  }

  function updateGenerationPreview(root) {
    var selected = getSelectedGeneration(root);
    var photo = qs(root, '[data-sticker-photo]');
    var sample = qs(root, '[data-sticker-sample-photo]');
    var controls = qs(root, '[data-sticker-photo-controls]');
    var status = qs(root, '[data-sticker-photo-status]');
    var referencePhoto = getCurrentPhoto(root);
    var source = selected
      ? selected.previewUrl || selected.imageUrl
      : root._stickerUploadedPreviewSrc || '';

    if (!photo) return;
    if (source && photo.getAttribute('src') !== source) photo.src = source;
    photo.hidden = !source;
    if (sample) sample.hidden = !!source;
    if (controls) controls.hidden = !source;
    if (status) {
      status.textContent = selected
        ? translate(root, 'avatarInPreview', { label: getGenerationDisplayLabel(root, selected) })
        : referencePhoto
          ? referencePhoto.name
          : translate(root, 'photoGuidance');
    }
    root._stickerState.previewingGeneratedAvatar = !!selected;
    updatePhoto(root);
  }

  function syncSelectedGenerationContext(root, result) {
    var state = root._stickerState;
    if (result) {
      if (isAssistantV12Enabled(root)) {
        state.assistantHasUngeneratedChanges = !result.contextFingerprintSnapshot ||
          result.contextFingerprintSnapshot !== getAssistantContextFingerprint(root);
        if (!state.assistantHasUngeneratedChanges) {
          state.assistantGeneratedContextFingerprint = result.contextFingerprintSnapshot;
        }
      }
    }
    return !state.assistantHasUngeneratedChanges;
  }

  function selectGenerationForPreview(root, result) {
    var state = root._stickerState;
    state.selectedGenerationId = result ? result.id : '';
    state.selectedGenerationLabel = result ? result.label : '';
    if (result) {
      state.selectedGenerationIdsByStyle[result.style] = result.id;
      syncSelectedGenerationContext(root, result);
    }
    updateGeneration(root);
  }

  function renderGenerationResults(root) {
    var state = root._stickerState;
    var results = getStyleResults(root, state.style);
    var list = qs(root, '[data-sticker-results]');

    if (!list) return;
    list.innerHTML = '';
    list.hidden = results.length === 0;

    results.forEach(function (result) {
      var item = document.createElement('div');
      var summary = document.createElement('div');
      var thumb = document.createElement('span');
      var title = document.createElement('span');
      var badge = document.createElement('span');
      var previewButton = document.createElement('button');
      var cartButton = document.createElement('button');
      var inCart = isGenerationInCart(root, result.id);
      var inPreview = result.id === state.selectedGenerationId;

      item.className = 'sticker-customizer__result';
      item.classList.toggle('is-selected', inPreview);
      item.classList.toggle('is-in-cart', inCart);

      summary.className = 'sticker-customizer__result-summary';

      thumb.className = 'sticker-customizer__result-thumb sticker-customizer__result-thumb--' + state.style;
      thumb.textContent = result.attempt;
      if (result.imageUrl) {
        thumb.classList.add('has-image');
        thumb.style.backgroundImage = 'url("' + result.imageUrl.replace(/"/g, '%22') + '")';
      }

      title.className = 'sticker-customizer__result-title';
      title.textContent = getGenerationDisplayLabel(root, result);

      badge.className = 'sticker-customizer__result-badge';
      badge.textContent = inCart ? translate(root, 'addedToCart') : translate(root, 'notAddedToCart');

      previewButton.type = 'button';
      previewButton.className = 'sticker-customizer__result-preview';
      previewButton.setAttribute('data-sticker-action', 'select-generation');
      previewButton.setAttribute('data-sticker-generation-id', result.id);
      previewButton.disabled = inPreview;
      previewButton.textContent = inPreview ? translate(root, 'addedToPreview') : translate(root, 'addToPreview');

      cartButton.type = 'button';
      cartButton.className = 'sticker-customizer__result-cart';
      cartButton.setAttribute('data-sticker-generation-id', result.id);
      cartButton.setAttribute('data-sticker-action', inCart ? 'remove-generation' : 'add-generation');
      cartButton.disabled = !inCart && isAssistantV12Enabled(root) && !getAcceptedDesignSnapshot(result);
      cartButton.textContent = inCart ? translate(root, 'removeFromCart') : translate(root, 'addToCart');


      summary.appendChild(thumb);
      summary.appendChild(title);
      summary.appendChild(badge);
      item.appendChild(summary);
      item.appendChild(previewButton);
      item.appendChild(cartButton);
      list.appendChild(item);
    });
  }

  function getAssistantComparisonSource(root, selected) {
    var state = root && root._stickerState;
    var previous = null;
    if (!state || !selected) return null;
    var sameStyle = (state.generationResults[selected.style] || []).filter(function (result) {
      return result.id !== selected.id && (result.previewUrl || result.imageUrl);
    });
    if (sameStyle.length) previous = sameStyle[sameStyle.length - 1];
    if (!previous) {
      Object.keys(state.generationResults).forEach(function (style) {
        (state.generationResults[style] || []).forEach(function (result) {
          if (result.id !== selected.id && (result.previewUrl || result.imageUrl)) previous = result;
        });
      });
    }
    if (previous) {
      return {
        id: previous.id,
        src: previous.previewUrl || previous.imageUrl,
        label: getGenerationDisplayLabel(root, previous),
        imageAlt: getGenerationImageAlt(root, previous)
      };
    }
    if (root._stickerUploadedPreviewSrc) {
      return { id: 'reference-photo', src: root._stickerUploadedPreviewSrc,
        label: translate(root, 'resultReferencePhoto'), imageAlt: translate(root, 'resultReferencePhoto') };
    }
    if (root._stickerLastHonestPreviewAsset) {
      return { id: 'approved-preview', src: root._stickerLastHonestPreviewAsset,
        label: translate(root, 'resultReferenceAvatar'), imageAlt: root._stickerMiaPreviewDescription || translate(root, 'avatarExample') };
    }
    return null;
  }

  function syncAssistantResultLoop(root) {
    var state = root && root._stickerState;
    var panel = qs(root, '[data-sticker-assistant-result]');
    var selected = state ? getSelectedGeneration(root) : null;
    var comparison = getAssistantComparisonSource(root, selected);
    var currentImage = panel && qs(panel, '[data-sticker-assistant-result-current]');
    var previousImage = panel && qs(panel, '[data-sticker-assistant-result-previous]');
    var previousFigure = panel && qs(panel, '[data-sticker-assistant-result-previous-figure]');
    var status = panel && qs(panel, '[data-sticker-assistant-result-status]');
    var compare = panel && qs(panel, '[data-sticker-result-loop-action="compare"]');
    var accept = panel && qs(panel, '[data-sticker-result-loop-action="accept"]');
    var comparing = !!(state && state.assistantResultComparisonVisible && comparison);
    if (!panel || !state) return false;
    panel.hidden = state.assistantExperience !== 'guided' || !selected;
    panel.setAttribute('aria-hidden', panel.hidden ? 'true' : 'false');
    if (panel.hidden) return false;
    if (currentImage && (selected.previewUrl || selected.imageUrl)) {
      currentImage.src = selected.previewUrl || selected.imageUrl;
      currentImage.alt = typeof getGenerationImageAlt === 'function' ? getGenerationImageAlt(root, selected) : translate(root, 'avatarExample');
      currentImage.hidden = false;
    } else if (currentImage) {
      currentImage.removeAttribute('src');
      currentImage.alt = '';
      currentImage.hidden = true;
    }
    if (previousImage && comparison) {
      previousImage.src = comparison.src;
      previousImage.alt = comparison.imageAlt || root.getAttribute('data-generation-image-alt') || translate(root, 'avatarExample');
    } else if (previousImage) {
      previousImage.removeAttribute('src');
      previousImage.alt = '';
    }
    if (previousFigure) previousFigure.hidden = !comparing;
    if (compare) {
      compare.disabled = !comparison;
      compare.setAttribute('aria-pressed', comparing ? 'true' : 'false');
    }
    if (accept) accept.disabled = !!state.assistantHasUngeneratedChanges;
    if (status) {
      var statusText = state.assistantHasUngeneratedChanges
        ? translate(root, 'resultRefinementPending')
        : state.assistantAcceptedGenerationId === selected.id
          ? translate(root, 'resultAccepted')
          : translate(root, 'resultReady');
      if (status.textContent !== statusText) status.textContent = statusText;
    }
    return true;
  }

  function handleAssistantResultAction(root, action) {
    var state = root && root._stickerState;
    var selected = state ? getSelectedGeneration(root) : null;
    var panel = qs(root, '[data-sticker-assistant-result]');
    var focusTarget;
    if (!state || !selected) return { ok: false, code: 'result-unavailable' };
    if (action === 'accept') {
      if (state.assistantHasUngeneratedChanges) {
        return { ok: false, code: 'result-has-ungenerated-changes' };
      }
      if (state.assistantAcceptedGenerationId === selected.id) {
        if (!getAcceptedDesignSnapshot(selected)) {
          selected.acceptedCartSnapshot = freezeAcceptedDesignSnapshot(root, selected);
        }
        syncAssistantResultLoop(root);
        return { ok: true, action: action, duplicate: true };
      }
      selected.acceptedCartSnapshot = freezeAcceptedDesignSnapshot(root, selected);
      if (!selected.acceptedCartSnapshot) return { ok: false, code: 'result-unavailable' };
      state.assistantAcceptedGenerationId = selected.id;
      state.assistantResultComparisonVisible = false;
      appendAssistantTranscriptEntry(root, {
        id: 'result-accepted:' + selected.id,
        role: 'receipt',
        text: translate(root, 'resultAccepted')
      });
      announceAssistantState(root, translate(root, 'resultAccepted'));
    } else if (action === 'compare') {
      if (!getAssistantComparisonSource(root, selected)) return { ok: false, code: 'comparison-unavailable' };
      state.assistantResultComparisonVisible = !state.assistantResultComparisonVisible;
      announceAssistantState(root, translate(root, state.assistantResultComparisonVisible
        ? 'resultComparisonOpened' : 'resultComparisonClosed'));
    } else if (action === 'refine') {
      state.assistantResultComparisonVisible = false;
      state.assistantVisualCategory = '';
      state.assistantProposals = [];
      setGuidedPreviewMode(root, 'shelf');
      renderGuidedNextActions(root);
      focusAssistantExperience(root, 'guided');
      announceAssistantState(root, translate(root, 'resultRefinePrompt'));
    } else if (action === 'full-options') {
      setAssistantExperience(root, 'full');
    } else {
      return { ok: false, code: 'result-action-unavailable' };
    }
    if (action === 'accept') renderGenerationResults(root);
    syncAssistantResultLoop(root);
    if (panel && action !== 'refine' && action !== 'full-options') {
      focusTarget = qs(panel, '[data-sticker-result-loop-action="' + action + '"]');
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
    }
    return { ok: true, action: action };
  }

  function updateGenerationProgress(root, requestedStatus) {
    var track = qs(root, '[data-sticker-generation-progress-track]');
    var bar = qs(root, '[data-sticker-generation-progress-bar]');
    var label = qs(root, '[data-sticker-generation-progress-label]');
    var step = qs(root, '[data-sticker-generation-progress-step]');
    var status = normalizeGenerationStatus(requestedStatus);
    var allowed = [
      GENERATION_STATUS.QUEUED, GENERATION_STATUS.PROCESSING,
      GENERATION_STATUS.SUCCEEDED, GENERATION_STATUS.FAILED
    ];
    var key;
    if (allowed.indexOf(status) === -1) return false;
    key = status === GENERATION_STATUS.QUEUED ? 'generationProgressQueued'
      : status === GENERATION_STATUS.PROCESSING ? 'generationProgressProcessing'
        : status === GENERATION_STATUS.SUCCEEDED ? 'generationProgressSucceeded'
          : 'generationProgressFailed';
    if (track) {
      track.removeAttribute('aria-valuemin');
      track.removeAttribute('aria-valuemax');
      track.removeAttribute('aria-valuenow');
      track.setAttribute('aria-valuetext', translate(root, key));
      track.classList.toggle('is-indeterminate',
        status === GENERATION_STATUS.QUEUED || status === GENERATION_STATUS.PROCESSING);
      track.classList.toggle('is-terminal',
        status === GENERATION_STATUS.SUCCEEDED || status === GENERATION_STATUS.FAILED);
    }
    if (bar) bar.removeAttribute('style');
    if (label) label.textContent = translate(root, key);
    if (step) {
      step.textContent = translate(root, key);
      if (root._stickerLastAnnouncedGenerationStatus === status) {
        step.setAttribute('aria-live', 'off');
      } else {
        step.setAttribute('aria-live', 'polite');
        root._stickerLastAnnouncedGenerationStatus = status;
      }
    }
    syncClairamiProcessing(root, status);
    return true;
  }

  function syncClairamiProcessing(root, status) {
    var container = qs(root, '[data-sticker-clairami-processing]');
    var image = container && qs(container, '[data-sticker-clairami-processing-image]');
    var enabled = root.getAttribute('data-sticker-clairami-processing-enabled') === 'true';
    var state = root._stickerState;
    var isMia = state && state.subjectSource === 'approved-avatar' && state.approvedAvatarId === 'mia';
    var shouldShow = enabled && isMia && status === GENERATION_STATUS.PROCESSING;
    var requestId = state && state.activeGenerationRequestId || '';
    var source;

    if (!container || !image) return;
    if (!shouldShow) {
      container.hidden = true;
      container.setAttribute('aria-hidden', 'true');
      image.hidden = true;
      image.onload = null;
      image.onerror = null;
      image.removeAttribute('data-clairami-loading');
      image.removeAttribute('src');
      return;
    }

    source = image.getAttribute('data-src') || '';
    container.hidden = false;
    container.setAttribute('aria-hidden', 'true');
    if (!source || image.getAttribute('data-clairami-unavailable') === 'true') {
      image.hidden = true;
      image.onload = null;
      image.onerror = null;
      image.removeAttribute('data-clairami-loading');
      image.removeAttribute('src');
      return;
    }
    if (image.getAttribute('src') === source && image.complete && image.naturalWidth > 0) {
      image.hidden = false;
      image.onload = null;
      image.onerror = null;
      image.removeAttribute('data-clairami-loading');
      container.setAttribute('aria-hidden', 'false');
      return;
    }
    image.hidden = false;
    image.setAttribute('data-clairami-loading', 'true');
    image.onload = function () {
      var currentState = root._stickerState;
      var stillCurrent = root.getAttribute('data-sticker-clairami-processing-enabled') === 'true' &&
        currentState && currentState.subjectSource === 'approved-avatar' &&
        currentState.approvedAvatarId === 'mia' &&
        normalizeGenerationStatus(root._stickerState && root._stickerState.generationStatus) === GENERATION_STATUS.PROCESSING &&
        (currentState.activeGenerationRequestId || '') === requestId;
      image.onload = null;
      image.onerror = null;
      image.removeAttribute('data-clairami-loading');
      if (!stillCurrent) {
        image.hidden = true;
        container.hidden = true;
        container.setAttribute('aria-hidden', 'true');
        image.removeAttribute('src');
        return;
      }
      image.hidden = false;
      container.hidden = false;
      container.setAttribute('aria-hidden', 'false');
    };
    image.onerror = function () {
      image.hidden = true;
      image.setAttribute('data-clairami-unavailable', 'true');
      image.onload = null;
      image.onerror = null;
      image.removeAttribute('data-clairami-loading');
      image.removeAttribute('src');
      container.setAttribute('aria-hidden', 'true');
    };
    if (!image.getAttribute('src')) image.setAttribute('src', source);
  }

  function openGenerationProgress(root) {
    var modal = qs(root, '[data-sticker-generation-progress]');

    if (!modal) return;
    root._stickerGenerationProgressPreviousFocus = document.activeElement;
    root._stickerGenerationProgressDismissedForRequest = '';
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    updateGenerationProgress(root, root._stickerState.generationStatus);
    var closeButton = qs(modal, '[data-sticker-action="close-generation-progress"]');
    if (closeButton && typeof closeButton.focus === 'function') closeButton.focus();
  }

  function closeGenerationProgress(root, restoreFocus) {
    var modal = qs(root, '[data-sticker-generation-progress]');
    var previousFocus = root._stickerGenerationProgressPreviousFocus;
    if (modal) {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
    }
    root._stickerGenerationProgressDismissedForRequest =
      root._stickerState && root._stickerState.activeGenerationRequestId || '';
    if (root._stickerState && root._stickerState.generationStatus === GENERATION_STATUS.SUCCEEDED &&
        syncAssistantResultLoop(root)) {
      var resultTitle = qs(root, '[data-sticker-assistant-result-title]');
      if (resultTitle && typeof resultTitle.focus === 'function') resultTitle.focus();
    } else if (restoreFocus && previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
    root._stickerGenerationProgressPreviousFocus = null;
  }

  function hideGenerationError(root) {
    var error = qs(root, '[data-sticker-error="generation"]');
    var message = qs(root, '[data-sticker-generation-error-message]');
    var support = qs(root, '[data-sticker-generation-error-support]');
    var detail = qs(root, '[data-sticker-generation-error-detail]');
    var reasons = qs(root, '[data-sticker-photo-preflight-reasons]');
    var recovery = qs(root, '[data-sticker-photo-preflight-recovery]');

    if (!error) return;
    error.hidden = true;
    if (message) message.textContent = '';
    if (support) support.hidden = true;
    if (detail) detail.textContent = '';
    if (reasons) {
      reasons.textContent = '';
      reasons.hidden = true;
    }
    if (recovery) recovery.hidden = true;
    error.removeAttribute('data-photo-preflight-recovery');
  }

  function normalizePhotoPreflightRecovery(generationError) {
    var body = generationError && generationError.responseBody;
    var preflight;
    var reasonCodes;
    var normalized = [];

    if (String(generationError && generationError.code || '').toUpperCase() !== PHOTO_PREFLIGHT_ERROR_CODE) {
      return null;
    }
    preflight = body && !Array.isArray(body) && body.photoPreflight;
    reasonCodes = preflight && !Array.isArray(preflight) && preflight.reasonCodes;
    if (!preflight || preflight.decision !== 'needs_user_action' || !Array.isArray(reasonCodes)) {
      return { reasonCodes: ['analysis_unavailable'], translationKeys: ['photoPreflightUnavailable'] };
    }
    reasonCodes.forEach(function (reasonCode) {
      if (!Object.prototype.hasOwnProperty.call(PHOTO_PREFLIGHT_REASON_TRANSLATIONS, reasonCode)) return;
      if (normalized.some(function (item) { return item.code === reasonCode; })) return;
      normalized.push({ code: reasonCode, key: PHOTO_PREFLIGHT_REASON_TRANSLATIONS[reasonCode] });
    });
    if (!normalized.length || normalized.length !== reasonCodes.length) {
      return { reasonCodes: ['analysis_unavailable'], translationKeys: ['photoPreflightUnavailable'] };
    }
    return {
      reasonCodes: normalized.map(function (item) { return item.code; }),
      translationKeys: normalized.map(function (item) { return item.key; })
    };
  }

  function formatInclusiveSubjectWording(root, composition) {
    var allowedKeys = [
      'contractVersion', 'decision', 'reasonCodes', 'confidence',
      'visiblePersonCount', 'visibleChildCount', 'visiblePersonCountConfidence',
      'visibleChildCountConfidence', 'framing', 'qualitySignals'
    ];
    var qualityKeys = ['sharpness', 'lighting', 'faceVisibility'];
    var people;
    var children;
    var childWording;
    var childKey;
    var valid = composition && !Array.isArray(composition) &&
      Object.keys(composition).length === allowedKeys.length &&
      Object.keys(composition).every(function (key) { return allowedKeys.indexOf(key) > -1; }) &&
      composition.contractVersion === '1.0' && composition.decision === 'continue' &&
      Array.isArray(composition.reasonCodes) && composition.reasonCodes.length === 0 &&
      typeof composition.confidence === 'number' && isFinite(composition.confidence) &&
      composition.confidence >= 0 && composition.confidence <= 1 &&
      Number.isInteger(composition.visiblePersonCount) &&
      Number.isInteger(composition.visibleChildCount) &&
      typeof composition.visiblePersonCountConfidence === 'number' &&
      typeof composition.visibleChildCountConfidence === 'number' &&
      isFinite(composition.visiblePersonCountConfidence) &&
      isFinite(composition.visibleChildCountConfidence) &&
      composition.visiblePersonCountConfidence >= 0.90 &&
      composition.visibleChildCountConfidence >= 0.90 &&
      composition.visiblePersonCountConfidence <= 1 &&
      composition.visibleChildCountConfidence <= 1 &&
      composition.framing === 'clear' && composition.qualitySignals &&
      !Array.isArray(composition.qualitySignals) &&
      Object.keys(composition.qualitySignals).length === qualityKeys.length &&
      Object.keys(composition.qualitySignals).every(function (key) { return qualityKeys.indexOf(key) > -1; }) &&
      composition.qualitySignals.sharpness === 'clear' &&
      composition.qualitySignals.lighting === 'good' &&
      composition.qualitySignals.faceVisibility === 'clear';

    if (!valid) return translate(root, 'inclusiveSubjectNeutral');
    people = composition.visiblePersonCount;
    children = composition.visibleChildCount;
    if (people < 1 || people > 4 || children < 1 || children > 4 || children > people) {
      return translate(root, 'inclusiveSubjectNeutral');
    }

    childKey = children === 1 ? 'inclusiveSubjectOne'
      : children === 2 ? 'inclusiveSubjectTwo'
        : children === 3 ? 'inclusiveSubjectThree'
          : 'inclusiveSubjectOther';
    childWording = translate(root, childKey, { count: children });
    if (children < people) {
      return translate(root, 'inclusiveSubjectMixedGroup', {
        people: people,
        children: childWording
      });
    }
    return childWording;
  }

  function showPhotoPreflightRecovery(root, recovery) {
    var error = qs(root, '[data-sticker-error="generation"]');
    var message = qs(root, '[data-sticker-generation-error-message]');
    var reasons = qs(root, '[data-sticker-photo-preflight-reasons]');
    var actions = qs(root, '[data-sticker-photo-preflight-recovery]');
    var support = qs(root, '[data-sticker-generation-error-support]');
    var detail = qs(root, '[data-sticker-generation-error-detail]');

    if (!error || !recovery) return false;
    if (message) message.textContent = translate(root, 'photoPreflightNeedsAction');
    if (reasons) {
      reasons.textContent = '';
      recovery.translationKeys.forEach(function (translationKey) {
        var item = document.createElement('li');
        item.textContent = translate(root, translationKey);
        reasons.appendChild(item);
      });
      reasons.hidden = false;
    }
    if (actions) actions.hidden = false;
    if (support) support.hidden = true;
    if (detail) detail.textContent = '';
    error.setAttribute('data-photo-preflight-recovery', 'true');
    error.hidden = false;
    return true;
  }

  function getGenerationErrorMessage(root, generationError) {
    var code = String(generationError && generationError.code || '').toUpperCase();

    if (code === 'GENERATION_NETWORK_ERROR') return translate(root, 'generationNetworkFriendly');
    if (code === 'MODERATION_BLOCKED_SEXUAL_MINORS') return translate(root, 'moderationSexualMinors');
    if (code === 'MODERATION_BLOCKED_SEXUAL') return translate(root, 'moderationSexual');
    if (code.indexOf('MODERATION_BLOCKED_SELF_HARM') === 0) return translate(root, 'moderationSelfHarm');
    if (code.indexOf('MODERATION_BLOCKED_VIOLENCE') === 0) return translate(root, 'moderationViolence');
    if (code.indexOf('MODERATION_BLOCKED_HATE') === 0) return translate(root, 'moderationHate');
    if (code.indexOf('MODERATION_BLOCKED_HARASSMENT') === 0) return translate(root, 'moderationHarassment');
    if (code.indexOf('MODERATION_BLOCKED_ILLICIT') === 0) return translate(root, 'moderationIllicit');
    if (code.indexOf('MODERATION_BLOCKED_') === 0) return translate(root, 'moderationGeneric');
    if (code === 'OPENAI_SAFETY_BLOCKED') return translate(root, 'generationSafetyBlocked');
    if (
      code === 'MODERATION_FAILED' ||
      code === 'MODERATION_NOT_CONFIGURED' ||
      code === 'OPENAI_GENERATION_FAILED' ||
      code === 'OPENAI_NOT_CONFIGURED' ||
      code === 'GENERATION_ENQUEUE_FAILED'
    ) return translate(root, 'generationServiceUnavailable');
    if (
      code === 'INVALID_IMAGE' ||
      code === 'UNSUPPORTED_IMAGE' ||
      code === 'PHOTO_METADATA_MISMATCH'
    ) return translate(root, 'generationInvalidImage');
    if (code === 'INVALID_PAYLOAD' || code === 'IDEMPOTENCY_CONFLICT') {
      return translate(root, 'generationInvalidRequest');
    }
    if (code === 'GENERATION_QUOTA_EXCEEDED') return translate(root, 'generationQuotaReached');

    return translate(root, 'generationFailedFriendly');
  }

  function getPrivacySafeGenerationDiagnostic(generationError, photoPreflightRecovery) {
    var requestedCode = String(generationError && generationError.code || '').toUpperCase();
    var requestedStatus = generationError && generationError.status;
    var diagnostic = {
      code: GENERATION_DIAGNOSTIC_CODES.indexOf(requestedCode) === -1 ? 'UNKNOWN' : requestedCode
    };

    if (Number.isInteger(requestedStatus) && requestedStatus >= 400 && requestedStatus <= 599) {
      diagnostic.status = requestedStatus;
    }
    if (Array.isArray(photoPreflightRecovery && photoPreflightRecovery.reasonCodes)) {
      diagnostic.reasonCodes = photoPreflightRecovery.reasonCodes.filter(function (reasonCode) {
        return Object.prototype.hasOwnProperty.call(PHOTO_PREFLIGHT_REASON_TRANSLATIONS, reasonCode);
      }).slice(0, 4);
    }
    return diagnostic;
  }

  function getGenerationErrorEntitlements(generationError) {
    var body = generationError && generationError.responseBody;
    return body && !Array.isArray(body) ? body.entitlements : null;
  }

  function showGenerationError(root, message, includeSupportDetails, friendlyMessage) {
    var error = qs(root, '[data-sticker-error="generation"]');
    var messageElement = qs(root, '[data-sticker-generation-error-message]');
    var support = qs(root, '[data-sticker-generation-error-support]');
    var detail = qs(root, '[data-sticker-generation-error-detail]');

    if (!error) return;
    hideGenerationError(root);
    if (messageElement) {
      messageElement.textContent = includeSupportDetails
        ? friendlyMessage || translate(root, 'generationFailedFriendly')
        : message;
    }
    if (support) support.hidden = !includeSupportDetails;
    if (detail) detail.textContent = includeSupportDetails ? message : '';
    error.hidden = false;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getGenerationCreditProductUrl(root) {
    return (root.getAttribute('data-generation-credit-product-url') || '/products/pack-retouches-ia').trim() || '/products/pack-retouches-ia';
  }

  function generationCreditMessageHtml(root) {
    return translate(root, 'creditsUsedHtml', {
      url: escapeHtml(getGenerationCreditProductUrl(root))
    });
  }

  function updateGeneration(root) {
    var state = root._stickerState;
    var style = state.style;
    var styleLabel = getStyleLabel(root);
    var attempts = getGenerationAttemptsTotal(state);
    var includedTotal = Math.max(1, parseInt(state.includedGenerationsTotal, 10) || GENERATION_INCLUDED_TOTAL);
    var remaining = state.generationEntitlementsVerified && Number.isInteger(state.includedGenerationsRemaining)
      ? Math.max(0, state.includedGenerationsRemaining)
      : Math.max(0, includedTotal - attempts);
    var creditBalance = Math.max(0, parseInt(state.creditBalance, 10) || 0);
    var canGenerate = remaining > 0 || creditBalance > 0;
    var generated = !!state.generatedStyles[style];
    var count = qs(root, '[data-sticker-generation-count]');
    var status = qs(root, '[data-sticker-generation-status]');
    var button = qs(root, '[data-sticker-action="generate-style"]');
    var error = qs(root, '[data-sticker-error="generation"]');
    var previewStatus = qs(root, '[data-sticker-preview-status]');
    var preview = qs(root, '[data-sticker-preview]');
    var property = qs(root, '[data-sticker-generation-property]');
    var idProperty = qs(root, '[data-sticker-generation-id-property]');
    var numgenProperty = qs(root, '[data-sticker-numgen-property]');
    var imageProperty = qs(root, '[data-sticker-generation-image-property]');
    var clientPdfProperty = qs(root, '[data-sticker-client-pdf-property]');
    var printPdfProperty = qs(root, '[data-sticker-print-pdf-property]');
    var stableProperty = qs(root, '[data-sticker-stable-generation-property]');
    var stableIdProperty = qs(root, '[data-sticker-stable-generation-id-property]');
    var stableImageProperty = qs(root, '[data-sticker-stable-generation-image-property]');
    var stableClientPdfProperty = qs(root, '[data-sticker-stable-client-pdf-property]');
    var stablePrintPdfProperty = qs(root, '[data-sticker-stable-print-pdf-property]');
    var selected = getSelectedGeneration(root);

    if (count) {
      if (remaining > 0) {
        count.textContent = translate(root, remaining === 1 ? 'includedRemainingOne' : 'includedRemainingOther', { count: remaining }) +
          (creditBalance > 0 ? ' + ' + translate(root, creditBalance === 1 ? 'creditOne' : 'creditOther', { count: creditBalance }) : '');
      } else {
        count.textContent = translate(root, creditBalance === 1 ? 'creditAvailableOne' : 'creditAvailableOther', { count: creditBalance });
      }
    }

    if (state.isGenerating) {
      if (button) {
        button.disabled = true;
        button.textContent = state.generationStatus === GENERATION_STATUS.QUEUED
          ? translate(root, 'generationQueued')
          : translate(root, 'generationProcessing');
      }
      if (status) {
        status.textContent = state.generationStatus === GENERATION_STATUS.QUEUED
          ? translate(root, 'requestQueuedForStyle', { style: styleLabel })
          : translate(root, 'creatingForStyle', { style: styleLabel });
      }
    } else if (state.generationStatus === GENERATION_STATUS.FAILED) {
      if (button) {
        button.disabled = state.generationEntitlementsVerified === false;
        button.textContent = translate(root, 'newGenerationAfterFailure');
      }
      if (status) status.textContent = translate(root, 'generationFailedDetail');
    } else if (!canGenerate) {
      if (button) {
        button.disabled = true;
        button.textContent = translate(root, 'limitReached');
      }
      if (status) status.innerHTML = generationCreditMessageHtml(root);
    } else {
      if (button) {
        button.disabled = false;
        button.textContent = generated ? translate(root, 'generateAgain') : translate(root, 'generateAvatar');
      }
      if (status) {
        status.textContent = generated
          ? translate(root, 'imageReadyForStyle', { style: styleLabel })
          : translate(root, 'noAvatarForStyle', { style: styleLabel });
      }
    }

    if (state.generationStatus !== GENERATION_STATUS.IDLE) {
      updateGenerationProgress(root, state.generationStatus);
    }

    if (status && generated && !state.isGenerating && state.generationStatus !== GENERATION_STATUS.FAILED) {
      status.textContent = translate(root, 'chooseAvatar');
    }

    if (error && canGenerate && state.generationStatus !== GENERATION_STATUS.FAILED) hideGenerationError(root);
    if (preview) {
      preview.classList.toggle('is-generating', state.isGenerating);
      preview.classList.toggle('has-generated', generated);
    }
    if (previewStatus) {
      previewStatus.hidden = !selected;
      previewStatus.textContent = selected ? translate(root, 'selectedPreviewStatus', { label: getGenerationDisplayLabel(root, selected) }) : '';
    }
    if (property) {
      property.value = getGenerationPropertyValue(root, selected);
    }
    if (idProperty) {
      idProperty.value = selected ? selected.id : '';
    }
    if (numgenProperty) numgenProperty.value = selected ? selected.id : '';
    if (imageProperty) {
      imageProperty.value = selected ? selected.imageUrl || '' : '';
    }
    if (clientPdfProperty) {
      clientPdfProperty.value = selected ? selected.clientPdfUrl || '' : '';
    }
    if (printPdfProperty) {
      printPdfProperty.value = selected ? selected.printPdfUrl || '' : '';
    }
    if (stableProperty) stableProperty.value = getGenerationPropertyValue(root, selected);
    if (stableIdProperty) stableIdProperty.value = selected ? selected.id : '';
    if (stableImageProperty) stableImageProperty.value = selected ? selected.imageUrl || '' : '';
    if (stableClientPdfProperty) stableClientPdfProperty.value = selected ? selected.clientPdfUrl || '' : '';
    if (stablePrintPdfProperty) stablePrintPdfProperty.value = selected ? selected.printPdfUrl || '' : '';
    updateGenerationPreview(root);
    renderGenerationResults(root);
    syncAssistantResultLoop(root);
    updateConfig(root);
    updatePrimaryAction(root);
  }

  function getTextValue(root, position) {
    var input = qs(root, '[data-sticker-text="' + position + '"]');
    if (hasNoTextChoice(root, position)) return '';
    return input ? (input.value || '').trim().toUpperCase() : '';
  }

  function getUnicodeCharacters(value) {
    var text = String(value || '');
    var segmenter;

    if (window.Intl && typeof window.Intl.Segmenter === 'function') {
      segmenter = new window.Intl.Segmenter(undefined, { granularity: 'grapheme' });
      return Array.from(segmenter.segment(text), function (entry) { return entry.segment; });
    }
    return Array.from(text);
  }

  function normalizeStickerText(value, maxChars) {
    return getUnicodeCharacters(String(value || '').toUpperCase()).slice(0, maxChars).join('');
  }

  function syncGuidedTextStep(root) {
    var maxChars = parseInt(root.getAttribute('data-max-chars'), 10) || 26;
    var notProvided = translate(root, 'notProvided');
    var noText = translate(root, 'noText');

    ['top', 'bottom'].forEach(function (position) {
      var input = qs(root, '[data-sticker-guided-text="' + position + '"]');
      var count = qs(root, '[data-sticker-guided-count="' + position + '"]');
      var summary = qs(root, '[data-sticker-guided-text-summary="' + position + '"]');
      var withoutText = hasNoTextChoice(root, position);
      var value = getTextValue(root, position);
      var summaryKey = position === 'top' ? 'topTextSummary' : 'bottomTextSummary';

      if (input && input.value !== value) input.value = value;
      if (count) count.textContent = String(Math.min(getUnicodeCharacters(value).length, maxChars));
      if (summary) {
        summary.textContent = translate(root, summaryKey, {
          value: withoutText ? noText : value || notProvided
        });
      }
    });
  }

  function getCurrentPhoto(root) {
    var input = qs(root, '[data-sticker-photo-input]');
    return root._stickerPhotoFile || (input && input.files && input.files[0] ? input.files[0] : null);
  }

  function getMinimumIntakeStatus(state, photoAvailable) {
    var validatedChoices = state && state.validatedAssistantChoices || {};
    return {
      style: !!(validatedChoices.style && state.style),
      color: !!(validatedChoices.color && state.tryonColor),
      photo: !!photoAvailable
    };
  }

  function getMissingMinimumInputs(status) {
    return GUIDED_MINIMUM_INPUTS.filter(function (name) {
      return !status[name];
    });
  }

  function isGuidedExperienceEnabled(root) {
    var config = window.ClairatierGuidedAssistantConfig;
    return root && root.getAttribute('data-sticker-guided-enabled') !== 'false' &&
      (!config || config.enabled !== false);
  }

  function getAssistantShellState(enabled, requestedExperience, previewMode) {
    var guided = !!enabled && requestedExperience !== 'full';
    return {
      experience: guided ? 'guided' : 'full',
      assistantHidden: !guided,
      fullOptionsHidden: guided,
      previewMode: guided && previewMode === 'shelf' ? 'shelf' : 'foreground'
    };
  }

  var LOCAL_JOURNEY_STEPS = ['avatar', 'style', 'color', 'text-top', 'text-bottom', 'background', 'sun', 'fade', 'avatar-fade'];

  function localJourneyEnabled(root) {
    return !!root && root.getAttribute('data-sticker-local-guidance-enabled') === 'true' && isMiaPrivatePilotReady(root);
  }

  function localCopy(root, key, variables) {
    var messages = getTranslations(root).messages || {};
    if (key.indexOf('wardrobeOutfits.') === 0) {
      return formatTranslation((messages.journeyWardrobeOutfits || {})[key.slice('wardrobeOutfits.'.length)] || '', variables);
    }
    if (key.indexOf('wardrobeColorNames.') === 0) {
      return formatTranslation((messages.journeyWardrobeColorNames || {})[key.slice('wardrobeColorNames.'.length)] || '', variables);
    }
    var copy = formatTranslation(messages['journey' + key.charAt(0).toUpperCase() + key.slice(1)] || '', variables);
    if (root._stickerState && root._stickerState.approvedAvatarId !== 'mia' && ['nameMum', 'nameDad', 'nameFamily', 'textBottomMia', 'modeTitle', 'mode'].indexOf(key) !== -1) {
      var name = root._stickerState.approvedAvatarId || 'mia'; name = name.charAt(0).toUpperCase() + name.slice(1);
      copy = copy.replace(/Mia/g, name).replace(/MIA/g, name.toUpperCase());
    }
    return copy.replace(/&(?:amp;)+/g, '&');
  }

  function getLocalJourney(root) {
    var state = root._stickerState;
    if (!state.localJourney) state.localJourney = { index: 0, completed: [], review: false, options: false, chat: false, chatExpanded: false, quantity: 1, drafts: [], editing: null };
    return state.localJourney;
  }

  function getLocalSessionKey(root) {
    var product = root.getAttribute('data-product-id') || root.getAttribute('data-product-handle') || 'product';
    var theme = window.Shopify && window.Shopify.theme && window.Shopify.theme.id || 'default';
    return 'clairatier:local-journey:v1:' + encodeURIComponent(String(theme)) + ':' + encodeURIComponent(product);
  }

  // Only local design choices belong here. Never serialize the state object,
  // generated results, photographs, conversation, credentials or asset URLs.
  function normalizeLocalSession(root, source, catalogSlot) {
    if (!source || source.version !== 1 || !source.choices || typeof source.choices !== 'object' || Array.isArray(source.choices) ||
        !source.text || typeof source.text.top !== 'string' || typeof source.text.bottom !== 'string') return null;
    var choices = {};
    ['avatar', 'style', 'mode', 'accessory', 'hair', 'garment', 'color', 'background', 'fade'].forEach(function (category) {
      var value = source.choices[category];
      if (typeof value !== 'string' || category === 'avatar' && value === 'photo') return;
      var controls = qsa(root, '[data-mia-choice="' + category + '"]' + (category === 'fade' ? ' option' : ''));
      if (controls.some(function (control) { return control.value === value && (catalogSlot || !control.disabled); })) choices[category] = value;
    });
    if (!choices.style) return null;
    if (typeof castPreviewEnabled === 'function' && castPreviewEnabled(root)) {
      if (source.choices.avatar && !choices.avatar) return null;
      if (/^cast-/.test(source.choices.garment || '') && !getCastPreviewEntry(root, choices.avatar, choices.style, choices.garment)) return null;
      if (choices.avatar && ['mia', 'clara'].indexOf(choices.avatar) < 0 && !getCastPreviewEntry(root, choices.avatar, choices.style, choices.garment)) return null;
    }
    if (/^cast-custom-/.test(source.choices.hair || source.choices.accessory || '')) {
      var customState = { subjectSource: 'approved-avatar', approvedAvatarId: choices.avatar, style: choices.style, approvedAvatarGarmentId: choices.garment, approvedAvatarHairstyleId: choices.hair || '', selectedAccessoryId: choices.accessory || '', presentationMode: choices.mode === 'incognito' ? 'incognito' : 'standard' };
      if (!getCastCustomizationEntry(root, customState)) return null;
    }
    var savedGarment = qsa(root, '[data-mia-choice="garment"]').find(function (control) { return control.value === choices.garment; });
    if (savedGarment && savedGarment.getAttribute('data-garment-style') && savedGarment.getAttribute('data-garment-style') !== choices.style &&
        !(choices.avatar !== 'clara' && choices.garment === 'garment-yoke-blouse-dress')) delete choices.garment;
    var position = LOCAL_JOURNEY_STEPS.indexOf(source.step === 'garment' ? 'color' : source.step);
    var completed = Array.isArray(source.completed) ? LOCAL_JOURNEY_STEPS.filter(function (step) { return source.completed.indexOf(step) !== -1; }) : [];
    // Legacy reviewed designs keep their original appearance with the new option off.
    if (source.sun === undefined && source.review === true && completed.length === LOCAL_JOURNEY_STEPS.length - 1) completed.push('sun');
    if (source.sun !== undefined && typeof source.sun !== 'boolean') return null;
    var record = {
      sun: source.sun === true,
      version: 1, choices: choices, step: LOCAL_JOURNEY_STEPS[Math.max(0, position)], completed: completed,
      review: source.review === true && completed.length === LOCAL_JOURNEY_STEPS.length,
      chat: source.chat === true, chatExpanded: source.chat === true && source.chatExpanded === true,
      options: source.options === true, open: source.open === true,
      quantity: Number.isSafeInteger(source.quantity) && source.quantity > 0 ? source.quantity : 1,
      text: {}, transforms: {}, palette: {}, whiteBacking: {},
      name: typeof source.name === 'string' ? source.name.slice(0, 80) : ''
    };
    ['top', 'bottom'].forEach(function (position) {
      if (source.text && typeof source.text[position] === 'string') record.text[position] = normalizeStickerText(source.text[position], 26);
    });
    record.symbol = firstLocalCharacter(typeof source.symbol === 'string' ? source.symbol : '');
    record.palette.textColor = normalizeTextColor(source.palette && source.palette.textColor);
    var bounds = { photoScale: [0.75, 1.2, 1], photoX: [-48, 48, 0], photoY: [-48, 48, 0], topSize: [20, 106, 78], bottomSize: [20, 106, 78], avatarBottomFade: [0, 24, 0] };
    Object.keys(bounds).forEach(function (key) {
      var value = source.transforms && source.transforms[key];
      record.transforms[key] = typeof value === 'number' && Number.isFinite(value) ? clamp(value, bounds[key][0], bounds[key][1]) : bounds[key][2];
    });
    ['topSizeRequest', 'bottomSizeRequest'].forEach(function (key) {
      var value = source.transforms && source.transforms[key];
      if (typeof value === 'number' && Number.isFinite(value)) record.transforms[key] = clamp(value, 20, 106);
    });
    record.transforms.backgroundTransform = normalizeBackgroundTransform(source.transforms && source.transforms.backgroundTransform);
    ['requestedPrimaryColor', 'requestedSecondaryColor', 'requestedAccentColor', 'requestedFinishColor'].forEach(function (key) {
      var value = source.palette && source.palette[key];
      if (typeof value === 'string' && /^(#[0-9a-f]{6})?$/i.test(value)) record.palette[key] = value;
    });
    record.palette.wardrobeFamily = source.palette && ['all', 'blue', 'green', 'teal', 'pink', 'purple', 'red', 'coral', 'yellow', 'neutral', 'dark'].indexOf(source.palette.wardrobeFamily) >= 0 ? source.palette.wardrobeFamily : 'all';
    record.palette.wardrobeAudience = source.palette && ['girl', 'boy', 'all'].indexOf(source.palette.wardrobeAudience) >= 0 ? source.palette.wardrobeAudience : 'girl';
    record.palette.wardrobePaletteMode = source.palette && source.palette.wardrobePaletteMode === 'custom' ? 'custom' : 'catalog';
    record.palette.wardrobeStage = source.palette && source.palette.wardrobeStage === 'colors' ? 'colors' : 'outfit';
    record.palette.wardrobeEditing = source.palette && source.palette.wardrobeEditing === true;
    record.palette.wardrobePaletteEdited = source.palette && source.palette.wardrobePaletteEdited === true;
    var customColors = source.palette && source.palette.wardrobeCustomColors;
    if (customColors && typeof customColors === 'object') {
      record.palette.wardrobeCustomColors = {};
      ['primary', 'secondary', 'accent', 'finish'].forEach(function (key) {
        if (typeof customColors[key] === 'string' && /^#[0-9a-f]{6}$/i.test(customColors[key])) record.palette.wardrobeCustomColors[key] = customColors[key].toUpperCase();
      });
      if (!record.palette.wardrobeCustomColors.primary) delete record.palette.wardrobeCustomColors;
    }
    record.palette.wardrobePaletteValidated = source.palette && source.palette.wardrobePaletteValidated === true;
    record.palette.wardrobeChosenColorRoles = {};
    var chosenColorRoles = source.palette && source.palette.wardrobeChosenColorRoles;
    if (chosenColorRoles && typeof chosenColorRoles === 'object') {
      ['primary', 'secondary', 'accent', 'finish'].forEach(function (key) {
        if (chosenColorRoles[key] === true) record.palette.wardrobeChosenColorRoles[key] = true;
      });
    }
    var paletteSource = source.palette && source.palette.approvedAvatarPaletteSource;
    if (['predefined', 'custom', 'catalog'].indexOf(paletteSource) !== -1) record.palette.approvedAvatarPaletteSource = paletteSource;
    var backing = source.whiteBacking || {};
    ['enabled', 'topText', 'bottomText', 'avatar', 'brand', 'badge'].forEach(function (key) { record.whiteBacking[key] = key === 'enabled' ? backing[key] === true : backing[key] !== false; });
    record.whiteBacking.style = ['band', 'outline', 'bold', 'soft', 'offset', 'double', 'fine', 'cushion', 'glow', 'lifted', 'triple'].indexOf(backing.style) !== -1 ? backing.style : 'glow';
    record.previewBackground = false;
    record.proofAvatars = normalizeMultiAvatarSlots(root, source.proofAvatars);
    record.proofActiveAvatar = Number.isInteger(source.proofActiveAvatar) ? clamp(source.proofActiveAvatar, 0, Math.max(0, record.proofAvatars.length - 1)) : 0;
    // A shared catalog background belongs to the composition, not the active slot.
    if (!catalogSlot && record.proofAvatars.length > 1) {
      var sharedBackground = qsa(root, '[data-mia-choice="background"]').find(function (control) { return control.value === source.choices.background; });
      var backgroundStyle = sharedBackground && sharedBackground.getAttribute('data-background-style');
      if (sharedBackground && (!backgroundStyle || record.proofAvatars.some(function (slot) { return slot.state.style === backgroundStyle; }))) {
        record.choices.background = sharedBackground.value;
        var sharedFade = qsa(root, '[data-mia-choice="fade"] option').find(function (control) { return control.value === source.choices.fade; });
        if (sharedFade) record.choices.fade = sharedFade.value;
      }
    }
    return record;
  }

  function persistLocalSession(root) {
    if (!root._localSessionReady || root._localSessionRestoring || root._localResetting || !localJourneyEnabled(root)) return;
    var state = root._stickerState;
    if (state.subjectSource === 'photo') return;
    var journey = getLocalJourney(root);
    var choices = {};
    ['avatar', 'style', 'mode', 'accessory', 'hair', 'garment', 'color', 'background'].forEach(function (category) {
      var selected = getMiaSelected(root, category);
      if (selected) choices[category] = selected.value;
    });
    var fade = qs(root, '[data-mia-choice="fade"]');
    if (fade) choices.fade = fade.value;
    var overlay = qs(root, '[data-sticker-overlay]');
    var name = qs(root, '[data-local-design-name]');
    var record = normalizeLocalSession(root, {
      version: 1, choices: choices, step: LOCAL_JOURNEY_STEPS[journey.index], completed: journey.completed,
      review: journey.review, options: journey.options, chat: journey.chat, chatExpanded: journey.chatExpanded,
      sun: state.sunEnabled === true, previewBackground: false, quantity: journey.quantity,
      open: !!overlay && !overlay.hidden, name: name ? name.value : '',
      text: { top: getTextValue(root, 'top'), bottom: getTextValue(root, 'bottom') }, symbol: state.symbol,
      transforms: { photoScale: state.photoScale, photoX: state.photoX, photoY: state.photoY, topSize: state.topSize, bottomSize: state.bottomSize, topSizeRequest: state.topSizeRequest, bottomSizeRequest: state.bottomSizeRequest, avatarBottomFade: state.avatarBottomFade, backgroundTransform: state.backgroundTransform },
      palette: { wardrobeCustomColors: state.wardrobeCustomColors, wardrobeFamily: state.wardrobeFamily, wardrobeAudience: state.wardrobeAudience, wardrobePaletteMode: state.wardrobePaletteMode, wardrobeStage: state.wardrobeStage, wardrobeEditing: state.wardrobeEditing, wardrobeChosenColorRoles: state.wardrobeChosenColorRoles, wardrobePaletteEdited: state.wardrobePaletteEdited, wardrobePaletteValidated: state.wardrobePaletteValidated, requestedFinishColor: state.requestedFinishColor, requestedPrimaryColor: state.requestedPrimaryColor, requestedSecondaryColor: state.requestedSecondaryColor, requestedAccentColor: state.requestedAccentColor, approvedAvatarPaletteSource: state.approvedAvatarPaletteSource },
      whiteBacking: getLocalWhiteBacking(root), proofAvatars: state.proofAvatars, proofActiveAvatar: state.proofActiveAvatar
    });
    // Synchronization can briefly disable choices while changing character/style.
    // Keep the last complete session until the new tuple is consistent.
    if (!record) return;
    record.palette.textColor = normalizeTextColor(state.textColor);
    try { if (!root._localReadonlyPreview) window.sessionStorage.setItem(getLocalSessionKey(root), JSON.stringify(record)); } catch (error) {}
    return record;
  }

  function readLocalSession(root) {
    if (root._browserReplaySession) return normalizeLocalSession(root, root._browserReplaySession);
    if (root._localReadonlyPreview) return null;
    if (root._browserRecipeInvalid) return null;
    try {
      var stored = window.sessionStorage.getItem(getLocalSessionKey(root));
      if (!stored || stored.length > 16000) return null;
      return normalizeLocalSession(root, JSON.parse(stored));
    } catch (error) { return null; }
  }

  function restoreLocalSession(root, savedRecord) {
    var record = savedRecord || readLocalSession(root);
    if (!record) return false;
    root._localSessionRestoring = true;
    try {
      var state = root._stickerState;
      state.proofAvatars = record.proofAvatars; state.proofActiveAvatar = record.proofActiveAvatar;
      Object.keys(record.choices).forEach(function (category) {
        qsa(root, '[data-mia-choice="' + category + '"]').forEach(function (control) {
          if (category === 'fade') control.value = record.choices[category];
          else control.checked = control.value === record.choices[category];
        });
      });
      syncMiaRuntimeChoices(root, '');
      var selectedStyle = getMiaSelected(root, 'style');
      if (selectedStyle) root._stickerLastHonestPreviewAsset = selectedStyle.getAttribute('data-preview-' + (state.presentationMode || 'standard')) || '';
      delete state.topSizeRequest; delete state.bottomSizeRequest;
      Object.assign(state, record.transforms, record.palette);
      state.wardrobeCustomColors = state.wardrobeCustomColors || { primary: state.requestedPrimaryColor || '#16233F' };
      state.whiteBacking = record.whiteBacking;
      state.sunEnabled = record.sun === true;
      syncSunPreview(root);
      ['top', 'bottom'].forEach(function (position) {
        if (Object.prototype.hasOwnProperty.call(record.text, position)) applyLocalChoice(root, 'text-' + position, record.text[position]);
      });
      applyLocalChoice(root, 'symbol', record.symbol);
      var journey = getLocalJourney(root);
      Object.assign(journey, { index: LOCAL_JOURNEY_STEPS.indexOf(record.step), completed: record.completed, review: record.review, options: record.options, chat: record.chat, chatExpanded: record.chatExpanded, quantity: record.quantity });
      state.previewBackground = false;
      state.validatedAssistantChoices.style = record.completed.indexOf('style') !== -1;
      state.validatedAssistantChoices.color = record.completed.indexOf('color') !== -1;
      var name = qs(root, '[data-local-design-name]');
      if (name) name.value = record.name;
      root._localDefaultsApplied = true;
      updatePhoto(root);
      updateSize(root, 'top'); updateSize(root, 'bottom');
      syncAssistantHonestPreview(root);
      if (record.open) {
        var overlay = qs(root, '[data-sticker-overlay]');
        if (overlay) {
          setFieldsEnabled(root, true);
          overlay.hidden = false;
          overlay.setAttribute('aria-hidden', 'false');
          document.body.classList.add('sticker-customizer-open');
          syncAssistantVisualViewport(root);
        }
      }
      return true;
    } finally { root._localSessionRestoring = false; }
  }

  function advanceLocalJourney(journey) {
    var step = LOCAL_JOURNEY_STEPS[journey.index];
    if (journey.completed.indexOf(step) === -1) journey.completed.push(step);
    if (journey.index < LOCAL_JOURNEY_STEPS.length - 1) journey.index += 1;
    else {
      var missing = LOCAL_JOURNEY_STEPS.findIndex(function (entry) { return journey.completed.indexOf(entry) === -1; });
      if (missing === -1) journey.review = true;
      else journey.index = missing;
    }
    journey.options = false;
    return journey;
  }

  function canReviewLocalJourney(journey) {
    return journey.index === LOCAL_JOURNEY_STEPS.length - 1 && LOCAL_JOURNEY_STEPS.slice(0, -1).every(function (step) { return journey.completed.indexOf(step) !== -1; });
  }

  function getLocalGuidanceContext(root) {
    var journey = getLocalJourney(root);
    return { mode: 'deterministic-v1', currentStep: journey.review ? 'complete' : LOCAL_JOURNEY_STEPS[journey.index], completedSteps: journey.completed.slice() };
  }

  function localTitle(root, step) {
    return localCopy(root, step === 'text-top' ? 'textTop' : step === 'text-bottom' ? 'textBottom' : step === 'avatar-fade' ? 'avatarFade' : step);
  }

  function createLocalButton(root, text, attribute, value) {
    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = text;
    button.setAttribute(attribute, value);
    return button;
  }

  function localExactAvatar(root) {
    var state = root._stickerState;
    if (state.subjectSource !== 'approved-avatar') return false;
    if (typeof getMiaExactChoiceAsset === 'function') return !!getMiaExactChoiceAsset(root);
    return !state.approvedAvatarHairstyleId && state.approvedAvatarGarmentId === 'garment-yoke-blouse-dress' &&
      (!state.symbol || state.symbolChoice === 'no') && (!getMiaSelected(root, 'color') || getMiaSelected(root, 'color').value === 'original');
  }

  function localPending(root) {
    if (root._stickerState.proofAvatars && root._stickerState.proofAvatars.length > 1 &&
        root._stickerState.proofAvatars.some(function (slot) { return !slot.asset; })) return true;
    return !localExactAvatar(root) && (!getSelectedGeneration(root) || root._stickerState.assistantHasUngeneratedChanges);
  }

  function localWhiteContentRatio(radius, backing) {
    var outset = Math.SQRT2 * 0.08;
    if (backing) {
      var extent = backing.enabled && backing.avatar && {
        outline: [0.012, 0, 0], bold: [0.028, 0, 0], soft: [0.016, 0.006, 0],
        offset: [0.016, 0, Math.SQRT2 * 0.025], double: [0.035, 0, 0],
        fine: [0.006, 0, 0], cushion: [0.045, 0, 0], glow: [0.012, 0.014, 0],
        lifted: [0.016, 0, 0.03], triple: [0.046, 0, 0]
      }[backing.style];
      outset = extent ? Math.max(0.02, Math.SQRT2 * extent[0] + 3 * (extent[1] + 0.0015) + extent[2]) : 0.02;
    }
    return Math.min(2, 1 / (2 * (radius + outset)));
  }

  function measureLocalAlpha(pixels, side) {
    var transparent = false;
    var radius = 0;
    var occupied = false;
    var minX = side, minY = side, maxX = -1, maxY = -1;
    var bands = [];
    for (var i = 0; i < pixels.length; i += 4) {
      if (pixels[i + 3] < 255) transparent = true;
      if (!pixels[i + 3]) continue;
      occupied = true;
      var x = (i / 4) % side;
      var y = Math.floor(i / 4 / side);
      var bandIndex = Math.floor(y / 4);
      var band = bands[bandIndex] || (bands[bandIndex] = { minX: side, maxX: -1, minY: y, maxY: y });
      band.minX = Math.min(band.minX, x); band.maxX = Math.max(band.maxX, x); band.maxY = y;
      minX = Math.min(minX, x); minY = Math.min(minY, y);
      maxX = Math.max(maxX, x); maxY = Math.max(maxY, y);
      radius = Math.max(radius, Math.hypot((x + 0.5) / side - 0.5, (y + 0.5) / side - 0.5));
    }
    // Four-row unions preserve the existing alpha padding with a bounded profile.
    var rows = bands.filter(Boolean).map(function (band) {
      return { left: Math.max(0, (band.minX - 2) / side), right: Math.min(1, (band.maxX + 3) / side),
        top: Math.max(0, (band.minY - 2) / side), bottom: Math.min(1, (band.maxY + 3) / side) };
    });
    return { transparent: transparent, rows: rows, radius: occupied ? Math.min(Math.SQRT1_2, radius + Math.SQRT2 / side) : Math.SQRT1_2,
      bounds: occupied ? { left: Math.max(0, (minX - 2) / side), top: Math.max(0, (minY - 2) / side),
        right: Math.min(1, (maxX + 3) / side), bottom: Math.min(1, (maxY + 3) / side) } : { left: 0, top: 0, right: 1, bottom: 1 } };
  }

  function localImageAlpha(root, element) {
    var source = element.currentSrc || element.getAttribute('src');
    var fallback = { transparent: false, radius: Math.SQRT1_2 };
    if (!source) return fallback;
    var cache = root._localAlphaCache || (root._localAlphaCache = Object.create(null));
    if (Object.prototype.hasOwnProperty.call(cache, source)) return cache[source];
    cache[source] = fallback;
    var alphaResolve;
    var alphaPromises = root._localAlphaPromises || (root._localAlphaPromises = Object.create(null));
    alphaPromises[source] = new Promise(function (resolve) { alphaResolve = resolve; });
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var side = 96;
        var canvas = document.createElement('canvas');
        canvas.width = side; canvas.height = side;
        var context = canvas.getContext('2d', { willReadFrequently: true });
        var scale = side / Math.max(probe.naturalWidth, probe.naturalHeight);
        var width = probe.naturalWidth * scale;
        var height = probe.naturalHeight * scale;
        context.drawImage(probe, (side - width) / 2, (side - height) / 2, width, height);
        cache[source] = measureLocalAlpha(context.getImageData(0, 0, side, side).data, side);
        if (width < side || height < side) {
          var sourceCanvas = document.createElement('canvas');
          sourceCanvas.width = side; sourceCanvas.height = side;
          var sourceContext = sourceCanvas.getContext('2d', { willReadFrequently: true });
          sourceContext.drawImage(probe, 0, 0, side, side);
          cache[source].transparent = measureLocalAlpha(sourceContext.getImageData(0, 0, side, side).data, side).transparent;
        }
        if (!cache[source].transparent) cache[source].radius = Math.SQRT1_2;
      } catch (error) { cache[source] = fallback; }
      updatePhoto(root);
      alphaResolve();
    };
    probe.onerror = function () { cache[source] = fallback; alphaResolve(); };
    probe.src = source;
    return fallback;
  }

  function localWhiteFilter(root, style, layer, size) {
    var svg = qs(root, '[data-local-finish-filters]');
    if (!svg) {
      svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('data-local-finish-filters', '');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.cssText = 'position:absolute;width:0;height:0;pointer-events:none';
      root.appendChild(svg);
    }
    var id = root.id + '-finish-' + layer + '-' + style + '-' + String(size).replace('.', '-');
    var filter = qs(svg, '[id="' + id + '"]');
    if (!filter) {
      filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
      filter.id = id; svg.appendChild(filter);
    }
    filter.setAttribute('x', '-30%'); filter.setAttribute('y', '-30%');
    filter.setAttribute('width', '160%'); filter.setAttribute('height', '160%');
    filter.setAttribute('color-interpolation-filters', 'sRGB');
    filter.setAttribute('primitiveUnits', layer === 'avatar' ? 'objectBoundingBox' : 'userSpaceOnUse');
    var unit = layer === 'avatar' ? 1 : size;
    var avatar = layer === 'avatar';
    var preset = avatar ? { outline: [0.012], bold: [0.028], soft: [0.016, 0.006], offset: [0.016, 0.025], double: [0.035, 0.022, 0.009], fine: [0.006], cushion: [0.045], glow: [0.012, 0.014], lifted: [0.016, -0.03], triple: [0.046, 0.036, 0.027, 0.019, 0.008] }[style] : { outline: [0.09], bold: [0.19], soft: [0.11, 0.03], offset: [0.11, 0.09], double: [0.23, 0.15, 0.06], fine: [0.045], cushion: [0.27], glow: [0.08, 0.08], lifted: [0.11, -0.12], triple: [0.30, 0.24, 0.18, 0.12, 0.05] }[style];
    var radius = preset[0] * unit;
    var shape = '<feMorphology in="SourceAlpha" operator="dilate" radius="' + radius + '" result="outer"/>';
    if (style === 'soft' || style === 'glow') shape += '<feGaussianBlur in="outer" stdDeviation="' + (unit * preset[1]) + '" result="outer"/>';
    if (style === 'offset') shape += '<feOffset in="outer" dx="' + (unit * preset[1]) + '" dy="' + (unit * preset[1]) + '" result="outer"/>';
    if (style === 'double') shape += '<feMorphology in="SourceAlpha" operator="dilate" radius="' + (unit * preset[1]) + '" result="gap"/><feComposite in="outer" in2="gap" operator="out" result="ring"/><feMorphology in="SourceAlpha" operator="dilate" radius="' + (unit * preset[2]) + '" result="inner"/><feComposite in="ring" in2="inner" operator="over" result="outer"/>';
    if (style === 'lifted') shape += '<feOffset in="outer" dx="0" dy="' + (unit * preset[1]) + '" result="outer"/>';
    if (style === 'triple') {
      shape += '<feMorphology in="SourceAlpha" operator="dilate" radius="' + (unit * preset[1]) + '" result="gap1"/><feComposite in="outer" in2="gap1" operator="out" result="ring1"/>';
      shape += '<feMorphology in="SourceAlpha" operator="dilate" radius="' + (unit * preset[2]) + '" result="middle"/><feMorphology in="SourceAlpha" operator="dilate" radius="' + (unit * preset[3]) + '" result="gap2"/><feComposite in="middle" in2="gap2" operator="out" result="ring2"/>';
      shape += '<feMorphology in="SourceAlpha" operator="dilate" radius="' + (unit * preset[4]) + '" result="core"/><feMerge result="outer"><feMergeNode in="ring1"/><feMergeNode in="ring2"/><feMergeNode in="core"/></feMerge>';
    }
    // Smooth only the white silhouette. Keep the source image and letters sharp.
    shape += '<feGaussianBlur in="outer" stdDeviation="' + (unit * (avatar ? 0.0015 : 0.01)) + '" result="outer"/>';
    filter.innerHTML = shape + '<feFlood flood-color="white"/><feComposite in2="outer" operator="in"/><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>';
    return 'url(#' + id + ')';
  }

  function setLocalChatMode(root, mode) {
    var journey = getLocalJourney(root);
    journey.chat = mode !== 'compact';
    journey.chatExpanded = mode === 'expanded';
    journey.options = false;
    root.classList.remove('is-local-settings', 'is-preview-large');
    root._stickerState.guidedPreviewMode = 'shelf';
    qs(root, '[data-local-targets]').hidden = true;
    qs(root, '[data-local-transforms]').hidden = true;
    qs(root, '[data-local-action="settings"]').setAttribute('aria-expanded', 'false');
    renderLocalJourney(root);
  }

  function setLocalChatExpanded(root, expanded) {
    var journey = getLocalJourney(root);
    journey.chat = !!expanded;
    journey.chatExpanded = false;
    journey.options = false;
    root.classList.remove('is-local-settings', 'is-preview-large');
    root._stickerState.guidedPreviewMode = 'shelf';
    qs(root, '[data-local-targets]').hidden = true;
    qs(root, '[data-local-transforms]').hidden = true;
    qs(root, '[data-local-action="settings"]').setAttribute('aria-expanded', 'false');
    renderLocalJourney(root);
  }

  function focusLocalPreviewTarget(root, target) {
    window.clearTimeout(root._localFocusTimer);
    root.setAttribute('data-local-focus-target', target);
    root._localFocusTimer = window.setTimeout(function () {
      root.removeAttribute('data-local-focus-target');
    }, 2800);
  }

  function syncLocalTextBacking(root) {
    if (!localJourneyEnabled(root)) return;
    var config = getLocalWhiteBacking(root);
    ['top', 'bottom'].forEach(function (position) {
      var present = !hasNoTextChoice(root, position) && !!getTextValue(root, position).trim();
      var backing = qs(root, '[data-local-backing="' + position + '"]');
      var text = qs(root, '[data-sticker-preview-text="' + position + '"]');
      if (backing) backing.style.display = 'none';
      if (backing) backing.removeAttribute('hidden');
      if (text && !present) text.textContent = '';
      if (text && present) fitLocalText(root, position, text);
      else if (root._stickerState && root._stickerState.localTextOverflow) root._stickerState.localTextOverflow[position] = false;
      if (!present && typeof syncLocalTextSizeControls === 'function') syncLocalTextSizeControls(root, position);
    });
    var fade = qs(root, '[data-sticker-fade-preview]');
    if (fade) fade.style.display = 'none';
    var group = qs(root, '.sticker-customizer__local-text-backing');
    if (group) group.style.display = 'none';
    ['top', 'bottom', 'brand'].forEach(function (position) {
      var original = qs(root, position === 'brand' ? '.sticker-customizer__brand-text' : '.sticker-customizer__text--' + position);
      if (!original) return;
      var clone = qs(root, '[data-local-text-halo="' + position + '"]');
      if (!clone) {
        clone = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        clone.setAttribute('data-local-text-halo', position);
        original.parentNode.insertBefore(clone, original);
      }
      var source = qs(original, 'textPath');
      var size = position === 'brand' ? 29 : root._stickerState[position === 'top' ? 'topSize' : 'bottomSize'];
      var band = localWhiteBackingBand(position, size, localWhiteBackingTextLength(source ? source.textContent : '', size, position === 'brand' ? 9 : 0), root._stickerState.sunEnabled === true);
      clone.setAttribute('d', band.path);
      clone.style.fill = 'none'; clone.style.stroke = '#fff'; clone.style.strokeWidth = band.strokeWidth + 'px';
      clone.style.strokeLinecap = 'round';
      var present = position === 'brand' || (!hasNoTextChoice(root, position) && !!getTextValue(root, position).trim());
      var active = config.enabled && config[position === 'brand' ? 'brand' : position + 'Text'] && present;
      clone.style.display = active && (!config.style || config.style === 'band') ? '' : 'none';
      if (original.style) original.style.filter = active && config.style && config.style !== 'band' ? localWhiteFilter(root, config.style, position, size) : '';
    });
    var badge = qs(root, '.sticker-customizer__brand-badge-svg');
    if (badge) {
      var badgeBacking = qs(root, '[data-local-badge-halo]');
      if (!badgeBacking) {
        badgeBacking = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        badgeBacking.setAttribute('data-local-badge-halo', '');
        badgeBacking.setAttribute('x', '630'); badgeBacking.setAttribute('y', '758');
        badgeBacking.setAttribute('width', '51'); badgeBacking.setAttribute('height', '54');
        badgeBacking.setAttribute('rx', '12'); badgeBacking.setAttribute('fill', 'white');
        badge.parentNode.insertBefore(badgeBacking, badge);
      }
      badgeBacking.style.display = config.enabled && config.badge && (!config.style || config.style === 'band') ? '' : 'none';
      if (badge.style) badge.style.filter = config.enabled && config.badge && config.style !== 'band' ? localWhiteFilter(root, config.style, 'badge', 15) : '';
    }
    updatePhoto(root);
  }

  function localWhiteBackingTextLength(
    text,
    size,
    spacing = 0,
  ) {
    const widths = [
      722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778,
      667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611,
    ];
    const characters = Array.from(
      text
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, ''),
    );
    return (
      characters.reduce((sum, character) => {
        const code = character.charCodeAt(0) - 65;
        const width =
          code >= 0 && code < 26
            ? widths[code]
            : /[0-9]/.test(character)
              ? 556
              : character === ' '
                ? 278
                : /['’.,:!\-]/.test(character)
                  ? 278
                  : 1000;
        return sum + (width * size) / 1000;
      }, 0) +
      Math.max(0, characters.length - 1) * spacing
    );
  }

  function localWhiteBackingBand(
    position,
    size,
    length,
    eclat,
  ) {
    const isTop = position === 'top';
    const radius =
      (eclat && position !== 'brand' ? 320.3125 : position === 'bottom' ? 290 : 300) + size * (isTop ? 0.36 : -0.36);
    const cy =
      eclat && position !== 'brand' ? position === 'top' ? 538.28125 : 479.6875 : position === 'top' ? 500 : position === 'bottom' ? 475 : 535.1923788646684;
    const half =
      Math.min(Math.PI * 0.92, (Math.max(0, length) + 24) / radius) / 2;
    const middle = isTop ? -Math.PI / 2 : Math.PI / 2;
    const start = middle + (isTop ? -half : half);
    const end = middle + (isTop ? half : -half);
    const round = (value) => Math.round(value * 1000) / 1000;
    return {
      path: `M ${round(500 + radius * Math.cos(start))} ${round(cy + radius * Math.sin(start))} A ${round(radius)} ${round(radius)} 0 0 ${isTop ? 1 : 0} ${round(500 + radius * Math.cos(end))} ${round(cy + radius * Math.sin(end))}`,
      strokeWidth: size + 24,
    };
  }


  function localWhiteBackingGeometry(input, backing, topPresent, bottomPresent) {
    const clamp = (n, min, max) =>
      Math.min(max, Math.max(min, n));
    const finite = (n, fallback) =>
      Number.isFinite(n) ? n : fallback;
    const top = backing.enabled && backing.topText && topPresent ? 250 : 100;
    const bottom =
      backing.enabled && backing.bottomText && bottomPresent ? 678 : 850;
    const left = 240;
    const right = 760;
    const safeCircle =
      backing.enabled && backing.bottomText && bottomPresent
        ? { x: 500, y: 475, radius: 290 - 78 * 0.36 - (78 + 24) / 2 - 12 }
        : backing.enabled && backing.topText && topPresent
          ? { x: 500, y: 500, radius: 300 + 78 * 0.36 - (78 + 24) / 2 - 12 }
          : null;
    const diameter = Math.min(
      460 * clamp(finite(input.imageScale, 1), 0.25, 4),
      right - left,
      bottom - top,
      ...(safeCircle
        ? [
            2 * safeCircle.radius,
            2 * (safeCircle.x - left),
            2 * (right - safeCircle.x),
            2 * (safeCircle.y - top),
            2 * (bottom - safeCircle.y),
          ]
        : []),
    );
    const radius = diameter / 2;
    let centerX = clamp(
      500 + (finite(input.imageOffsetX, 0) * 1000) / 300,
      left + radius,
      right - radius,
    );
    let centerY = clamp(
      460 + (finite(input.imageOffsetY, 0) * 1000) / 300,
      top + radius,
      bottom - radius,
    );
    if (safeCircle) {
      const dx = centerX - safeCircle.x;
      const dy = centerY - safeCircle.y;
      const distance = Math.hypot(dx, dy);
      const allowed = Math.max(0, safeCircle.radius - radius);
      if (distance > allowed) {
        centerX = safeCircle.x + (dx * allowed) / distance;
        centerY = safeCircle.y + (dy * allowed) / distance;
      }
    }
    return {
      imageScale: diameter / 460,
      imageOffsetX: ((centerX - 500) * 300) / 1000,
      imageOffsetY: ((centerY - 460) * 300) / 1000,
      centerX,
      centerY,
      diameter,
      left: centerX - radius,
      top: centerY - radius,
      bounds: { left, right, top, bottom },
    };
  }

  function calculateLocalTextFit(measuredLength, position, requestedSize) {
    var available = Math.PI * (position === 'top' ? 300 : 290) * 0.8;
    if (!(measuredLength > 0)) return null;
    var manual = typeof requestedSize === 'number' && Number.isFinite(requestedSize);
    var size = Math.max(manual ? 20 : 44, Math.min(manual ? clamp(requestedSize, 20, 106) : 78, Math.floor(78 * available / measuredLength)));
    return { size: size, overflow: measuredLength * size / 78 > available + 1 };
  }

  function fitLocalText(root, position, text) {
    if (typeof text.getComputedTextLength !== 'function') return;
    var state = root._stickerState;
    var previous = text.style.fontSize;
    var sun = state.sunEnabled === true;
    var maximum = sun ? (getLocalWhiteBacking(root).enabled ? 60 : 76.5625) : 78;
    text.style.fontSize = maximum + 'px';
    var measured = text.getComputedTextLength();
    var requested = state[position + 'SizeRequest'];
    var manual = typeof requested === 'number' && Number.isFinite(requested);
    var fit = sun ? eclatTextFit(measured, maximum) : calculateLocalTextFit(measured, position, manual ? requested : undefined);
    if (!fit) { text.style.fontSize = previous; return; }
    if (sun && manual) fit.size = Math.min(fit.size, clamp(requested, 20, 106));
    state.localTextSizeLimits = state.localTextSizeLimits || {};
    state.localTextSizeLimits[position] = sun ? eclatTextFit(measured, maximum).size : calculateLocalTextFit(measured, position, 106).size;
    state[position === 'top' ? 'topSize' : 'bottomSize'] = fit.size;
    state.localTextOverflow = state.localTextOverflow || {};
    state.localTextOverflow[position] = fit.overflow;
    if (fit.overflow && state.localJourney) state.localJourney.completed = state.localJourney.completed.filter(function (step) { return step !== 'text-' + position; });
    updateSize(root, position);
  }

  function syncLocalTextSizeControls(root, position) {
    var group = qs(root, '[data-local-text-size="' + position + '"]');
    if (!group) return;
    var state = root._stickerState, size = state[position + 'Size'];
    var limit = state.localTextSizeLimits && state.localTextSizeLimits[position] || 106;
    var disabled = !getTextValue(root, position).trim() || hasNoTextChoice(root, position);
    var slider = qs(group, 'input');
    slider.max = String(Math.max(20, Math.floor(limit)));
    slider.value = String(Math.min(Number(slider.max), Math.round(size)));
    slider.disabled = disabled;
    slider.setAttribute('aria-valuetext', Math.round(size / 78 * 100) + ' %');
    qs(group, 'output').textContent = Math.round(size / 78 * 100) + ' %';
    qsa(group, '[data-local-text-size-step]').forEach(function (button) { button.disabled = disabled || (Number(button.getAttribute('data-local-text-size-step')) < 0 ? size <= 20 : size >= limit - .1); });
  }

  function setLocalTextSize(root, position, value) {
    if (['top', 'bottom'].indexOf(position) < 0 || !Number.isFinite(Number(value))) return false;
    root._stickerState[position + 'SizeRequest'] = clamp(Number(value), 20, 106);
    syncLocalTextBacking(root);
    syncLocalTextSizeControls(root, position);
    updateConfig(root); persistLocalSession(root);
    return true;
  }

  function renderLocalTextSizeControls(root, container, position) {
    var group = document.createElement('fieldset'); group.className = 'sticker-customizer__text-size-controls'; group.setAttribute('data-local-text-size', position);
    var legend = document.createElement('legend'); legend.textContent = localCopy(root, position === 'top' ? 'textSizeTop' : 'textSizeBottom'); group.appendChild(legend);
    var row = document.createElement('div'); row.className = 'sticker-customizer__text-size-row';
    [-1, 1].forEach(function (direction) {
      var button = document.createElement('button'); button.type = 'button'; button.textContent = direction < 0 ? '−' : '+';
      button.setAttribute('data-local-text-size-step', String(direction)); button.setAttribute('data-local-text-size-position', position);
      button.setAttribute('aria-label', localCopy(root, direction < 0 ? 'textSizeReduce' : 'textSizeEnlarge')); row.appendChild(button);
      if (direction < 0) { var output = document.createElement('output'); output.setAttribute('aria-live', 'polite'); row.appendChild(output); }
    }); group.appendChild(row);
    var label = document.createElement('label'); label.className = 'visually-hidden'; label.htmlFor = (root.id || 'sticker') + '-size-' + position; label.textContent = legend.textContent; group.appendChild(label);
    var slider = document.createElement('input'); slider.type = 'range'; slider.min = '20'; slider.max = '106'; slider.step = '1'; slider.id = label.htmlFor; slider.setAttribute('data-local-text-size-input', position); group.appendChild(slider);
    var hint = document.createElement('p'); hint.id = slider.id + '-hint'; hint.textContent = localCopy(root, 'textSizeHint'); slider.setAttribute('aria-describedby', hint.id); group.appendChild(hint);
    container.appendChild(group); syncLocalTextSizeControls(root, position);
  }

  function localTextSuggestions(root, position) {
    var name = String(root._stickerState.approvedAvatarId || 'mia').toUpperCase();
    return Array.from({ length: 10 }, function (_, index) { return localCopy(root, (position === 'top' ? 'textTopSuggestion' : 'textBottomSuggestion') + (index + 1), { name: name }); });
  }

  function renderLocalTextSuggestions(root, container, position, value) {
    var label = document.createElement('label'); label.className = 'sticker-customizer__inspirations'; label.textContent = localCopy(root, 'textInspirations');
    var select = document.createElement('select'); select.setAttribute('data-local-text-suggestions', position);
    var placeholder = document.createElement('option'); placeholder.value = ''; placeholder.disabled = true; placeholder.textContent = localCopy(root, 'textSuggestionPrompt'); select.appendChild(placeholder);
    var none = document.createElement('option'); none.value = '__none__'; none.textContent = localCopy(root, 'noText'); select.appendChild(none);
    localTextSuggestions(root, position).forEach(function (text) { var option = document.createElement('option'); option.value = text; option.textContent = text; select.appendChild(option); });
    select.value = !value ? '__none__' : localTextSuggestions(root, position).indexOf(value) >= 0 ? value : '';
    label.appendChild(select); container.appendChild(label);
  }

  function localChoiceButton(root, container, label, value, selected, card, color) {
    var button = createLocalButton(root, '', 'data-local-choice', value);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    var holder = button;
    if (card) {
      holder = document.createElement('div');
      holder.className = 'sticker-customizer__journey-image-card';
      if (selected) holder.classList.add('is-selected');
      holder.setAttribute('data-local-image-card', '');
      var actions = document.createElement('div');
      actions.className = 'sticker-customizer__journey-image-actions';
      var image = document.createElement('img');
      image.src = card;
      image.alt = typeof getCastAssetDescription === 'function' ? getCastAssetDescription(root, card) : '';
      if (image.alt) button.setAttribute('aria-label', label);
      image.loading = 'lazy';
      button.appendChild(image);
      var enlarge = createLocalButton(root, '⤢', 'data-local-action', 'enlarge-image');
      enlarge.className = 'sticker-customizer__journey-image-enlarge';
      enlarge.setAttribute('data-local-image-src', card);
      enlarge.setAttribute('data-local-image-label', label);
      if (image.alt) enlarge.setAttribute('data-local-image-alt', image.alt);
      enlarge.setAttribute('aria-label', typeof localCopy === 'function' ? localCopy(root, 'enlargeImage', { label: label }) : label);
      if (selected && typeof localPending === 'function' && localPending(root)) {
        var pending = createLocalButton(root, localCopy(root, 'pending'), 'data-local-action', 'preview-help');
        pending.className = 'sticker-customizer__journey-image-pending';
        pending.setAttribute('aria-label', localCopy(root, 'pendingDetails'));
        actions.appendChild(pending);
      }
      actions.appendChild(enlarge);
      holder.appendChild(actions);
      holder.appendChild(button);
    }
    if (color) {
      var swatch = document.createElement('span');
      swatch.className = 'sticker-customizer__local-swatch';
      swatch.style.backgroundColor = color;
      button.appendChild(swatch);
    }
    var title = document.createElement('span');
    title.textContent = label;
    button.appendChild(title);
    container.appendChild(holder);
    return button;
  }

  function appendLocalRetainedImage(root, container, step) {
    if (['photo', 'mode'].indexOf(step) === -1) return;
    var preview = qs(root, '[data-sticker-approved-avatar-preview]');
    var source = root._stickerLastHonestPreviewAsset || preview && (preview.currentSrc || preview.getAttribute('src'));
    if (!source) return;
    var holder = document.createElement('div');
    holder.className = 'sticker-customizer__journey-retained-image sticker-customizer__journey-image-card';
    holder.setAttribute('data-local-image-card', '');
    var actions = document.createElement('div');
    actions.className = 'sticker-customizer__journey-image-actions';
    var image = document.createElement('img');
    image.src = source; image.alt = localCopy(root, 'latestImage'); image.loading = 'lazy';
    holder.appendChild(image);
    var enlarge = createLocalButton(root, '⤢', 'data-local-action', 'enlarge-image');
    enlarge.className = 'sticker-customizer__journey-image-enlarge';
    enlarge.setAttribute('data-local-image-src', source);
    enlarge.setAttribute('data-local-image-label', localCopy(root, 'latestImage'));
    enlarge.setAttribute('aria-label', localCopy(root, 'enlargeImage', { label: localCopy(root, 'latestImage') }));
    if (localPending(root)) {
      var pending = createLocalButton(root, localCopy(root, 'pending'), 'data-local-action', 'preview-help');
      pending.className = 'sticker-customizer__journey-image-pending';
      pending.setAttribute('aria-label', localCopy(root, 'pendingDetails'));
      actions.appendChild(pending);
    }
    actions.appendChild(enlarge);
    holder.appendChild(actions);
    container.appendChild(holder);
  }

  function getLocalPendingSteps(root) {
    if (!localPending(root)) return [];
    var state = root._stickerState;
    var referenceSource = state.assistantGeneratedContextFingerprint || state.assistantPendingBaselineFingerprint || '';
    var reference;
    var current;
    var pending = [];
    var add = function (step) { if (pending.indexOf(step) === -1) pending.push(step); };
    try { reference = referenceSource ? JSON.parse(referenceSource) : null; } catch (error) { reference = null; }
    try { current = JSON.parse(getAssistantContextFingerprint(root)); } catch (error) { current = null; }
    if (!reference || !current) return pending;
    if (reference.style !== current.style) add('style');
    if (reference.garment !== current.garment || JSON.stringify(reference.palette) !== JSON.stringify(current.palette) || reference.finishColor !== current.finishColor) add('color');
    if (reference.mode !== current.mode || reference.accessory !== current.accessory) add('mode');
    if (reference.hairstyle !== current.hairstyle) add('hairstyle');
    if (reference.symbol !== current.symbol) add('symbol');
    return ['style', 'color', 'mode', 'hairstyle', 'symbol'].filter(function (step) { return pending.indexOf(step) !== -1; });
  }

  function localPendingExplanation(root) {
    var labels = getLocalPendingSteps(root).map(function (step) { return localTitle(root, step); });
    var explanation = localCopy(root, 'pendingHelp');
    return labels.length ? explanation + ' ' + localCopy(root, 'pendingSteps', { changes: labels.join(', ') }) : explanation;
  }

  function openLocalImageDialog(root, button) {
    var dialog = qs(root, '[data-local-image-dialog]');
    var items;
    if (!dialog) return;
    items = qsa(root, '[data-local-image-card] [data-local-action="enlarge-image"]').filter(function (item) {
      return !item.hidden && !item.closest('[hidden]');
    });
    root._localImageDialogItems = items;
    root._localImageDialogIndex = Math.max(0, items.indexOf(button));
    syncLocalImageDialog(root, 0);
    root._localImageDialogOpener = button;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var close = qs(dialog, '[data-local-action="close-image"]');
    if (close) close.focus();
  }

  function syncLocalImageDialog(root, direction) {
    var dialog = qs(root, '[data-local-image-dialog]');
    var image = dialog && qs(dialog, '[data-local-image-dialog-image]');
    var title = dialog && qs(dialog, '[data-local-image-dialog-title]');
    var items = root._localImageDialogItems || [];
    var index = items.length ? ((root._localImageDialogIndex % items.length) + items.length) % items.length : 0;
    var item = items[index];
    if (!dialog || !image || !title || !item) return;
    root._localImageDialogIndex = index;
    image.src = item.getAttribute('data-local-image-src') || '';
    image.alt = item.getAttribute('data-local-image-alt') || item.getAttribute('data-local-image-label') || '';
    title.textContent = image.alt;
    if (direction && typeof image.animate === 'function' && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      if (typeof image.getAnimations === 'function') image.getAnimations().forEach(function (animation) { animation.cancel(); });
      image.animate([
        { opacity: 0.28, transform: 'translateX(' + (direction > 0 ? '22px' : '-22px') + ') scale(.985)' },
        { opacity: 1, transform: 'translateX(0) scale(1)' }
      ], { duration: 280, easing: 'cubic-bezier(.22,.75,.25,1)' });
    }
    qsa(dialog, '[data-local-action="previous-image"], [data-local-action="next-image"]').forEach(function (button) {
      button.hidden = items.length < 2;
    });
  }

  function navigateLocalImageDialog(root, direction) {
    if (!(root._localImageDialogItems || []).length) return;
    root._localImageDialogIndex += direction;
    syncLocalImageDialog(root, direction);
  }

  function closeLocalImageDialog(root) {
    var dialog = qs(root, '[data-local-image-dialog]');
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    if (root._localImageDialogOpener && typeof root._localImageDialogOpener.focus === 'function') root._localImageDialogOpener.focus();
    root._localImageDialogOpener = null;
    root._localImageDialogItems = [];
    root._localImageDialogIndex = 0;
  }

  function openLocalResetDialog(root, opener) {
    var dialog = qs(root, '[data-local-reset-dialog]');
    if (!dialog) return;
    root._localResetDialogOpener = opener;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var cancel = qs(dialog, '[data-local-action="cancel-reset"]');
    if (cancel) cancel.focus();
  }

  function closeLocalResetDialog(root) {
    var dialog = qs(root, '[data-local-reset-dialog]');
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    if (root._localResetDialogOpener && typeof root._localResetDialogOpener.focus === 'function') root._localResetDialogOpener.focus();
    root._localResetDialogOpener = null;
  }

  function confirmLocalReset(root) {
    root._localResetting = true;
    if (root._stickerState) {
      root._stickerState.assistantTranscript = [];
      root._stickerState.assistantRecentTurnIds = [];
      root._stickerState.localJourney = { index: 0, completed: [], review: false, options: false, chat: false, chatExpanded: false, quantity: 1, drafts: [], editing: null };
    }
    try {
      window.sessionStorage.removeItem(getLocalSessionKey(root));
      window.sessionStorage.removeItem(getAssistantTranscriptKey(root));
      window.sessionStorage.removeItem(getGuidedContextKey(root));
      window.sessionStorage.removeItem('clairatier-car-view-v4');
    } catch (error) {}
    closeLocalResetDialog(root);
    window.location.reload();
  }

  function miaAssetUrl(root, filename) {
    var base = root && root.getAttribute('data-mia-preview-assets');
    if (!base || !filename) return '';
    var url = new URL(base, window.location.href);
    url.pathname = url.pathname.replace(/[^/]+$/, filename);
    return url.href;
  }

  function getMiaAccessoryAsset(root, control) {
    var state = root && root._stickerState;
    var style = state && state.style || 'signature';
    if (!control) return '';
    if (control.value === 'opaque-incognito') {
      var styleControl = getMiaSelected(root, 'style');
      return styleControl ? styleControl.getAttribute('data-preview-incognito') || '' : '';
    }
    if (control.getAttribute('data-generic-reference') === 'true' || control.getAttribute('data-accessory-audience') === 'boy') {
      return miaAssetUrl(root, 'clairatier-accessory-' + control.value + '.webp');
    }
    return miaAssetUrl(root, 'clairatier-mia-' + style + '-accessory-' + control.value + '-v1-storefront-preview.webp');
  }

  function getMiaHairAsset(root, control) {
    var style = root && root._stickerState && root._stickerState.style || 'signature';
    return control ? control.getAttribute('data-preview-' + style) || '' : '';
  }

  // Public preview catalog, deliberately separate from the print-master contract.
  var CAST_PREVIEW_IDS = ['mia', 'clara', 'emma', 'sofia', 'nora', 'jade', 'alba', 'lina', 'leo', 'hugo', 'evan', 'noah', 'adam', 'luca', 'elias', 'milo'];

  var CAST_BABY_IDS = ['mia', 'emma', 'alba', 'nora', 'sofia', 'lina', 'noah', 'luca', 'jade', 'clara', 'leo', 'hugo', 'evan', 'adam', 'elias', 'milo'];
  var CAST_BABY_WARDROBE_IDS = ['mia', 'emma', 'alba', 'nora', 'sofia', 'lina', 'noah', 'luca', 'clara', 'adam', 'elias', 'leo', 'hugo', 'jade', 'evan', 'milo'];
  var CAST_SIGNATURE_DEFAULTS = { mia: 1, emma: 2, alba: 3, jade: 4, nora: 5, sofia: 6, lina: 7, clara: 8, noah: 1, leo: 2, hugo: 3, evan: 4, adam: 5, luca: 6, elias: 7, milo: 9 };

  // The preset carries the life stage through existing sessions, slots and PDF recipes.
  function castLifeStage(state) {
    return state && /^cast-[a-z]+-baby-/.test(state.approvedAvatarGarmentId || '') ? 'baby' : 'grown';
  }

  function defaultCastPreviewEntry(root, avatar, stage, style) {
    var entries = (root._castPreviewCatalog || []).filter(function (entry) {
      return entry.characterId === avatar && (entry.lifeStage || 'grown') === stage && entry.styleId === (style || 'signature');
    });
    return entries.find(function (entry) { return entry.outfitNumber === CAST_SIGNATURE_DEFAULTS[avatar]; }) || entries[0] || null;
  }

  function castPreviewEnabled(root) {
    return !!root && root.getAttribute('data-cast-preview-enabled') === 'true' && isMiaPrivatePilotReady(root) &&
      String(root.getAttribute('data-cast-preview-theme') || '').split(',').indexOf(String(window.Shopify && window.Shopify.theme && window.Shopify.theme.id)) >= 0;
  }

  function normalizeCastCustomizationCatalog(source) {
    if (!source || source.schemaVersion !== 1 || source.productionReady !== false || !Array.isArray(source.entries) || source.entries.length !== 160) return [];
    var seen = {}, result = [];
    source.entries.forEach(function (e) {
      if (!e || CAST_PREVIEW_IDS.indexOf(e.characterId) < 0 || ['hair', 'masks'].indexOf(e.category) < 0 || !Number.isInteger(e.variant) || e.variant < 1 || e.variant > 5 || !/^[a-f0-9]{64}$/.test(e.sha256 || '')) return;
      var number = String(e.variant).padStart(2, '0'), outfit = e.category === 'hair' ? 1 : e.variant;
      var id = 'cast-custom-' + e.characterId + '-' + e.category + '-' + number;
      var style = e.category === 'hair' ? 'signature' : 'hero';
      var filename = 'clairatier-' + e.characterId + '-' + e.category + '-variant-' + number + '-' + (style === 'hero' ? 'comics' : style) + '-outfit-' + String(outfit).padStart(2, '0') + '-knees-' + e.sha256.slice(0, 16) + '-storefront-preview.webp';
      if (seen[id] || e.id !== id || e.styleId !== style || e.outfitNumber !== outfit || e.asset !== filename) return;
      seen[id] = true; result.push({ id: id, characterId: e.characterId, category: e.category, variant: e.variant, outfitNumber: outfit, styleId: style, asset: e.asset, sha256: e.sha256 });
    });
    return result.length === 160 ? result : [];
  }

  function castCustomizationMatches(entry, state) {
    if (!entry || !state || entry.characterId !== state.approvedAvatarId || entry.styleId !== state.style) return false;
    return state.approvedAvatarGarmentId === 'cast-' + entry.characterId + '-' + entry.styleId + '-outfit-' + String(entry.outfitNumber).padStart(2, '0');
  }

  function getCastCustomizationEntry(root, state) {
    if (!castPreviewEnabled(root) || !state || state.subjectSource !== 'approved-avatar' || state.presentationMode !== 'standard' || state.wardrobePaletteMode === 'custom' || state.symbol && state.symbolChoice !== 'no') return null;
    if (state.approvedAvatarHairstyleId && state.selectedAccessoryId) return null;
    var id = state.approvedAvatarHairstyleId || state.selectedAccessoryId;
    return (root._castCustomizationCatalog || []).find(function (entry) {
      return entry.id === id && castCustomizationMatches(entry, state) && (entry.category === 'hair' ? !state.selectedAccessoryId : !state.approvedAvatarHairstyleId);
    }) || null;
  }

  function castCustomizationLabel(root, entry) {
    return localCopy(root, entry.category === 'hair' ? 'hairstyle' : 'masksHeadwear').replace(/&(?:amp;)+/g, '&') + ' ' + entry.variant;
  }

  function loadCastCustomizationCatalog(root) {
    var url = root.getAttribute('data-cast-customization-catalog');
    if (!url) return Promise.resolve();
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('cast-customization-unavailable'); return response.json();
    }).then(function (catalog) {
      root._castCustomizationCatalog = normalizeCastCustomizationCatalog(catalog);
      var holder = document.createElement('div'); holder.hidden = true; holder.setAttribute('data-cast-customization-choices', '');
      root._castCustomizationCatalog.forEach(function (entry) {
        var input = document.createElement('input'); input.type = 'radio'; input.name = 'cast-custom-' + entry.category + '-' + root.id; input.value = entry.id;
        input.setAttribute('data-mia-choice', entry.category === 'hair' ? 'hair' : 'accessory');
        input.setAttribute('data-presentation-mode', 'standard'); input.setAttribute('data-accessory-styles', entry.styleId); holder.appendChild(input);
      }); root.appendChild(holder);
    }).catch(function () { root._castCustomizationCatalog = []; });
  }

  function selectCastCustomization(root, id) {
    var entry = (root._castCustomizationCatalog || []).find(function (item) { return item.id === id; });
    if (!castPreviewEnabled(root) || !castCustomizationMatches(entry, root._stickerState)) return false;
    var state = root._stickerState, restoring = root._localSessionRestoring;
    root._localSessionRestoring = true;
    try {
      ['hair', 'accessory', 'mode'].forEach(function (category) {
        var value = category === 'mode' ? entry.category === 'hair' ? 'standard' : 'accessories' : category === (entry.category === 'hair' ? 'hair' : 'accessory') ? entry.id : '';
        qsa(root, '[data-mia-choice="' + category + '"]').forEach(function (control) { control.checked = control.value === value; });
      });
      state.approvedAvatarHairstyleId = entry.category === 'hair' ? entry.id : '';
      state.selectedAccessoryId = entry.category === 'masks' ? entry.id : '';
      root._stickerLastHonestPreviewAsset = '';
      syncMiaRuntimeChoices(root, entry.category === 'hair' ? 'hair' : 'accessory');
      syncAssistantHonestPreview(root); updatePhoto(root); renderLocalJourney(root);
    } finally { root._localSessionRestoring = restoring; }
    persistLocalSession(root); return true;
  }

  function renderCastCustomizationChoices(root, step, container) {
    var state = root._stickerState, category = step === 'hairstyle' ? 'hair' : step === 'mode' ? 'masks' : '';
    if (!castPreviewEnabled(root) || !category) return false;
    var entries = (root._castCustomizationCatalog || []).filter(function (entry) { return entry.category === category && castCustomizationMatches(entry, state); });
    if (!entries.length) return false;
    var base = getCastPreviewEntry(root, state.approvedAvatarId, state.style, state.approvedAvatarGarmentId);
    localChoiceButton(root, container, localCopy(root, category === 'hair' ? 'currentHair' : 'currentAppearance'), 'cast-outfit:' + base.presetId,
      !state.approvedAvatarHairstyleId && !state.selectedAccessoryId, miaAssetUrl(root, base.asset));
    entries.forEach(function (entry) {
      localChoiceButton(root, container, castCustomizationLabel(root, entry), 'cast-custom:' + entry.id,
        state.approvedAvatarHairstyleId === entry.id || state.selectedAccessoryId === entry.id, miaAssetUrl(root, entry.asset));
    }); return true;
  }

  function normalizeCastCustomizationState(root) {
    var state = root._stickerState;
    if (!state || !/^cast-custom-/.test(state.approvedAvatarHairstyleId || state.selectedAccessoryId || '') || getCastCustomizationEntry(root, state)) return;
    qsa(root, '[data-mia-choice="hair"]').concat(qsa(root, '[data-mia-choice="accessory"]')).forEach(function (control) { control.checked = false; });
    qsa(root, '[data-mia-choice="mode"]').forEach(function (control) { control.checked = control.value === 'standard'; });
    state.approvedAvatarHairstyleId = ''; state.selectedAccessoryId = ''; state.presentationMode = 'standard'; state.appearanceMode = 'standard';
    root._stickerLastHonestPreviewAsset = '';
  }

  function normalizeCastPreviewCatalog(source) {
    if (!source || source.schemaVersion !== 1 || source.productionReady !== false || !Array.isArray(source.entries)) return [];
    var seen = {}, entries = [];
    source.entries.forEach(function (entry) {
      if (!entry || CAST_PREVIEW_IDS.indexOf(entry.characterId) < 0 || ['signature', 'hero', 'prince-princess'].indexOf(entry.styleId) < 0 ||
          !Number.isInteger(entry.outfitNumber) || entry.outfitNumber < 1 || entry.outfitNumber > 10 ||
          !/^[a-f0-9]{64}$/.test(entry.sha256 || '') || typeof entry.asset !== 'string') return;
      var baby = entry.lifeStage === 'baby';
      var babyWardrobe = baby && CAST_BABY_WARDROBE_IDS.indexOf(entry.characterId) >= 0;
      if (entry.lifeStage && !baby || baby && (CAST_BABY_IDS.indexOf(entry.characterId) < 0 || !babyWardrobe && entry.styleId === 'signature' && entry.outfitNumber !== CAST_SIGNATURE_DEFAULTS[entry.characterId])) return;
      var id = 'cast-' + entry.characterId + (baby ? '-baby' : '') + '-' + entry.styleId + '-outfit-' + String(entry.outfitNumber).padStart(2, '0');
      var legacyClara = entry.characterId === 'clara' && entry.styleId === 'signature' && CLARA_SIGNATURE_PREVIEWS['signature-girl-outfit-' + String(entry.outfitNumber).padStart(2, '0')] === entry.asset;
      var sourceStyle = entry.styleId === 'hero' ? '(?:hero|comics)' : entry.styleId === 'prince-princess' ? '(?:prince|princesse|prince-princess)' : 'signature';
      if (baby) {
        var babyAsset = entry.styleId === 'signature' ? '^clairatier-' + entry.characterId + '-baby-seated-[a-f0-9]{16}\\.webp$' : '^clairatier-' + entry.characterId + '-baby-' + entry.styleId + '-outfit-' + String(entry.outfitNumber).padStart(2, '0') + '-preview-v' + (entry.characterId === 'alba' ? '[123]' : '1') + '\\.webp$';
        var wardrobeAsset = '^clairatier-' + entry.characterId + '-baby-' + entry.styleId + '-outfit-' + String(entry.outfitNumber).padStart(2, '0') + '-preview-v' + (entry.characterId === 'jade' ? '5' : entry.characterId === 'evan' ? '6' : entry.characterId === 'milo' ? '7' : '4') + '\\.webp$';
        if (entry.presetId !== id || seen[id] || !new RegExp(babyAsset).test(entry.asset) && !(babyWardrobe && new RegExp(wardrobeAsset).test(entry.asset))) return;
        seen[id] = true; entries.push({ characterId: entry.characterId, styleId: entry.styleId, outfitNumber: entry.outfitNumber, presetId: id, asset: entry.asset, sha256: entry.sha256, lifeStage: 'baby' }); return;
      }
      if (entry.presetId !== id || seen[id] || entry.asset.indexOf(entry.sha256.slice(0, 16)) < 0 ||
          !legacyClara && !new RegExp('^clairatier-' + entry.characterId + '-' + sourceStyle + '-outfit-' + String(entry.outfitNumber).padStart(2, '0') + '-knees-[a-f0-9]{16}-storefront-preview\\.webp$').test(entry.asset)) return;
      seen[id] = true;
      entries.push({ characterId: entry.characterId, styleId: entry.styleId, outfitNumber: entry.outfitNumber, presetId: id, asset: entry.asset, sha256: entry.sha256 });
    });
    // Partial/duplicated or malformed catalogs never activate a partial selection.
    return entries.length === source.entries.length ? entries : [];
  }

  function getCastPreviewEntry(root, avatar, style, garment) {
    if (!castPreviewEnabled(root)) return null;
    return (root._castPreviewCatalog || []).find(function (entry) {
      return entry.characterId === avatar && entry.styleId === style && entry.presetId === garment;
    }) || null;
  }

  function getCastExactChoiceAsset(root) {
    var state = root && root._stickerState;
    var customization = getCastCustomizationEntry(root, state);
    if (customization) return miaAssetUrl(root, customization.asset);
    if (!state || state.subjectSource !== 'approved-avatar' || state.presentationMode !== 'standard' || state.approvedAvatarHairstyleId ||
        state.selectedAccessoryId || state.wardrobePaletteMode === 'custom' || state.symbol && state.symbolChoice !== 'no') return '';
    var entry = getCastPreviewEntry(root, state.approvedAvatarId, state.style, state.approvedAvatarGarmentId);
    if (!entry) return '';
    // Frozen recipes retain their original approved file, even after a portrait update.
    var legacy = root._browserReplayRecipe && (root._castPreviewLegacyCatalog || []).find(function (item) { return item.presetId === entry.presetId; });
    var frozen = legacy && (root._browserReplayRecipe.assets || []).find(function (source) { return isDiscoveryPresetAsset(source, legacy, window.location.href); });
    return frozen || miaAssetUrl(root, entry.asset);
  }

  function hasCastPreviewSelection(root) {
    var state = root && root._stickerState;
    var unsupported = function (selection) {
      return !!selection && (['mia', 'clara'].indexOf(selection.approvedAvatarId) < 0 || /^cast-/.test(selection.approvedAvatarGarmentId || ''));
    };
    return !!state && (unsupported(state) || (state.proofAvatars || []).some(function (slot) { return unsupported(slot.state); }));
  }

  function loadCastPreviewCatalog(root) {
    if (root._castPreviewPromise) return root._castPreviewPromise;
    root._castPreviewPromise = fetch(root.getAttribute('data-cast-preview-catalog'), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('cast-catalog-unavailable');
      return response.json();
    }).then(function (catalog) {
      root._castPreviewCatalog = normalizeCastPreviewCatalog(catalog);
      root._castPreviewLegacyCatalog = normalizeCastPreviewCatalog({ schemaVersion: 1, productionReady: false, entries: catalog.legacyEntries || [] });
      var holder = document.createElement('div'); holder.hidden = true; holder.setAttribute('data-cast-native-choices', '');
      var avatars = qsa(root, '[data-mia-choice="avatar"]');
      CAST_PREVIEW_IDS.forEach(function (id) {
        if (!root._castPreviewCatalog.some(function (entry) { return entry.characterId === id; }) || avatars.some(function (control) { return control.value === id; })) return;
        var label = document.createElement('label'), input = document.createElement('input'), title = document.createElement('strong');
        input.type = 'radio'; input.name = avatars[0].name; input.value = id; input.setAttribute('data-mia-choice', 'avatar');
        title.textContent = id.charAt(0).toUpperCase() + id.slice(1); label.appendChild(input); label.appendChild(title); holder.appendChild(label);
      });
      root._castPreviewCatalog.forEach(function (entry) {
        var input = document.createElement('input'); input.type = 'radio'; input.name = 'cast-garment-' + root.id; input.value = entry.presetId;
        input.setAttribute('data-mia-choice', 'garment'); input.setAttribute('data-garment-style', entry.styleId); holder.appendChild(input);
      });
      root.appendChild(holder);
      return loadCastCustomizationCatalog(root);
    }).catch(function () { root._castPreviewCatalog = []; }).then(function () { root._castPreviewReady = true; });
    return root._castPreviewPromise;
  }

  function getApprovedAvatarDescription(root, avatarState) {
    var state = avatarState || root._stickerState;
    if (!state || state.subjectSource !== 'approved-avatar' || CAST_PREVIEW_IDS.indexOf(state.approvedAvatarId) < 0) return '';
    var id = state.approvedAvatarId;
    var style = qsa(root, '[data-mia-choice="style"]').find(function (control) { return control.value === state.style; });
    var title = style && typeof style.closest === 'function' && qs(style.closest('label'), 'strong');
    var parts = [id.charAt(0).toUpperCase() + id.slice(1), localCopy(root, castLifeStage(state) === 'baby' ? 'lifeStageBaby' : 'lifeStageGrown'), title ? title.textContent.trim() : getStyleGuide(root, state.style).title];
    var outfit = /outfit-(\d{2})$/.exec(state.approvedAvatarGarmentId || '');
    if (outfit) parts.push(localCopy(root, 'wardrobeOutfit', { number: String(Number(outfit[1])) }));
    var customization = getCastCustomizationEntry(root, state);
    if (customization) parts.push(castCustomizationLabel(root, customization));
    return parts.filter(Boolean).join(' · ');
  }

  function getCastAssetDescription(root, source) {
    if (!castPreviewEnabled(root) || !source) return '';
    var basename;
    try { basename = new URL(source, window.location.href).pathname.split('/').pop(); } catch (error) { return ''; }
    var custom = (root._castCustomizationCatalog || []).find(function (item) { return item.asset === basename; });
    if (custom) return custom.characterId.charAt(0).toUpperCase() + custom.characterId.slice(1) + ' · ' + castCustomizationLabel(root, custom) + ' · ' + localCopy(root, 'wardrobeOutfit', { number: String(custom.outfitNumber) });
    var entry = (root._castPreviewCatalog || []).concat(root._castPreviewLegacyCatalog || []).find(function (item) { return item.asset === basename; });
    return entry ? getApprovedAvatarDescription(root, { subjectSource: 'approved-avatar', approvedAvatarId: entry.characterId, style: entry.styleId, approvedAvatarGarmentId: entry.presetId }) : '';
  }

  function selectCastPreviewEntry(root, entry) {
    if (!entry || !getCastPreviewEntry(root, entry.characterId, entry.styleId, entry.presetId)) return false;
    delete root._castLifeStageBrowser;
    var state = root._stickerState;
    ['avatar', 'style', 'garment', 'mode', 'color', 'hair', 'accessory'].forEach(function (category) {
      var value = { avatar: entry.characterId, style: entry.styleId, garment: entry.presetId, mode: 'standard', color: 'original', hair: '', accessory: '' }[category];
      qsa(root, '[data-mia-choice="' + category + '"]').forEach(function (control) { control.checked = control.value === value; });
    });
    state.wardrobePaletteMode = 'catalog'; state.wardrobePaletteValidated = true; state.wardrobeEditing = false;
    state.selectedAccessoryId = ''; state.approvedAvatarHairstyleId = ''; state.presentationMode = 'standard';
    root._stickerLastHonestPreviewAsset = '';
    var restoring = root._localSessionRestoring;
    root._localSessionRestoring = true;
    try {
      syncMiaRuntimeChoices(root, 'garment'); syncAssistantHonestPreview(root); updatePhoto(root); renderLocalJourney(root);
    } finally { root._localSessionRestoring = restoring; }
    persistLocalSession(root);
    return true;
  }

  function renderCastPreviewChoices(root, step, container) {
    var state = root._stickerState;
    if (!castPreviewEnabled(root) || !root._castPreviewCatalog || !root._castPreviewCatalog.length) return false;
    var stage = step === 'avatar' && root._castLifeStageBrowser || castLifeStage(state);
    var entries = root._castPreviewCatalog.filter(function (entry) { return entry.characterId === state.approvedAvatarId && (entry.lifeStage || 'grown') === stage; });
    if (step === 'avatar') {
      var stages = document.createElement('div'); stages.className = 'sticker-customizer__life-stages';
      stages.setAttribute('role', 'group'); stages.setAttribute('aria-label', localCopy(root, 'lifeStageLabel'));
      ['baby', 'grown'].forEach(function (choice) {
        localChoiceButton(root, stages, localCopy(root, choice === 'baby' ? 'lifeStageBaby' : 'lifeStageGrown'), 'cast-stage:' + choice, stage === choice);
      });
      container.appendChild(stages);
      (stage === 'baby' ? CAST_BABY_IDS : CAST_PREVIEW_IDS).forEach(function (id) {
        var entry = defaultCastPreviewEntry(root, id, stage);
        if (!entry) return;
        var label = id.charAt(0).toUpperCase() + id.slice(1);
        localChoiceButton(root, container, label, 'cast-avatar:' + id, state.approvedAvatarId === id, miaAssetUrl(root, entry.asset));
      });
      return true;
    }
    if (step === 'style' && entries.length) {
      if (state.approvedAvatarId === 'mia' && !/^cast-/.test(state.approvedAvatarGarmentId || '')) return false;
      ['signature', 'hero', 'prince-princess'].forEach(function (style) {
        var entry = defaultCastPreviewEntry(root, state.approvedAvatarId, stage, style);
        var control = qsa(root, '[data-mia-choice="style"]').find(function (item) { return item.value === style; });
        var title = control && qs(control.closest('label'), 'strong');
        if (entry) localChoiceButton(root, container, title ? title.textContent.trim() : getStyleGuide(root, style).title, 'cast-outfit:' + entry.presetId, state.style === style, miaAssetUrl(root, entry.asset));
      });
      return true;
    }
    if ((step === 'color' || step === 'garment') && entries.length) {
      var legacyClara = stage === 'grown' && state.approvedAvatarId === 'clara' && state.style === 'signature' && !/^cast-/.test(state.approvedAvatarGarmentId || '');
      if (legacyClara) renderClaraChoices(root, step, container);
      if (stage === 'grown' && state.approvedAvatarId === 'mia') localChoiceButton(root, container, localCopy(root, 'keepMia'), 'cast-legacy-mia', state.approvedAvatarGarmentId === 'garment-yoke-blouse-dress',
        getMiaSelected(root, 'style').getAttribute('data-preview-standard'));
      entries.filter(function (entry) { return entry.styleId === state.style && (!legacyClara || entry.outfitNumber > 5); }).forEach(function (entry) {
        localChoiceButton(root, container, localCopy(root, 'wardrobeOutfit', { number: String(entry.outfitNumber) }), 'cast-outfit:' + entry.presetId,
          state.approvedAvatarGarmentId === entry.presetId, miaAssetUrl(root, entry.asset));
      });
      return true;
    }
    if ((step === 'mode' || step === 'hairstyle') && (['mia', 'clara'].indexOf(state.approvedAvatarId) < 0 || /^cast-/.test(state.approvedAvatarGarmentId || ''))) {
      localChoiceButton(root, container, localCopy(root, step === 'hairstyle' ? 'currentHair' : 'currentAppearance'), 'cast-keep', true, getCastExactChoiceAsset(root)); return true;
    }
    return false;
  }

  function parseCastDiscoveryPreset(root, search) {
    if (typeof search !== 'string' || search.length > 2048) return null;
    var values = new URLSearchParams(search).getAll('clairatier_preset');
    if (values.length !== 1) return null;
    return (root._castPreviewCatalog || []).find(function (entry) { return entry.presetId === values[0]; }) || null;
  }

  function applyCastDiscoveryPreset(root, search, existingState) {
    if (!castPreviewEnabled(root) || !localJourneyEnabled(root) || !root._wardrobeReady || root._stickerDiscoveryPresetApplied ||
        hasDiscoveryPresetCustomerState(root, existingState)) return false;
    var entry = parseCastDiscoveryPreset(root, search);
    if (!entry || !isDiscoveryPresetAsset(miaAssetUrl(root, entry.asset), entry, window.location.href)) return false;
    var valid = ['avatar', 'style', 'garment'].every(function (category) {
      var value = { avatar: entry.characterId, style: entry.styleId, garment: entry.presetId }[category];
      return qsa(root, '[data-mia-choice="' + category + '"]').some(function (control) { return control.value === value && !control.disabled; });
    });
    if (!valid || !selectCastPreviewEntry(root, entry)) return false;
    root._stickerDiscoveryPresetApplied = entry.presetId; root.setAttribute('data-sticker-discovery-preset', entry.presetId);
    persistLocalSession(root); return true;
  }

  var CLARA_SIGNATURE_PREVIEWS = {
    "signature-girl-outfit-01": "clairatier-clara-signature-standard-signature-girl-outfit-01-knees-v2-5bf16593ce8651a7-storefront-preview.webp",
    "signature-girl-outfit-02": "clairatier-clara-signature-standard-signature-girl-outfit-02-knees-v2-71ca9308c14ab97f-storefront-preview.webp",
    "signature-girl-outfit-03": "clairatier-clara-signature-standard-signature-girl-outfit-03-knees-v2-8037ea30399e26f0-storefront-preview.webp",
    "signature-girl-outfit-04": "clairatier-clara-signature-standard-signature-girl-outfit-04-knees-v2-96f700f0f54eb5cf-storefront-preview.webp",
    "signature-girl-outfit-05": "clairatier-clara-signature-standard-signature-girl-outfit-05-knees-v2-5fac55de80b398c3-storefront-preview.webp"
};

  function claraPreviewEnabled(root) {
    return !!root && root.getAttribute('data-clara-preview-enabled') === 'true' && isMiaPrivatePilotReady(root);
  }

  function getClaraExactChoiceAsset(root) {
    var state = root && root._stickerState;
    if (!claraPreviewEnabled(root) || !state || state.subjectSource !== 'approved-avatar' || state.approvedAvatarId !== 'clara' ||
        state.style !== 'signature' || state.presentationMode !== 'standard' || state.approvedAvatarHairstyleId || state.selectedAccessoryId ||
        state.wardrobePaletteMode === 'custom' || state.symbol && state.symbolChoice !== 'no') return '';
    var asset = CLARA_SIGNATURE_PREVIEWS[state.approvedAvatarGarmentId];
    return asset ? miaAssetUrl(root, asset) : '';
  }

  function renderClaraChoices(root, step, container) {
    var state = root._stickerState;
    if (step === 'color' || step === 'garment') {
      var note = document.createElement('p'); note.textContent = localCopy(root, 'claraApprovedOutfits'); container.appendChild(note);
      Object.keys(CLARA_SIGNATURE_PREVIEWS).forEach(function (id, index) {
        localChoiceButton(root, container, localCopy(root, 'wardrobeOutfit', { number: String(index + 1) }), 'clara-outfit:' + id,
          state.approvedAvatarGarmentId === id, miaAssetUrl(root, CLARA_SIGNATURE_PREVIEWS[id]));
      });
      return true;
    }
    if (step === 'style' || step === 'mode' || step === 'hairstyle') {
      localChoiceButton(root, container, localCopy(root, 'claraApprovedAppearance'), 'clara-keep', true, getClaraExactChoiceAsset(root));
      return true;
    }
    return false;
  }

  function getMiaExactChoiceAsset(root) {
    var state = root && root._stickerState;
    var style = getMiaSelected(root, 'style');
    var color = getMiaSelected(root, 'color');
    var hair = getMiaSelected(root, 'hair');
    var accessory = getMiaSelected(root, 'accessory');
    if (state && (['mia', 'clara'].indexOf(state.approvedAvatarId) < 0 || /^cast-/.test(state.approvedAvatarGarmentId || ''))) return typeof getCastExactChoiceAsset === 'function' ? getCastExactChoiceAsset(root) : '';
    if (state && state.approvedAvatarId === 'clara') return getClaraExactChoiceAsset(root);
    var wardrobe = state && getLocalWardrobeEntry(root, state.approvedAvatarGarmentId);
    var wardrobeAsset = wardrobe && wardrobe.miaPreviewCompositable === true && typeof wardrobe.miaPreviewAsset === 'string' &&
      /-girl-outfit-/.test(wardrobe.id) && state.wardrobePaletteMode !== 'custom' ? wardrobe.compositableImage || '' : '';
    if (!state || !style || state.subjectSource !== 'approved-avatar' || state.symbol && state.symbolChoice !== 'no') return '';
    if (hair && accessory) return '';
    if (wardrobeAsset && !hair && !accessory) return wardrobeAsset;
    if (state.approvedAvatarGarmentId !== 'garment-yoke-blouse-dress' || color && color.value !== 'original') return '';
    if (accessory) return accessory.getAttribute('data-generic-reference') === 'true' || accessory.getAttribute('data-accessory-audience') === 'boy'
      ? '' : getMiaAccessoryAsset(root, accessory);
    if (hair) return state.presentationMode === 'standard' ? getMiaHairAsset(root, hair) : '';
    return style.getAttribute('data-preview-' + (state.presentationMode || 'standard')) || '';
  }

  function getMiaAccessoryLabel(root, control) {
    var messages = getTranslations(root).messages || {};
    if (!control) return '';
    if (control.value === 'opaque-incognito') return messages.journeyOpaqueAccessory || '';
    var map = control.getAttribute('data-accessory-kind') === 'headwear'
      ? messages.journeyAccessoryHeadwear || {}
      : messages.journeyAccessoryMasks || {};
    return map[control.value] || '';
  }

  function renderLocalModeChoices(root, container) {
    var state = root._stickerState;
    var accessoryMode = state.appearanceMode === 'accessories';
    localChoiceButton(root, container, localCopy(root, 'currentAppearance'), 'mode-surface:standard', !accessoryMode);
    localChoiceButton(root, container, localCopy(root, 'masksHeadwear'), 'mode-surface:accessories', accessoryMode);
    if (!accessoryMode) return;
    var hint = document.createElement('p');
    hint.textContent = localCopy(root, 'masksHeadwearHint');
    container.appendChild(hint);
    [['girl', 'wardrobeForMia'], ['all', 'allAccessories']].forEach(function (definition) {
      localChoiceButton(root, container, localCopy(root, definition[1]), 'accessory-audience:' + definition[0],
        (state.accessoryAudience || 'girl') === definition[0]);
    });
    qsa(root, '[data-mia-choice="accessory"]').filter(function (control) {
      if (/^cast-custom-/.test(control.value)) return false;
      var audience = control.getAttribute('data-accessory-audience') || 'all';
      return (control.getAttribute('data-accessory-styles') || '').split(',').indexOf(state.style) >= 0 &&
        ((state.accessoryAudience || 'girl') === 'all' || audience === 'girl' || audience === 'all');
    }).forEach(function (control) {
      var button = localChoiceButton(root, container, getMiaAccessoryLabel(root, control), 'accessory:' + control.value,
        !!control.checked, getMiaAccessoryAsset(root, control));
      if (control.getAttribute('data-eyes-visible') === 'true') button.title = localCopy(root, 'eyesVisible');
      if (control.getAttribute('data-presentation-mode') === 'incognito') button.title = localCopy(root, 'eyesHidden');
    });
  }

  function getLocalWardrobeEntry(root, id) {
    return (root._wardrobeCatalog || []).find(function (entry) { return entry.id === id; });
  }

  function loadLocalWardrobe(root) {
    if (root._wardrobeLoading) return root._wardrobeLoading;
    var catalogUrl = root.getAttribute('data-wardrobe-catalog');
    var assetUrl = root.getAttribute('data-wardrobe-assets');
    if (!catalogUrl || !assetUrl) { root._wardrobeReady = true; return Promise.resolve(); }
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 8000);
    root._wardrobeLoading = fetch(catalogUrl, { signal: controller.signal }).then(function (response) {
      if (!response.ok) throw new Error('wardrobe-unavailable');
      return response.json();
    }).then(function (catalog) {
      if (!catalog || catalog.version !== 1 || !Array.isArray(catalog.outfits) || catalog.outfits.length !== 60) throw new Error('wardrobe-invalid');
      root._wardrobeCatalog = catalog.outfits.filter(function (entry) { return /^(signature|hero|royal)-(girl|boy)-outfit-\d{2}$/.test(entry.id) && ['signature', 'hero', 'prince-princess'].indexOf(entry.style) >= 0; });
      var holder = document.createElement('div'); holder.hidden = true; holder.setAttribute('data-wardrobe-controls', '');
      root._wardrobeCatalog.forEach(function (entry, index) {
        var label = document.createElement('label'); var input = document.createElement('input'); var strong = document.createElement('strong');
        input.type = 'radio'; input.name = 'wardrobe-' + (root.id || 'customizer'); input.value = entry.id;
        input.setAttribute('data-mia-choice', 'garment'); input.setAttribute('data-garment-style', entry.style);
        strong.textContent = localCopy(root, 'wardrobeOutfit', { number: String(index % 20 + 1) });
        var image = document.createElement('img');
        var clothingName = 'clairatier-wardrobe-' + entry.id + '.webp';
        var clothingUrl = new URL(assetUrl, window.location.href); clothingUrl.pathname = clothingUrl.pathname.replace(/[^/]+$/, clothingName);
        entry.image = clothingUrl.href;
        entry.pickerImage = clothingUrl.href;
        if (typeof entry.miaPreviewAsset === 'string' && /^clairatier-mia-(signature|hero|prince-princess)-standard-(signature|hero|royal)-girl-outfit-\d{2}-v1-storefront-preview\.webp$/.test(entry.miaPreviewAsset)) {
          var pickerUrl = new URL(assetUrl, window.location.href); pickerUrl.pathname = pickerUrl.pathname.replace(/[^/]+$/, entry.miaPreviewAsset);
          entry.pickerImage = pickerUrl.href;
        }
        entry.compositableImage = entry.miaPreviewCompositable === true ? entry.pickerImage : '';
        image.src = entry.image; image.loading = 'lazy'; image.alt = '';
        label.appendChild(input); label.appendChild(strong); label.appendChild(image); holder.appendChild(label);
        if (MIA_GARMENT_IDS.indexOf(entry.id) < 0) MIA_GARMENT_IDS.push(entry.id);
        MIA_GARMENT_METADATA[entry.id] = {
          colorSlots: clamp(Number(entry.colorSlots) || 1, 1, 3),
          finish: entry.finish && entry.finish.kind || ''
        };
      });
      root.appendChild(holder);
    }).catch(function () { root._wardrobeCatalog = []; root._wardrobeError = true; }).then(function () {
      window.clearTimeout(timeout); root._wardrobeReady = true;
    });
    return root._wardrobeLoading;
  }

  function normalizeWardrobeHex(value) {
    value = String(value || '').trim().toUpperCase();
    return /^#[0-9A-F]{6}$/.test(value) ? value : '';
  }

  function wardrobeHexToRgb(value) {
    var hex = normalizeWardrobeHex(value);
    return hex ? {
      r: parseInt(hex.slice(1, 3), 16),
      g: parseInt(hex.slice(3, 5), 16),
      b: parseInt(hex.slice(5, 7), 16)
    } : null;
  }

  function wardrobeRgbToHex(value) {
    var match = String(value || '').trim().match(/^(?:rgb\s*)?\(?\s*(\d{1,3})\s*[, ]\s*(\d{1,3})\s*[, ]\s*(\d{1,3})\s*\)?$/i);
    if (!match) return '';
    var channels = match.slice(1).map(Number);
    if (channels.some(function (channel) { return channel < 0 || channel > 255; })) return '';
    return '#' + channels.map(function (channel) { return channel.toString(16).padStart(2, '0'); }).join('').toUpperCase();
  }

  function wardrobeRgbLabel(value) {
    var rgb = wardrobeHexToRgb(value);
    return rgb ? 'RGB ' + rgb.r + ', ' + rgb.g + ', ' + rgb.b : '';
  }

  function wardrobePaletteEntries(entry) {
    var source = entry && Array.isArray(entry.colorDefaults) ? entry.colorDefaults : entry && Array.isArray(entry.palette) ? entry.palette : [];
    return source.map(function (color, index) {
      var hex = normalizeWardrobeHex(typeof color === 'string' ? color : color && color.hex);
      var name = typeof color === 'object' && color && typeof color.name === 'string' ? color.name : '';
      return { hex: hex, name: name, index: index };
    }).filter(function (color) { return !!color.hex; });
  }

  function wardrobeColorName(root, value, color) {
    var hex = normalizeWardrobeHex(value);
    var resolved = color && normalizeWardrobeHex(color.hex) === hex ? color : null;
    if (!resolved) {
      (root._wardrobeCatalog || []).some(function (entry) {
        var candidates = (entry.colorDefaults || []).concat(entry.finish && entry.finish.color || []);
        resolved = candidates.find(function (candidate) { return normalizeWardrobeHex(candidate && candidate.hex) === hex; }) || null;
        return !!resolved;
      });
    }
    var catalogName = resolved && typeof resolved.name === 'string' ? resolved.name : '';
    var translatedName = catalogName ? localCopy(root, 'wardrobeColorNames.' + catalogName) : '';
    return translatedName || localCopy(root, 'wardrobeCustomColor');
  }

  function wardrobeColorRoles(entry) {
    var slotCount = clamp(Number(entry && entry.colorSlots) || 1, 1, 3);
    return ['primary', 'secondary', 'accent'].slice(0, slotCount);
  }

  function wardrobeCurrentColors(entry) {
    var palette = wardrobePaletteEntries(entry);
    var colors = {};
    wardrobeColorRoles(entry).forEach(function (role, index) { colors[role] = palette[index] && palette[index].hex || entry.primaryColor || '#000000'; });
    if (entry && entry.finish && entry.finish.color) colors.finish = normalizeWardrobeHex(entry.finish.color.hex);
    return colors;
  }

  function wardrobeRequiredColorRoles(entry) {
    var roles = wardrobeColorRoles(entry);
    if (entry && entry.finish && entry.finish.color) roles.push('finish');
    return roles;
  }

  function wardrobeHasChosenEveryColor(state, entry) {
    var chosen = state && state.wardrobeChosenColorRoles || {};
    return !!entry && wardrobeRequiredColorRoles(entry).every(function (role) { return chosen[role] === true; });
  }

  function wardrobeColorDescription(root, role, value, paletteColor) {
    return localCopy(root, 'wardrobeColorDescription', {
      role: localCopy(root, 'wardrobe' + role.charAt(0).toUpperCase() + role.slice(1)),
      name: wardrobeColorName(root, value, paletteColor),
      hex: normalizeWardrobeHex(value),
      rgb: wardrobeRgbLabel(value)
    });
  }

  function updateWardrobeColorState(root, field, value) {
    if (['primary', 'secondary', 'accent', 'finish'].indexOf(field) === -1) return false;
    var hex = normalizeWardrobeHex(value);
    if (!hex) return false;
    var state = root._stickerState;
    state.wardrobeColorTarget = field;
    state.wardrobeCustomColors = state.wardrobeCustomColors || { primary: '#16233F' };
    state.wardrobeCustomColors[field] = hex;
    state.wardrobeChosenColorRoles = state.wardrobeChosenColorRoles || {};
    state.wardrobeChosenColorRoles[field] = true;
    var entry = getLocalWardrobeEntry(root, state.approvedAvatarGarmentId);
    var defaults = entry ? wardrobeCurrentColors(entry) : {};
    state.wardrobePaletteEdited = Object.keys(defaults).some(function (role) {
      return normalizeWardrobeHex(state.wardrobeCustomColors[role]) !== normalizeWardrobeHex(defaults[role]);
    });
    state.wardrobePaletteMode = state.wardrobePaletteEdited ? 'custom' : 'catalog';
    state.wardrobePaletteValidated = false;
    qsa(root, '[data-wardrobe-color="' + field + '"]').forEach(function (input) { input.value = hex; });
    qsa(root, '[data-wardrobe-hex="' + field + '"]').forEach(function (input) { input.value = hex; });
    qsa(root, '[data-wardrobe-rgb="' + field + '"]').forEach(function (input) { input.value = wardrobeRgbLabel(hex); });
    qsa(root, '[data-wardrobe-palette-summary="requested"] [data-wardrobe-summary-color="' + field + '"]').forEach(function (swatch) { swatch.style.backgroundColor = hex; });
    if (entry) {
      var roles = wardrobeColorRoles(entry);
      var palette = wardrobePaletteEntries(entry);
      var paletteColor = field === 'finish' ? entry.finish && entry.finish.color : palette[roles.indexOf(field)];
      qsa(root, '[data-wardrobe-palette-summary="requested"] [data-wardrobe-summary-label="' + field + '"]').forEach(function (label) {
        label.textContent = wardrobeColorDescription(root, field, hex, paletteColor);
      });
      qsa(root, '.sticker-customizer__wardrobe-custom-field').forEach(function (label) {
        var control = qs(label, '[data-wardrobe-color]');
        label.classList.toggle('is-unset', !!control && state.wardrobeChosenColorRoles[control.getAttribute('data-wardrobe-color')] !== true);
      });
      var required = wardrobeRequiredColorRoles(entry);
      var nextRole = required.find(function (role) { return state.wardrobeChosenColorRoles[role] !== true; });
      if (nextRole) state.wardrobeColorTarget = nextRole;
      var validate = qs(root, '[data-local-action="validate-wardrobe-colors"]');
      if (validate) validate.disabled = !wardrobeHasChosenEveryColor(state, entry) || Object.keys(state.wardrobeColorInvalidFields || {}).length > 0;
      syncMiaRuntimeChoices(root, 'color'); markAssistantContextChanged(root, 'color'); publishGuidedContext(root);
    }
    return true;
  }

  function setWardrobeColorValidity(root, input, field, valid) {
    var state = root._stickerState;
    state.wardrobeColorInvalidFields = state.wardrobeColorInvalidFields || {};
    state.wardrobePaletteValidated = false;
    if (valid) delete state.wardrobeColorInvalidFields[field];
    else {
      state.wardrobeColorInvalidFields[field] = true;
      state.wardrobeColorInvalidMessage = input.validationMessage || localCopy(root, 'wardrobeValidate');
    }
    qsa(root, '[data-wardrobe-color="' + field + '"], [data-wardrobe-hex="' + field + '"], [data-wardrobe-rgb="' + field + '"]').forEach(function (control) {
      control.setAttribute('aria-invalid', String(!valid && control === input));
    });
    var error = qs(root, '[data-wardrobe-color-error]');
    if (error) {
      var hasErrors = Object.keys(state.wardrobeColorInvalidFields).length > 0;
      if (!hasErrors) state.wardrobeColorInvalidMessage = '';
      error.textContent = hasErrors ? state.wardrobeColorInvalidMessage : '';
      error.hidden = !hasErrors;
    }
    var validate = qs(root, '[data-local-action="validate-wardrobe-colors"]');
    if (validate) {
      validate.textContent = localCopy(root, 'wardrobeValidate');
      var entry = getLocalWardrobeEntry(root, state.approvedAvatarGarmentId);
      validate.disabled = Object.keys(state.wardrobeColorInvalidFields).length > 0 || !wardrobeHasChosenEveryColor(state, entry);
    }
    return valid;
  }

  function beginLocalWardrobeEdit(root, requestedStage) {
    var state = root._stickerState;
    if (!root._wardrobeEditSnapshot) {
      root._wardrobeEditSnapshot = {
        approvedAvatarGarmentId: state.approvedAvatarGarmentId,
        wardrobeCustomColors: JSON.parse(JSON.stringify(state.wardrobeCustomColors || {})),
        wardrobePaletteMode: state.wardrobePaletteMode,
        wardrobeStage: state.wardrobeStage,
        wardrobePaletteEdited: state.wardrobePaletteEdited,
        wardrobePaletteValidated: state.wardrobePaletteValidated,
        wardrobeChosenColorRoles: JSON.parse(JSON.stringify(state.wardrobeChosenColorRoles || {})),
        requestedPrimaryColor: state.requestedPrimaryColor,
        requestedSecondaryColor: state.requestedSecondaryColor,
        requestedAccentColor: state.requestedAccentColor,
        requestedFinishColor: state.requestedFinishColor,
        approvedAvatarPaletteSource: state.approvedAvatarPaletteSource
      };
    }
    state.wardrobeEditing = true;
    state.wardrobeStage = requestedStage === 'colors' && getLocalWardrobeEntry(root, state.approvedAvatarGarmentId) ? 'colors' : 'outfit';
    state.wardrobePaletteMode = state.wardrobeStage === 'colors' ? 'custom' : 'catalog';
    state.wardrobePaletteValidated = false;
    state.wardrobeChosenColorRoles = {};
  }

  function cancelLocalWardrobeEdit(root) {
    var state = root._stickerState;
    var snapshot = root._wardrobeEditSnapshot;
    if (snapshot) Object.keys(snapshot).forEach(function (key) {
      state[key] = snapshot[key] === undefined ? undefined : JSON.parse(JSON.stringify(snapshot[key]));
    });
    state.wardrobeEditing = false;
    root._wardrobeEditSnapshot = null;
    qsa(root, '[data-mia-choice="garment"]').forEach(function (input) { input.checked = input.value === state.approvedAvatarGarmentId; });
    syncMiaRuntimeChoices(root, 'color');
    markAssistantContextChanged(root, 'garment');
  }

  function renderLocalWardrobe(root, container) {
    var paletteEntriesFor = typeof wardrobePaletteEntries === 'function' ? wardrobePaletteEntries : function (entry) {
      return (entry && Array.isArray(entry.palette) ? entry.palette : []).map(function (color) {
        return typeof color === 'string' ? { name: '', hex: color } : color;
      });
    };
    var rolesFor = typeof wardrobeColorRoles === 'function' ? wardrobeColorRoles : function (entry) {
      return ['primary', 'secondary', 'accent'].slice(0, Math.max(1, Math.min(3, Number(entry && entry.colorSlots) || 1)));
    };
    var currentColorsFor = typeof wardrobeCurrentColors === 'function' ? wardrobeCurrentColors : function (entry) {
      var palette = paletteEntriesFor(entry); var colors = {};
      rolesFor(entry).forEach(function (role, index) { colors[role] = palette[index] && palette[index].hex || entry && entry.primaryColor || '#000000'; });
      return colors;
    };
    var audienceFor = function (entry) {
      var match = entry && String(entry.id || '').match(/-(girl|boy)-outfit-/);
      return match ? match[1] : '';
    };
    var styleColors = function (entries) {
      var colors = [];
      var add = function (value) {
        value = typeof value === 'string' ? value.toUpperCase() : '';
        if (/^#[0-9A-F]{6}$/.test(value) && colors.indexOf(value) === -1) colors.push(value);
      };
      entries.forEach(function (entry) {
        add(entry.primaryColor);
        if (Array.isArray(entry.colorDefaults)) entry.colorDefaults.forEach(function (color) { add(color && color.hex); });
        else if (Array.isArray(entry.palette)) entry.palette.forEach(function (color) { add(typeof color === 'string' ? color : color && color.hex); });
      });
      return colors.slice(0, 18);
    };
    var colorSummary = function (entry, colors, titleKey) {
      var summary = document.createElement('span');
      summary.className = 'sticker-customizer__wardrobe-color-summary';
      summary.setAttribute('data-wardrobe-palette-summary', titleKey === 'wardrobeRequestedPalette' ? 'requested' : 'current');
      summary.setAttribute('aria-label', localCopy(root, titleKey));
      var heading = document.createElement('strong'); heading.textContent = localCopy(root, titleKey); summary.appendChild(heading);
      var roles = rolesFor(entry);
      if (entry.finish && entry.finish.color) roles.push('finish');
      var palette = paletteEntriesFor(entry);
      roles.forEach(function (role, index) {
        var item = document.createElement('span'); var label = document.createElement('span'); var swatch = document.createElement('span');
        var paletteColor = role === 'finish' ? entry.finish.color : palette[index];
        label.textContent = typeof wardrobeColorDescription === 'function'
          ? wardrobeColorDescription(root, role, colors[role], paletteColor)
          : localCopy(root, 'wardrobe' + role.charAt(0).toUpperCase() + role.slice(1));
        if (titleKey === 'wardrobeRequestedPalette') label.setAttribute('data-wardrobe-summary-label', role);
        swatch.className = 'sticker-customizer__local-swatch'; swatch.style.backgroundColor = colors[role];
        if (titleKey === 'wardrobeRequestedPalette') swatch.setAttribute('data-wardrobe-summary-color', role);
        swatch.setAttribute('aria-hidden', 'true');
        item.appendChild(label); item.appendChild(swatch); summary.appendChild(item);
      });
      return summary;
    };
    var state = root._stickerState;
    var family = state.wardrobeFamily || 'all';
    var audience = ['girl', 'boy', 'all'].indexOf(state.wardrobeAudience) >= 0 ? state.wardrobeAudience : 'all';
    var selectedEntry = getLocalWardrobeEntry(root, state.approvedAvatarGarmentId);
    var stage = state.wardrobeStage === 'colors' && selectedEntry ? 'colors' : 'outfit';
    var mode = stage === 'colors' ? 'custom' : 'catalog';
    var styleEntries = (root._wardrobeCatalog || []).filter(function (entry) { return entry.style === state.style; });
    var entries = styleEntries.filter(function (entry) { return audience === 'all' || audienceFor(entry) === audience; });
    if (!state.wardrobeEditing) {
      var currentCards = document.createElement('div');
      currentCards.className = 'sticker-customizer__wardrobe-cards sticker-customizer__wardrobe-selected';
      var currentStyle = getMiaSelected(root, 'style');
      var currentLabel = selectedEntry && selectedEntry.labelKey ? localCopy(root, 'wardrobeOutfits.' + selectedEntry.id) : localCopy(root, 'currentOutfit');
      var currentAsset = selectedEntry ? selectedEntry.pickerImage || selectedEntry.image : currentStyle && currentStyle.getAttribute('data-preview-' + (state.presentationMode || 'standard'));
      localChoiceButton(root, currentCards, currentLabel, 'wardrobe-outfit:' + (selectedEntry ? selectedEntry.id : 'current'), true, currentAsset);
      container.appendChild(currentCards);
      if (selectedEntry) container.appendChild(colorSummary(selectedEntry, state.wardrobeCustomColors || currentColorsFor(selectedEntry), 'wardrobeRequestedPalette'));
      var editActions = document.createElement('div');
      editActions.className = 'sticker-customizer__wardrobe-entry-actions';
      var customizeWardrobe = createLocalButton(root, localCopy(root, 'wardrobeCustom'), 'data-local-action', 'customize-wardrobe-colors');
      customizeWardrobe.className = 'sticker-customizer__wardrobe-customize';
      editActions.appendChild(customizeWardrobe);
      var editWardrobe = createLocalButton(root, localCopy(root, 'wardrobeChangeOutfit'), 'data-local-action', 'change-wardrobe-outfit');
      editWardrobe.className = 'sticker-customizer__wardrobe-change';
      editActions.appendChild(editWardrobe);
      container.appendChild(editActions);
      var currentHint = document.createElement('p');
      currentHint.className = 'sticker-customizer__wardrobe-hint';
      currentHint.textContent = localCopy(root, 'wardrobeReferenceHint');
      container.appendChild(currentHint);
      return;
    }
    if (stage === 'outfit') {
      var audienceToolbar = document.createElement('div');
      audienceToolbar.className = 'sticker-customizer__wardrobe-audiences';
      audienceToolbar.setAttribute('role', 'group');
      audienceToolbar.setAttribute('aria-label', localCopy(root, 'wardrobeAudienceLabel'));
      [['girl', 'wardrobeForMia'], ['boy', 'wardrobeBoys'], ['all', 'wardrobeAllOutfits']].forEach(function (definition) {
        var button = createLocalButton(root, localCopy(root, definition[1]), 'data-local-choice', 'wardrobe-audience:' + definition[0]);
        button.setAttribute('aria-pressed', String(audience === definition[0]));
        audienceToolbar.appendChild(button);
      });
      container.appendChild(audienceToolbar);
      var toolbar = document.createElement('div'); toolbar.className = 'sticker-customizer__wardrobe-families';
      ['all', 'blue', 'green', 'teal', 'pink', 'purple', 'red', 'coral', 'yellow', 'neutral', 'dark'].forEach(function (key) {
        if (key !== 'all' && !entries.some(function (entry) { return entry.families.indexOf(key) >= 0; })) return;
        var title = key === 'all' ? 'wardrobeAll' : 'wardrobeFamily' + key.charAt(0).toUpperCase() + key.slice(1);
        var button = createLocalButton(root, localCopy(root, title), 'data-local-choice', 'wardrobe-family:' + key);
        button.setAttribute('aria-pressed', String(family === key));
        var familyEntry = entries.find(function (entry) { return entry.families[0] === key; });
        if (familyEntry) { var swatch = document.createElement('span'); swatch.className = 'sticker-customizer__local-swatch'; swatch.style.backgroundColor = familyEntry.primaryColor; swatch.setAttribute('aria-hidden', 'true'); button.appendChild(swatch); }
        toolbar.appendChild(button);
      });
      container.appendChild(toolbar);
    } else {
      var selectedCards = document.createElement('div'); selectedCards.className = 'sticker-customizer__wardrobe-cards sticker-customizer__wardrobe-selected';
      var selectedLabel = selectedEntry.labelKey ? localCopy(root, 'wardrobeOutfits.' + selectedEntry.id) : '';
      localChoiceButton(root, selectedCards, selectedLabel, 'wardrobe-outfit:' + selectedEntry.id, true, selectedEntry.pickerImage || selectedEntry.image);
      container.appendChild(selectedCards);
      var change = createLocalButton(root, localCopy(root, 'wardrobeChangeOutfit'), 'data-local-action', 'change-wardrobe-outfit');
      change.className = 'sticker-customizer__wardrobe-change'; container.appendChild(change);
    }
    var cancelChange = createLocalButton(root, localCopy(root, 'back'), 'data-local-action', 'cancel-wardrobe-edit');
    cancelChange.className = 'sticker-customizer__wardrobe-cancel';
    container.appendChild(cancelChange);
    var hint = document.createElement('p'); hint.className = 'sticker-customizer__wardrobe-hint';
    hint.textContent = localCopy(root, root._wardrobeError ? 'wardrobeUnavailable' : stage === 'colors' ? 'wardrobeCustomHint' : 'wardrobeReferenceHint'); container.appendChild(hint);
    if (mode === 'custom') {
      var defaults = currentColorsFor(selectedEntry || entries[0]);
      var colors = state.wardrobeCustomColors || Object.assign({}, defaults);
      state.wardrobeCustomColors = colors;
      var recommendation = document.createElement('strong'); recommendation.className = 'sticker-customizer__wardrobe-recommendation';
      recommendation.textContent = localCopy(root, state.wardrobePaletteEdited ? 'wardrobeCustomized' : 'wardrobeRecommended'); container.appendChild(recommendation);
      if (selectedEntry) container.appendChild(colorSummary(selectedEntry, currentColorsFor(selectedEntry), 'wardrobeCurrentPalette'));
      var fields = document.createElement('div'); fields.className = 'sticker-customizer__wardrobe-palette';
      var roles = selectedEntry ? rolesFor(selectedEntry) : ['primary'];
      if (selectedEntry && selectedEntry.finish && selectedEntry.finish.color) roles.push('finish');
      state.wardrobeChosenColorRoles = state.wardrobeChosenColorRoles || {};
      roles.forEach(function (key) {
        colors[key] = (typeof normalizeWardrobeHex === 'function' ? normalizeWardrobeHex(colors[key]) : colors[key]) || defaults[key] || '#000000';
        var label = document.createElement('label');
        label.className = 'sticker-customizer__wardrobe-custom-field' + (state.wardrobeColorTarget === key ? ' is-active' : '') + (state.wardrobeChosenColorRoles[key] === true ? '' : ' is-unset');
        label.textContent = localCopy(root, 'wardrobe' + key.charAt(0).toUpperCase() + key.slice(1));
        var input = document.createElement('input'); input.type = 'color'; input.value = colors[key]; input.setAttribute('data-wardrobe-color', key); label.appendChild(input); fields.appendChild(label);
        var hex = document.createElement('input'); hex.type = 'text'; hex.value = colors[key]; hex.inputMode = 'text'; hex.pattern = '#[0-9A-Fa-f]{6}';
        hex.setAttribute('data-wardrobe-hex', key); hex.setAttribute('aria-label', localCopy(root, 'wardrobeHex', { role: label.textContent })); label.appendChild(hex);
        var rgb = document.createElement('input'); rgb.type = 'text'; rgb.value = typeof wardrobeRgbLabel === 'function' ? wardrobeRgbLabel(colors[key]) : colors[key]; rgb.inputMode = 'numeric'; rgb.pattern = '(?:RGB\\s*)?\\(?\\s*(?:25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})\\s*[, ]\\s*(?:25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})\\s*[, ]\\s*(?:25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})\\s*\\)?';
        rgb.setAttribute('data-wardrobe-rgb', key); rgb.setAttribute('aria-label', localCopy(root, 'wardrobeRgb', { role: label.textContent })); label.appendChild(rgb);
      }); container.appendChild(fields);
      var paletteError = document.createElement('p'); paletteError.className = 'sticker-customizer__wardrobe-color-error';
      paletteError.setAttribute('data-wardrobe-color-error', ''); paletteError.setAttribute('role', 'alert'); paletteError.setAttribute('aria-live', 'polite'); paletteError.hidden = true;
      if (Object.keys(state.wardrobeColorInvalidFields || {}).length) {
        paletteError.textContent = state.wardrobeColorInvalidMessage || localCopy(root, 'wardrobeValidate');
        paletteError.hidden = false;
      }
      container.appendChild(paletteError);
      if (selectedEntry) container.appendChild(colorSummary(selectedEntry, colors, 'wardrobeRequestedPalette'));
      var stylePalette = document.createElement('details'); stylePalette.className = 'sticker-customizer__wardrobe-style-palette';
      var paletteTitle = document.createElement('summary'); paletteTitle.textContent = localCopy(root, 'colorInspirations'); stylePalette.appendChild(paletteTitle);
      var paletteSwatches = document.createElement('div'); paletteSwatches.setAttribute('role', 'group'); paletteSwatches.setAttribute('aria-label', localCopy(root, 'wardrobeStyleColors'));
      styleColors(styleEntries).forEach(function (color) {
        var button = createLocalButton(root, '', 'data-local-choice', 'wardrobe-palette:' + color);
        button.className = 'sticker-customizer__wardrobe-style-color';
        button.style.backgroundColor = color;
        button.setAttribute('aria-label', localCopy(root, 'wardrobeUseStyleColor', { color: color }));
        button.title = color;
        paletteSwatches.appendChild(button);
      });
      stylePalette.appendChild(paletteSwatches); container.appendChild(stylePalette);
      var validate = createLocalButton(root, localCopy(root, state.wardrobePaletteValidated ? 'wardrobeValidated' : 'wardrobeValidate'), 'data-local-action', 'validate-wardrobe-colors');
      validate.className = 'sticker-customizer__wardrobe-validate';
      validate.disabled = !selectedEntry || !!state.wardrobePaletteValidated || !wardrobeHasChosenEveryColor(state, selectedEntry) || Object.keys(state.wardrobeColorInvalidFields || {}).length > 0;
      container.appendChild(validate);
    }
    if (stage === 'outfit') {
      var cards = document.createElement('div'); cards.className = 'sticker-customizer__wardrobe-cards'; container.appendChild(cards);
      entries.filter(function (entry) { return family === 'all' || entry.families.indexOf(family) >= 0; }).forEach(function (entry) {
        var selected = state.approvedAvatarGarmentId === entry.id;
        var outfitLabel = entry.labelKey ? localCopy(root, 'wardrobeOutfits.' + entry.id) : '';
        if (!outfitLabel) return;
        var outfitButton = localChoiceButton(root, cards, outfitLabel, 'wardrobe-outfit:' + entry.id, selected, entry.pickerImage || entry.image);
        outfitButton.appendChild(colorSummary(entry, currentColorsFor(entry), 'wardrobeCurrentPalette'));
      });
    }
    if (stage === 'outfit' && state.style === 'signature' && family === 'all') {
      var details = document.createElement('details'); var summary = document.createElement('summary'); summary.textContent = localCopy(root, 'wardrobeLegacy'); details.appendChild(summary);
      var legacy = document.createElement('div'); legacy.className = 'sticker-customizer__wardrobe-cards'; details.appendChild(legacy);
      qsa(root, '[data-mia-choice="garment"]').filter(function (input) { return input.value.indexOf('garment-') === 0; }).forEach(function (input) {
        var image = qs(input.closest('label'), 'img'); localChoiceButton(root, legacy, getMiaChoiceLabel(input), 'wardrobe-outfit:' + input.value, state.approvedAvatarGarmentId === input.value, image && image.src);
      }); container.appendChild(details);
    }
  }

  function applyLocalWardrobeChoice(root, value) {
    var state = root._stickerState;
    if (value.indexOf('wardrobe-audience:') === 0) {
      var audience = value.slice(18);
      if (['girl', 'boy', 'all'].indexOf(audience) >= 0) state.wardrobeAudience = audience;
      return;
    }
    if (value.indexOf('wardrobe-palette:') === 0) {
      var color = value.slice('wardrobe-palette:'.length).toUpperCase();
      var target = ['primary', 'secondary', 'accent', 'finish'].indexOf(state.wardrobeColorTarget) >= 0 ? state.wardrobeColorTarget : 'primary';
      if (!/^#[0-9A-F]{6}$/.test(color)) return;
      if (!updateWardrobeColorState(root, target, color)) return;
      if (state.wardrobeColorInvalidFields) delete state.wardrobeColorInvalidFields[target];
      if (!Object.keys(state.wardrobeColorInvalidFields || {}).length) state.wardrobeColorInvalidMessage = '';
      return;
    }
    if (value.indexOf('wardrobe-family:') === 0) {
      var family = value.slice(16);
      state.wardrobePaletteMode = 'catalog';
      state.wardrobePaletteValidated = false;
      state.wardrobeColorInvalidFields = {};
      state.wardrobeColorInvalidMessage = '';
      state.wardrobeFamily = family;
      if (getLocalWardrobeEntry(root, state.approvedAvatarGarmentId)) syncMiaRuntimeChoices(root, 'color');
      return;
    }
    var id = value.slice(16);
    if (id === 'current') {
      id = 'garment-yoke-blouse-dress'; state.wardrobePaletteMode = 'catalog';
      qsa(root, '[data-mia-choice="color"]').forEach(function (input) { input.checked = input.value === 'original'; });
      state.wardrobeEditing = false;
      state.wardrobeStage = 'outfit';
      state.wardrobePaletteValidated = true;
      state.wardrobeChosenColorRoles = {};
    }
    var entry = getLocalWardrobeEntry(root, id);
    if (entry && entry.style !== state.style) return;
    if (entry && !state.wardrobeEditing && state.approvedAvatarGarmentId === id) return;
    state.approvedAvatarGarmentId = id;
    state.wardrobeStage = entry ? 'colors' : 'outfit';
    state.wardrobePaletteMode = 'catalog';
    state.wardrobePaletteValidated = !entry;
    state.wardrobePaletteEdited = false;
    state.wardrobeChosenColorRoles = {};
    state.wardrobeColorInvalidFields = {};
    state.wardrobeColorInvalidMessage = '';
    if (entry) state.wardrobeCustomColors = wardrobeCurrentColors(entry);
    qsa(root, '[data-mia-choice="garment"]').forEach(function (input) { input.checked = input.value === id; });
    syncMiaRuntimeChoices(root, 'color'); markAssistantContextChanged(root, 'garment');
  }

  function normalizeTextColor(value) {
    return typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value.trim()) ? value.trim().toUpperCase() : '#000000';
  }

  function applyTextColorPreview(root) {
    var color = normalizeTextColor(root._stickerState.textColor);
    qsa(root, '.sticker-customizer__text--top, .sticker-customizer__text--bottom, [data-sticker-preview-text]').forEach(function (element) { element.style.fill = color; });
  }

  function setLocalTextColor(root, value) {
    var valid = typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value.trim());
    var hex = qs(root, '[data-local-text-color-hex]');
    var error = qs(root, '[data-local-text-color-error]');
    if (hex) hex.setAttribute('aria-invalid', String(!valid));
    if (error) error.hidden = valid;
    if (!valid) return false;
    root._stickerState.textColor = normalizeTextColor(value);
    applyTextColorPreview(root);
    qsa(root, '[data-local-text-color-preset]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.getAttribute('data-local-text-color-preset') === root._stickerState.textColor)); });
    var picker = qs(root, '[data-local-text-color-input]');
    if (picker) picker.value = root._stickerState.textColor;
    var inspirations = qs(root, '[data-local-text-color-select]');
    if (inspirations) inspirations.value = Array.from(inspirations.options).some(function (option) { return option.value === root._stickerState.textColor; }) ? root._stickerState.textColor : '';
    var colorMenu = qs(root, '[data-local-color-menu]');
    if (colorMenu) {
      qs(colorMenu, '[data-local-color-swatch]').style.backgroundColor = root._stickerState.textColor;
      var selected = inspirations && Array.from(inspirations.options).find(function (option) { return option.value === root._stickerState.textColor; });
      qs(colorMenu, '[data-local-color-name]').textContent = selected ? selected.textContent : root._stickerState.textColor;
      var summary = qs(colorMenu, 'summary');
      summary.setAttribute('aria-label', localCopy(root, 'colorInspirations') + ' : ' + qs(colorMenu, '[data-local-color-name]').textContent);
      var restoreFocus = colorMenu.contains(document.activeElement) && document.activeElement !== summary;
      colorMenu.open = false;
      if (restoreFocus) summary.focus({ preventScroll: true });
    }
    if (hex) hex.value = root._stickerState.textColor;
    updateConfig(root);
    persistLocalSession(root);
    return true;
  }

  function renderLocalTextColorControls(root, container) {
    var color = normalizeTextColor(root._stickerState.textColor);
    var group = document.createElement('fieldset'); group.className = 'sticker-customizer__text-colors';
    var legend = document.createElement('legend'); legend.textContent = translate(root, 'textColorTitle'); group.appendChild(legend);
    var hint = document.createElement('p'); hint.textContent = translate(root, 'textColorHint'); group.appendChild(hint);
    var inspiration = document.createElement('div'); inspiration.className = 'sticker-customizer__color-inspirations'; inspiration.textContent = localCopy(root, 'colorInspirations');
    var swatches = document.createElement('select'); swatches.setAttribute('data-local-text-color-select', '');
    var prompt = document.createElement('option'); prompt.value = ''; prompt.disabled = true; prompt.textContent = localCopy(root, 'colorSuggestionPrompt'); swatches.appendChild(prompt);
    [['Black', '#000000'], ['White', '#FFFFFF'], ['Ivory', '#FFF4DF'], ['Navy', '#18344A'], ['Forest', '#244D3B'], ['Burgundy', '#762C45'], ['Gold', '#9B6617']].forEach(function (preset) {
      var option = document.createElement('option'); option.value = preset[1]; option.textContent = translate(root, 'textColor' + preset[0]); swatches.appendChild(option);
    });
    swatches.value = Array.from(swatches.options).some(function (option) { return option.value === color; }) ? color : '';
    swatches.hidden = true; swatches.tabIndex = -1; swatches.setAttribute('aria-hidden', 'true');
    inspiration.appendChild(swatches);
    var menu = document.createElement('details'); menu.setAttribute('data-local-color-menu', '');
    var summary = document.createElement('summary'), chip = document.createElement('span'), current = document.createElement('span');
    chip.setAttribute('data-local-color-swatch', ''); chip.setAttribute('aria-hidden', 'true'); chip.style.backgroundColor = color;
    current.setAttribute('data-local-color-name', ''); current.textContent = swatches.selectedOptions.length && swatches.value ? swatches.selectedOptions[0].textContent : color;
    summary.setAttribute('aria-label', localCopy(root, 'colorInspirations') + ' : ' + current.textContent);
    summary.appendChild(chip); summary.appendChild(current); menu.appendChild(summary);
    var choices = document.createElement('div'); choices.className = 'sticker-customizer__color-options';
    Array.from(swatches.options).filter(function (option) { return option.value; }).forEach(function (option) {
      var button = document.createElement('button'); button.type = 'button'; button.setAttribute('data-local-text-color-preset', option.value);
      button.setAttribute('aria-pressed', String(option.value === color));
      var rectangle = document.createElement('span'); rectangle.className = 'sticker-customizer__color-chip'; rectangle.style.backgroundColor = option.value; rectangle.setAttribute('aria-hidden', 'true');
      button.appendChild(rectangle); button.appendChild(document.createTextNode(option.textContent)); choices.appendChild(button);
    });
    menu.appendChild(choices); inspiration.appendChild(menu); group.appendChild(inspiration);
    var pickerLabel = document.createElement('label'); pickerLabel.textContent = translate(root, 'textColorCustom');
    var picker = document.createElement('input'); picker.type = 'color'; picker.value = color; picker.setAttribute('data-local-text-color-input', ''); pickerLabel.appendChild(picker); group.appendChild(pickerLabel);
    var hexLabel = document.createElement('label'); hexLabel.textContent = translate(root, 'textColorHex');
    var hex = document.createElement('input'); hex.type = 'text'; hex.value = color; hex.maxLength = 7; hex.spellcheck = false; hex.autocomplete = 'off'; hex.setAttribute('data-local-text-color-hex', ''); hex.setAttribute('aria-invalid', 'false');
    var error = document.createElement('p'); error.id = (root.id || 'sticker') + '-text-color-error'; error.hidden = true; error.setAttribute('data-local-text-color-error', ''); error.setAttribute('role', 'status'); error.textContent = translate(root, 'textColorError');
    hex.setAttribute('aria-describedby', error.id); hexLabel.appendChild(hex); group.appendChild(hexLabel); group.appendChild(error); container.appendChild(group);
  }

  function renderLocalChoices(root, step, container) {
    var state = root._stickerState;
    var category = step === 'hairstyle' ? 'hair' : step;
    var controls;
    var input = qs(root, '[data-local-input]');
    var inputLabel = qs(root, '[data-local-input-label]');
    container.textContent = '';
    inputLabel.hidden = true;
    if (step === 'sun') {
      var help = document.createElement('p'); help.className = 'sticker-customizer__sun-help'; help.textContent = localCopy(root, 'sunHelp'); container.appendChild(help);
      localChoiceButton(root, container, localCopy(root, 'sunOff'), 'off', !state.sunEnabled);
      localChoiceButton(root, container, localCopy(root, 'sunOn'), 'on', state.sunEnabled === true, qs(root, '[data-sticker-sun-preview]').src);
      return;
    }
    if (renderCastCustomizationChoices(root, step, container)) return;
    if (renderCastPreviewChoices(root, step, container)) return;
    if (root._stickerState.approvedAvatarId === 'clara' && claraPreviewEnabled(root) && renderClaraChoices(root, step, container)) return;
    if (step === 'avatar-fade') { renderLocalAvatarFadeControls(root, container); return; }
    if (typeof appendLocalRetainedImage === 'function') appendLocalRetainedImage(root, container, step);
    if (step === 'color' && root._wardrobeReady && root.getAttribute('data-wardrobe-catalog')) { renderLocalWardrobe(root, container); return; }
    if (step === 'mode') { renderLocalModeChoices(root, container); return; }
    if (step === 'photo') {
      localChoiceButton(root, container, state.approvedAvatarId === 'clara' ? localCopy(root, 'claraApprovedAppearance') : localCopy(root, 'keepMia'), 'keep-mia', state.subjectSource === 'approved-avatar');
      localChoiceButton(root, container, localCopy(root, 'addPhoto'), 'photo', state.subjectSource === 'photo');
      if (isMiaPrivatePilotReady(root)) container.lastElementChild.disabled = true;
      return;
    }
    if (step.indexOf('text-') === 0 || step === 'symbol') {
      var position = step.slice(5);
      var value = step === 'symbol' ? state.symbol : getTextValue(root, position);
      if (step === 'symbol') {
        localChoiceButton(root, container, localCopy(root, 'noSymbol'), '', !value);
        ['★', '♥', '☀'].forEach(function (symbol) { localChoiceButton(root, container, symbol, symbol, value === symbol); });
      } else renderLocalTextSuggestions(root, container, position, value);
      inputLabel.hidden = false;
      qs(root, '[data-local-input-title]').textContent = localTitle(root, step);
      if (step === 'symbol') input.removeAttribute('maxlength');
      else input.maxLength = parseInt(root.getAttribute('data-max-chars'), 10) || 26;
      if (document.activeElement !== input) input.value = value || '';
      if (step !== 'symbol') { renderLocalTextSizeControls(root, container, position); renderLocalTextColorControls(root, container); }
      return;
    }
    if (step === 'fade') {
      var backing = getLocalWhiteBacking(root);
      ['band', 'outline', 'bold', 'soft', 'offset', 'double', 'fine', 'cushion', 'glow', 'lifted', 'triple'].forEach(function (style) {
        localChoiceButton(root, container, localCopy(root, 'halo' + style.charAt(0).toUpperCase() + style.slice(1)), style, backing.enabled && (backing.style || 'band') === style);
      });
      localChoiceButton(root, container, localCopy(root, 'haloOff'), 'off', !backing.enabled);
      if (backing.enabled) container.appendChild(createLocalButton(root, localCopy(root, 'refine'), 'data-local-action', 'refine-halo'));
      return;
    }
    if (step === 'hairstyle') {
      [['girl', 'wardrobeForMia'], ['all', 'allHairstyles']].forEach(function (definition) {
        localChoiceButton(root, container, localCopy(root, definition[1]), 'hair-audience:' + definition[0],
          (state.hairAudience || 'girl') === definition[0]);
      });
      var currentHairStyle = getMiaSelected(root, 'style');
      localChoiceButton(root, container, localCopy(root, 'currentHair'), '', !state.approvedAvatarHairstyleId,
        currentHairStyle && currentHairStyle.getAttribute('data-preview-' + (state.presentationMode || 'standard')));
    }
    if (step === 'garment' && state.style !== 'signature') {
      var currentStyle = getMiaSelected(root, 'style');
      localChoiceButton(root, container, localCopy(root, 'currentOutfit'), 'garment-yoke-blouse-dress', state.approvedAvatarGarmentId === 'garment-yoke-blouse-dress', currentStyle && currentStyle.getAttribute('data-preview-' + (state.presentationMode || 'standard')));
      return;
    }
    controls = step === 'fade' ? qsa(root, '[data-mia-choice="fade"] option') : qsa(root, '[data-mia-choice="' + category + '"]');
    controls.filter(function (control) {
      if (/^cast-custom-/.test(control.value)) return false;
      if (step === 'avatar') return control.value === 'mia' || control.value === 'clara' && claraPreviewEnabled(root);
      if (step === 'hairstyle' && (state.hairAudience || 'girl') !== 'all') {
        return ['hair-classic-bob', 'hair-curly-bob', 'hair-shoulder-waves', 'hair-shoulder-coils', 'hair-half-up-soft', 'hair-low-ponytail', 'hair-twin-braids', 'hair-two-strand-twists'].indexOf(control.value) >= 0;
      }
      if (step === 'garment') return control.getAttribute('data-garment-style') === state.style;
      if (step === 'background') return !control.getAttribute('data-background-style') || control.getAttribute('data-background-style') === state.style;
      if (step === 'fade') return state.selectedBackgroundId === 'background-none-white' ? !control.value : !!control.value;
      return true;
    }).forEach(function (control) {
      var owner = control.closest('label');
      var image = owner && qs(owner, 'img');
      var title = owner && qs(owner, 'strong');
      var asset = step === 'style' ? control.getAttribute('data-preview-' + (state.presentationMode || 'standard')) : image && image.getAttribute('src');
      if (step === 'hairstyle') asset = getMiaHairAsset(root, control);
      if (step === 'avatar') {
        var style = getMiaSelected(root, 'style');
        asset = control.value === 'clara' ? miaAssetUrl(root, CLARA_SIGNATURE_PREVIEWS['signature-girl-outfit-01']) : style && style.getAttribute('data-preview-' + (state.presentationMode || 'standard'));
      }
      if (step === 'fade') asset = control.getAttribute('data-fade-src');
      localChoiceButton(root, container, title ? title.textContent.trim() : owner ? owner.textContent.trim() : control.textContent.trim(), control.value,
        step === 'fade' ? control.selected : control.checked, asset, step === 'color' ? control.getAttribute('data-srgb-primary') : '');
    });
  }

  function localPrice(root, quantity) {
    if (typeof browserRecipeEnabled === 'function' && browserRecipeEnabled(root)) return browserRecipePrice(root, quantity);
    var data;
    try { data = JSON.parse(qs(root, '[data-local-variants]').textContent); } catch (error) { return null; }
    var variant = data.variants.find(function (entry) { return String(entry.id) === String(getSelectedVariantId(root)); });
    if (!variant || !Number.isFinite(variant.price) || variant.price < 0) return null;
    var privateQuantity = root && typeof root.getAttribute === 'function' && root.getAttribute('data-product-id') === '10530170274128';
    if (privateQuantity && (!Number.isInteger(quantity) || quantity < 1 || quantity > 10)) return null;
    var count = privateQuantity ? quantity : clamp(Number(quantity) || 1, 1, 99);
    var discount = clamp(Number(data.additionalDiscountPercent) || 0, 0, 100);
    var additionalUnitPrice = Math.round(variant.price * (100 - discount) / 100);
    var total = variant.price + (count - 1) * additionalUnitPrice;
    var format = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: data.currency || 'EUR' });
    return { variant: variant, currency: data.currency || 'EUR', cents: total, formatted: format.format(total / 100), unit: format.format(variant.price / 100), additionalUnit: format.format(additionalUnitPrice / 100), additionalUnitPrice: additionalUnitPrice, discount: discount };
  }

  // This phase is an ordinary Shopify cart route. No session, generation or quote API is used.
  function browserRecipeEnabled(root) {
    return !!root && root.getAttribute('data-browser-recipe-enabled') === 'true' &&
      root.getAttribute('data-product-id') === '10530170274128' &&
      root.getAttribute('data-product-handle') === PRIVATE_PILOT_PRODUCT_HANDLE &&
      (root.getAttribute('data-sticker-private-pilot-template-suffix') === 'clairatier-personnalisation' ||
        root._localReadonlyPreview === true && root.closest && !!root.closest('[data-clairatier-cart-renderer][inert]')) &&
      !!window.ClairatierBrowserRecipe;
  }

  function browserRecipePrice(root, quantity) {
    var data, variant;
    if (personalizedOffersEnabled(root)) {
      data = personalizedOffersCatalogue(root);
      variant = window.ClairatierPersonalizedOffers.variant(data, 'single', [quantity]);
    } else {
      try { data = JSON.parse(qs(root, '[data-local-variants]').textContent); } catch (_) { return null; }
      variant = window.ClairatierBrowserRecipe.packVariant(data, quantity, '53144689148240');
    }
    if (!variant) return null;
    var format = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: data.currency });
    return { variant: variant, currency: data.currency, cents: variant.price, formatted: format.format(variant.price / 100),
      unit: format.format(variant.price / 100), additionalUnitPrice: 0, discount: 0 };
  }

  function browserRecipeAssets(root) {
    var preview = qs(root, '[data-sticker-preview]'), result = [];
    qsa(preview, 'img').forEach(function (image) {
      var style = window.getComputedStyle(image);
      if (!image.hidden && style.display !== 'none' && style.visibility !== 'hidden') {
        var url = window.ClairatierBrowserRecipe.publicAsset(image.currentSrc || image.src);
        if (result.indexOf(url) < 0) result.push(url);
      }
    });
    qsa(preview, 'svg image').forEach(function (image) {
      var url = window.ClairatierBrowserRecipe.publicAsset(new URL(image.getAttribute('href') || image.getAttributeNS('http://www.w3.org/1999/xlink', 'href'), window.location.href).href);
      if (result.indexOf(url) < 0) result.push(url);
    });
    var font = Array.prototype.find.call(document.querySelectorAll('link[as="font"]'), function (link) { return /open_sans\/opensans_n7\./.test(link.href); });
    if (!font) throw new Error('BROWSER_RECIPE_FONT_UNAVAILABLE');
    result.push(window.ClairatierBrowserRecipe.publicAsset(font.href));
    result.sort();
    if (root._browserReplayRecipe && window.ClairatierBrowserRecipe.canonical(result) !== window.ClairatierBrowserRecipe.canonical(root._browserReplayRecipe.assets)) throw new Error('BROWSER_RECIPE_ASSET_CHANGED');
    return result;
  }

  async function captureBrowserRecipe(root) {
    if (!browserRecipeEnabled(root) || localPending(root) || root._proofLayoutUnavailable || root._browserRecipeInvalid) throw new Error('BROWSER_RECIPE_UNAVAILABLE');
    syncMultiAvatarPreview(root);
    var images = qsa(qs(root, '[data-sticker-preview]'), 'img').filter(function (image) { return !image.hidden && window.getComputedStyle(image).display !== 'none'; });
    await Promise.all(images.map(function (image) { return image.decode ? image.decode() : image.complete && image.naturalWidth ? Promise.resolve() : Promise.reject(new Error('BROWSER_RECIPE_IMAGE_UNAVAILABLE')); }));
    await Promise.all(Object.values(root._localAlphaPromises || {})); await Promise.resolve(document.fonts && document.fonts.ready);
    updatePhoto(root); syncLocalTextBacking(root); syncMultiAvatarPreview(root);
    var session = persistLocalSession(root); if (!session) throw new Error('BROWSER_RECIPE_SESSION_UNAVAILABLE');
    session.quantity = 1; session.step = 'avatar'; session.completed = LOCAL_JOURNEY_STEPS.slice();
    session.review = true; session.open = true; session.chat = false; session.chatExpanded = false; session.options = false;
    var recipe = { version: 'browser-recipe/1', renderer: 'shopify-watermarked/1', diameterMm: 140,
      session: session, textFlags: { top: !hasNoTextChoice(root, 'top'), bottom: !hasNoTextChoice(root, 'bottom') }, assets: browserRecipeAssets(root) };
    return window.ClairatierBrowserRecipe.validate(recipe);
  }

  async function loadBrowserRecipe(root) {
    var hash = window.location.hash, api = window.ClairatierBrowserRecipe;
    var cartRenderer = !!(root.closest && root.closest('[data-clairatier-cart-renderer]'));
    root._localReadonlyPreview = cartRenderer || new URLSearchParams(window.location.search).get('clairatier-preview') === '1';
    if (root._localReadonlyPreview && !cartRenderer) document.documentElement.classList.add('clairatier-recipe-preview');
    var legacySteps = ['avatar', 'style', 'color', 'photo', 'mode', 'hairstyle', 'symbol', 'text-top', 'text-bottom', 'background', 'sun', 'fade', 'avatar-fade'];
    try {
      if (hash.indexOf('#clairatier-recipe=') === 0) {
        var recipe = await api.decode(hash.slice('#clairatier-recipe='.length));
        var normalized = normalizeLocalSession(root, recipe.session);
        var comparable = Object.assign({}, recipe.session);
        if (normalized && Array.isArray(comparable.completed) && comparable.completed.every(function (step) { return legacySteps.indexOf(step) !== -1; }) && legacySteps.indexOf(comparable.step) !== -1) {
          comparable.step = normalized.step; comparable.completed = normalized.completed; comparable.review = normalized.review;
        }
        if (!normalized || api.canonical(normalized) !== api.canonical(comparable)) throw new Error('BROWSER_RECIPE_CHANGED');
        root._browserReplaySession = normalized; root._browserReplayRecipe = recipe;
      }
      if (root._localReadonlyPreview && !cartRenderer && !root._browserReplayRecipe) throw new Error('BROWSER_RECIPE_INVALID');
    } catch (_) { root._browserRecipeInvalid = true; root._browserRecipeErrorCode = /^BROWSER_RECIPE_[A-Z_]+$/.test(_.message) ? _.message : _.name; }
    var panel = document.querySelector('[data-browser-recipe-panel]');
    if (!panel || panel._bound) return;
    panel._bound = true;
    var status = qs(panel, '[data-browser-recipe-status]');
    if (root._browserRecipeInvalid) status.textContent = localCopy(root, 'browserError');
    qs(panel, '[data-browser-recipe-restore]').addEventListener('click', async function () {
      try {
        var raw = qs(panel, '[data-browser-recipe-input]').value;
        if (raw.length > 18000) throw new Error('BROWSER_RECIPE_SIZE');
        var input = JSON.parse(raw), restored;
        if (window.ClairatierPersonalizedOffers && (input.version === 'native-offer/1' || input._clairatier_offer_version)) {
          restored = window.ClairatierPersonalizedOffers.restore(input, Number(qs(panel, '[data-browser-recipe-design]').value));
        } else restored = input._clairatier_recipe_version ? api.fromProperties(input) : api.validate(input);
        var token = await api.encode(restored);
        window.location.assign(api.url(window.location.href, token)); window.location.reload();
      } catch (_) { status.textContent = localCopy(root, 'browserError'); }
    });
    qsa(document, '[data-browser-recipe-pdf]').forEach(function (pdfButton) { pdfButton.addEventListener('click', async function () {
      var button = this; button.disabled = true; status.textContent = localCopy(root, 'browserWorking');
      try {
        // Opening the modal gives the renderer real dimensions, including on a recovered order URL.
        var overlay = qs(root, '[data-sticker-overlay]'); if (overlay.hidden) open(root);
        var current = await captureBrowserRecipe(root);
        if (root._browserReplayRecipe && api.canonical(current.assets) !== api.canonical(root._browserReplayRecipe.assets)) throw new Error('BROWSER_RECIPE_ASSET_CHANGED');
        var canvas = await renderBrowserRecipeCanvas(root);
        var bytes = Uint8Array.from(window.atob(canvas.toDataURL('image/jpeg', 0.96).split(',')[1]), function (c) { return c.charCodeAt(0); });
        var pdf = api.pdf(bytes, canvas.width, 140), link = document.createElement('a'), url = URL.createObjectURL(pdf);
        link.href = url; link.download = 'clairatier-watermarked-140mm.pdf'; link.click();
        window.setTimeout(function () { URL.revokeObjectURL(url); }, 30000); status.textContent = localCopy(root, 'browserWatermark');
      } catch (_) { status.textContent = localCopy(root, 'browserError'); }
      finally { button.disabled = false; }
    }); });
  }

  async function submitBrowserRecipe(root, draft) {
    if (root._localReadonlyPreview) throw new Error('BROWSER_RECIPE_READONLY');
    if (personalizedOffersEnabled(root)) return submitPersonalizedOffer(root, 'single', draft ? [draft] : null);
    var journey = getLocalJourney(root), status = qs(root, '[data-local-cart-status]');
    if (journey.cartBusy) return;
    journey.cartBusy = true; renderLocalReview(root);
    try {
      var count = draft ? draft.quantity : journey.quantity, price = browserRecipePrice(root, count); if (!price) throw new Error('BROWSER_RECIPE_PRICE');
      var api = window.ClairatierBrowserRecipe;
      var recipe = draft ? api.validate(JSON.parse(api.canonical(draft.browserRecipe))) : await captureBrowserRecipe(root);
      var id = await api.fingerprint(recipe), token = await api.encode(recipe), url = api.url(window.location.href, token);
      var beforeResponse = await window.fetch(getCartUrl('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!beforeResponse.ok) throw new Error('BROWSER_RECIPE_CART');
      var before = await beforeResponse.json(), total = 0;
      if (before.currency !== price.currency || !Array.isArray(before.items)) throw new Error('BROWSER_RECIPE_CURRENCY');
      before.items.forEach(function (item) {
        if (item.properties && item.properties._clairatier_design_id === id) {
          // A creation is represented by exactly one native pack, never multiple prices for a browser-invented bundle.
          total += Number(item.properties._clairatier_pack_count || 1) * item.quantity;
        }
      });
      if (total + count > 10 || total || !draft && journey.quantity !== count) throw new Error('BROWSER_RECIPE_EXISTING_CREATION');
      var properties = api.properties(recipe, url, id); properties._clairatier_pack_count = String(count);
      var response = await window.fetch(getCartUrl('cart/add.js'), { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: price.variant.id, quantity: 1, properties: properties }] }) });
      if (!response.ok) throw new Error('BROWSER_RECIPE_CART');
      var added = await response.json(), item = added.items && added.items[0];
      function matchesNativeLine(line) {
        return !!line && String(line.variant_id || line.id) === String(price.variant.id) && line.quantity === 1 &&
          !!line.properties && Object.keys(properties).every(function (key) { return line.properties[key] === properties[key]; }) &&
          ['price', 'original_price', 'discounted_price', 'final_price', 'line_price', 'original_line_price', 'final_line_price'].every(function (key) {
            return Number.isSafeInteger(line[key]) && line[key] === price.variant.price;
          });
      }
      if (!Array.isArray(added.items) || added.items.length !== 1 || !matchesNativeLine(item)) throw new Error('BROWSER_RECIPE_CART_MISMATCH');
      // The add response has no cart currency and may race with another tab.
      // Read back once; never retry the mutation or delete a possibly concurrent line.
      var afterResponse = await window.fetch(getCartUrl('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!afterResponse.ok) throw new Error('BROWSER_RECIPE_CART');
      var after = await afterResponse.json();
      if (after.currency !== price.currency || !Array.isArray(after.items)) throw new Error('BROWSER_RECIPE_CURRENCY');
      var sameCreation = after.items.filter(function (line) { return line.properties && line.properties._clairatier_design_id === id; });
      var actualCopies = sameCreation.reduce(function (sum, line) {
        var packCount = Number(line.properties._clairatier_pack_count);
        return Number.isSafeInteger(packCount) && packCount > 0 && Number.isSafeInteger(line.quantity) && line.quantity > 0 ? sum + packCount * line.quantity : NaN;
      }, 0);
      if (sameCreation.length !== 1 || !matchesNativeLine(sameCreation[0]) || actualCopies !== count || actualCopies > 10) throw new Error('BROWSER_RECIPE_CART_MISMATCH');
      runThemeCartAction(added);
      status.textContent = localCopy(root, 'browserAdded');

    } catch (_) {
      status.textContent = localCopy(root, 'browserCartError');
      var cartLink = document.createElement('a'); cartLink.href = getCartUrl('cart'); cartLink.textContent = translate(root, 'copyOrdinary');
      status.appendChild(document.createTextNode(' ')); status.appendChild(cartLink);
    }
    finally { journey.cartBusy = false; renderLocalReview(root); }
  }

  function personalizedOffersCatalogue(root) {
    var node = document.querySelector('[data-personalized-offers-catalogue]');
    try { return node ? JSON.parse(node.textContent) : null; } catch (_) { return null; }
  }

  function personalizedOffersEnabled(root) {
    return browserRecipeEnabled(root) && !!window.ClairatierPersonalizedOffers &&
      window.ClairatierPersonalizedOffers.ready(personalizedOffersCatalogue(root));
  }

  async function submitPersonalizedOffer(root, kind, drafts) {
    var journey = getLocalJourney(root), status = qs(root, '[data-local-cart-status]');
    if (journey.cartBusy || journey.offerMutationUncertain) return;
    journey.cartBusy = true; status.textContent = localCopy(root, 'browserWorking'); renderLocalReview(root);
    try {
      var inputs;
      if (drafts) inputs = drafts.map(function (draft) { return { recipe: draft.browserRecipe, count: draft.quantity }; });
      else inputs = [{ recipe: await captureBrowserRecipe(root), count: journey.quantity }];
      var result = await window.ClairatierPersonalizedOffers.add(personalizedOffersCatalogue(root), kind, inputs, {
        page: window.location.href, url: getCartUrl, fetch: window.fetch.bind(window)
      });
      runThemeCartAction(result.added);
      status.textContent = localCopy(root, 'offersAdded');
    } catch (error) {
      if (error.mutationUncertain) journey.offerMutationUncertain = true;
      status.textContent = localCopy(root, 'offersError');
      var link = document.createElement('a'); link.href = getCartUrl('cart'); link.textContent = translate(root, 'copyOrdinary');
      status.appendChild(document.createTextNode(' ')); status.appendChild(link);
    } finally { journey.cartBusy = false; renderLocalReview(root); }
  }

  async function renderBrowserRecipeCanvas(root, resourcesReady) {
    // Exact SVG text/backing and live character placement, not the old approximate arc renderer.
    var preview = qs(root, '[data-sticker-preview]'), scene = qs(preview, '.sticker-customizer__text-layer');
    var circle = qs(preview, '[data-sticker-background-preview]'), sceneStyle = window.getComputedStyle(scene), circleStyle = window.getComputedStyle(circle);
    function unit(value, size) { return /%$/.test(value) ? parseFloat(value) * 10 : parseFloat(value) / size * 1000; }
    var width = parseFloat(sceneStyle.width), height = parseFloat(sceneStyle.height);
    var bounds = { x: unit(circleStyle.left, width), y: unit(circleStyle.top, height), side: unit(circleStyle.width, width) };
    if (!(bounds.side > 0)) throw new Error('BROWSER_RECIPE_GEOMETRY');
    var proof = await captureMultiAvatarProofLayers(root, resourcesReady), canvas = document.createElement('canvas');
    canvas.width = 2048; canvas.height = 2048;
    var ctx = canvas.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, 2048, 2048);
    function image(url) { return new Promise(function (resolve, reject) { var img = new Image(); img.crossOrigin = 'anonymous'; img.onload = function () { resolve(img); }; img.onerror = function () { reject(new Error('BROWSER_RECIPE_RESOURCE')); }; img.src = url; }); }
    async function layer(element, clipped) {
      if (!element || element.hidden || window.getComputedStyle(element).display === 'none') return;
      var style = window.getComputedStyle(element), imageData = await image(element.currentSrc || element.src);
      var r = element.getBoundingClientRect(), base = scene.getBoundingClientRect();
      var x = ((r.left - base.left) / base.width * 1000 - bounds.x) / bounds.side * 2048;
      var y = ((r.top - base.top) / base.height * 1000 - bounds.y) / bounds.side * 2048;
      ctx.save(); if (clipped) { ctx.beginPath(); ctx.arc(1024, 1024, 1024, 0, Math.PI * 2); ctx.clip(); }
      ctx.globalAlpha = Number(style.opacity); ctx.drawImage(imageData, x, y, r.width / base.width * 1000 / bounds.side * 2048, r.height / base.height * 1000 / bounds.side * 2048); ctx.restore();
    }
    await layer(circle, true); if (proof.fadeVisible) await layer(qs(preview, '[data-sticker-fade-preview]'), true);
    await layer(qs(preview, '[data-sticker-sun-preview]'), true);
    var frames = qsa(preview, '[data-proof-avatar-index]').sort(function (a, b) { return Number(a.getAttribute('data-proof-avatar-index')) - Number(b.getAttribute('data-proof-avatar-index')); });
    if (!frames.length) frames = [qs(preview, '[data-sticker-photo-frame]')];
    var avatars = proof.version === 2 ? proof.avatars : [{ rect: proof.avatarRect, backing: proof.avatarBacking, fade: proof.avatarFade }];
    if (avatars.length !== frames.length) throw new Error('BROWSER_RECIPE_GEOMETRY');
    for (var index = 0; index < avatars.length; index++) {
      var slot = avatars[index]; if (slot.backing) ctx.drawImage(await image(slot.backing), 0, 0, 2048, 2048);
      var character = qs(frames[index], '[data-sticker-approved-avatar-preview], [data-proof-avatar-image]');
      var avatarImage = await image(character.currentSrc || character.src), characterStyle = window.getComputedStyle(character);
      var r = window.ClairatierBrowserRecipe.containRect(slot.rect, avatarImage.naturalWidth, avatarImage.naturalHeight,
        characterStyle.objectFit, characterStyle.objectPosition), scale = 2048 / 1000;
      var temporary = document.createElement('canvas'); temporary.width = 2048; temporary.height = 2048;
      var temp = temporary.getContext('2d'); temp.drawImage(avatarImage, r.x * scale, r.y * scale, r.width * scale, r.height * scale);
      if (slot.fade) { var gradient = temp.createLinearGradient(0, slot.fade.start * scale, 0, slot.fade.end * scale); gradient.addColorStop(0, '#fff'); gradient.addColorStop(1, 'transparent'); temp.globalCompositeOperation = 'destination-in'; temp.fillStyle = gradient; temp.fillRect(0, 0, 2048, 2048); }
      ctx.drawImage(temporary, 0, 0); temporary.width = 1; temporary.height = 1;
    }
    ctx.drawImage(await image(proof.overlay), 0, 0, 2048, 2048);
    var watermark = qs(preview, '.sticker-customizer__watermark-layer');
    if (!watermark || watermark.hidden) throw new Error('BROWSER_RECIPE_WATERMARK');
    await layer(watermark, false);
    return canvas;
  }

  function waitForPreviewImages(preview) {
    return Promise.all(qsa(preview, 'img').filter(function (img) {
      return !img.hidden && img.getAttribute('src') && img.getClientRects().length;
    }).map(function (img) {
      img.loading = 'eager';
      if (img.complete) return img.naturalWidth > 0 ? Promise.resolve() : Promise.reject(new Error('BROWSER_RECIPE_RESOURCE'));
      return new Promise(function (resolve, reject) {
        var timer;
        function finish(error) {
          window.clearTimeout(timer); img.removeEventListener('load', loaded); img.removeEventListener('error', failed);
          if (error) reject(error); else resolve();
        }
        function loaded() { finish(img.naturalWidth > 0 ? null : new Error('BROWSER_RECIPE_RESOURCE')); }
        function failed() { finish(new Error('BROWSER_RECIPE_RESOURCE')); }
        img.addEventListener('load', loaded); img.addEventListener('error', failed);
        timer = window.setTimeout(failed, 30000);
      });
    }));
  }

  async function initReadonlyRecipePreview(root) {
    if (!root._localReadonlyPreview || root.closest('[data-clairatier-cart-renderer]') || root._readonlyPreviewStarted) return;
    root._readonlyPreviewStarted = true;
    var phase = 'recipe';
    try {
      if (root._browserRecipeInvalid || !root._browserReplayRecipe) throw new Error('BROWSER_RECIPE_INVALID');
      var preview = qs(root, '[data-sticker-preview]');
      var overlay = qs(root, '[data-sticker-overlay]'); overlay.hidden = false;
      preview.setAttribute('role', 'img'); preview.setAttribute('aria-label', translate(root, 'cartPreviewTitle'));
      phase = 'resources';
      await Promise.resolve(document.fonts && document.fonts.ready);
      await waitForPreviewImages(preview);
      await Promise.all(Object.values(root._localAlphaPromises || {}));
      updatePhoto(root); syncLocalTextBacking(root); syncMultiAvatarPreview(root);
      await new Promise(function (resolve) { window.requestAnimationFrame(function () { window.requestAnimationFrame(resolve); }); });
      phase = 'canvas';
      var canvas = await renderBrowserRecipeCanvas(root, true);
      var blob = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/png'); });
      if (!blob || blob.size > 4000000) throw new Error('BROWSER_RECIPE_RESOURCE');
      var image = document.createElement('img');
      image.className = 'clairatier-recipe-preview-image';
      image.alt = translate(root, 'cartPreviewTitle');
      image.src = URL.createObjectURL(blob);
      phase = 'png';
      await image.decode();
      document.body.appendChild(image);
      document.documentElement.setAttribute('data-clairatier-preview-state', 'ready');
    } catch (_) {
      document.documentElement.setAttribute('data-clairatier-preview-state', 'error');
      document.documentElement.setAttribute('data-clairatier-preview-phase', phase);
      document.documentElement.setAttribute('data-clairatier-preview-error', root._browserRecipeErrorCode || (/^BROWSER_RECIPE_[A-Z_]+$/.test(_.message) ? _.message : _.name));
      var error = document.createElement('p'); error.className = 'clairatier-recipe-preview-error'; error.textContent = localCopy(root, 'browserError'); document.body.appendChild(error);
    }
  }

  function submitLocalDraft(root, draft) {
    if (browserRecipeEnabled(root)) return draft && draft.browserRecipe ? submitBrowserRecipe(root, draft) : undefined;
    if (copyCartEnabled(root)) {
      if (!draft || !draft.approvedSelection) { qs(root, '[data-local-cart-status]').textContent = copyCartText(root, 'copySourceUnavailable'); return; }
      return submitAuthoritativeCopyCreation(root, readSavedCopySelection(root, draft));
    }
    var journey = getLocalJourney(root);
    if (journey.cartBusy || !draft || (draft.state.proofAvatars || []).length > 1 || !draft.snapshot || !draft.result || areMiaPrivatePilotPaidActionsBlocked(root)) return;
    journey.cartBusy = true;
    root._stickerState.selectedGenerationId = draft.result.id;
    renderLocalReview(root);
    Promise.resolve().then(function () {
      return submit(root, draft.snapshot);
    }).then(function (item) {
      if (!item) return;
      runThemeCartAction(item);
      qs(root, '[data-local-cart-status]').textContent = translate(root, 'generationAdded', { label: draft.name });
    }).catch(function () {
      qs(root, '[data-local-cart-status]').textContent = translate(root, 'cartAddFailed');
    }).finally(function () {
      journey.cartBusy = false;
      renderLocalReview(root);
    });
  }

  function renderLocalSavings(root, price, quantity) {
    var original = qs(root, '[data-local-original-price]'), savings = qs(root, '[data-local-savings]');
    var single = price && localPrice(root, 1), reference = single ? single.cents * quantity : 0;
    var reduction = price && !copyCartEnabled(root) && reference > price.cents;
    var money = price && new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: price.currency });
    if (original) { original.hidden = !reduction; original.textContent = reduction ? money.format(reference / 100) : ''; }
    if (savings) { savings.hidden = !reduction; savings.textContent = reduction ? localCopy(root, 'savings', { amount: money.format((reference - price.cents) / 100), count: quantity }) : ''; }
  }

  function renderLocalReview(root) {
    var journey = getLocalJourney(root);
    var price = localPrice(root, journey.quantity);
    qs(root, '[data-local-quantity]').textContent = String(journey.quantity);
    if (journey.quantity > localQuantityLimit(root)) qs(root, '[data-local-cart-status]').textContent = copyCartText(root, 'copyQuantityLimit');
    qs(root, '[data-local-price]').textContent = copyCartEnabled(root) ? '—' : price ? price.formatted : '—';
    renderLocalSavings(root, price, journey.quantity);
    qs(root, '[data-local-price-note]').textContent = price ? price.discount ? localCopy(root, 'priceNote', { price: price.unit, variant: price.additionalUnit }) : price.unit + ' · ' + (String(price.variant.title) === '1' || price.variant.title === 'Default Title' ? localCopy(root, 'unit') : price.variant.title) : '';
    qs(root, '[data-local-action="less"]').disabled = journey.quantity <= 1;
    qs(root, '[data-local-action="more"]').disabled = journey.quantity >= localQuantityLimit(root);
    qs(root, '[data-local-action="generate"]').hidden = !localPending(root);
    if (copyCartEnabled(root)) qs(root, '[data-local-price-note]').textContent = copyCartText(root, 'copyShipping');
    var name = qs(root, '[data-local-design-name]');
    if (!name.value.trim()) name.value = localCopy(root, 'nameFamily');
    var names = qs(root, '[data-local-name-suggestions]');
    names.textContent = '';
    ['nameMum', 'nameDad', 'nameFamily'].forEach(function (key) {
      names.appendChild(createLocalButton(root, localCopy(root, key), 'data-local-name', localCopy(root, key)));
    });
    var cart = qs(root, '[data-local-action="add-current"]');
    var multi = (root._stickerState.proofAvatars || []).length > 1;
    var blocked = multi || localPending(root) || !getSelectedGeneration(root) || areMiaPrivatePilotPaidActionsBlocked(root) || !price || !price.variant.available;
    if (browserRecipeEnabled(root)) {
      blocked = localPending(root) || root._proofLayoutUnavailable || !price || root._browserRecipeInvalid;
      qs(root, '[data-local-cart-help]').textContent = !price ? localCopy(root, 'browserPriceUnavailable') : blocked ? localCopy(root, 'cartPending') : '';
      qs(root, '[data-local-price-note]').textContent = localCopy(root, 'browserPriceNote');
    }
    if (approvedCompositionCartEnabled(root) || copyCartEnabled(root)) {
      try { readApprovedCompositionSelection(root); blocked = copyCartEnabled(root) ? journey.quantity > 10 : !price || !price.variant.available; }
      catch (error) { blocked = true; queueApprovedCompositionReviewRefresh(root); }
    }
    cart.disabled = !!blocked || !!journey.cartBusy || !!journey.offerMutationUncertain;
    if (!browserRecipeEnabled(root)) qs(root, '[data-local-cart-help]').textContent = !blocked ? '' : areMiaPrivatePilotPaidActionsBlocked(root) && !(approvedCompositionCartEnabled(root) || copyCartEnabled(root)) ? localCopy(root, 'cartPilot') : localPending(root) ? localCopy(root, 'cartPending') : multi ? multiAvatarCopy(root, (root._stickerState.proofAvatars || []).some(function (slot) { return slot.state.approvedAvatarId === 'clara'; }) ? 'charactersNote' : 'multiAvatarNote') : localCopy(root, 'cartBlocked');
    if (multi) qs(root, '[data-local-action="generate"]').hidden = true;
    var list = qs(root, '[data-local-designs]');
    list.textContent = '';
    journey.drafts.forEach(function (draft, index) {
      var row = document.createElement('article');
      row.className = 'sticker-customizer__local-design';
      var preview = draft.previewElement.cloneNode(true);
      qsa(preview, '[id]').forEach(function (element) {
        var oldId = element.id;
        var newId = oldId + '-draft-' + index;
        element.id = newId;
        qsa(preview, '[href], [xlink\\:href]').forEach(function (reference) {
          ['href', 'xlink:href'].forEach(function (name) {
            if (reference.getAttribute(name) === '#' + oldId) reference.setAttribute(name, '#' + newId);
          });
        });
      });
      row.appendChild(preview);
      var text = document.createElement('strong');
      var format = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: draft.currency });
      var draftPrice = browserRecipeEnabled(root) ? browserRecipePrice(root, draft.quantity) : null;
      var draftTotal = browserRecipeEnabled(root) ? draftPrice ? draftPrice.cents : NaN : draft.unitPrice + (draft.quantity - 1) * (draft.additionalUnitPrice == null ? draft.unitPrice : draft.additionalUnitPrice);
      text.textContent = draft.name + ' · ' + draft.quantity + ' · ' + (Number.isFinite(draftTotal) ? format.format(draftTotal / 100) : '—');
      row.appendChild(text);
      row.appendChild(createLocalButton(root, localCopy(root, 'edit'), 'data-local-edit', String(index)));
      var add = createLocalButton(root, localCopy(root, 'addCart'), 'data-local-add', String(index));
      add.disabled = copyCartEnabled(root) ? !!journey.cartBusy || !draft.approvedSelection || draft.quantity > 10 : !!journey.cartBusy || (draft.state.proofAvatars || []).length > 1 || !draft.snapshot || !draft.result || areMiaPrivatePilotPaidActionsBlocked(root);
      if (browserRecipeEnabled(root)) add.disabled = !!journey.cartBusy || !!journey.offerMutationUncertain || !draft.browserRecipe || !draftPrice;
      row.appendChild(add);
      row.appendChild(createLocalButton(root, localCopy(root, 'remove'), 'data-local-remove', String(index)));
      list.appendChild(row);
    });
    var offerPanel = qs(root, '[data-personalized-duo]');
    if (offerPanel) {
      offerPanel.hidden = !personalizedOffersEnabled(root);
      var duo = qs(offerPanel, '[data-local-action="add-duo"]'), duoPrice = null;
      if (journey.drafts.length === 2 && journey.drafts.every(function (draft) { return !!draft.browserRecipe; })) {
        duoPrice = window.ClairatierPersonalizedOffers && window.ClairatierPersonalizedOffers.variant(personalizedOffersCatalogue(root), 'duo', journey.drafts.map(function (draft) { return draft.quantity; }));
      }
      duo.disabled = !duoPrice || !!journey.cartBusy || !!journey.offerMutationUncertain;
      qs(offerPanel, '[data-personalized-duo-price]').textContent = duoPrice ? new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: 'EUR' }).format(duoPrice.price / 100) : '—';
    }
  }

  // Éclat uses a 1000-unit sticker; the customizer scene includes outer margins.
  function eclatTextFit(measured, maximum) {
    if (!(measured > 0)) return null;
    var available = Math.PI * 320.3125 * .8;
    var size = Math.max(20, Math.min(maximum, Math.floor(maximum * available / measured)));
    return { size: size, overflow: measured * size / maximum > available + 1 };
  }

  function eclatAvatarGeometry(count, index, input, alpha, backing) {
    input = input || {}; alpha = alpha || {};
    var finite = function (value, fallback) { return Number.isFinite(Number(value)) ? Number(value) : fallback; };
    var scale = clamp(finite(input.photoScale, 1), .75, 1.2);
    var dx = clamp(finite(input.photoX, 0), -48, 48), dy = clamp(finite(input.photoY, 0), -48, 48);
    var spacing = count === 2 ? 230 : 165;
    var cx = 500 + (index - (count - 1) / 2) * spacing + (count === 1 ? dx : clamp(dx, -4, 4));
    var cy = 510 + dy;
    var rows = alpha.transparent && Array.isArray(alpha.rows) && alpha.rows.length ? alpha.rows : [{left:0,right:1,top:0,bottom:1}];
    var bounds = alpha.bounds || {left:0,right:1,top:0,bottom:1};
    if (backing && backing.enabled && backing.avatar && (!backing.style || backing.style === 'band')) {
      rows = [{left:0,right:1,top:0,bottom:1}]; bounds = rows[0];
    }
    var outset = backing && backing.enabled && backing.avatar ? .10 : 0;
    var desired = (count === 1 ? 490 : count === 2 ? 330 : 240) * scale;
    if (count > 1) desired = Math.min(desired, (count === 2 ? 212 : 145) / Math.max(.1, bounds.right - bounds.left + 2 * outset));
    function inside(diameter) {
      return rows.every(function (row) {
        return [row.left - outset, row.right + outset].every(function (x) {
          return [row.top - outset, row.bottom + outset].every(function (y) {
            return Math.hypot(cx - 500 + (x - .5) * diameter, cy - 510 + (y - .5) * diameter) <= 248;
          });
        });
      });
    }
    var low = 0, high = desired;
    for (var step = 0; step < 32; step++) { var mid = (low + high) / 2; if (inside(mid)) low = mid; else high = mid; }
    return { centerX: 109.375 + cx * .78125, centerY: 90.625 + cy * .78125, diameter: low * .78125 };
  }

  function syncEclatComposition(root) {
    var on = root._stickerState && root._stickerState.sunEnabled === true;
    var brand = qs(root, '.sticker-customizer__brand-text');
    // The wordmark and fixed orange dot form one lockup, independent of the sun.
    if (brand) { brand.style.fontSize = ''; brand.style.letterSpacing = ''; }
    ['top', 'bottom'].forEach(function (position) {
      var text = qs(root, '[data-sticker-preview-text="' + position + '"]');
      if (!text) return;
      var href = text.getAttribute('href') || text.getAttribute('xlink:href') || '';
      var path = href.charAt(0) === '#' && qs(root, '[id="' + href.slice(1) + '"]');
      if (!path) return;
      if (!path.hasAttribute('data-eclat-original-path')) path.setAttribute('data-eclat-original-path', path.getAttribute('d'));
      path.setAttribute('d', on ? position === 'top' ? 'M 179.6875 483.59375 A 320.3125 320.3125 0 0 1 820.3125 483.59375' : 'M 179.6875 479.6875 A 320.3125 320.3125 0 0 0 820.3125 479.6875' : path.getAttribute('data-eclat-original-path'));
      if (on && position === 'top') text.parentNode.setAttribute('transform', 'translate(0 54.6875)');
      else text.parentNode.removeAttribute('transform');
      text.style.letterSpacing = on ? '.78125px' : '';
    });
  }

  function syncSunPreview(root) {
    var sun = qs(root, '[data-sticker-sun-preview]');
    if (sun) sun.hidden = !(root._stickerState && root._stickerState.sunEnabled === true);
    if (typeof syncEclatComposition === 'function') syncEclatComposition(root);
  }

  function renderLocalJourney(root) {
    if (!localJourneyEnabled(root) || !root._stickerState) return;
    var state = root._stickerState;
    syncSunPreview(root);
    renderMultiAvatarControls(root);
    var journey = getLocalJourney(root);
    var panel = qs(root, '[data-local-guide]');
    if (!panel) return;
    var step = LOCAL_JOURNEY_STEPS[journey.index];
    panel.hidden = false;
    root.setAttribute('data-local-chat', journey.chatExpanded ? 'expanded' : journey.chat ? 'split' : 'compact');
    root.setAttribute('data-local-review', journey.review ? 'true' : 'false');
    qs(root, '[data-local-settings]').hidden = false;
    qs(root, '[data-local-title]').textContent = localTitle(root, journey.review ? 'complete' : step);
    qs(root, '[data-local-progress]').textContent = localCopy(root, 'progress', { current: journey.index + 1, total: LOCAL_JOURNEY_STEPS.length });
    qs(root, '[data-local-help]').textContent = step === 'photo' ? localCopy(root, 'photoHelp') : step === 'fade' ? localCopy(root, 'haloHelp') : step === 'avatar-fade' ? localCopy(root, 'avatarFadeHelp') : step === 'symbol' ? localCopy(root, 'singleSymbol') : '';
    if (journey.review) qs(root, '[data-local-help]').textContent = '';
    var options = qs(root, '[data-local-options]');
    options.hidden = !journey.options;
    options.textContent = '';
    if (journey.options) {
      var resetAll = createLocalButton(root, localCopy(root, 'resetAll'), 'data-local-action', 'reset-all');
      resetAll.className = 'sticker-customizer__reset-all';
      options.appendChild(resetAll);
      LOCAL_JOURNEY_STEPS.forEach(function (entry, index) {
        var button = createLocalButton(root, localTitle(root, entry), 'data-local-step', String(index));
        button.setAttribute('aria-current', index === journey.index ? 'step' : 'false');
        options.appendChild(button);
      });
    }
    var invitationStep = step;
    if (step === 'color') {
      invitationStep = state.wardrobeEditing && state.wardrobeStage === 'colors' ? 'colors' : 'outfit';
      if (!root._wardrobeReady || !root.getAttribute('data-wardrobe-catalog')) invitationStep = 'colors';
    }
    qsa(root, '[data-local-invitation]').forEach(function (invitation) {
      var invitationKey = invitation.getAttribute('data-local-invitation');
      invitation.hidden = journey.review || journey.options || journey.chatExpanded ||
        (invitationKey !== invitationStep && !(step === 'color' && !state.wardrobeEditing && invitationKey === 'colors'));
    });
    var choices = qs(root, '[data-local-choices]');
    renderLocalChoices(root, step, choices);
    choices.hidden = journey.review || journey.options || journey.chatExpanded;
    if (journey.review || journey.options || journey.chatExpanded) qs(root, '[data-local-input-label]').hidden = true;
    qs(root, '[data-local-review]').hidden = !journey.review || journey.chat;
    qs(root, '[data-local-action="add-current"]').hidden = !journey.review || journey.chat || journey.options;
    var next = qs(root, '[data-local-action="next"]');
    next.hidden = journey.review || journey.chatExpanded || journey.options;
    next.textContent = localCopy(root, canReviewLocalJourney(journey) ? 'review' : 'keep');
    qs(root, '[data-local-action="back"]').disabled = journey.index === 0 && !journey.review && !journey.options;
    var chat = qs(root, '[data-local-action="chat"]');
    chat.hidden = !CUSTOMIZER_AI_ENABLED;
    chat.setAttribute('aria-expanded', String(journey.chat));
    chat.textContent = localCopy(root, journey.chatExpanded ? 'chatCollapse' : journey.chat ? 'chatExpand' : 'chat');
    if (journey.review) renderLocalReview(root);
    syncLocalTextBacking(root);
    syncLocalHaloControls(root);
    var textOverflow = step.indexOf('text-') === 0 && root._stickerState.localTextOverflow && root._stickerState.localTextOverflow[step.slice(5)];
    qs(root, '[data-local-input]').setAttribute('aria-invalid', String(!!textOverflow));
    if (textOverflow) qs(root, '[data-local-help]').textContent = localCopy(root, 'shortenText');
    next.disabled = !!textOverflow || (step === 'color' && state.wardrobeEditing &&
      (state.wardrobeStage !== 'colors' || !getLocalWardrobeEntry(root, state.approvedAvatarGarmentId) || !state.wardrobePaletteValidated));
    persistLocalSession(root);
  }

  function applyLocalChoice(root, step, value) {
    var state = root._stickerState;
    if (step === 'sun') {
      if (value !== 'on' && value !== 'off') return;
      state.sunEnabled = value === 'on'; syncSunPreview(root); renderLocalJourney(root); persistLocalSession(root); return;
    }
    if (value.indexOf('cast-stage:') === 0) {
      var stage = value.slice(11);
      if (['baby', 'grown'].indexOf(stage) < 0) return;
      if (stage === castLifeStage(state)) { delete root._castLifeStageBrowser; renderLocalJourney(root); return; }
      var outfitNumber = Number((/outfit-(\d{2})$/.exec(state.approvedAvatarGarmentId || '') || [])[1]);
      var stageEntry = (root._castPreviewCatalog || []).find(function (entry) {
        return entry.characterId === state.approvedAvatarId && (entry.lifeStage || 'grown') === stage && entry.styleId === state.style && entry.outfitNumber === outfitNumber;
      }) || defaultCastPreviewEntry(root, state.approvedAvatarId, stage, state.style);
      if (stageEntry) selectCastPreviewEntry(root, stageEntry);
      else { root._castLifeStageBrowser = stage; renderLocalJourney(root); }
      return;
    }
    if (step === 'avatar' && value.indexOf('cast-avatar:') === 0) {
      selectCastPreviewEntry(root, defaultCastPreviewEntry(root, value.slice(12), root._castLifeStageBrowser || castLifeStage(state))); return;
    }
    if (value.indexOf('cast-custom:') === 0) { selectCastCustomization(root, value.slice(12)); return; }
    if (value === 'cast-keep') return;
    if (value === 'cast-legacy-mia' && state.approvedAvatarId === 'mia') {
      qsa(root, '[data-mia-choice="garment"]').forEach(function (control) { control.checked = control.value === 'garment-yoke-blouse-dress'; });
      state.wardrobePaletteMode = 'catalog'; state.wardrobePaletteValidated = true;
      syncMiaRuntimeChoices(root, 'garment'); syncAssistantHonestPreview(root); updatePhoto(root); renderLocalJourney(root); persistLocalSession(root); return;
    }
    if (value.indexOf('cast-outfit:') === 0) {
      var entry = (root._castPreviewCatalog || []).find(function (item) { return item.presetId === value.slice(12) && item.characterId === state.approvedAvatarId; });
      selectCastPreviewEntry(root, entry); return;
    }
    if (step === 'avatar' && CAST_PREVIEW_IDS.indexOf(value) >= 0 && castPreviewEnabled(root)) {
      selectCastPreviewEntry(root, defaultCastPreviewEntry(root, value, castLifeStage(state)) || defaultCastPreviewEntry(root, value, 'grown')); return;
    }
    if (value === 'clara-keep') return;
    if (value.indexOf('clara-outfit:') === 0) {
      var outfitId = value.slice('clara-outfit:'.length);
      if (!claraPreviewEnabled(root) || state.approvedAvatarId !== 'clara' || !CLARA_SIGNATURE_PREVIEWS[outfitId]) return;
      qsa(root, '[data-mia-choice="garment"]').forEach(function (input) { input.checked = input.value === outfitId; });
      state.wardrobePaletteMode = 'catalog'; state.wardrobePaletteValidated = true; state.wardrobeEditing = false;
      syncMiaRuntimeChoices(root, 'garment'); syncAssistantHonestPreview(root); updatePhoto(root); renderLocalJourney(root); persistLocalSession(root); return;
    }
    if (step === 'avatar' && (value === 'mia' || value === 'clara')) {
      if (value === 'clara' && !claraPreviewEnabled(root)) return;
      qsa(root, '[data-mia-choice="avatar"]').forEach(function (input) { input.checked = input.value === value; });
      qsa(root, '[data-mia-choice="style"]').forEach(function (input) { input.checked = input.value === 'signature'; });
      qsa(root, '[data-mia-choice="mode"]').forEach(function (input) { input.checked = input.value === 'standard'; });
      qsa(root, '[data-mia-choice="hair"], [data-mia-choice="accessory"]').forEach(function (input) { input.checked = false; });
      qsa(root, '[data-mia-choice="garment"]').forEach(function (input) { input.checked = input.value === (value === 'clara' ? 'signature-girl-outfit-01' : 'garment-yoke-blouse-dress'); });
      qsa(root, '[data-mia-choice="color"]').forEach(function (input) { input.checked = input.value === 'original'; });
      state.selectedAccessoryId = ''; state.approvedAvatarHairstyleId = ''; state.presentationMode = 'standard';
      state.wardrobePaletteMode = 'catalog'; state.wardrobePaletteValidated = true; state.wardrobeEditing = false;
      root._stickerLastHonestPreviewAsset = '';
      syncMiaRuntimeChoices(root, 'avatar'); syncAssistantHonestPreview(root); updatePhoto(root); renderLocalJourney(root); persistLocalSession(root); return;
    }
    if (step === 'avatar-fade') { setLocalAvatarBottomFade(root, value); return; }
    if (step === 'color' && value.indexOf('wardrobe-') === 0) { applyLocalWardrobeChoice(root, value); syncAssistantHonestPreview(root); publishGuidedContext(root); return; }
    if (step === 'mode' && value.indexOf('mode-surface:') === 0) {
      state.appearanceMode = value.slice('mode-surface:'.length) === 'accessories' ? 'accessories' : 'standard';
      qsa(root, '[data-mia-choice="mode"]').forEach(function (input) { input.checked = input.value === (state.appearanceMode === 'accessories' ? 'accessories' : 'standard'); });
      if (state.appearanceMode === 'standard') {
        qsa(root, '[data-mia-choice="accessory"]').forEach(function (input) { input.checked = false; });
        state.selectedAccessoryId = ''; state.presentationMode = 'standard';
      }
      syncMiaRuntimeChoices(root, step); markAssistantContextChanged(root, step);
      renderLocalJourney(root); syncAssistantHonestPreview(root); publishGuidedContext(root); return;
    }
    if (step === 'mode' && value.indexOf('accessory-audience:') === 0) {
      state.accessoryAudience = value.slice('accessory-audience:'.length) === 'all' ? 'all' : 'girl';
      renderLocalJourney(root); return;
    }
    if (step === 'hairstyle' && value.indexOf('hair-audience:') === 0) {
      state.hairAudience = value.slice('hair-audience:'.length) === 'all' ? 'all' : 'girl';
      renderLocalJourney(root); return;
    }
    if (step === 'mode' && value.indexOf('accessory:') === 0) {
      var accessoryId = value.slice('accessory:'.length);
      var accessory = qsa(root, '[data-mia-choice="accessory"]').find(function (input) { return input.value === accessoryId; });
      if (!accessory) return;
      qsa(root, '[data-mia-choice="accessory"]').forEach(function (input) { input.checked = input === accessory; });
      state.appearanceMode = 'accessories'; state.selectedAccessoryId = accessoryId;
      state.presentationMode = accessory.getAttribute('data-presentation-mode') === 'incognito' ? 'incognito' : 'standard';
      markAssistantContextChanged(root, step); renderLocalJourney(root); syncAssistantHonestPreview(root); publishGuidedContext(root); return;
    }
    if (step === 'photo') {
      if (value === 'photo') {
        var picker = qs(root, '[data-sticker-photo-picker]');
        if (picker) picker.click();
      } else {
        setSubjectSource(root, 'approved-avatar');
        state.assistantOptionalPhotoOfferState = 'declined';
        qsa(root, '[data-mia-choice="avatar"]').forEach(function (input) { input.checked = input.value === state.approvedAvatarId; });
        syncMiaRuntimeChoices(root);
      }
    } else if (step.indexOf('text-') === 0) {
      var position = step.slice(5);
      var canonical = qs(root, '[data-sticker-text="' + position + '"]');
      if (canonical) canonical.value = normalizeStickerText(value, 26);
      qsa(root, '[data-sticker-text-choice="' + position + '"]').forEach(function (input) { input.checked = input.value === (value.trim() ? 'yes' : 'no'); });
      updateTextChoice(root, position);
    } else if (step === 'symbol') {
      value = firstLocalCharacter(value);
      qs(root, '[data-sticker-symbol-input]').value = value;
      qs(root, '[data-local-input]').value = value;
      qsa(root, '[data-sticker-symbol-choice]').forEach(function (input) { input.checked = input.value === (value ? 'yes' : 'no'); });
      updateSymbol(root, true);
    } else if (step === 'background') applyBackgroundSelection(root, value);
    else if (step === 'fade') {
      var enabled = value !== 'off';
      var selectedStyle = ['band', 'outline', 'bold', 'soft', 'offset', 'double', 'fine', 'cushion', 'glow', 'lifted', 'triple'].indexOf(value) >= 0 ? value : 'band';
      root._stickerState.whiteBacking = { enabled: enabled, topText: true, bottomText: true, avatar: true, brand: true, badge: true, style: selectedStyle };
      updatePhoto(root);
      updateConfig(root);
    } else {
      var category = step === 'hairstyle' ? 'hair' : step;
      if (step === 'style' && state.style !== value) {
        state.wardrobeFamily = 'all'; state.wardrobeStage = 'outfit'; state.wardrobeEditing = false; state.wardrobePaletteMode = 'catalog'; state.wardrobePaletteEdited = false; state.wardrobePaletteValidated = true; state.wardrobeChosenColorRoles = {}; state.requestedFinishColor = '';
        state.selectedAccessoryId = ''; state.appearanceMode = 'standard'; state.presentationMode = 'standard';
        qsa(root, '[data-mia-choice="color"]').forEach(function (input) { input.checked = input.value === 'original'; });
        qsa(root, '[data-mia-choice="garment"]').forEach(function (input) { input.checked = input.value === 'garment-yoke-blouse-dress'; });
        qsa(root, '[data-mia-choice="mode"]').forEach(function (input) { input.checked = input.value === 'standard'; });
        qsa(root, '[data-mia-choice="accessory"]').forEach(function (input) { input.checked = false; });
      }
      qsa(root, '[data-mia-choice="' + category + '"]').forEach(function (input) { input.checked = input.value === value; });
      syncMiaRuntimeChoices(root, step);
      markAssistantContextChanged(root, step);
    }
    syncAssistantHonestPreview(root);
    publishGuidedContext(root);
  }

  function localReadingDuration(message) {
    return 2000 + Math.ceil(String(message).trim().split(/\s+/).filter(Boolean).length * 60000 / 150);
  }

  function firstLocalCharacter(value) {
    var text = String(value || '').trim().normalize('NFC');
    if (typeof Intl.Segmenter === 'function') {
      var entries = new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text);
      var first = entries[Symbol.iterator]().next();
      return first.done ? '' : first.value.segment;
    }
    return Array.from(text)[0] || '';
  }

  function getLocalWhiteBacking(root) {
    var state = root._stickerState;
    if (!state.whiteBacking) state.whiteBacking = { enabled: false, topText: true, bottomText: true, avatar: true, brand: true, badge: true, style: 'glow' };
    return state.whiteBacking;
  }

  function openLocalSettings(root, target) {
    var journey = getLocalJourney(root);
    journey.chat = false;
    journey.chatExpanded = false;
    journey.transformTarget = target || '';
    qs(root, '[data-local-targets]').hidden = false;
    qs(root, '[data-local-transforms]').hidden = !target;
    qs(root, '[data-local-action="settings"]').setAttribute('aria-expanded', 'true');
    root.classList.add('is-local-settings');
    syncLocalHaloControls(root);
  }

  function syncLocalHaloControls(root) {
    var journey = getLocalJourney(root);
    var backing = getLocalWhiteBacking(root);
    var transforms = qs(root, '[data-local-transforms]');
    var haloTarget = qs(root, '[data-local-target="halo"]');
    if (!backing.enabled && journey.transformTarget === 'halo') journey.transformTarget = '';
    if (haloTarget) haloTarget.hidden = !backing.enabled;
    root.setAttribute('data-local-transform-target', journey.transformTarget || 'none');
    if (transforms && !qs(root, '[data-local-targets]').hidden) transforms.hidden = !journey.transformTarget;
    var halo = journey.transformTarget === 'halo';
    qsa(root, '[data-local-adjust]').forEach(function (button) {
      button.hidden = halo;
      button.disabled = false;
      if (journey.transformTarget !== 'background') {
        var state = root._stickerState;
        var adjustment = button.getAttribute('data-local-adjust');
        var input = { imageScale: state.photoScale, imageOffsetX: state.photoX, imageOffsetY: state.photoY };
        if (adjustment === 'zoom_in') input.imageScale += 0.1;
        if (adjustment === 'zoom_out') input.imageScale = Math.max(0.75, input.imageScale - 0.1);
        if (adjustment === 'left') input.imageOffsetX -= 8;
        if (adjustment === 'right') input.imageOffsetX += 8;
        if (adjustment === 'up') input.imageOffsetY -= 8;
        if (adjustment === 'down') input.imageOffsetY += 8;
        if (adjustment === 'reset') { input.imageScale = 1; input.imageOffsetX = 0; input.imageOffsetY = 0; }
        var next = localWhiteBackingGeometry(input, backing, !!getTextValue(root, 'top').trim(), !!getTextValue(root, 'bottom').trim());
        button.disabled = Math.abs(next.imageScale - state.photoScale) < 0.0001 && Math.abs(next.imageOffsetX - state.photoX) < 0.0001 && Math.abs(next.imageOffsetY - state.photoY) < 0.0001;
      }
    });
    qsa(root, '[data-local-halo]').forEach(function (button) {
      button.hidden = !halo;
      button.setAttribute('aria-pressed', String(backing.enabled && backing[button.getAttribute('data-local-halo')]));
    });
    qsa(root, '[data-local-target]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.getAttribute('data-local-target') === journey.transformTarget)); });
  }

  function showLocalNotice(root, message) {
    var toast = qs(root, '[data-sticker-toast]');
    var text = qs(root, '[data-sticker-toast-message]');
    if (!toast || !text) return;
    hideToast(root);
    toast.removeAttribute('data-preview-explanation');
    text.textContent = message;
    toast.hidden = false;
    var meter = qs(toast, 'progress');
    if (!meter) { meter = document.createElement('progress'); toast.appendChild(meter); }
    var timerLabel = qs(toast, '[data-local-toast-timer]');
    if (!timerLabel) { timerLabel = document.createElement('small'); timerLabel.setAttribute('data-local-toast-timer', ''); toast.insertBefore(timerLabel, meter); }
    timerLabel.textContent = localCopy(root, 'messageTimer');
    var keep = qs(toast, '[data-local-action="keep-notice"]');
    if (!keep) { keep = createLocalButton(root, localCopy(root, 'messageKeep'), 'data-local-action', 'keep-notice'); toast.appendChild(keep); }
    meter.setAttribute('aria-label', localCopy(root, 'messageTimer'));
    meter.max = localReadingDuration(message);
    meter.value = meter.max;
    var history = qs(root, '[data-local-message-history]');
    if (!history) {
      history = document.createElement('details'); history.setAttribute('data-local-message-history', '');
      var summary = document.createElement('summary'); summary.textContent = localCopy(root, 'messages'); history.appendChild(summary);
      qs(root, '[data-local-scroll]').appendChild(history);
    }
    var entry = document.createElement('p'); entry.textContent = message; history.appendChild(entry);
    var previous = Date.now();
    root._stickerToastTimer = window.setInterval(function () {
      var now = Date.now();
      if (!document.hidden && !toast.matches(':hover') && !toast.contains(document.activeElement) && !toast.hasAttribute('data-kept')) meter.value -= now - previous;
      previous = now;
      if (meter.value <= 0) hideToast(root);
    }, 100);
    toast.removeAttribute('data-kept');
  }

  function captureLocalDraft(root) {
    var journey = getLocalJourney(root);
    var state = root._stickerState;
    var result = getSelectedGeneration(root);
    if (state.assistantHasUngeneratedChanges) result = null;
    var price = localPrice(root, journey.quantity);
    if (!price) return;
    var browserMode = browserRecipeEnabled(root), browserRecipe = null;
    if (browserMode) {
      if (localPending(root) || root._proofLayoutUnavailable || root._browserRecipeInvalid) return;
      syncMultiAvatarPreview(root);
      var session = persistLocalSession(root); if (!session) return;
      session.quantity = 1; session.step = 'avatar'; session.completed = LOCAL_JOURNEY_STEPS.slice();
      session.review = true; session.open = true; session.chat = false; session.chatExpanded = false; session.options = false;
      try { browserRecipe = window.ClairatierBrowserRecipe.validate({ version: 'browser-recipe/1', renderer: 'shopify-watermarked/1', diameterMm: 140,
        session: session, textFlags: { top: !hasNoTextChoice(root, 'top'), bottom: !hasNoTextChoice(root, 'bottom') }, assets: browserRecipeAssets(root) }); }
      catch (_) { qs(root, '[data-local-cart-status]').textContent = localCopy(root, 'browserError'); return; }
    }
    var payload = browserMode ? { personalization: {}, composition: {}, subject: {} } : buildGenerationPayload(root);
    var snapshot = !browserMode && result && !localPending(root) ? freezeAcceptedDesignSnapshot(root, result) : null;
    if (snapshot) snapshot = freezeAcceptedSnapshotValue(Object.assign({}, snapshot, { quantity: journey.quantity, variantId: String(price.variant.id) }));
    var draft = {
      name: qs(root, '[data-local-design-name]').value.trim() || localCopy(root, 'complete') + ' ' + (journey.drafts.length + 1),
      quantity: journey.quantity, variantId: String(price.variant.id), unitPrice: price.variant.price, additionalUnitPrice: price.additionalUnitPrice, currency: price.currency, result: result,
      browserRecipe: browserRecipe, approvedSelection: browserMode ? null : captureSavedCopySelection(root), snapshot: snapshot, payload: JSON.parse(JSON.stringify({ personalization: payload.personalization, composition: payload.composition, subject: payload.subject })),
      preview: result && !localPending(root) ? result.imageUrl : (qs(root, '[data-sticker-approved-avatar-preview]') || {}).src || '',
      previewElement: qs(root, '[data-sticker-preview]').cloneNode(true),
      state: {}, choices: {}, top: getTextValue(root, 'top'), bottom: getTextValue(root, 'bottom')
    };
    ['sunEnabled', 'proofAvatars', 'proofActiveAvatar', 'style', 'subjectSource', 'presentationMode', 'appearanceMode', 'selectedAccessoryId', 'approvedAvatarHairstyleId', 'approvedAvatarGarmentId', 'tryonGarment', 'tryonColor', 'requestedPrimaryColor', 'requestedSecondaryColor', 'requestedFinishColor', 'wardrobeFamily', 'wardrobeAudience', 'wardrobeStage', 'wardrobePaletteMode', 'wardrobePaletteEdited', 'wardrobePaletteValidated', 'wardrobeCustomColors', 'approvedAvatarPaletteSource', 'approvedAvatarFinishId', 'selectedBackgroundId', 'selectedFadeId', 'backgroundTransform', 'photoScale', 'photoX', 'photoY', 'topSize', 'bottomSize', 'topSizeRequest', 'bottomSizeRequest', 'textColor', 'symbol', 'symbolChoice', 'whiteBacking', 'avatarBottomFade'].forEach(function (key) { draft.state[key] = JSON.parse(JSON.stringify(state[key] == null ? null : state[key])); });
    ['avatar', 'style', 'mode', 'accessory', 'hair', 'garment', 'color', 'background'].forEach(function (category) { var selected = getMiaSelected(root, category); draft.choices[category] = selected ? selected.value : ''; });
    if (journey.editing == null) journey.drafts.push(draft);
    else journey.drafts[journey.editing] = draft;
    journey.editing = journey.editing == null ? journey.drafts.length - 1 : journey.editing;
    journey.variantId = draft.variantId;
    qs(root, '[data-local-cart-status]').textContent = snapshot || browserRecipe ? localCopy(root, 'saved') : localCopy(root, 'cartBlocked');
    renderLocalReview(root);
  }

  function restoreLocalDraftIdentity(journey, draft, index) {
    journey.editing = index;
    journey.quantity = draft.quantity;
    journey.variantId = String(draft.variantId || '');
    journey.review = false;
    journey.index = 0;
  }

  function initializeLocalDefaultTexts(root) {
    if (root._localDefaultsApplied) return;
    root._localDefaultsApplied = true;
    if (!getTextValue(root, 'top').trim()) applyLocalChoice(root, 'text-top', localCopy(root, 'textTopBaby'));
    if (!getTextValue(root, 'bottom').trim()) applyLocalChoice(root, 'text-bottom', localCopy(root, 'textBottomBaby'));
  }

  function parseDiscoveryPreset(search) {
    // Discovery links contain only a public model ID, never customer text or URLs.
    if (typeof search !== 'string' || search.length > 2048) return null;
    var values = new URLSearchParams(search).getAll('clairatier_preset');
    if (values.length !== 1) return null;
    var match = /^mia-(signature|hero|prince-princess)-(standard|incognito)$/.exec(values[0]);
    if (!match) return null;
    var palettes = { signature: 'warm-ivory-honey', hero: 'midnight-turquoise-coral', 'prince-princess': 'jewel-blue-emerald' };
    return {
      id: values[0], style: match[1], mode: match[2],
      asset: 'clairatier-avatar-mia-' + match[1] + '-' + match[2] + '-' + palettes[match[1]] + '-v1-storefront-preview.webp'
    };
  }

  function isDiscoveryPresetAsset(source, preset, baseUrl) {
    if (!source || !preset) return false;
    try {
      var base = new URL(baseUrl);
      var asset = new URL(source, base);
      return asset.protocol === 'https:' && !asset.username && !asset.password && !asset.hash &&
        (asset.origin === base.origin || asset.origin === 'https://cdn.shopify.com') &&
        /\/(?:cdn\/shop\/t\/[^/]+\/assets|s\/files\/(?:[^/]+\/){1,5}t\/[^/]+\/assets)\//.test(asset.pathname) &&
        asset.pathname.slice(asset.pathname.lastIndexOf('/') + 1) === preset.asset;
    } catch (error) { return false; }
  }

  function hasDiscoveryPresetCustomerState(root, existingState) {
    var state = root && root._stickerState;
    var journey = state && state.localJourney;
    return existingState || !state || hasPhoto(root) || !!root._stickerUploadedPreviewSrc ||
      state.subjectSource !== 'approved-avatar' || state.approvedAvatarId !== 'mia' ||
      !!getSelectedGeneration(root) || !!state.isGenerating ||
      !!(state.validatedAssistantChoices && (state.validatedAssistantChoices.style || state.validatedAssistantChoices.color)) ||
      state.wardrobePaletteMode === 'custom' || state.symbolChoice === 'yes' && !!String(state.symbol || '').trim() ||
      !!(journey && ((journey.completed || []).length || (journey.drafts || []).length || journey.editing != null));
  }

  function applyDiscoveryPreset(root, search, existingState) {
    var preset = parseDiscoveryPreset(search);
    if (!preset || !localJourneyEnabled(root) || !root._wardrobeReady || root._stickerDiscoveryPresetApplied ||
        hasDiscoveryPresetCustomerState(root, existingState)) return false;
    // Validate every required native choice and the approved asset before mutation.
    var style = qsa(root, '[data-mia-choice="style"]').find(function (control) { return control.value === preset.style; });
    var avatar = qsa(root, '[data-mia-choice="avatar"]').find(function (control) { return control.value === 'mia'; });
    var mode = qsa(root, '[data-mia-choice="mode"]').find(function (control) { return control.value === (preset.mode === 'incognito' ? 'accessories' : 'standard'); });
    var opaque = qsa(root, '[data-mia-choice="accessory"]').find(function (control) { return control.value === 'opaque-incognito'; });
    if (!style || !avatar || !mode || !isDiscoveryPresetAsset(style.getAttribute('data-preview-' + preset.mode), preset, window.location.href) ||
        preset.mode === 'incognito' && (!opaque || opaque.getAttribute('data-presentation-mode') !== 'incognito' ||
          (opaque.getAttribute('data-accessory-styles') || '').split(',').indexOf(preset.style) < 0)) return false;
    applyLocalChoice(root, 'avatar', 'mia');
    applyLocalChoice(root, 'style', preset.style);
    applyLocalChoice(root, 'mode', preset.mode === 'incognito' ? 'mode-surface:accessories' : 'mode-surface:standard');
    if (preset.mode === 'incognito') applyLocalChoice(root, 'mode', 'accessory:opaque-incognito');
    root._stickerDiscoveryPresetApplied = preset.id;
    root.setAttribute('data-sticker-discovery-preset', preset.id);
    updatePhoto(root);
    renderLocalJourney(root);
    persistLocalSession(root);
    return true;
  }

  function isFreshCopyCartPageDefault(root) {
    var state = root && root._stickerState, journey = state && state.localJourney, color = root && getMiaSelected(root, 'color');
    return !!state && root.getAttribute('data-copy-cart-page') === 'true' && (copyCartEnabled(root) || browserRecipeEnabled(root)) &&
      root.getAttribute('data-product-id') === '10530170274128' &&
      root.getAttribute('data-product-handle') === PRIVATE_PILOT_PRODUCT_HANDLE &&
      String(getSelectedVariantId(root)) === '53144689148240' && localJourneyEnabled(root) &&
      state.subjectSource === 'approved-avatar' && state.approvedAvatarId === 'mia' && state.style === 'signature' &&
      state.presentationMode === 'standard' && state.approvedAvatarGarmentId === 'garment-yoke-blouse-dress' &&
      !state.approvedAvatarHairstyleId && !state.selectedAccessoryId && !state.symbol &&
      color && color.value === 'original' &&
      state.wardrobePaletteMode === 'catalog' && state.wardrobePaletteEdited !== true &&
      state.selectedBackgroundId === 'background-none-white' && (state.proofAvatars || []).length <= 1 &&
      !hasPhoto(root) && !root._stickerUploadedPreviewSrc && !getSelectedGeneration(root) && !state.isGenerating &&
      !state.selectedGenerationId && !state.activeGenerationRequestId && !Object.keys(state.generationResults || {}).length &&
      !getTextValue(root, 'top').trim() && !getTextValue(root, 'bottom').trim() &&
      !(state.validatedAssistantChoices && (state.validatedAssistantChoices.style || state.validatedAssistantChoices.color)) &&
      (!journey || journey.quantity === 1 && journey.index === 0 && !journey.review && !journey.options && !journey.chat && !journey.cartBusy &&
        !(journey.completed || []).length && !(journey.drafts || []).length && journey.editing == null) &&
      (state.photoScale == null || state.photoScale === 1) && !state.photoX && !state.photoY;
  }

  function prepareCopyCartPageDefault(root) {
    if (root._copyPageDefaultPrepared) return;
    root._copyPageDefaultPrepared = true;
    root._copyPageDefaultCandidate = false;
    // Capture prior context before init publishes its own default guided record.
    try {
      if (!isFreshCopyCartPageDefault(root) || new URLSearchParams(window.location.search).has('clairatier_preset') ||
          [getGuidedContextKey(root), getLocalSessionKey(root), GENERATION_SESSION_KEY, 'clairatier.copyCartIntent.v1']
            .some(function (key) { return window.sessionStorage.getItem(key) !== null; })) return;
    } catch (error) { return; }
    root._copyPageDefaultCandidate = true;
    var changed = function () { root._copyPageDefaultCandidate = false; };
    root.addEventListener('input', changed, true);
    root.addEventListener('change', changed, true);
    root.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-local-choice], [data-mia-choice], [data-local-proof-slot], [data-local-adjust], [data-local-halo], [data-local-text-color-preset], [data-local-text-size-step], [data-local-action]')) changed();
    }, true);
  }

  function initializeCopyCartPageDefault(root, restoredSession) {
    if (root._copyPageDefaultAttempted) return false;
    root._copyPageDefaultAttempted = true;
    if (!root._copyPageDefaultCandidate || restoredSession || !isFreshCopyCartPageDefault(root) ||
        !root._castPreviewReady || !root._wardrobeReady || !castPreviewEnabled(root) ||
        new URLSearchParams(window.location.search).has('clairatier_preset')) return false;
    try {
      if (!root._copyPageDefaultContextCaptured ||
          window.sessionStorage.getItem(getGuidedContextKey(root)) !== root._copyPageDefaultGuidedContext ||
          [getLocalSessionKey(root), GENERATION_SESSION_KEY, 'clairatier.copyCartIntent.v1']
            .some(function (key) { return window.sessionStorage.getItem(key) !== null; })) return false;
    } catch (error) { return false; }
    if (root.getAttribute('data-browser-recipe-enabled') === 'true') {
      var babyOutfit = defaultCastPreviewEntry(root, 'mia', 'baby');
      if (!babyOutfit || !isDiscoveryPresetAsset(miaAssetUrl(root, babyOutfit.asset), babyOutfit, window.location.href)) return false;
      return selectCastPreviewEntry(root, babyOutfit);
    }
    var outfit = (root._castPreviewCatalog || []).find(function (entry) { return entry.presetId === 'cast-mia-signature-outfit-01'; });
    var hair = (root._castCustomizationCatalog || []).find(function (entry) { return entry.id === 'cast-custom-mia-hair-01'; });
    if (!outfit || !hair || !castCustomizationMatches(hair, { approvedAvatarId: 'mia', style: 'signature', approvedAvatarGarmentId: outfit.presetId }) ||
        !isDiscoveryPresetAsset(miaAssetUrl(root, outfit.asset), outfit, window.location.href) ||
        !isDiscoveryPresetAsset(miaAssetUrl(root, hair.asset), hair, window.location.href)) return false;
    var choices = { avatar: 'mia', style: 'signature', garment: outfit.presetId, mode: 'standard', color: 'original', hair: hair.id };
    if (!Object.keys(choices).every(function (category) {
      return qsa(root, '[data-mia-choice="' + category + '"]').some(function (control) { return control.value === choices[category] && !control.disabled; });
    })) return false;
    if (!selectCastPreviewEntry(root, outfit)) return false;
    return selectCastCustomization(root, hair.id);
  }

  function captureCopyCartPageDefaultContext(root) {
    if (!root._copyPageDefaultCandidate || root._copyPageDefaultContextCaptured) return;
    try {
      root._copyPageDefaultGuidedContext = window.sessionStorage.getItem(getGuidedContextKey(root));
      root._copyPageDefaultContextCaptured = true;
    } catch (error) { root._copyPageDefaultCandidate = false; }
  }

  function initLocalJourney(root) {
    if (!localJourneyEnabled(root) || root._localJourneyBound) return;
    if (castPreviewEnabled(root) && !root._castPreviewReady) { loadCastPreviewCatalog(root).then(function () { initLocalJourney(root); renderLocalJourney(root); }); return; }
    if (root.getAttribute('data-wardrobe-catalog') && !root._wardrobeReady) { loadLocalWardrobe(root).then(function () { initLocalJourney(root); renderLocalJourney(root); }); return; }
    if (browserRecipeEnabled(root) && !root._browserRecipeLoaded) {
      if (!root._browserRecipeLoading) {
        root._browserRecipeLoading = true;
        loadBrowserRecipe(root).finally(function () { root._browserRecipeLoaded = true; initLocalJourney(root); renderLocalJourney(root); initReadonlyRecipePreview(root); });
      }
      return;
    }
    root._localJourneyBound = true;
    root._stickerState.assistantExperience = 'guided';
    syncAssistantShell(root);
    getLocalJourney(root);
    var restoredSession = restoreLocalSession(root);
    var existingPresetState = restoredSession || !!getTextValue(root, 'top').trim() || !!getTextValue(root, 'bottom').trim();
    initializeCopyCartPageDefault(root, existingPresetState);
    initializeLocalDefaultTexts(root);
    root._localSessionReady = true;
    if (!applyCastDiscoveryPreset(root, window.location.search, existingPresetState)) applyDiscoveryPreset(root, window.location.search, existingPresetState);
    window.addEventListener('pagehide', function () { persistLocalSession(root); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') persistLocalSession(root);
    });
    var resetDialog = qs(root, '[data-local-reset-dialog]');
    var imageDialog = qs(root, '[data-local-image-dialog]');
    if (resetDialog) resetDialog.addEventListener('cancel', function () {
      window.setTimeout(function () {
        if (root._localResetDialogOpener && typeof root._localResetDialogOpener.focus === 'function') root._localResetDialogOpener.focus();
        root._localResetDialogOpener = null;
      }, 0);
    });
    if (imageDialog) {
      var imageDialogTouchX = null;
      imageDialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          navigateLocalImageDialog(root, event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      imageDialog.addEventListener('touchstart', function (event) {
        imageDialogTouchX = event.touches.length === 1 ? event.touches[0].clientX : null;
      }, { passive: true });
      imageDialog.addEventListener('touchend', function (event) {
        if (imageDialogTouchX == null || !event.changedTouches.length) return;
        var delta = event.changedTouches[0].clientX - imageDialogTouchX;
        imageDialogTouchX = null;
        if (Math.abs(delta) >= 40) navigateLocalImageDialog(root, delta > 0 ? -1 : 1);
      }, { passive: true });
    }
    root.addEventListener('input', function (event) {
      var field = event.target.getAttribute('data-wardrobe-color') || event.target.getAttribute('data-wardrobe-hex') || event.target.getAttribute('data-wardrobe-rgb');
      var value = event.target.hasAttribute('data-wardrobe-rgb') ? wardrobeRgbToHex(event.target.value) : normalizeWardrobeHex(event.target.value);
      if (field && setWardrobeColorValidity(root, event.target, field, !!value)) updateWardrobeColorState(root, field, value);
      persistLocalSession(root);
    });
    root.addEventListener('focusin', function (event) {
      var field = event.target.getAttribute('data-wardrobe-color') || event.target.getAttribute('data-wardrobe-hex') || event.target.getAttribute('data-wardrobe-rgb');
      if (field) root._stickerState.wardrobeColorTarget = field;
    });
    var dock = qs(root, '.sticker-customizer__assistant-dock');
    var chatInput = qs(root, '[data-sticker-assistant-input]');
    if (dock) dock.addEventListener('click', function (event) {
      if (event.target.closest('[data-local-action="chat"],button')) return;
      if (!getLocalJourney(root).chat) setLocalChatExpanded(root, true);
    });
    if (chatInput) chatInput.addEventListener('focus', function () {
      if (!getLocalJourney(root).chat) setLocalChatExpanded(root, true);
    });
    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-local-action], [data-local-proof-slot], [data-local-choice], [data-local-step], [data-local-target], [data-local-adjust], [data-local-edit], [data-local-remove], [data-local-add], [data-local-name], [data-local-halo]');
      if (!target || !root.contains(target)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      var journey = getLocalJourney(root);
      var state = root._stickerState;
      var action = target.getAttribute('data-local-action');
      if (target.hasAttribute('data-local-proof-slot')) { switchMultiAvatar(root, Number(target.getAttribute('data-local-proof-slot'))); return; }
      if (action === 'proof-avatar-add' || action === 'proof-avatar-remove') { changeMultiAvatarCount(root, action === 'proof-avatar-add' ? 1 : -1); return; }
      var step = LOCAL_JOURNEY_STEPS[journey.index];
      if (target.hasAttribute('data-local-choice')) {
        var wasPending = localPending(root);
        applyLocalChoice(root, step, target.getAttribute('data-local-choice'));
        if (!wasPending && localPending(root)) showLocalNotice(root, localCopy(root, 'pendingHelp'));
      }
      if (action === 'next') {
        if (step.indexOf('text-') === 0 && state.localTextOverflow && state.localTextOverflow[step.slice(5)]) return;
        if (step === 'style' || step === 'color') state.validatedAssistantChoices[step] = true;
        if (step === 'photo' && state.subjectSource === 'approved-avatar') state.assistantOptionalPhotoOfferState = 'declined';
        advanceLocalJourney(journey);
      }
      if (action === 'back') {
        if (journey.review || journey.options || journey.chat) { journey.review = false; journey.options = false; journey.chat = false; journey.chatExpanded = false; }
        else journey.index = Math.max(0, journey.index - 1);
      }
      if (action === 'options') { journey.options = !journey.options; journey.chat = false; journey.chatExpanded = false; }
      if (action === 'chat') setLocalChatMode(root, journey.chatExpanded ? 'compact' : journey.chat ? 'expanded' : 'split');
      if (action === 'preview-help') {
        showLocalNotice(root, localPendingExplanation(root));
        qs(root, '[data-sticker-toast]').setAttribute('data-preview-explanation', '');
      }
      if (action === 'enlarge-image') openLocalImageDialog(root, target);
      if (action === 'previous-image') navigateLocalImageDialog(root, -1);
      if (action === 'next-image') navigateLocalImageDialog(root, 1);
      if (action === 'close-image') closeLocalImageDialog(root);
      if (action === 'reset-all') openLocalResetDialog(root, target);
      if (action === 'cancel-reset') closeLocalResetDialog(root);
      if (action === 'confirm-reset') { confirmLocalReset(root); return; }
      if (action === 'customize-wardrobe-colors') beginLocalWardrobeEdit(root, 'colors');
      if (action === 'change-wardrobe-outfit') {
        beginLocalWardrobeEdit(root, 'outfit');
      }
      if (action === 'cancel-wardrobe-edit') cancelLocalWardrobeEdit(root);
      if (action === 'validate-wardrobe-colors') {
        var wardrobeEntry = getLocalWardrobeEntry(root, state.approvedAvatarGarmentId);
        state.wardrobePaletteValidated = wardrobeHasChosenEveryColor(state, wardrobeEntry) &&
          !Object.keys(state.wardrobeColorInvalidFields || {}).length;
        if (state.wardrobePaletteValidated) { state.wardrobeEditing = false; root._wardrobeEditSnapshot = null; }
        state.validatedAssistantChoices.color = state.wardrobePaletteValidated;
      }
      if (action === 'focus-guide' || action === 'focus-preview') {
        setLocalChatMode(root, 'compact');
        if (action === 'focus-preview') {
          qs(root, '[data-sticker-action="toggle-preview"]').click();
          qs(root, '[data-sticker-action="toggle-preview"]').focus();
        } else qs(root, '[data-local-title]').focus();
      }
      if (target.hasAttribute('data-local-name')) qs(root, '[data-local-design-name]').value = target.getAttribute('data-local-name');
      if (action === 'refine-halo') openLocalSettings(root, 'halo');
      if (target.hasAttribute('data-local-halo')) {
        var backing = getLocalWhiteBacking(root);
        var key = target.getAttribute('data-local-halo');
        if (!backing.enabled) { backing.enabled = true; ['topText', 'bottomText', 'avatar', 'brand', 'badge'].forEach(function (name) { backing[name] = false; }); }
        backing[key] = !backing[key];
        updatePhoto(root); updateConfig(root);
      }
      if (target.hasAttribute('data-local-step')) { journey.index = Number(target.getAttribute('data-local-step')); journey.review = false; journey.options = false; }
      if (action === 'more' && journey.quantity < localQuantityLimit(root)) journey.quantity += 1;
      if (action === 'less' && journey.quantity > 1) journey.quantity -= 1;
      if (action === 'save') captureLocalDraft(root);
      if (action === 'add-duo' && !target.disabled && personalizedOffersEnabled(root)) submitPersonalizedOffer(root, 'duo', journey.drafts.slice());
      if (action === 'add-current' && !target.disabled) {
        if (browserRecipeEnabled(root)) submitBrowserRecipe(root);
        else if (approvedCompositionCartEnabled(root) || copyCartEnabled(root)) submitApprovedCompositionCart(root);
        else {
          captureLocalDraft(root);
          var current = journey.drafts[journey.editing];
          submitLocalDraft(root, current);
        }
      }
      if (action === 'new') { journey.index = 0; journey.completed = []; journey.review = false; journey.quantity = 1; journey.editing = null; journey.variantId = ''; qs(root, '[data-local-design-name]').value = ''; }
      if (action === 'generate' && journey.review) {
        var generationReview = openAssistantGenerationReview(root, createGuidedActionId('generate_now'));
        journey.chat = !!generationReview.reviewOpened;
        journey.chatExpanded = false;
        if (!generationReview.reviewOpened) qs(root, '[data-local-cart-status]').textContent = localCopy(root, 'pilotLimited');
      }
      if (action === 'keep-notice') qs(root, '[data-sticker-toast]').setAttribute('data-kept', '');
      if (action === 'settings') {
        var settings = qs(root, '[data-local-targets]');
        settings.hidden = !settings.hidden;
        journey.chat = false;
        journey.chatExpanded = false;
        journey.transformTarget = '';
        target.setAttribute('aria-expanded', String(!settings.hidden));
        qs(root, '[data-local-transforms]').hidden = true;
        root.classList.toggle('is-local-settings', !settings.hidden);
        syncLocalHaloControls(root);
      }
      if (target.hasAttribute('data-local-target')) {
        journey.transformTarget = target.getAttribute('data-local-target');
        qsa(root, '[data-local-target]').forEach(function (button) { button.setAttribute('aria-pressed', String(button === target)); });
        qs(root, '[data-local-transforms]').hidden = false;
        syncLocalHaloControls(root);
        focusLocalPreviewTarget(root, journey.transformTarget);
      }
      if (target.hasAttribute('data-local-adjust')) {
        var adjustment = target.getAttribute('data-local-adjust');
        var dimension = { zoom_in: 'scale', zoom_out: 'scale', left: 'x', right: 'x', up: 'y', down: 'y', reset: 'reset' }[adjustment];
        var direction = ['zoom_out', 'left', 'up'].indexOf(adjustment) >= 0 ? -1 : 1;
        if (journey.transformTarget === 'background') adjustBackgroundTransform(root, dimension, direction);
        else {
          if (dimension === 'scale') state.photoScale = clamp(state.photoScale + direction * 0.1, 0.75, 1.2);
          if (dimension === 'x') state.photoX = clamp(state.photoX + direction * 8, -48, 48);
          if (dimension === 'y') state.photoY = clamp(state.photoY + direction * 8, -48, 48);
          if (dimension === 'reset') { state.photoScale = 1; state.photoX = 0; state.photoY = 0; }
          updatePhoto(root); updateConfig(root);
        }
      }
      if (target.hasAttribute('data-local-remove')) { journey.drafts.splice(Number(target.getAttribute('data-local-remove')), 1); journey.editing = null; }
      if (target.hasAttribute('data-local-edit')) {
        var index = Number(target.getAttribute('data-local-edit'));
        var draft = journey.drafts[index];
        Object.keys(draft.state).forEach(function (key) { state[key] = JSON.parse(JSON.stringify(draft.state[key])); });
        Object.keys(draft.choices).forEach(function (category) { qsa(root, '[data-mia-choice="' + category + '"]').forEach(function (input) { input.checked = input.value === draft.choices[category]; }); });
        qs(root, '[data-mia-choice="fade"]').value = state.selectedFadeId;
        applyLocalChoice(root, 'text-top', draft.top); applyLocalChoice(root, 'text-bottom', draft.bottom);
        restoreLocalDraftIdentity(journey, draft, index);
        qs(root, '[data-local-design-name]').value = draft.name;
        syncMiaRuntimeChoices(root); updatePhoto(root);
      }
      if (target.hasAttribute('data-local-add')) {
        var accepted = journey.drafts[Number(target.getAttribute('data-local-add'))];
        submitLocalDraft(root, accepted);
      }
      renderLocalJourney(root);
      if (['next', 'back'].indexOf(action) !== -1 || target.hasAttribute('data-local-step')) {
        qs(root, '[data-local-scroll]').scrollTop = 0;
        qs(root, '[data-local-title]').focus({ preventScroll: true });
      }
    }, true);
    root.addEventListener('click', function (event) {
      var sizeButton = event.target.closest('[data-local-text-size-step]');
      if (sizeButton && root.contains(sizeButton)) {
        var position = sizeButton.getAttribute('data-local-text-size-position');
        setLocalTextSize(root, position, root._stickerState[position + 'Size'] + Number(sizeButton.getAttribute('data-local-text-size-step')) * 2);
      }
      var button = event.target.closest('[data-local-text-color-preset]');
      if (button && root.contains(button)) setLocalTextColor(root, button.getAttribute('data-local-text-color-preset'));
    });
    root.addEventListener('input', function (event) {
      if (event.target.matches('[data-local-text-color-input], [data-local-text-color-hex]') && !event.isComposing) setLocalTextColor(root, event.target.value);
      if (event.target.matches('[data-local-avatar-fade-input]')) setLocalAvatarBottomFade(root, event.target.value);
      if (event.target.matches('[data-local-text-size-input]')) setLocalTextSize(root, event.target.getAttribute('data-local-text-size-input'), event.target.value);
    });
    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-local-text-color-select]')) setLocalTextColor(root, event.target.value);
      if (event.target.matches('[data-local-text-suggestions]')) {
        var position = event.target.getAttribute('data-local-text-suggestions'), value = event.target.value === '__none__' ? '' : event.target.value;
        applyLocalChoice(root, 'text-' + position, value); qs(root, '[data-local-input]').value = getTextValue(root, position);
        updateConfig(root); persistLocalSession(root);
      }
    });
    qs(root, '[data-local-input]').addEventListener('input', function (event) {
      if (event.isComposing) return;
      applyLocalChoice(root, LOCAL_JOURNEY_STEPS[getLocalJourney(root).index], event.target.value);
    });
    qs(root, '[data-local-input]').addEventListener('compositionend', function (event) {
      applyLocalChoice(root, LOCAL_JOURNEY_STEPS[getLocalJourney(root).index], event.target.value);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { renderLocalJourney(root); });
    root.addEventListener('focusin', function (event) {
      if (event.target.matches('[data-sticker-assistant-input]')) {
        getLocalJourney(root).chat = true; renderLocalJourney(root);
      }
    });
    renderLocalJourney(root);
    bindPublicPersonalizer(root);
  }

  function syncAssistantShell(root) {
    var state = root && root._stickerState;
    var shell;
    var assistant;
    var previewExpanded;
    var previewToggle;

    if (!state) return;
    shell = getAssistantShellState(
      isGuidedExperienceEnabled(root),
      state.assistantExperience,
      state.guidedPreviewMode
    );
    state.assistantExperience = shell.experience;
    state.guidedPreviewMode = shell.previewMode;
    root.setAttribute('data-sticker-experience', shell.experience);
    root.setAttribute('data-sticker-preview-mode', shell.previewMode);
    previewExpanded = root.classList.contains('is-preview-large');

    assistant = qs(root, '[data-sticker-assistant-surface]');
    if (assistant) {
      var assistantBlocked = shell.assistantHidden || previewExpanded;
      assistant.hidden = shell.assistantHidden;
      assistant.setAttribute('aria-hidden', assistantBlocked ? 'true' : 'false');
      if (assistantBlocked) assistant.setAttribute('inert', '');
      else assistant.removeAttribute('inert');
    }
    qsa(root, '[data-sticker-experience-switch-action]').forEach(function (button) {
      var action = button.getAttribute('data-sticker-experience-switch-action');
      var hidden = shell.experience === 'guided'
        ? action !== 'open_full_options'
        : action !== 'return_to_guided';

      button.hidden = hidden;
      button.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      if (hidden) button.setAttribute('inert', '');
      else button.removeAttribute('inert');
    });
    qsa(root, '[data-sticker-full-options]').forEach(function (element) {
      var fullOptionsBlocked = shell.fullOptionsHidden || previewExpanded;
      element.hidden = shell.fullOptionsHidden;
      element.setAttribute('aria-hidden', fullOptionsBlocked ? 'true' : 'false');
      if (fullOptionsBlocked) element.setAttribute('inert', '');
      else element.removeAttribute('inert');
    });

    previewToggle = qs(root, '[data-sticker-action="toggle-preview"]');
    if (previewToggle) {
      previewToggle.setAttribute('aria-expanded', previewExpanded ? 'true' : 'false');
      previewToggle.textContent = previewExpanded
        ? translate(root, 'reducePreview')
        : translate(root, 'enlargePreview');
    }
    if (localJourneyEnabled(root)) {
      var localGuide = qs(root, '[data-local-guide]');
      if (localGuide) {
        localGuide.toggleAttribute('inert', previewExpanded);
        localGuide.setAttribute('aria-hidden', String(previewExpanded));
      }
    }
  }

  function syncAssistantVisualViewport(root) {
    var overlay = qs(root, '[data-sticker-overlay]');
    var viewport = window.visualViewport;

    if (!overlay) return;
    if (!viewport) {
      overlay.style.removeProperty('--sticker-visual-viewport-height');
      overlay.style.removeProperty('--sticker-visual-viewport-top');
      return;
    }
    overlay.style.setProperty(
      '--sticker-visual-viewport-height',
      Math.max(240, Math.round(viewport.height)) + 'px'
    );
    overlay.style.setProperty(
      '--sticker-visual-viewport-top',
      Math.max(0, Math.round(viewport.offsetTop)) + 'px'
    );
  }

  function getCustomizerFullscreenElement() {
    return document.fullscreenElement || document.webkitFullscreenElement || null;
  }

  function syncCustomizerFullscreen(root) {
    var dialog = qs(root, '.sticker-customizer__dialog');
    var button = qs(root, '[data-sticker-action="toggle-fullscreen"]');
    var active = getCustomizerFullscreenElement() === dialog || root.classList.contains('is-customizer-fullscreen-fallback');
    root.classList.toggle('is-customizer-fullscreen', active);
    if (button) {
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', button.getAttribute(active ? 'data-exit-label' : 'data-enter-label') || '');
    }
  }

  function exitCustomizerFullscreen(root) {
    var dialog = qs(root, '.sticker-customizer__dialog');
    root.classList.remove('is-customizer-fullscreen-fallback');
    if (getCustomizerFullscreenElement() === dialog) {
      var exit = document.exitFullscreen || document.webkitExitFullscreen;
      if (exit) {
        try { exit.call(document); } catch (error) {}
      }
    }
    syncCustomizerFullscreen(root);
  }

  function toggleCustomizerFullscreen(root) {
    var dialog = qs(root, '.sticker-customizer__dialog');
    if (!dialog) return;
    if (getCustomizerFullscreenElement() === dialog || root.classList.contains('is-customizer-fullscreen-fallback')) {
      exitCustomizerFullscreen(root);
      return;
    }
    enterCustomizerFullscreen(root);
  }

  function enterCustomizerFullscreen(root) {
    var dialog = qs(root, '.sticker-customizer__dialog');
    if (!dialog || getCustomizerFullscreenElement() === dialog || root.classList.contains('is-customizer-fullscreen-fallback')) return;
    var request = dialog.requestFullscreen || dialog.webkitRequestFullscreen;
    if (!request) {
      root.classList.add('is-customizer-fullscreen-fallback');
      syncCustomizerFullscreen(root);
      return;
    }
    try {
      var result = request.call(dialog);
      if (result && typeof result.catch === 'function') result.catch(function () {
        root.classList.add('is-customizer-fullscreen-fallback');
        syncCustomizerFullscreen(root);
      });
    } catch (error) {
      root.classList.add('is-customizer-fullscreen-fallback');
    }
    syncCustomizerFullscreen(root);
  }

  function bindCustomizerFullscreen(root) {
    if (root._stickerFullscreenBound) return;
    root._stickerFullscreenBound = true;
    document.addEventListener('fullscreenchange', function () { syncCustomizerFullscreen(root); });
    document.addEventListener('webkitfullscreenchange', function () { syncCustomizerFullscreen(root); });
    syncCustomizerFullscreen(root);
  }

  function bindAssistantVisualViewport(root) {
    var viewport = window.visualViewport;
    var handler;

    if (!viewport || root._stickerVisualViewportHandler) return;
    handler = function () {
      var overlay = qs(root, '[data-sticker-overlay]');
      if (overlay && !overlay.hidden) syncAssistantVisualViewport(root);
    };
    root._stickerVisualViewportHandler = handler;
    viewport.addEventListener('resize', handler);
    viewport.addEventListener('scroll', handler);
  }

  function setGuidedPreviewMode(root, mode) {
    if (!root || !root._stickerState || root._stickerState.assistantExperience !== 'guided') return;
    root._stickerState.guidedPreviewMode = mode === 'shelf' ? 'shelf' : 'foreground';
    if (root._stickerState.guidedPreviewMode === 'shelf') {
      root.classList.remove('is-preview-large');
    }
    syncAssistantShell(root);
  }

  function isSafeGuidedSuggestion(suggestion) {
    var forbiddenFields = [
      'ethnicity',
      'religion',
      'disability',
      'gender',
      'nationality',
      'relationship'
    ];
    var policyValue;

    if (!suggestion || typeof suggestion !== 'object') return false;
    if (suggestion.inferredFromPhoto || suggestion.sensitiveTrait) return false;
    policyValue = [suggestion.category, suggestion.topic, suggestion.eligibility]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return !forbiddenFields.some(function (field) {
      return policyValue.indexOf(field) !== -1;
    });
  }

  function getGuidedNextActions(context, catalog, requestedCategory) {
    var source = catalog || {};
    var minimum = context && context.technical && context.technical.minimumIntake;
    var missing = minimum && Array.isArray(minimum.missing) ? minimum.missing : [];
    var nextRequired = missing.indexOf(requestedCategory) !== -1 ? requestedCategory : missing[0];
    var suggestions = [];
    var refinementTopics;

    if (!context || !minimum) return suggestions;
    if (context.assistantV12 && !minimum.complete) {
      if (nextRequired === 'style' || nextRequired === 'color') {
        return (source[nextRequired] || []).filter(isSafeGuidedSuggestion).map(function (choice) {
          return {
            kind: 'controlled-action', action: 'set_choice', category: nextRequired,
            value: choice.value, label: choice.label,
            swatchClass: choice.swatchClass, swatchStyle: choice.swatchStyle
          };
        }).slice(0, GUIDED_PRIMARY_CHOICE_LIMIT);
      }
      if (nextRequired === 'optional-photo-offer') {
        return [{ kind: 'controlled-action', action: 'attach_photo', label: source.photo.label }, {
          kind: 'controlled-action', action: 'decline_photo',
          label: source.v12Labels && source.v12Labels['avatar-transform'] || 'Mia'
        }].slice(0, GUIDED_PRIMARY_CHOICE_LIMIT);
      }
    }
    if (context.assistantV12 && minimum.complete) {
      if (!context.technical.generationInProgress && source.generate) {
        suggestions.push({ kind: 'controlled-action', action: 'generate_now', label: source.generate.label });
      }
      (context.refinementTopics || []).filter(function (entry) {
        return entry.status === 'available';
      }).slice(0, Math.max(0, GUIDED_PRIMARY_CHOICE_LIMIT - suggestions.length)).forEach(function (entry) {
        var controlId = Object.keys(ASSISTANT_V12_CONTROLS).filter(function (id) {
          return ASSISTANT_V12_CONTROLS[id].topic === entry.topic;
        })[0];
        var control = controlId && ASSISTANT_V12_CONTROLS[controlId];
        if (control) suggestions.push({
          kind: 'controlled-action', action: 'show_control',
          controlId: controlId, focusTarget: control.focusTarget,
          label: source.v12Labels && source.v12Labels[entry.topic] || entry.topic
        });
      });
      return suggestions.slice(0, GUIDED_PRIMARY_CHOICE_LIMIT);
    }
    if (nextRequired === 'style' || nextRequired === 'color') {
      suggestions = (source[nextRequired] || []).filter(isSafeGuidedSuggestion).map(function (choice) {
        return {
          kind: 'controlled-action',
          action: 'set_choice',
          category: nextRequired,
          value: choice.value,
          label: choice.label,
          swatchClass: choice.swatchClass,
          swatchStyle: choice.swatchStyle
        };
      });
    } else if (nextRequired === 'photo' && source.photo) {
      suggestions = [{
        kind: 'controlled-action',
        action: 'attach_photo',
        label: source.photo.label
      }];
    } else if (minimum.complete) {
      if (!context.technical.generationInProgress && source.generate) {
        suggestions.push({
          kind: 'controlled-action',
          action: 'request_generation',
          label: source.generate.label
        });
      }
      refinementTopics = (source.refinements || []).filter(function (suggestion) {
        return GUIDED_REFINEMENT_TOPICS.indexOf(suggestion.topic) !== -1 &&
          isSafeGuidedSuggestion(suggestion);
      });
      if (refinementTopics.length < GUIDED_REFINEMENT_TOPICS.length) {
        refinementTopics = refinementTopics.concat((source.contextual || []).filter(function (suggestion) {
          return GUIDED_CONTEXTUAL_TOPICS.indexOf(suggestion.topic) !== -1 &&
            isSafeGuidedSuggestion(suggestion);
        }).slice(0, 1));
      }
      suggestions = suggestions.concat(refinementTopics.map(function (suggestion) {
        return {
          kind: 'refinement-topic',
          topic: suggestion.topic,
          label: suggestion.label
        };
      }));
    }

    return suggestions.filter(function (suggestion) {
      return suggestion.label && isSafeGuidedSuggestion(suggestion);
    }).slice(0, GUIDED_PRIMARY_CHOICE_LIMIT);
  }

  function getGuidedChoiceCatalog(root) {
    var surface = qs(root, '[data-sticker-assistant-surface]');
    var visualCards = isAssistantVisualCardsReady(root);

    if (!surface) return {};
    return {
      style: qsa(root, visualCards
        ? '[data-mia-choice="style"]'
        : '[data-sticker-style][data-sticker-style-key]').map(function (input) {
        var label = input.closest('label');
        return {
          value: visualCards ? input.value : input.getAttribute('data-sticker-style-key'),
          label: label ? label.textContent.trim() : input.value
        };
      }),
      color: qsa(root, visualCards
        ? '[data-mia-choice="color"]'
        : '[data-sticker-tryon-color]').map(function (button) {
        var swatch = qs(button, '.sticker-customizer__tryon-swatch');
        var owner = button.closest && button.closest('label');
        return {
          value: visualCards ? button.value : button.getAttribute('data-sticker-tryon-color'),
          label: visualCards && owner ? owner.textContent.trim() :
            button.getAttribute('data-tryon-label') || button.textContent.trim(),
          swatchClass: swatch && swatch.className || 'sticker-customizer__tryon-swatch',
          swatchStyle: swatch && swatch.getAttribute('style') ||
            (visualCards ? '--sticker-choice-color:' + (button.getAttribute('data-srgb-primary') || '#D6AAA4') : '')
        };
      }),
      photo: { label: surface.getAttribute('data-photo-label') },
      generate: { label: surface.getAttribute('data-generate-label') },
      refinements: [
        { topic: 'garment', label: surface.getAttribute('data-garment-label') },
        { topic: 'symbol', label: surface.getAttribute('data-symbol-label') },
        { topic: 'avatar_preferences', label: surface.getAttribute('data-avatar-preferences-label') }
      ],
      contextual: [
        { topic: 'text', label: surface.getAttribute('data-text-label') }
      ],
      v12Labels: {
        style: surface.getAttribute('data-style-label'),
        color: surface.getAttribute('data-color-label'),
        mode: surface.getAttribute('data-mode-label'),
        hairstyle: surface.getAttribute('data-hairstyle-label'),
        garment: surface.getAttribute('data-garment-label'),
        background: surface.getAttribute('data-background-label'),
        fade: surface.getAttribute('data-fade-label'),
        'avatar-transform': surface.getAttribute('data-avatar-label')
      }
    };
  }

  function isAssistantVisualCardsReady(root) {
    var prototype = root && qs(root, '[data-sticker-mia-prototype]');
    return !!root && (root.getAttribute('data-sticker-visual-cards-enabled') === 'true' ||
      isMiaPrivatePilotReady(root)) &&
      isAssistantV12Enabled(root) && isMiaRuntimeReady(root) && !!prototype &&
      (isMiaPrivatePilotReady(root) ||
        prototype.getAttribute('data-runtime-published') === 'true' &&
        prototype.getAttribute('data-production-approved') === 'true' &&
        prototype.getAttribute('data-commercial-clearance') === 'true');
  }

  function getAssistantVisualControl(root, category, value) {
    var mapped = category === 'hairstyle' ? 'hair' : category;
    var controls;
    if (mapped === 'fade') {
      controls = qsa(root, '[data-mia-choice="fade"] option');
    } else {
      controls = qsa(root, '[data-mia-choice="' + mapped + '"]');
    }
    return controls.filter(function (control) { return control.value === value; })[0] || null;
  }

  function getAssistantVisualCard(root, category, value) {
    var control = getAssistantVisualControl(root, category, value);
    var owner = control && control.closest && control.closest('label');
    var image = owner && qs(owner, 'img');
    var title = owner && qs(owner, 'strong');
    var subtitle = owner && qs(owner, 'small');
    var mode = root._stickerState && root._stickerState.presentationMode || 'standard';
    if (!control) return null;
    return {
      cardAsset: category === 'style'
        ? control.getAttribute('data-preview-' + mode) || ''
        : image && image.getAttribute('src') || '',
      exactPreviewAsset: category === 'style'
        ? control.getAttribute('data-preview-' + mode) || ''
        : '',
      title: title ? title.textContent.trim() : '',
      subtitle: subtitle ? subtitle.textContent.trim() : '',
      generationRequired: control.getAttribute('data-requires-generation') === 'true'
    };
  }

  function getAssistantVisualCategoryActions(root, category) {
    var mapped = category === 'hairstyle' ? 'hair' : category;
    var controls = mapped === 'fade'
      ? qsa(root, '[data-mia-choice="fade"] option')
      : qsa(root, '[data-mia-choice="' + mapped + '"]');
    if ((category === 'hairstyle' || category === 'garment') &&
        root._stickerState.subjectSource === 'photo') return [];
    return controls.filter(function (control) {
      return !!control.value && !(mapped === 'avatar' && control.value !== 'mia');
    }).filter(function (control) {
      var group;
      if (category === 'background') {
        var backgroundStyle = control.getAttribute('data-background-style');
        return !backgroundStyle || backgroundStyle === root._stickerState.style;
      }
      if (category === 'hairstyle') {
        group = MIA_HAIRSTYLE_GROUPS[root._stickerState.assistantAvatarPreferenceSubtopic || 'hair-short'];
        return (group || []).indexOf(control.value) !== -1 && MIA_HAIRSTYLE_IDS.indexOf(control.value) !== -1;
      }
      if (category === 'garment') {
        group = MIA_GARMENT_GROUPS[root._stickerState.assistantGarmentGroup || 'garment-first'];
        return (group || []).indexOf(control.value) !== -1 && MIA_GARMENT_IDS.indexOf(control.value) !== -1;
      }
      return true;
    }).map(function (control, index) {
      var label = control.closest && control.closest('label');
      return {
        kind: 'controlled-action',
        action: ['background', 'fade'].indexOf(category) !== -1 ? 'local_visual_choice' : 'set_choice',
        category: category,
        value: control.value,
        label: label ? label.textContent.trim() : control.textContent.trim(),
        id: 'visual:' + category + ':' + control.value + ':' + index
      };
    }).slice(0, GUIDED_PRIMARY_CHOICE_LIMIT);
  }

  function applyAssistantHairstyleChoice(root, value) {
    var state = root && root._stickerState;
    var avatar = root && getMiaSelected(root, 'avatar');
    var control;
    if (!state || !isAssistantV12Enabled(root) || !isAssistantVisualCardsReady(root) ||
        state.subjectSource !== 'approved-avatar' || !avatar || avatar.value !== 'mia' ||
        MIA_HAIRSTYLE_IDS.indexOf(value) === -1) {
      return { ok: false, code: 'hairstyle-unavailable' };
    }
    control = getAssistantVisualControl(root, 'hairstyle', value);
    if (!control) return { ok: false, code: 'hairstyle-unavailable' };
    if (state.approvedAvatarHairstyleId === value) return { ok: true, duplicate: true };
    qsa(root, '[data-mia-choice="hair"]').forEach(function (entry) { entry.checked = entry === control; });
    syncMiaRuntimeChoices(root, 'hairstyle');
    state.assistantVisualCategory = '';
    markAssistantContextChanged(root, 'hairstyle');
    resetGeneration(root);
    publishGuidedContext(root);
    syncAssistantResultLoop(root);
    return { ok: true };
  }

  function applyAssistantGarmentChoice(root, value) {
    var state = root && root._stickerState;
    var avatar = root && getMiaSelected(root, 'avatar');
    var control;
    var metadata = MIA_GARMENT_METADATA[value];
    if (!state || !metadata || !isAssistantV12Enabled(root) || !isAssistantVisualCardsReady(root) ||
        state.subjectSource !== 'approved-avatar' || !avatar || avatar.value !== 'mia') {
      return { ok: false, code: 'garment-unavailable' };
    }
    control = getAssistantVisualControl(root, 'garment', value);
    if (!control) return { ok: false, code: 'garment-unavailable' };
    if (state.approvedAvatarGarmentId === value && state.tryonGarment === value &&
        state.approvedAvatarFinishId === metadata.finish && !state.requestedAccentColor &&
        (metadata.colorSlots === 2 ? !!state.requestedSecondaryColor : !state.requestedSecondaryColor)) {
      return { ok: true, duplicate: true };
    }
    qsa(root, '[data-mia-choice="garment"]').forEach(function (entry) { entry.checked = entry === control; });
    syncMiaRuntimeChoices(root, 'garment');
    state.assistantVisualCategory = '';
    markAssistantContextChanged(root, 'garment');
    resetGeneration(root);
    publishGuidedContext(root);
    syncAssistantResultLoop(root);
    return { ok: true };
  }

  function syncAssistantGarmentNavigator(root) {
    var state = root && root._stickerState;
    var panel = qs(root, '[data-sticker-garment-navigator]');
    var selector = qs(root, '[data-sticker-garment-group]');
    if (!state || !panel) return false;
    panel.hidden = !isAssistantV12Enabled(root) || !isAssistantVisualCardsReady(root) ||
      state.assistantExperience !== 'guided' || state.subjectSource !== 'approved-avatar' ||
      state.assistantVisualCategory !== 'garment';
    if (panel.hidden) return false;
    if (selector) selector.value = state.assistantGarmentGroup || 'garment-first';
    return true;
  }

  function syncAssistantGarmentManualControls(root) {
    var state = root && root._stickerState;
    var section = qs(root, '[data-sticker-mia-garment-manual]');
    if (!state || !section) return false;
    section.hidden = !isAssistantV12Enabled(root) || !isAssistantVisualCardsReady(root) ||
      state.subjectSource !== 'approved-avatar';
    qsa(root, '[data-sticker-mia-garment-manual-choice]').forEach(function (button) {
      var selected = button.getAttribute('data-sticker-mia-garment-manual-choice') === state.approvedAvatarGarmentId;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    return !section.hidden;
  }

  function syncAssistantAvatarPreferencePanel(root) {
    var state = root && root._stickerState;
    var panel = qs(root, '[data-sticker-avatar-preferences]');
    var selector = qs(root, '[data-sticker-avatar-preference-subtopic]');
    var text = qs(root, '[data-sticker-avatar-preference-text]');
    var apply = qs(root, '[data-sticker-avatar-preference-apply]');
    var subtopic;
    var isFreeText;
    if (!state || !panel) return false;
    subtopic = state.assistantAvatarPreferenceSubtopic || 'hair-short';
    isFreeText = subtopic === 'headwear' || subtopic === 'expression';
    panel.hidden = !isAssistantV12Enabled(root) || !isAssistantVisualCardsReady(root) ||
      state.assistantExperience !== 'guided' || state.subjectSource !== 'approved-avatar' ||
      state.assistantVisualCategory !== 'hairstyle';
    if (panel.hidden) return false;
    if (selector) selector.value = subtopic;
    if (text) {
      text.hidden = !isFreeText;
      text.value = subtopic === 'headwear' ? state.assistantHeadwearPreference || '' :
        subtopic === 'expression' ? state.assistantExpressionPreference || '' : '';
      text.setAttribute('aria-label', subtopic === 'headwear'
        ? panel.getAttribute('data-headwear-label') : panel.getAttribute('data-expression-label'));
    }
    if (apply) apply.hidden = !isFreeText;
    return true;
  }

  function getStructuredAvatarInstructions(root) {
    var state = root && root._stickerState || {};
    var panel = qs(root, '[data-sticker-avatar-preferences]');
    var combined;
    if (!panel) return '';
    combined = [
      state.assistantHeadwearPreference
        ? panel.getAttribute('data-headwear-label') + ': ' + state.assistantHeadwearPreference : '',
      state.assistantExpressionPreference
        ? panel.getAttribute('data-expression-label') + ': ' + state.assistantExpressionPreference : ''
    ].filter(Boolean).join('\n');
    return Array.from(combined).slice(0, 300).join('');
  }

  function normalizeAssistantAvatarPreference(value) {
    return Array.from(String(value || '')
      .replace(/[\u0000-\u001F\u007F]/g, ' ')
      .trim()
      .replace(/\s+/g, ' '))
      .slice(0, 120).join('');
  }

  function syncAssistantAvatarInstructionsControls(root) {
    var state = root && root._stickerState;
    var hasPreference = !!(state && (state.assistantHeadwearPreference || state.assistantExpressionPreference));
    var input = qs(root, '[data-sticker-avatar-instructions-input]');
    if (!state) return;
    qsa(root, '[data-sticker-avatar-instructions-choice]').forEach(function (choice) {
      choice.checked = choice.value === (hasPreference ? 'yes' : 'no');
    });
    state.avatarInstructionsChoice = hasPreference ? 'yes' : 'no';
    state.avatarInstructions = hasPreference ? getStructuredAvatarInstructions(root) : '';
    if (input) input.value = state.avatarInstructions;
    updateAvatarInstructions(root, false);
  }

  function clearAssistantAvatarPreferencesForPhoto(root) {
    var state = root && root._stickerState;
    var structured;
    if (!state) return;
    structured = getStructuredAvatarInstructions(root);
    state.approvedAvatarHairstyleId = '';
    qsa(root, '[data-mia-choice="hair"]').forEach(function (entry) { entry.checked = false; });
    state.assistantHeadwearPreference = '';
    state.assistantExpressionPreference = '';
    state.assistantAvatarPreferenceSubtopic = 'hair-short';
    if (structured && state.avatarInstructions === structured) syncAssistantAvatarInstructionsControls(root);
  }

  function applyAssistantAvatarPreferenceText(root) {
    var state = root && root._stickerState;
    var panel = qs(root, '[data-sticker-avatar-preferences]');
    var input = qs(root, '[data-sticker-avatar-preference-text]');
    var subtopic = state && state.assistantAvatarPreferenceSubtopic;
    var value;
    if (!state || !panel || !input || !isAssistantV12Enabled(root) ||
        !isAssistantVisualCardsReady(root) || state.subjectSource !== 'approved-avatar' ||
        state.assistantExperience !== 'guided' || state.assistantVisualCategory !== 'hairstyle' ||
        ['headwear', 'expression'].indexOf(subtopic) === -1) {
      return { ok: false, code: 'avatar-preference-unavailable' };
    }
    value = normalizeAssistantAvatarPreference(input.value);
    input.value = value;
    if ((subtopic === 'headwear' ? state.assistantHeadwearPreference : state.assistantExpressionPreference) === value) {
      return { ok: true, duplicate: true, subtopic: subtopic };
    }
    if (subtopic === 'headwear') state.assistantHeadwearPreference = value;
    else state.assistantExpressionPreference = value;
    syncAssistantAvatarInstructionsControls(root);
    state.assistantAvatarInstructionsRevision = (state.assistantAvatarInstructionsRevision || 0) + 1;
    state.assistantVisualCategory = '';
    markAssistantContextChanged(root, 'hairstyle');
    resetGeneration(root);
    publishGuidedContext(root);
    syncAssistantResultLoop(root);
    announceAssistantState(root, panel.getAttribute('data-saved-label'));
    focusAssistantExperience(root, 'guided');
    return { ok: true, subtopic: subtopic };
  }

  function getAssistantCanonicalChoiceState(root) {
    var state = root && root._stickerState || {};
    var color = getMiaSelected(root, 'color');
    var background = getMiaSelected(root, 'background');
    var fade = qs(root, '[data-mia-choice="fade"]');
    return {
      style: state.style || '',
      color: color ? color.value : state.tryonColor || '',
      palette: [state.requestedPrimaryColor, state.requestedSecondaryColor, state.requestedAccentColor].filter(Boolean),
      finishColor: state.requestedFinishColor || '',
      paletteSource: state.approvedAvatarPaletteSource || '',
      mode: state.presentationMode || 'standard',
      hairstyle: state.approvedAvatarHairstyleId || '',
      garment: state.approvedAvatarGarmentId || state.tryonGarment || '',
      background: background ? background.value : state.selectedBackgroundId || '',
      fade: fade && !fade.disabled ? fade.value : state.selectedFadeId || ''
    };
  }

  function syncAssistantChoiceSummary(root) {
    var summary = qs(root, '[data-sticker-assistant-choice-summary]');
    var state = root && root._stickerState;
    var choices;
    if (!summary || !state) return;
    choices = getAssistantCanonicalChoiceState(root);
    summary.textContent = [state.approvedAvatarId || '', choices.style, choices.color,
      choices.palette.join('/'), choices.mode, choices.hairstyle, choices.garment,
      choices.background, choices.fade].filter(Boolean).join(' · ');
  }

  function syncAssistantHonestPreview(root) {
    var state = root && root._stickerState;
    var preview = qs(root, '[data-sticker-approved-avatar-preview]');
    var sample = qs(root, '[data-sticker-sample-photo]');
    var photo = qs(root, '[data-sticker-photo]');
    var status = qs(root, '[data-sticker-honest-preview-status]');
    var style = getMiaSelected(root, 'style');
    var color = getMiaSelected(root, 'color');
    var background = getMiaSelected(root, 'background');
    var fade = qs(root, '[data-mia-choice="fade"]');
    var exact = localJourneyEnabled(root) ? localExactAvatar(root) : !!state && state.subjectSource === 'approved-avatar' && !!style &&
      (!color || color.value === 'original') && !state.approvedAvatarHairstyleId &&
      state.approvedAvatarGarmentId === 'garment-yoke-blouse-dress' &&
      (!background || background.value === 'background-none-white') && (!fade || !fade.value);
    var exactAsset = exact ? getMiaExactChoiceAsset(root) : '';
    var surface = qs(root, '[data-sticker-assistant-surface]');
    if (!isAssistantVisualCardsReady(root) || !preview || !surface) return false;
    root._stickerMiaPreviewAlt = root._stickerMiaPreviewAlt || preview.alt;
    if (state.subjectSource === 'photo') {
      preview.hidden = true;
      if (status) status.hidden = true;
      return false;
    }
    if (exactAsset) {
      preview.src = exactAsset;
      root._stickerLastHonestPreviewAsset = exactAsset;
      root._stickerMiaPreviewDescription = typeof getApprovedAvatarDescription === 'function' && getApprovedAvatarDescription(root) || root._stickerMiaPreviewAlt;
    } else if (root._stickerLastHonestPreviewAsset) {
      preview.src = root._stickerLastHonestPreviewAsset;
    }
    preview.alt = root._stickerMiaPreviewDescription || localCopy(root, 'charactersTitle');
    preview.hidden = false;
    if (sample) sample.hidden = true;
    if (photo) photo.hidden = true;
    if (status) {
      status.textContent = exactAsset ? '' : localJourneyEnabled(root) ? localCopy(root, 'pending') : surface.getAttribute('data-generation-required-label') || '';
      status.hidden = !!exactAsset;
      status.toggleAttribute('data-generation-required', !exactAsset);
    }
    syncMultiAvatarPreview(root);
    return !!exactAsset;
  }

  function getGuidedChoicePresentation(rootOrContext, contextOrSuggestion, suggestionOrIndex, visualIndex) {
    var legacyCall = arguments.length < 4;
    var root = legacyCall ? null : rootOrContext;
    var context = legacyCall ? rootOrContext : contextOrSuggestion;
    var suggestion = legacyCall ? contextOrSuggestion : suggestionOrIndex;
    var index = legacyCall ? suggestionOrIndex : visualIndex;
    var category = suggestion && suggestion.category || '';
    var canonical = root && typeof getAssistantCanonicalChoiceState === 'function'
      ? getAssistantCanonicalChoiceState(root)
      : {};
    var selectedValue = canonical[category] || context && context.validated && context.validated[category] || '';

    return {
      category: category,
      selectable: ['style', 'color', 'mode', 'hairstyle', 'garment', 'background', 'fade'].indexOf(category) !== -1,
      selected: !!selectedValue && selectedValue === suggestion.value,
      recommended: category === 'style' && index === 0
    };
  }

  function announceAssistantState(root, message) {
    var status = qs(root, '[data-sticker-assistant-status]');
    var announcement = String(message || '').trim();

    if (!status || !announcement || root._stickerLastAssistantAnnouncement === announcement) {
      return false;
    }
    root._stickerLastAssistantAnnouncement = announcement;
    status.textContent = '';
    window.setTimeout(function () {
      if (root._stickerLastAssistantAnnouncement === announcement) {
        status.textContent = announcement;
      }
    }, 0);
    return true;
  }

  function getAssistantFocusTarget(root, experience) {
    if (experience === 'full') {
      return qs(root, '[data-sticker-full-options] [data-sticker-tab][aria-selected="true"]') ||
        qs(root, '[data-sticker-full-options] [data-sticker-tab]');
    }
    return qs(root, '[data-sticker-assistant-choices] [data-sticker-assistant-suggestion]') ||
      qs(root, '[data-sticker-assistant-input]');
  }

  function focusAssistantExperience(root, experience) {
    root._stickerAssistantFocusSequence = (root._stickerAssistantFocusSequence || 0) + 1;
    var focusSequence = root._stickerAssistantFocusSequence;
    window.setTimeout(function () {
      var overlay = qs(root, '[data-sticker-overlay]');
      var target;

      if (focusSequence !== root._stickerAssistantFocusSequence || overlay && overlay.hidden) return;
      target = getAssistantFocusTarget(root, experience);
      if (target && typeof target.focus === 'function') target.focus();
    }, 0);
  }

  function createAssistantTurnId() {
    var bytes;
    var index;
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
    } else {
      bytes = [];
      for (index = 0; index < 16; index += 1) {
        bytes.push(Math.floor(Math.random() * 256));
      }
    }
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    return Array.prototype.map.call(bytes, function (value) {
      return value.toString(16).padStart(2, '0');
    }).join('').replace(
      /^(........)(....)(....)(....)(............)$/,
      '$1-$2-$3-$4-$5'
    );
  }

  function getAssistantRoleLabel(root, role) {
    if (role === 'user') return translate(root, 'assistantCustomerLabel');
    if (role === 'assistant') return translate(root, 'assistantLabel');
    if (role === 'receipt') return translate(root, 'assistantReceiptLabel');
    return translate(root, 'assistantErrorLabel');
  }

  function getAssistantUserMessage(state, turnId) {
    var entry = (state.assistantTranscript || []).filter(function (item) {
      return item.role === 'user' && item.turnId === turnId;
    }).pop();
    return entry ? entry.text : '';
  }

  function renderAssistantTranscript(root) {
    var state = root && root._stickerState;
    var container = qs(root, '[data-sticker-assistant-history]');
    var scroll = qs(root, '[data-sticker-assistant-scroll]');
    if (!state || !container) return;
    container.textContent = '';
    state.assistantTranscript.forEach(function (entry) {
      var item = document.createElement('div');
      var body = document.createElement('div');
      var label = document.createElement('span');
      var message = document.createElement('p');
      var avatar;
      var retry;

      item.className = 'sticker-customizer__assistant-message sticker-customizer__assistant-message--' + entry.role;
      item.setAttribute('data-assistant-transcript-entry', entry.id);
      body.className = 'sticker-customizer__assistant-message-body';
      label.className = 'visually-hidden';
      label.textContent = getAssistantRoleLabel(root, entry.role);
      message.textContent = entry.text;
      if (entry.role === 'assistant') {
        avatar = document.createElement('span');
        avatar.className = 'sticker-customizer__assistant-avatar';
        avatar.setAttribute('aria-hidden', 'true');
        item.appendChild(avatar);
      }
      body.appendChild(label);
      body.appendChild(message);
      if (entry.role === 'error' && entry.turnId && getAssistantUserMessage(state, entry.turnId)) {
        retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'sticker-customizer__assistant-retry';
        retry.setAttribute('data-sticker-assistant-retry', entry.turnId);
        retry.textContent = translate(root, 'assistantRetry');
        body.appendChild(retry);
      }
      item.appendChild(body);
      container.appendChild(item);
    });
    window.setTimeout(function () {
      if (scroll) scroll.scrollTop = scroll.scrollHeight;
    }, 0);
  }

  function appendAssistantTranscriptEntry(root, entry) {
    var state = root && root._stickerState;
    var normalized = normalizeAssistantTranscriptEntry(entry);
    if (!state || !normalized) return false;
    state.assistantTranscript = state.assistantTranscript.filter(function (item) {
      return item.id !== normalized.id;
    });
    state.assistantTranscript.push(normalized);
    state.assistantTranscript = state.assistantTranscript.slice(-ASSISTANT_TRANSCRIPT_LIMIT);
    persistAssistantConversation(root);
    renderAssistantTranscript(root);
    return true;
  }

  function removeAssistantTurnErrors(root, turnId) {
    var state = root && root._stickerState;
    if (!state) return;
    state.assistantTranscript = state.assistantTranscript.filter(function (entry) {
      return !(entry.role === 'error' && entry.turnId === turnId);
    });
    persistAssistantConversation(root);
    renderAssistantTranscript(root);
  }

  function setAssistantSending(root, sending, statusText) {
    var state = root && root._stickerState;
    var input = qs(root, '[data-sticker-assistant-input]');
    var submit = qs(root, '[data-sticker-assistant-submit]');
    var status = qs(root, '[data-sticker-assistant-request-status]');
    if (!state) return;
    state.assistantSending = !!sending;
    root.toggleAttribute('data-assistant-sending', !!sending);
    if (input) input.disabled = !!sending;
    if (submit) submit.disabled = !!sending;
    if (status) status.textContent = statusText || '';
  }

  function getAssistantV12ActionKey(proposal) {
    return proposal.action + ':' + JSON.stringify(proposal.args || {});
  }

  function isAssistantV12GenerationEligible(root) {
    var context = getGuidedContext(root);
    return !!(context && context.assistantV12 && context.technical.minimumIntake.complete &&
      context.optionalPhotoOfferState !== 'pending' && !context.technical.generationInProgress &&
      !isAssistantCompositionGenerationBlocked(root) &&
      (!context.result.reference || context.hasUngeneratedChanges));
  }

  function isAssistantCompositionGenerationBlocked(root) {
    var state = root && root._stickerState || {};
    var compositionChanged = !!state.selectedFadeId ||
      !!state.selectedBackgroundId && state.selectedBackgroundId !== 'background-none-white';
    return compositionChanged && root.getAttribute('data-sticker-composition-generation-enabled') !== 'true';
  }

  function normalizeAssistantProposal(proposal, root) {
    var validation;
    var label;
    if (!proposal || typeof proposal !== 'object') return null;
    validation = root && typeof isAssistantV12Enabled === 'function' && isAssistantV12Enabled(root)
      ? validateGuidedActionEnvelopeV12(proposal, root)
      : validateGuidedActionEnvelope(proposal);
    label = typeof proposal.label === 'string' ? proposal.label.trim().slice(0, 160) : '';
    if (!validation.ok || !label) return null;
    return {
      kind: 'controlled-action',
      id: proposal.id,
      action: proposal.action,
      category: validation.args.category || '',
      value: validation.args.value || '',
      controlId: validation.args.controlId || '',
      focusTarget: validation.args.focusTarget || '',
      label: label
    };
  }

  function normalizeAssistantResponse(response, turnId, root, expectedRevision) {
    var proposals;
    var assistantText;
    var seen = {};
    var generate;
    var v12 = !!root && typeof isAssistantV12Enabled === 'function' && isAssistantV12Enabled(root);
    if (!response || typeof response !== 'object' || Array.isArray(response)) return null;
    if (response.contractVersion !== (v12 ? ASSISTANT_V12_CONTRACT_VERSION : ASSISTANT_TURN_CONTRACT_VERSION) || response.turnId !== turnId) return null;
    if (v12 && (!Number.isInteger(response.contextRevision) || response.contextRevision !== expectedRevision)) return null;
    if (['ASSISTANT_OK', 'CONTENT_REFUSED', 'ASSISTANT_FALLBACK'].indexOf(response.code) === -1) return null;
    if (typeof response.fallback !== 'boolean' || !Array.isArray(response.proposals) ||
        (v12 ? response.proposals.length > 12 : response.proposals.length > 4)) {
      return null;
    }
    assistantText = typeof response.assistantText === 'string'
      ? response.assistantText.trim().slice(0, ASSISTANT_RESPONSE_TEXT_LIMIT)
      : '';
    if (!assistantText) return null;
    proposals = response.proposals.map(function (proposal) {
      var normalized = normalizeAssistantProposal(proposal, root);
      var key = normalized && [normalized.action, normalized.category, normalized.value,
        normalized.controlId, normalized.focusTarget].join(':');
      if (!normalized || seen[key] || seen['id:' + normalized.id]) return null;
      seen[key] = true;
      seen['id:' + normalized.id] = true;
      return normalized;
    });
    if (!v12 && proposals.some(function (proposal) { return !proposal; })) return null;
    proposals = proposals.filter(Boolean);
    if (v12) {
      generate = proposals.filter(function (proposal) { return proposal.action === 'generate_now'; })[0];
      proposals = proposals.filter(function (proposal) { return proposal.action !== 'generate_now'; });
      if (isAssistantV12GenerationEligible(root)) {
        proposals.unshift(generate || {
          kind: 'controlled-action', id: turnId + ':frontend-generate', action: 'generate_now',
          category: '', value: '', controlId: '', focusTarget: '',
          label: qs(root, '[data-sticker-assistant-surface]').getAttribute('data-generate-now-label')
        });
      }
    }
    proposals = proposals.slice(0, 4);
    return {
      turnId: turnId,
      assistantText: assistantText,
      proposals: proposals,
      code: response.code,
      fallback: response.fallback
    };
  }

  function normalizeAssistantContextText(value, maxLength) {
    return String(value || '').trim().replace(/\s+/g, ' ').slice(0, maxLength);
  }

  function getAssistantAvailableChoices(root) {
    var choices = [];
    if (isAssistantV12Enabled(root)) {
      [['style', 'style'], ['mode', 'mode'], ['hairstyle', 'hair'], ['garment', 'garment']].forEach(function (definition) {
        var hairstyleGroup = root._stickerState &&
          MIA_HAIRSTYLE_GROUPS[root._stickerState.assistantAvatarPreferenceSubtopic || 'hair-short'];
        var garmentGroup = root._stickerState &&
          MIA_GARMENT_GROUPS[root._stickerState.assistantGarmentGroup || 'garment-first'];
        if ((definition[0] === 'hairstyle' || definition[0] === 'garment') &&
            (!root._stickerState || root._stickerState.subjectSource !== 'approved-avatar')) return;
        qsa(root, '[data-mia-choice="' + definition[1] + '"]').forEach(function (element) {
          if (/^[A-Za-z0-9][A-Za-z0-9._-]{0,99}$/.test(element.value) &&
              !(definition[0] === 'style' && ASSISTANT_V12_STYLES.indexOf(element.value) === -1) &&
              !(definition[0] === 'hairstyle' && (!hairstyleGroup || hairstyleGroup.indexOf(element.value) === -1)) &&
              !(definition[0] === 'garment' && (!garmentGroup || garmentGroup.indexOf(element.value) === -1 ||
                MIA_GARMENT_IDS.indexOf(element.value) === -1))) {
            choices.push({ category: definition[0], value: element.value });
          }
        });
      });
      qsa(root, isAssistantVisualCardsReady(root)
        ? '[data-mia-choice="color"]'
        : '[data-sticker-tryon-color]').forEach(function (element) {
        var value = isAssistantVisualCardsReady(root)
          ? element.value || ''
          : element.getAttribute('data-sticker-tryon-color') || '';
        if (/^[A-Za-z0-9][A-Za-z0-9._-]{0,99}$/.test(value)) choices.push({ category: 'color', value: value });
      });
      return choices.slice(0, 12);
    }
    [
      ['style', '[data-sticker-style][data-sticker-style-key]', 'data-sticker-style-key'],
      ['color', '[data-sticker-tryon-color]', 'data-sticker-tryon-color'],
      ['garment', '[data-sticker-tryon-garment]', 'data-sticker-tryon-garment']
    ].forEach(function (definition) {
      qsa(root, definition[1]).forEach(function (element) {
        var value = element.getAttribute(definition[2]) || '';
        if (/^[A-Za-z0-9][A-Za-z0-9._-]{0,99}$/.test(value)) {
          choices.push({ category: definition[0], value: value });
        }
      });
    });
    return choices.slice(0, 12);
  }

  function getAssistantV12AvailableControls(root) {
    return Object.keys(ASSISTANT_V12_CONTROLS).map(function (controlId) {
      var control = getAssistantV12Control(root, controlId);
      return control ? { controlId: controlId, focusTarget: control.definition.focusTarget } : null;
    }).filter(Boolean);
  }

  function normalizeAssistantV12Topics(root, stored) {
    var storedByTopic = {};
    (Array.isArray(stored) ? stored : []).forEach(function (entry) {
      if (entry && typeof entry.topic === 'string' && ASSISTANT_V12_TOPIC_STATUSES.indexOf(entry.status) !== -1) {
        storedByTopic[entry.topic] = entry.status;
      }
    });
    return Object.keys(ASSISTANT_V12_CONTROLS).map(function (controlId) {
      var topic = ASSISTANT_V12_CONTROLS[controlId].topic;
      return {
        topic: topic,
        status: (topic === 'hairstyle' || topic === 'garment') && root._stickerState &&
          root._stickerState.subjectSource === 'photo'
          ? 'not-applicable'
          : storedByTopic[topic] || (getAssistantV12Control(root, controlId) ? 'available' : 'unavailable')
      };
    });
  }

  function syncAssistantHairstyleTopicForSubject(root, sourceType) {
    var state = root && root._stickerState;
    var found = false;
    var restoredStatus;
    if (!state || !isAssistantV12Enabled(root)) return;
    state.assistantRefinementTopics = (state.assistantRefinementTopics || []).map(function (entry) {
      if (entry.topic !== 'hairstyle') return entry;
      found = true;
      if (sourceType === 'photo') {
        if (entry.status !== 'not-applicable') state.assistantHairstyleTopicStatusBeforePhoto = entry.status;
        return { topic: 'hairstyle', status: 'not-applicable' };
      }
      restoredStatus = state.assistantHairstyleTopicStatusBeforePhoto;
      if (ASSISTANT_V12_TOPIC_STATUSES.indexOf(restoredStatus) === -1 || restoredStatus === 'not-applicable') {
        restoredStatus = getAssistantV12Control(root, 'hairstyle-selector') ? 'available' : 'unavailable';
      }
      return { topic: 'hairstyle', status: restoredStatus };
    });
    if (!found) {
      state.assistantRefinementTopics.push({
        topic: 'hairstyle',
        status: sourceType === 'photo'
          ? 'not-applicable'
          : (getAssistantV12Control(root, 'hairstyle-selector') ? 'available' : 'unavailable')
      });
    }
    if (sourceType !== 'photo') state.assistantHairstyleTopicStatusBeforePhoto = '';
  }

  function syncAssistantGarmentTopicForSubject(root, sourceType) {
    var state = root && root._stickerState;
    var found = false;
    var restoredStatus;
    if (!state || !isAssistantV12Enabled(root)) return;
    state.assistantRefinementTopics = (state.assistantRefinementTopics || []).map(function (entry) {
      if (entry.topic !== 'garment') return entry;
      found = true;
      if (sourceType === 'photo') {
        if (entry.status !== 'not-applicable') state.assistantGarmentTopicStatusBeforePhoto = entry.status;
        return { topic: 'garment', status: 'not-applicable' };
      }
      restoredStatus = state.assistantGarmentTopicStatusBeforePhoto;
      if (ASSISTANT_V12_TOPIC_STATUSES.indexOf(restoredStatus) === -1 || restoredStatus === 'not-applicable') {
        restoredStatus = getAssistantV12Control(root, 'garment-selector') ? 'available' : 'unavailable';
      }
      return { topic: 'garment', status: restoredStatus };
    });
    if (!found) {
      state.assistantRefinementTopics.push({
        topic: 'garment',
        status: sourceType === 'photo'
          ? 'not-applicable'
          : (getAssistantV12Control(root, 'garment-selector') ? 'available' : 'unavailable')
      });
    }
    if (sourceType !== 'photo') state.assistantGarmentTopicStatusBeforePhoto = '';
  }

  function getAssistantV12Subject(root) {
    var state = root._stickerState;
    if (state.subjectSource === 'approved-avatar' && isMiaRuntimeReady(root)) {
      return { sourceType: 'approved-avatar', avatarId: state.approvedAvatarId || 'mia', presentationMode: state.presentationMode, ready: true };
    }
    if (state.subjectSource === 'photo' && hasUsablePhoto(root)) return { sourceType: 'photo', ready: true };
    return null;
  }

  function getAssistantLocale() {
    var locale = String(document.documentElement.lang || '').toLowerCase();
    if (locale === 'pt' || locale === 'pt-pt') return 'pt-PT';
    var language = locale.split('-')[0];
    return ['fr', 'en', 'it', 'es', 'nl', 'de'].indexOf(language) >= 0 ? language : 'en';
  }

  function buildAssistantTurnPayload(root, message, turnId) {
    var context = getGuidedContext(root);
    var state = root._stickerState;
    var payload = {
      turnId: turnId,
      message: normalizeAssistantContextText(message, 800),
      locale: getAssistantLocale(),
      context: {
        style: context.validated.style || undefined,
        color: context.validated.color || undefined,
        photoReady: !!context.validated.photo.available,
        garment: normalizeAssistantContextText(context.optional.garment, 100) || undefined,
        topText: normalizeAssistantContextText(getTextValue(root, 'top'), 80) || undefined,
        bottomText: normalizeAssistantContextText(getTextValue(root, 'bottom'), 80) || undefined,
        symbol: normalizeAssistantContextText(context.optional.symbol, 16) || undefined,
        avatarPreferences: state.avatarInstructionsChoice === 'yes'
          ? normalizeAssistantContextText(state.avatarInstructions, 300) || undefined
          : undefined,
        currentResultAvailable: !!getSelectedGeneration(root),
        generationStatus: state.generationStatus,
        availableChoices: getAssistantAvailableChoices(root)
      },
      recentTurnIds: state.assistantRecentTurnIds.filter(function (id) {
        return id !== turnId;
      }).slice(-ASSISTANT_RECENT_TURN_LIMIT)
    };
    if (isAssistantV12Enabled(root)) {
      payload.contextRevision = state.assistantContextRevision;
      payload.context.subject = getAssistantV12Subject(root);
      payload.context.photoReady = state.subjectSource === 'photo' && hasUsablePhoto(root);
      payload.context.optionalPhotoOfferState = state.assistantOptionalPhotoOfferState;
      payload.context.hasUngeneratedChanges = !!state.assistantHasUngeneratedChanges;
      payload.context.refinementTopics = state.assistantRefinementTopics;
      payload.context.availableControls = getAssistantV12AvailableControls(root);
    }
    if (localJourneyEnabled(root)) {
      var localPayload = buildGenerationPayload(root);
      localPayload.personalization.avatarInstructionsEnabled = !!(localPayload.personalization.avatarInstructionsEnabled && String(localPayload.personalization.avatarInstructions || '').trim());
      localPayload.personalization.symbolChoice = localPayload.personalization.symbolChoice === 'yes' && String(localPayload.personalization.symbol || '').trim() ? 'yes' : 'no';
      if (localPayload.composition.productProfileVersion === '') localPayload.composition.productProfileVersion = null;
      payload.contextRevision = state.assistantContextRevision;
      payload.context.localGuidance = getLocalGuidanceContext(root);
      payload.context.personalization = localPayload.personalization;
      payload.context.composition = localPayload.composition;
    }
    return payload;
  }

  function getAssistantTurnsEndpoint(generationEndpoint) {
    var url;
    try {
      url = new URL(String(generationEndpoint || '').trim(), window.location.href);
      if (url.protocol !== 'https:' || !/\/generations\/?$/.test(url.pathname)) return '';
      url.pathname = url.pathname.replace(/\/generations\/?$/, '/assistant/turns');
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function createAssistantRequestError(status, code) {
    var error = new Error('assistant-request-failed');
    error.status = status || 0;
    error.code = code || '';
    return error;
  }

  function fetchAssistantTurn(endpoint, payload, session, signal) {
    if (!CUSTOMIZER_AI_ENABLED) return Promise.reject(customizerAiDisabledError());
    return window.fetch(endpoint, {
      method: 'POST',
      credentials: 'omit',
      cache: 'no-store',
      referrerPolicy: 'no-referrer',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session.token
      },
      body: JSON.stringify(payload),
      signal: signal
    }).then(function (response) {
      return response.text().then(function (body) {
        var parsed;
        if (!response.ok) throw createAssistantRequestError(response.status);
        try {
          parsed = JSON.parse(body);
        } catch (error) {
          throw createAssistantRequestError(response.status, 'invalid-response');
        }
        return parsed;
      });
    });
  }

  function assertAssistantRequestActive(root, payload, signal, requestSequence) {
    var state = root && root._stickerState;
    var error;
    if ((signal && signal.aborted) || (requestSequence != null && (!state ||
        state.assistantPendingTurnId !== payload.turnId || state.assistantRequestSequence !== requestSequence))) {
      error = createAssistantRequestError(0, 'request-cancelled');
      error.name = 'AbortError';
      throw error;
    }
    if (requestSequence != null && payload.contextRevision != null &&
        state.assistantContextRevision !== payload.contextRevision) {
      throw createAssistantRequestError(0, 'context-changed');
    }
  }

  function requestAssistantTurn(root, payload, signal, forceRefresh, requestSequence) {
    if (!CUSTOMIZER_AI_ENABLED) return Promise.reject(customizerAiDisabledError());
    var generationEndpoint = (root.getAttribute('data-generation-endpoint') || '').trim();
    var assistantEndpoint = getAssistantTurnsEndpoint(generationEndpoint);
    if (!assistantEndpoint || !window.fetch) {
      return Promise.reject(createAssistantRequestError(0, 'unavailable'));
    }
    return getGenerationSession(generationEndpoint, !!forceRefresh)
      .then(function (session) {
        assertAssistantRequestActive(root, payload, signal, requestSequence);
        return fetchAssistantTurn(assistantEndpoint, payload, session, signal);
      })
      .catch(function (error) {
        if (error && error.status === 401 && !forceRefresh) {
          assertAssistantRequestActive(root, payload, signal, requestSequence);
          return requestAssistantTurn(root, payload, signal, true, requestSequence);
        }
        throw error;
      });
  }

  function getAssistantFailureMessage(root, error) {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return translate(root, 'assistantOffline');
    }
    if (error && error.name === 'AbortError') return translate(root, 'assistantTimeout');
    if (error && error.status === 429) return translate(root, 'assistantRateLimited');
    if (error && error.code === 'unavailable') return translate(root, 'assistantUnavailable');
    return translate(root, 'assistantFailed');
  }

  function finishAssistantTurn(root, turnId, requestSequence, response) {
    var state = root._stickerState;
    var normalized;
    if (!state || state.assistantPendingTurnId !== turnId ||
        state.assistantRequestSequence !== requestSequence) {
      return { ok: false, code: 'stale-response' };
    }
    if (isAssistantV12Enabled(root) && state.assistantPendingContextRevision !== state.assistantContextRevision) {
      return failAssistantTurn(root, turnId, requestSequence, createAssistantRequestError(0, 'context-changed'));
    }
    normalized = normalizeAssistantResponse(response, turnId, root, state.assistantPendingContextRevision);
    if (!normalized) throw createAssistantRequestError(200, 'invalid-response');
    state.assistantPendingTurnId = '';
    state.assistantRecentTurnIds.push(turnId);
    state.assistantRecentTurnIds = state.assistantRecentTurnIds.slice(-ASSISTANT_RECENT_TURN_LIMIT);
    state.assistantProposals = normalized.proposals;
    appendAssistantTranscriptEntry(root, {
      id: 'assistant:' + turnId,
      role: 'assistant',
      text: normalized.assistantText,
      turnId: turnId,
      code: normalized.code
    });
    setAssistantSending(root, false, '');
    renderGuidedNextActions(root);
    announceAssistantState(root, normalized.assistantText);
    focusAssistantExperience(root, 'guided');
    return { ok: true, response: normalized };
  }

  function failAssistantTurn(root, turnId, requestSequence, error) {
    var state = root._stickerState;
    var message;
    if (!state || state.assistantPendingTurnId !== turnId ||
        state.assistantRequestSequence !== requestSequence) {
      return { ok: false, code: 'stale-response' };
    }
    state.assistantPendingTurnId = '';
    state.assistantProposals = [];
    message = getAssistantFailureMessage(root, error);
    appendAssistantTranscriptEntry(root, {
      id: 'error:' + turnId,
      role: 'error',
      text: message,
      turnId: turnId,
      code: error && error.code === 'invalid-response' ? 'INVALID_RESPONSE' : 'REQUEST_FAILED'
    });
    setAssistantSending(root, false, '');
    renderGuidedNextActions(root);
    announceAssistantState(root, message);
    window.setTimeout(function () {
      var retry = qs(root, '[data-sticker-assistant-retry="' + turnId + '"]');
      if (retry && typeof retry.focus === 'function') retry.focus();
    }, 0);
    return { ok: false, code: 'assistant-request-failed' };
  }

  function startAssistantTurn(root, message, options) {
    if (!CUSTOMIZER_AI_ENABLED) return { ok: false, code: 'CUSTOMIZER_AI_DISABLED' };
    var state = root && root._stickerState;
    var settings = options || {};
    var turnId = settings.turnId || createAssistantTurnId();
    var normalizedMessage = normalizeAssistantContextText(message, 800);
    var payload;
    var requestSequence;
    var controller = typeof window.AbortController === 'function'
      ? new window.AbortController()
      : null;
    var timeout;

    if (!state || !normalizedMessage) return { ok: false, code: 'empty-free-text-request' };
    if (state.assistantSending) {
      announceAssistantState(root, translate(root, 'assistantDuplicate'));
      return { ok: false, code: 'assistant-request-in-progress' };
    }
    if (!isAssistantTurnId(turnId)) return { ok: false, code: 'invalid-turn-id' };
    removeAssistantTurnErrors(root, turnId);
    if (settings.appendUser !== false) {
      appendAssistantTranscriptEntry(root, {
        id: 'user:' + turnId,
        role: 'user',
        text: normalizedMessage,
        turnId: turnId
      });
    }
    payload = buildAssistantTurnPayload(root, normalizedMessage, turnId);
    state.assistantPendingTurnId = turnId;
    state.assistantPendingMessage = normalizedMessage;
    state.assistantPendingContextRevision = isAssistantV12Enabled(root) ? payload.contextRevision : -1;
    state.assistantRequestSequence += 1;
    requestSequence = state.assistantRequestSequence;
    state.assistantAbortController = controller;
    state.assistantProposals = [];
    setGuidedPreviewMode(root, 'shelf');
    setAssistantSending(root, true, translate(root, 'assistantSending'));
    renderGuidedNextActions(root);
    timeout = window.setTimeout(function () {
      var error = createAssistantRequestError(0, 'timeout');
      error.name = 'AbortError';
      if (controller) controller.abort();
      failAssistantTurn(root, turnId, requestSequence, error);
    }, ASSISTANT_REQUEST_TIMEOUT_MS);
    requestAssistantTurn(root, payload, controller ? controller.signal : undefined, false, requestSequence)
      .then(function (response) {
        if (timeout) window.clearTimeout(timeout);
        return finishAssistantTurn(root, turnId, requestSequence, response);
      })
      .catch(function (error) {
        if (timeout) window.clearTimeout(timeout);
        return failAssistantTurn(root, turnId, requestSequence, error);
      });
    return { ok: true, turnId: turnId };
  }

  function retryAssistantTurn(root, turnId) {
    var state = root && root._stickerState;
    var message = state ? getAssistantUserMessage(state, turnId) : '';
    if (!message) return { ok: false, code: 'retry-message-missing' };
    return startAssistantTurn(root, message, {
      turnId: turnId,
      appendUser: false
    });
  }

  function cancelAssistantTurn(root) {
    var state = root && root._stickerState;
    if (!state || !state.assistantSending) return;
    state.assistantRequestSequence += 1;
    state.assistantPendingTurnId = '';
    if (state.assistantAbortController && typeof state.assistantAbortController.abort === 'function') {
      state.assistantAbortController.abort();
    }
    state.assistantAbortController = null;
    setAssistantSending(root, false, '');
  }

  function getGuidedChoiceAnnouncement(root, button) {
    var category = button.getAttribute('data-assistant-category') || '';
    var label = button.textContent.trim();
    var tryonSummary;

    if (category === 'style') {
      return translate(root, 'styleSummary', { value: label }, label);
    }
    if (category === 'color') {
      tryonSummary = qs(root, '[data-sticker-tryon-summary]');
      return tryonSummary && tryonSummary.textContent.trim() || label;
    }
    return label;
  }

  function applyAssistantLocalVisualChoice(root, category, value) {
    var control = getAssistantVisualControl(root, category, value);
    if (!isAssistantVisualCardsReady(root) || !control || ['background', 'fade'].indexOf(category) === -1) {
      return { ok: false, code: 'visual-choice-not-available' };
    }
    if (category === 'background') return applyBackgroundSelection(root, value);
    var select = qs(root, '[data-mia-choice="fade"]');
    if (!select || control.disabled) return { ok: false, code: 'visual-choice-not-available' };
    var applied = applyFadeSelection(root, value);
    if (!applied.ok) return applied;
    root._stickerState.assistantVisualCategory = '';
    return applied;
  }

  function renderGuidedNextActions(root) {
    if (typeof localJourneyEnabled === 'function' && localJourneyEnabled(root)) {
      renderLocalJourney(root);
      return;
    }
    var container = qs(root, '[data-sticker-assistant-choices]');
    var textStep = qs(root, '[data-sticker-guided-text-step]');
    var visualStage = qs(root, '[data-sticker-assistant-visual-stage]');
    var visualTitle = qs(root, '[data-sticker-assistant-visual-title]');
    var visualHelp = qs(root, '[data-sticker-assistant-visual-help]');
    var context;
    var actions;
    var focusedCategory;
    var visualCards;
    var hasGenerationRequired;
    function syncStaticQuestion(category) {
      var question = root && qs(root, '.sticker-customizer__assistant-question');
      var visible = category === 'style';
      if (!question) return;
      question.hidden = !visible;
      if (typeof question.setAttribute === 'function') {
        question.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
    }

    syncStaticQuestion('');
    if (typeof root.removeAttribute === 'function') root.removeAttribute('data-sticker-visual-category');
    if (visualStage) visualStage.hidden = true;
    if (visualHelp) visualHelp.hidden = true;
    if (container) container.removeAttribute('aria-describedby');
    if (!container || !root._stickerState) return;
    if (root._stickerState.assistantFocusedTopic === 'text') {
      container.hidden = true;
      if (textStep) {
        textStep.hidden = false;
        syncGuidedTextStep(root);
      }
      return;
    }
    if (textStep) textStep.hidden = true;
    if (typeof syncAssistantAvatarPreferencePanel === 'function') {
      syncAssistantAvatarPreferencePanel(root);
    }
    if (typeof syncAssistantGarmentNavigator === 'function') {
      syncAssistantGarmentNavigator(root);
    }
    context = getGuidedContext(root);
    actions = isAssistantVisualCardsReady(root) && root._stickerState.assistantVisualCategory
      ? getAssistantVisualCategoryActions(root, root._stickerState.assistantVisualCategory)
      : root._stickerState.assistantProposals.length
      ? root._stickerState.assistantProposals.slice(0, GUIDED_PRIMARY_CHOICE_LIMIT)
      : getGuidedNextActions(context, getGuidedChoiceCatalog(root));
    focusedCategory = actions.length && actions.every(function (suggestion) {
      return suggestion.category && suggestion.category === actions[0].category;
    }) ? actions[0].category : '';
    visualCards = actions.map(function (suggestion) {
      return getAssistantVisualCard(root, suggestion.category, suggestion.value);
    });
    hasGenerationRequired = visualCards.some(function (card) {
      return !!(card && card.generationRequired);
    });
    syncStaticQuestion(focusedCategory);
    container.textContent = '';
    if (focusedCategory) {
      container.setAttribute('data-assistant-choice-category', focusedCategory);
      container.setAttribute('role', 'radiogroup');
    } else {
      container.removeAttribute('data-assistant-choice-category');
      container.setAttribute('role', 'group');
    }
    if (visualStage) visualStage.hidden = !(isAssistantVisualCardsReady(root) && focusedCategory);
    if (isAssistantVisualCardsReady(root) && focusedCategory && typeof root.setAttribute === 'function') {
      root.setAttribute('data-sticker-visual-category', focusedCategory);
    } else if (typeof root.removeAttribute === 'function') {
      root.removeAttribute('data-sticker-visual-category');
    }
    if (visualHelp) visualHelp.hidden = !hasGenerationRequired;
    if (hasGenerationRequired && visualHelp && visualHelp.id) {
      container.setAttribute('aria-describedby', visualHelp.id);
    } else {
      container.removeAttribute('aria-describedby');
    }
    if (visualTitle && focusedCategory) {
      var visualLabel = getGuidedChoiceCatalog(root).v12Labels[focusedCategory] || '';
      var visualTemplate = qs(root, '[data-sticker-assistant-surface]').getAttribute('data-visual-category-label') || '{category}';
      visualTitle.textContent = visualLabel ? formatTranslation(visualTemplate, { category: visualLabel }) : '';
      visualTitle.hidden = !visualLabel;
    }
    container.classList.toggle('is-visual-card-rail', isAssistantVisualCardsReady(root) && !!focusedCategory);
    actions.forEach(function (suggestion, index) {
      var button = document.createElement('button');
      var presentation = getGuidedChoicePresentation(root, context, suggestion, index);
      var visualCard = visualCards[index];
      var cardImage;
      var swatch;
      var label;
      var subtitle;
      var descriptionIds = [];
      button.type = 'button';
      button.className = 'sticker-customizer__choice button button--border-transparent';
      if (visualCard && visualCard.cardAsset) {
        cardImage = document.createElement('img');
        cardImage.src = visualCard.cardAsset;
        cardImage.alt = '';
        cardImage.setAttribute('aria-hidden', 'true');
        cardImage.loading = 'lazy';
        button.appendChild(cardImage);
        label = document.createElement('span');
        label.className = 'sticker-customizer__choice-title';
        label.textContent = visualCard.title || suggestion.label;
        button.appendChild(label);
        button.setAttribute('aria-label', visualCard.title || suggestion.label);
        if (visualCard.subtitle) {
          subtitle = document.createElement('small');
          subtitle.className = 'sticker-customizer__choice-subtitle';
          subtitle.id = (root.id || 'sticker-customizer') + '-visual-' +
            String(suggestion.category || 'choice').replace(/[^a-z0-9-]/gi, '-') + '-' +
            String(suggestion.value || index).replace(/[^a-z0-9-]/gi, '-') + '-description';
          subtitle.textContent = visualCard.subtitle;
          button.appendChild(subtitle);
          descriptionIds.push(subtitle.id);
        }
      } else if (presentation.category === 'color') {
        swatch = document.createElement('span');
        swatch.className = suggestion.swatchClass || 'sticker-customizer__tryon-swatch';
        swatch.setAttribute('aria-hidden', 'true');
        if (suggestion.swatchStyle) swatch.setAttribute('style', suggestion.swatchStyle);
        label = document.createElement('span');
        label.textContent = suggestion.label;
        button.appendChild(swatch);
        button.appendChild(label);
      } else {
        button.textContent = suggestion.label;
      }
      if (visualCard && visualCard.generationRequired) {
        button.setAttribute('data-generation-required', 'true');
        if (visualHelp && visualHelp.id) descriptionIds.push(visualHelp.id);
      }
      if (descriptionIds.length) button.setAttribute('aria-describedby', descriptionIds.join(' '));
      button.setAttribute('data-sticker-assistant-suggestion', suggestion.kind);
      if (suggestion.action) button.setAttribute('data-assistant-action', suggestion.action);
      if (suggestion.id) button.setAttribute('data-assistant-action-id', suggestion.id);
      if (suggestion.category) button.setAttribute('data-assistant-category', suggestion.category);
      if (suggestion.value) button.setAttribute('data-assistant-value', suggestion.value);
      if (suggestion.topic) button.setAttribute('data-assistant-topic', suggestion.topic);
      if (suggestion.controlId) button.setAttribute('data-assistant-control-id', suggestion.controlId);
      if (suggestion.focusTarget) button.setAttribute('data-assistant-focus-target', suggestion.focusTarget);
      if (suggestion.action === 'local_visual_choice') {
        button.setAttribute('data-assistant-local-category', suggestion.category);
      }
      if (presentation.selectable) {
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', presentation.selected ? 'true' : 'false');
      }
      if (presentation.selected) button.classList.add('is-selected');
      button.disabled = !!root._stickerState.assistantSending;
      if (presentation.recommended) {
        button.classList.add('is-recommended');
        button.setAttribute('data-assistant-recommended', 'true');
      }
      container.appendChild(button);
    });
    container.hidden = actions.length === 0;
  }

  function navigateAssistantVisualCards(root, event) {
    var card = event.target.closest && event.target.closest(
      '[data-sticker-assistant-choices].is-visual-card-rail [data-sticker-assistant-suggestion]'
    );
    var cards;
    var index;
    var nextIndex;
    if (!card || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
    cards = qsa(root, '[data-sticker-assistant-choices].is-visual-card-rail [data-sticker-assistant-suggestion]');
    index = cards.indexOf(card);
    if (index === -1) return;
    if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = cards.length - 1;
    else nextIndex = (index + (event.key === 'ArrowRight' ? 1 : -1) + cards.length) % cards.length;
    event.preventDefault();
    cards[nextIndex].focus();
    if (typeof cards[nextIndex].scrollIntoView === 'function') {
      var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      cards[nextIndex].scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center'
      });
    }
  }

  function createGuidedActionId(action) {
    return 'guided:' + action + ':' + Date.now() + ':' + Math.random().toString(36).slice(2, 10);
  }

  function activateGuidedSuggestion(root, button) {
    var action = button.getAttribute('data-assistant-action');
    var actionId = button.getAttribute('data-assistant-action-id') || '';
    var topic = button.getAttribute('data-assistant-topic');
    var args = {};
    var labelText = button.textContent.trim();
    var result;

    if (button.hasAttribute('data-assistant-local-category')) {
      result = applyAssistantLocalVisualChoice(
        root,
        button.getAttribute('data-assistant-local-category') || '',
        button.getAttribute('data-assistant-value') || ''
      );
      renderGuidedNextActions(root);
      return result;
    }

    if (topic) {
      emitAnalyticsEvent('clairatier_refinement_selected', {
        category_code: topic
      });
      emitGuidedEvent(root, 'clairatier:assistant-refinement-request', {
        topic: topic,
        context: getGuidedContext(root)
      });
      setGuidedPreviewMode(root, 'shelf');
      if (topic === 'text') {
        root._stickerState.assistantFocusedTopic = 'text';
        renderGuidedNextActions(root);
        window.setTimeout(function () {
          var input = qs(root, '[data-sticker-guided-text="top"]');
          if (input && typeof input.focus === 'function') input.focus();
        }, 0);
      }
      return { ok: true, topic: topic };
    }
    if (!action) return { ok: false, code: 'suggestion-action-missing' };
    if (action === 'set_choice') {
      args.category = button.getAttribute('data-assistant-category') || '';
      args.value = button.getAttribute('data-assistant-value') || '';
    }
    if (action === 'show_control') {
      args.controlId = button.getAttribute('data-assistant-control-id') || '';
      args.focusTarget = button.getAttribute('data-assistant-focus-target') || '';
    }
    result = dispatchGuidedAction(root, {
      id: actionId || createGuidedActionId(action),
      action: action,
      args: args
    });
    if (result.ok && actionId && !result.reviewOnly) {
      root._stickerState.assistantProposals = [];
      appendAssistantTranscriptEntry(root, {
        id: 'receipt:' + actionId,
        role: 'receipt',
        text: translate(root, 'assistantActionReceipt', { label: labelText }),
        code: 'ACTION_ACCEPTED'
      });
    }
    if (result.ok && action === 'set_choice') {
      setGuidedPreviewMode(root, 'shelf');
      announceAssistantState(root, getGuidedChoiceAnnouncement(root, button));
    }
    renderGuidedNextActions(root);
    if (result.ok && action === 'set_choice') focusAssistantExperience(root, 'guided');
    return result;
  }

  function submitGuidedFreeText(root) {
    var input = qs(root, '[data-sticker-assistant-input]');
    var request = input ? input.value.trim() : '';
    var result;

    if (!request) return { ok: false, code: 'empty-free-text-request' };
    result = startAssistantTurn(root, request);
    if (result.ok && input) input.value = '';
    return result;
  }

  function getGuidedContext(root) {
    var state = root && root._stickerState;
    var selected = state ? getSelectedGeneration(root) : null;
    var photoAvailable;
    var minimumIntake;
    var missingRequiredInputs;

    if (!state) return null;
    photoAvailable = hasUsableSubject(root);
    minimumIntake = getMinimumIntakeStatus(state, photoAvailable);
    missingRequiredInputs = getMissingMinimumInputs(minimumIntake);
    var context = {
      version: GUIDED_CONTRACT_VERSION,
      experience: state.assistantExperience,
      current: {
        style: state.style || '',
        color: state.tryonColor || ''
      },
      validated: {
        style: minimumIntake.style ? state.style : '',
        color: minimumIntake.color ? state.tryonColor : '',
        photo: {
          available: photoAvailable,
          reference: photoAvailable ? 'browser-session' : ''
        }
      },
      optional: {
        garment: isAssistantV12Enabled(root) && state.subjectSource === 'photo'
          ? ''
          : state.tryonGarment || '',
        symbol: state.symbolChoice === 'no' ? '' : state.symbol || '',
        avatarPreferencesProvided: state.avatarInstructionsChoice === 'yes' && !!state.avatarInstructions
      },
      result: {
        reference: selected ? selected.id : '',
        status: state.generationStatus
      },
      technical: {
        generationInProgress: !!state.isGenerating,
        minimumIntake: {
          required: GUIDED_MINIMUM_INPUTS.slice(),
          missing: missingRequiredInputs,
          complete: missingRequiredInputs.length === 0
        }
      },
      availableActions: GUIDED_ACTIONS.slice()
    };
    if (isAssistantV12Enabled(root)) {
      context.assistantV12 = true;
      context.contextRevision = state.assistantContextRevision;
      context.subject = getAssistantV12Subject(root);
      context.optionalPhotoOfferState = state.assistantOptionalPhotoOfferState;
      context.refinementTopics = state.assistantRefinementTopics;
      context.hasUngeneratedChanges = !!state.assistantHasUngeneratedChanges;
      context.contextFingerprint = state.assistantContextFingerprint || '';
      context.generatedContextFingerprint = state.assistantGeneratedContextFingerprint || '';
      context.availableActions = ASSISTANT_V12_ACTIONS.slice();
      context.technical.minimumIntake.complete = !!context.subject && !!context.validated.style &&
        !!context.validated.color && context.optionalPhotoOfferState !== 'pending';
      context.technical.minimumIntake.missing = [
        context.subject ? '' : 'subject',
        context.validated.style ? '' : 'style',
        context.validated.color ? '' : 'color',
        context.optionalPhotoOfferState === 'pending' ? 'optional-photo-offer' : ''
      ].filter(Boolean);
    }
    return context;
  }

  function persistGuidedContext(root) {
    var state = root._stickerState;
    var context;

    if (!state || root._localResetting) return;
    context = getGuidedContext(root);
    try {
      window.sessionStorage.setItem(
        getGuidedContextKey(root),
        JSON.stringify(buildGuidedPreferenceRecord(context, state.processedAssistantActionIds, state))
      );
    } catch (error) {}
    persistLocalSession(root);
  }

  function emitGuidedEvent(root, name, detail) {
    if (typeof window.CustomEvent !== 'function') return;
    root.dispatchEvent(new window.CustomEvent(name, { detail: detail }));
  }

  function getAssistantContextFingerprint(root) {
    var state = root && root._stickerState;
    if (!state) return '';
    return JSON.stringify({
      subjectSource: state.subjectSource,
      photoReady: hasUsablePhoto(root),
      photoSelectionRevision: state.subjectSource === 'photo' ? state.assistantPhotoSelectionRevision : 0,
      style: state.style,
      color: state.tryonColor,
      mode: state.presentationMode,
      accessory: state.selectedAccessoryId || '',
      hairstyle: state.approvedAvatarHairstyleId,
      garment: state.approvedAvatarGarmentId || state.tryonGarment,
      palette: [state.requestedPrimaryColor, state.requestedSecondaryColor, state.requestedAccentColor],
      finish: state.approvedAvatarFinishId,
      finishColor: state.requestedFinishColor,
      background: state.selectedBackgroundId || '',
      fade: state.selectedFadeId || '',
      backgroundTransform: normalizeBackgroundTransform(state.backgroundTransform),
      symbol: state.symbolChoice === 'no' ? '' : state.symbol,
      avatarInstructionsRevision: state.assistantAvatarInstructionsRevision || 0
    });
  }

  function completeAssistantGenerationContext(root, expectedFingerprint) {
    var state = root && root._stickerState;
    var currentFingerprint;
    if (!state || !isAssistantV12Enabled(root) || !expectedFingerprint) return false;
    currentFingerprint = getAssistantContextFingerprint(root);
    if (currentFingerprint !== expectedFingerprint) return false;
    state.assistantContextFingerprint = currentFingerprint;
    state.assistantGeneratedContextFingerprint = currentFingerprint;
    state.assistantHasUngeneratedChanges = false;
    persistGuidedContext(root);
    return true;
  }

  function bumpAssistantPhotoSelectionRevision(root) {
    var state = root && root._stickerState;
    if (!state) return 0;
    state.assistantPhotoSelectionRevision = (state.assistantPhotoSelectionRevision || 0) + 1;
    if (isAssistantV12Enabled(root)) {
      state.assistantContextRevision += 1;
      state.assistantHasUngeneratedChanges = true;
    }
    return state.assistantPhotoSelectionRevision;
  }

  function syncAssistantUngeneratedChanges(root) {
    var state = root && root._stickerState;
    var fingerprint;
    if (!state || !isAssistantV12Enabled(root)) return false;
    fingerprint = getAssistantContextFingerprint(root);
    if (state.assistantGeneratedContextFingerprint) {
      state.assistantHasUngeneratedChanges =
        fingerprint !== state.assistantGeneratedContextFingerprint;
    } else if (state.assistantContextFingerprint && state.assistantContextFingerprint !== fingerprint) {
      state.assistantHasUngeneratedChanges = true;
    }
    if (state.assistantHasUngeneratedChanges) state.assistantAcceptedGenerationId = '';
    state.assistantContextFingerprint = fingerprint;
    return state.assistantHasUngeneratedChanges;
  }

  function publishGuidedContext(root) {
    var state = root && root._stickerState;
    var fingerprint;
    var context;

    if (!state) return;
    if (isAssistantV12Enabled(root)) {
      fingerprint = getAssistantContextFingerprint(root);
      if (state.assistantContextFingerprint && state.assistantContextFingerprint !== fingerprint) {
        state.assistantContextRevision += 1;
      }
      syncAssistantUngeneratedChanges(root);
      invalidateAssistantGenerationReviewIfStale(root);
    }
    context = getGuidedContext(root);
    root._stickerState.assistantProposals = [];
    persistGuidedContext(root);
    renderGuidedNextActions(root);
    emitGuidedEvent(root, 'clairatier:assistant-context', context);
  }

  function markAssistantContextChanged(root, topic) {
    var state = root && root._stickerState;
    if (!state || !isAssistantV12Enabled(root)) return;
    if (!state.assistantHasUngeneratedChanges) {
      state.assistantPendingBaselineFingerprint = state.assistantGeneratedContextFingerprint || state.assistantContextFingerprint || getAssistantContextFingerprint(root);
    }
    state.assistantContextRevision += 1;
    state.assistantHasUngeneratedChanges = true;
    state.assistantAcceptedGenerationId = '';
    if (topic) {
      state.assistantRefinementTopics = state.assistantRefinementTopics.map(function (entry) {
        return entry.topic === topic ? { topic: entry.topic, status: 'completed' } : entry;
      });
    }
  }

  function setAssistantExperience(root, experience) {
    var previousExperience = root._stickerState.assistantExperience;
    var minimum;
    var stepId;

    root._stickerState.assistantExperience = experience === 'full' || !isGuidedExperienceEnabled(root)
      ? 'full'
      : 'guided';
    root._stickerState.guidedPreviewMode = 'foreground';
    root.classList.remove('is-preview-large');
    syncAssistantShell(root);
    publishGuidedContext(root);
    emitGuidedEvent(root, 'clairatier:assistant-experience', {
      experience: root._stickerState.assistantExperience
    });
    if (previousExperience === 'guided' && root._stickerState.assistantExperience === 'full' &&
        typeof emitAnalyticsEvent === 'function') {
      minimum = getMinimumIntakeStatus(root._stickerState,
        typeof hasUsableSubject === 'function' ? hasUsableSubject(root) : hasUsablePhoto(root));
      stepId = getMissingMinimumInputs(minimum)[0] || 'ready';
      emitAnalyticsEvent('clairatier_classic_fallback_selected', {
        step_id: stepId,
        reason_code: 'customer_selected'
      });
    }
    focusAssistantExperience(root, root._stickerState.assistantExperience);
  }

  function getGuidedChoiceElement(root, category, value) {
    var selector = '';

    if (category === 'style') selector = '[data-sticker-style][data-sticker-style-key]';
    if (category === 'color') selector = isAssistantVisualCardsReady(root)
      ? '[data-mia-choice="color"]'
      : '[data-sticker-tryon-color]';
    if (category === 'garment') selector = isAssistantV12Enabled(root)
      ? '[data-mia-choice="garment"]'
      : '[data-sticker-tryon-garment]';
    if (category === 'hairstyle') selector = '[data-mia-choice="hair"]';
    if (category === 'mode') selector = '[data-mia-choice="mode"]';
    if (isAssistantV12Enabled(root) && category === 'style' && ASSISTANT_V12_STYLES.indexOf(value) !== -1) {
      selector = '[data-mia-choice="style"]';
    }
    return qsa(root, selector).filter(function (element) {
      var attribute = category === 'style' && element.hasAttribute('data-sticker-style-key')
        ? 'data-sticker-style-key'
        : category === 'color' && element.hasAttribute('data-sticker-tryon-color')
          ? 'data-sticker-tryon-color'
          : category === 'garment' && element.hasAttribute('data-sticker-tryon-garment')
            ? 'data-sticker-tryon-garment'
            : 'value';
      return (attribute === 'value' ? element.value : element.getAttribute(attribute)) === value;
    })[0] || null;
  }

  function applyGuidedChoice(root, category, value) {
    var element = getGuidedChoiceElement(root, category, value);

    if (!element) return { ok: false, code: 'choice-not-available' };
    if (category === 'hairstyle') return applyAssistantHairstyleChoice(root, value);
    if (category === 'garment' && isAssistantV12Enabled(root)) return applyAssistantGarmentChoice(root, value);
    if (category === 'style') {
      root._stickerState.validatedAssistantChoices.style = true;
      qsa(root, '[data-sticker-style]').forEach(function (radio) {
        radio.checked = radio === element;
      });
      updateSelectedStyle(root);
      setStyle(root, value);
    }
    if (category === 'color') {
      root._stickerState.validatedAssistantChoices.color = true;
      if (element.hasAttribute('data-mia-choice')) {
        qsa(root, '[data-mia-choice="color"]').forEach(function (control) { control.checked = control === element; });
        syncMiaRuntimeChoices(root, category);
      } else {
        root._stickerState.tryonColor = value;
        updateTryon(root);
      }
    }
    if (category === 'garment') {
      root._stickerState.tryonGarment = value;
      updateTryon(root);
      emitAnalyticsEvent('clairatier_refinement_selected', {
        category_code: 'garment'
      });
    }
    if (category === 'hairstyle' || category === 'mode' ||
        (category === 'style' && element.hasAttribute('data-mia-choice'))) {
      qsa(root, '[data-mia-choice="' + (category === 'hairstyle' ? 'hair' : category) + '"]').forEach(function (control) {
        control.checked = control === element;
      });
      syncMiaRuntimeChoices(root, category);
    }
    if (isAssistantVisualCardsReady(root)) root._stickerState.assistantVisualCategory = '';
    markAssistantContextChanged(root, category);
    publishGuidedContext(root);
    if (category === 'style' || category === 'color') emitStepCompleted(root, category);
    return { ok: true };
  }

  function rememberGuidedAction(root, actionId) {
    var ids = root._stickerState.processedAssistantActionIds;

    ids.push(actionId);
    if (ids.length > GUIDED_ACTION_HISTORY_LIMIT) {
      root._stickerState.processedAssistantActionIds = ids.slice(-GUIDED_ACTION_HISTORY_LIMIT);
    }
    persistGuidedContext(root);
  }

  function pushAssistantControlHandoffHistory(root) {
    var state = root && root._stickerState;
    if (!state || state.assistantControlHandoffHistory || !window.history ||
        typeof window.history.pushState !== 'function') return;
    window.history.pushState(Object.assign({}, window.history.state || {}, {
      clairatierControlHandoff: true
    }), '', window.location.href);
    state.assistantControlHandoffHistory = true;
  }

  function closeAssistantControlHandoff(root, restoreFocus, fromHistory) {
    var state = root && root._stickerState;
    var opener = state && state.assistantControlHandoffOpener;
    var previousExperience = state && state.assistantControlHandoffPreviousExperience;
    var focusTarget;
    if (!state || !state.assistantControlHandoff) return false;
    state.assistantControlHandoff = null;
    state.assistantControlHandoffOpener = null;
    state.assistantControlHandoffPreviousExperience = '';
    state.assistantVisualCategory = '';
    if (state.backgroundEditorOpen) closeBackgroundEditor(root, false);
    else renderGuidedNextActions(root);
    if (previousExperience && previousExperience !== state.assistantExperience) {
      setAssistantExperience(root, previousExperience);
    }
    if (!fromHistory && state.assistantControlHandoffHistory && window.history &&
        window.history.state && window.history.state.clairatierControlHandoff &&
        typeof window.history.back === 'function') window.history.back();
    state.assistantControlHandoffHistory = false;
    if (restoreFocus) {
      focusTarget = isBackgroundEditorFocusTargetVisible(opener) ? opener :
        getAssistantFocusTarget(root, state.assistantExperience);
      if (!isBackgroundEditorFocusTargetVisible(focusTarget)) {
        focusTarget = qsa(root, '[data-sticker-background-editor-open]').filter(isBackgroundEditorFocusTargetVisible)[0];
      }
      if (focusTarget) focusBackgroundEditorTarget(root, focusTarget);
    }
    return true;
  }

  function getAssistantControlCurrentValue(root, handoff) {
    var state = root && root._stickerState;
    var output;
    var transform;
    if (!state || !handoff) return '';
    if (handoff.focusTarget.indexOf('background-zoom') === 0) {
      output = qs(root, '[data-sticker-background-zoom-output]');
      return output && output.textContent.trim() || '';
    }
    if (handoff.focusTarget.indexOf('background-') === 0 && handoff.focusTarget !== 'background') {
      transform = normalizeBackgroundTransform(state.backgroundTransform);
      return Math.round(transform.x * 100) + '% / ' + Math.round(transform.y * 100) + '%';
    }
    if (handoff.focusTarget === 'avatar') {
      return Math.round((Number.isFinite(Number(state.photoScale)) ? Number(state.photoScale) : 1) * 100) +
        '% / ' + Math.round(state.photoY || 0) + ' px';
    }
    if (handoff.focusTarget.indexOf('avatar-zoom') === 0) {
      return Math.round((Number.isFinite(Number(state.photoScale)) ? Number(state.photoScale) : 1) * 100) + '%';
    }
    if (handoff.focusTarget.indexOf('avatar-') === 0 && handoff.focusTarget !== 'avatar') {
      return Math.round(state.photoY || 0) + ' px';
    }
    return handoff.target ? (handoff.target.textContent || handoff.target.value || '').trim() : '';
  }

  function announceAssistantControlHandoff(root, handoff) {
    var surface = root && qs(root, '[data-sticker-assistant-surface]');
    var announcement = handoff && handoff.fallback
      ? surface && surface.getAttribute('data-control-fallback-label')
      : surface && surface.getAttribute('data-control-opened-label');
    if (!announcement) return false;
    return announceAssistantState(root, formatTranslation(announcement, {
      value: getAssistantControlCurrentValue(root, handoff) || '—'
    }));
  }

  function dismissAssistantControlHandoffOnEscape(event, candidates) {
    var closed = false;
    if (!event || event.key !== 'Escape') return false;
    (candidates || []).forEach(function (root) {
      if (closeAssistantControlHandoff(root, true, false)) closed = true;
    });
    if (!closed) return false;
    event.preventDefault();
    event.stopPropagation();
    return true;
  }

  function openAssistantControlHandoff(root, controlId, focusTarget, opener) {
    var state = root && root._stickerState;
    var handoff = resolveAssistantControlHandoff(root, controlId, focusTarget);
    var surface = root && qs(root, '[data-sticker-assistant-surface]');
    if (!state || !handoff) {
      var unavailableAnnouncement = surface && surface.getAttribute('data-control-unavailable-label');
      if (unavailableAnnouncement) announceAssistantState(root, unavailableAnnouncement);
      return { ok: false, code: 'control-not-available' };
    }
    if (state.assistantControlHandoff) {
      var ownsHistory = state.assistantControlHandoffHistory;
      closeAssistantControlHandoff(root, false, true);
      state.assistantControlHandoffHistory = ownsHistory;
    }
    state.assistantControlHandoff = handoff;
    state.assistantControlHandoffOpener = opener || document.activeElement;
    state.assistantControlHandoffPreviousExperience = state.assistantExperience;
    if (handoff.controlId === 'background-editor' || handoff.controlId === 'fade-selector') {
      if (!openBackgroundEditor(root, false, opener)) return { ok: false, code: 'control-not-available' };
      handoff.target = getAssistantControlFocusElement(root, handoff.controlId, handoff.focusTarget);
    } else if (handoff.controlId === 'avatar-editor') {
      setTab(root, 'photo');
      if (state.assistantExperience !== 'full') setAssistantExperience(root, 'full');
      handoff.target = getAssistantControlFocusElement(root, handoff.controlId, handoff.focusTarget);
    } else {
      if (state.assistantExperience !== 'guided') setAssistantExperience(root, 'guided');
      state.assistantVisualCategory = handoff.definition.topic;
      renderGuidedNextActions(root);
      handoff.target = qs(root, '[data-sticker-assistant-choices] [aria-checked="true"]') ||
        qs(root, '[data-sticker-assistant-choices] [data-sticker-assistant-suggestion]');
    }
    if (handoff.target) focusBackgroundEditorTarget(root, handoff.target);
    pushAssistantControlHandoffHistory(root);
    announceAssistantControlHandoff(root, handoff);
    return {
      ok: true,
      controlId: handoff.controlId,
      focusTarget: handoff.focusTarget,
      fallback: handoff.fallback
    };
  }

  function dispatchGuidedAction(root, envelope) {
    var validation = root && typeof isAssistantV12Enabled === 'function' && isAssistantV12Enabled(root)
      ? validateGuidedActionEnvelopeV12(envelope, root)
      : validateGuidedActionEnvelope(envelope);
    var state = root && root._stickerState;
    var picker;
    var result = { ok: false, code: 'customizer-not-ready' };

    if (!validation.ok || !state) return validation.ok ? result : validation;
    if (state.processedAssistantActionIds.indexOf(envelope.id) !== -1) {
      return { ok: false, code: 'duplicate-action' };
    }

    if (envelope.action === 'set_choice') {
      result = applyGuidedChoice(root, validation.args.category, validation.args.value);
    }
    if (envelope.action === 'attach_photo') {
      picker = qs(root, '[data-sticker-photo-picker]');
      if (picker) {
        picker.click();
        result = { ok: true };
      } else {
        result = { ok: false, code: 'photo-picker-unavailable' };
      }
    }
    if (envelope.action === 'request_generation') {
      if (state.isGenerating) {
        result = { ok: false, code: 'generation-in-progress' };
      } else if (!validate(root)) {
        result = {
          ok: false,
          code: 'generation-requirements-not-met',
          missing: getMissingMinimumInputs(getMinimumIntakeStatus(state,
            typeof hasUsableSubject === 'function' ? hasUsableSubject(root) : hasUsablePhoto(root)))
        };
      } else if (generateStyle(root)) {
        result = { ok: true };
      } else {
        result = { ok: false, code: 'generation-unavailable' };
      }
    }
    if (envelope.action === 'generate_now') {
      result = openAssistantGenerationReview(root, envelope.id);
      result.reviewOnly = true;
    }
    if (envelope.action === 'decline_photo') {
      if (state.subjectSource !== 'approved-avatar' || !isMiaRuntimeReady(root)) {
        result = { ok: false, code: 'subject-source-mismatch' };
      } else {
        state.assistantOptionalPhotoOfferState = 'declined';
        markAssistantContextChanged(root, 'avatar-transform');
        publishGuidedContext(root);
        result = { ok: true };
      }
    }
    if (envelope.action === 'show_control') {
      result = openAssistantControlHandoff(root, validation.args.controlId,
        validation.args.focusTarget, document.activeElement);
    }
    if (envelope.action === 'accept_result') {
      result = handleAssistantResultAction(root, 'accept');
    }
    if (envelope.action === 'compare_results') {
      result = handleAssistantResultAction(root, 'compare');
    }
    if (envelope.action === 'open_full_options') {
      closeAssistantControlHandoff(root, false, false);
      setAssistantExperience(root, 'full');
      result = { ok: true };
    }
    if (envelope.action === 'return_to_guided') {
      closeAssistantControlHandoff(root, false, false);
      setAssistantExperience(root, 'guided');
      syncAssistantResultLoop(root);
      window.setTimeout(function () {
        var title = qs(root, '[data-sticker-assistant-result-title]');
        if (title && getSelectedGeneration(root) && typeof title.focus === 'function') title.focus();
      }, 0);
      result = { ok: true };
    }
    if (envelope.action === 'request_human_help') {
      emitGuidedEvent(root, 'clairatier:assistant-human-help', { requested: true });
      result = { ok: true };
    }

    if (!result.ok) return result;
    if (!result.reviewOnly) rememberGuidedAction(root, envelope.id);
    result.context = getGuidedContext(root);
    emitGuidedEvent(root, 'clairatier:assistant-action', {
      id: envelope.id,
      action: envelope.action,
      context: result.context
    });
    return result;
  }

  function getSelectedVariantId(root) {
    var journey = root && root._stickerState && root._stickerState.localJourney;
    if (journey && journey.variantId && localJourneyEnabled(root)) return String(journey.variantId);
    var form = getForm(root);
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    return variantInput ? variantInput.value : '';
  }

  function createGenerationRequestId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'generation-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function freezeGenerationValue(value) {
    if (!value || typeof value !== 'object' || Object.isFrozen(value)) return value;
    Object.keys(value).forEach(function (key) { freezeGenerationValue(value[key]); });
    return Object.freeze(value);
  }

  function getGenerationReviewFingerprint(root) {
    var payload = getSerializablePayload(buildGenerationPayload(root));
    payload.requestId = '';
    payload.generation.requestedAt = '';
    return JSON.stringify({
      context: getAssistantContextFingerprint(root),
      payload: payload
    });
  }

  function hasExclusiveGenerationSubject(payload) {
    var approved = payload && payload.subject && payload.subject.sourceType === 'approved-avatar';
    var photo = payload && payload.subject && payload.subject.sourceType === 'photo';
    return payload && ['1.2', '2.0'].indexOf(payload.contractVersion) !== -1 && approved !== photo &&
      (approved ? !payload.photoFile && !payload.photo : !!payload.photoFile && !!payload.photo);
  }

  function updateAssistantGenerationReview(root, retry) {
    var dialog = qs(root, '[data-sticker-generation-review]');
    var summary = qs(root, '[data-sticker-generation-review-summary]');
    var confirm = qs(root, '[data-sticker-generation-review-confirm]');
    var retryButton = qs(root, '[data-sticker-generation-review-retry]');
    var credit = qs(root, '[data-sticker-generation-review-credit]');
    var retryNotice = qs(root, '[data-sticker-generation-review-retry-notice]');
    var surface = qs(root, '[data-sticker-assistant-surface]');
    var state = root._stickerState;
    var subject;
    var template;
    if (!dialog || !surface || !state) return false;
    subject = state.subjectSource === 'approved-avatar'
      ? surface.getAttribute('data-generation-review-mia-label')
      : surface.getAttribute('data-generation-review-photo-label');
    template = surface.getAttribute('data-generation-review-summary-template') || '{subject} · {style} · {color}';
    if (summary) summary.textContent = formatTranslation(template, {
      subject: subject || '',
      style: getStyleLabel(root),
      color: state.tryonColor || ''
    });
    if (confirm) confirm.hidden = !!retry;
    if (retryButton) retryButton.hidden = !retry;
    if (credit) {
      credit.hidden = false;
      credit.textContent = getGenerationConsequenceMessage(root, !!retry);
    }
    if (confirm) confirm.disabled = !retry && state.generationEntitlementsVerified === false;
    if (retryNotice) retryNotice.hidden = !retry;
    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    if (!dialog._stickerGenerationReviewFocusBound && typeof dialog.addEventListener === 'function') {
      dialog._stickerGenerationReviewFocusBound = true;
      dialog.addEventListener('keydown', function (event) {
        trapAssistantGenerationReviewFocus(dialog, event);
      });
    }
    window.setTimeout(function () {
      var target = retry ? retryButton : confirm;
      if (target && typeof target.focus === 'function') target.focus();
    }, 0);
    return true;
  }

  function trapAssistantGenerationReviewFocus(dialog, event) {
    var focusable;
    var index;
    if (!dialog || event.key !== 'Tab') return;
    focusable = qsa(dialog, 'button:not([hidden]):not([disabled])');
    if (!focusable.length) return;
    index = focusable.indexOf(document.activeElement);
    if (!event.shiftKey && index === focusable.length - 1) {
      event.preventDefault();
      focusable[0].focus();
    } else if (event.shiftKey && index <= 0) {
      event.preventDefault();
      focusable[focusable.length - 1].focus();
    }
  }

  function closeAssistantGenerationReview(root, restoreFocus) {
    var dialog = qs(root, '[data-sticker-generation-review]');
    var state = root && root._stickerState;
    var previousFocus = state && state.assistantGenerationReviewFocus;
    if (dialog) {
      dialog.hidden = true;
      dialog.setAttribute('aria-hidden', 'true');
    }
    if (state) {
      state.assistantGenerationReview = null;
      state.assistantGenerationReviewFocus = null;
    }
    if (restoreFocus && previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }

  function cancelAssistantGenerationReview(root) {
    var state = root && root._stickerState;
    if (state) state.assistantGenerationRetrySubmission = null;
    closeAssistantGenerationReview(root, true);
    return { ok: true, code: 'generation-review-cancelled' };
  }

  function invalidateAssistantGenerationReview(root, announce) {
    var state = root && root._stickerState;
    var surface = qs(root, '[data-sticker-assistant-surface]');
    if (!state) return false;
    state.assistantGenerationRetrySubmission = null;
    if (!state.assistantGenerationReview) return false;
    closeAssistantGenerationReview(root, false);
    if (announce && surface) {
      announceAssistantState(root, surface.getAttribute('data-generation-review-changed-label'));
    }
    return true;
  }

  function invalidateAssistantGenerationReviewIfStale(root) {
    var state = root && root._stickerState;
    if (!state || (!state.assistantGenerationReview && !state.assistantGenerationRetrySubmission)) return false;
    var expected = state.assistantGenerationReview
      ? state.assistantGenerationReview.fingerprint
      : state.assistantGenerationRetrySubmission.reviewFingerprint;
    if (expected === getGenerationReviewFingerprint(root)) return false;
    return invalidateAssistantGenerationReview(root, true);
  }

  function openAssistantGenerationReview(root, proposalId) {
    if (!CUSTOMIZER_AI_ENABLED) return false;
    var state = root && root._stickerState;
    var surface = qs(root, '[data-sticker-assistant-surface]');
    var dialog = qs(root, '[data-sticker-generation-review]');
    if (!state || !isAssistantV12Enabled(root)) return { ok: false, code: 'generation-contract-unavailable' };
    if (state.isGenerating) return { ok: false, code: 'generation-in-progress' };
    if (!isAssistantV12GenerationEligible(root)) {
      return { ok: false, code: 'generation-requirements-not-met' };
    }
    if (!dialog) return { ok: false, code: 'generation-confirmation-required' };
    state.assistantGenerationRetrySubmission = null;
    state.assistantGenerationReviewFocus = document.activeElement;
    state.assistantGenerationReview = {
      proposalId: String(proposalId || ''),
      fingerprint: getGenerationReviewFingerprint(root)
    };
    updateAssistantGenerationReview(root, false);
    refreshGenerationEntitlements(root).then(function (entitlements) {
      if (!state.assistantGenerationReview ||
          state.assistantGenerationReview.fingerprint !== getGenerationReviewFingerprint(root)) return;
      state.generationEntitlementsVerified = !!entitlements;
      updateAssistantGenerationReview(root, false);
    });
    if (surface) {
      announceAssistantState(root, surface.getAttribute('data-generation-confirmation-label'));
    }
    return { ok: false, code: 'generation-confirmation-required', reviewOpened: true };
  }

  function requestGenerationConfirmation(root, proposalId) {
    if (isAssistantV12Enabled(root)) return openAssistantGenerationReview(root, proposalId || 'manual-generation');
    return generateStyle(root) ? { ok: true, code: 'generation-submitted' }
      : { ok: false, code: 'generation-unavailable' };
  }

  function createFrozenGenerationSubmission(root) {
    var state = root && root._stickerState;
    var review = state && state.assistantGenerationReview;
    var payload;
    var serialized;
    var frozenPayload;
    if (!review || review.fingerprint !== getGenerationReviewFingerprint(root) ||
        !isAssistantV12GenerationEligible(root) || !validate(root)) return null;
    payload = buildGenerationPayload(root);
    if (!hasExclusiveGenerationSubject(payload)) return null;
    serialized = JSON.stringify(getSerializablePayload(payload));
    frozenPayload = JSON.parse(serialized);
    frozenPayload.photoFile = payload.photoFile || null;
    freezeGenerationValue(frozenPayload);
    return {
      proposalId: review.proposalId,
      requestId: frozenPayload.requestId,
      requestedAt: frozenPayload.generation.requestedAt,
      contextFingerprint: getAssistantContextFingerprint(root),
      reviewFingerprint: review.fingerprint,
      serializedPayload: serialized,
      payload: frozenPayload,
      formData: null
    };
  }

  function confirmAssistantGenerationReview(root) {
    var state = root && root._stickerState;
    var submission;
    if (!state || state.isGenerating) return { ok: false, code: 'generation-in-progress' };
    if (state.generationEntitlementsVerified === false) {
      return { ok: false, code: 'generation-entitlements-unverified' };
    }
    if (Number.isInteger(state.includedGenerationsRemaining) &&
        state.includedGenerationsRemaining <= 0 && Number(state.creditBalance) <= 0) {
      return { ok: false, code: 'generation-entitlements-exhausted' };
    }
    submission = createFrozenGenerationSubmission(root);
    if (!submission) {
      invalidateAssistantGenerationReview(root, true);
      return { ok: false, code: 'generation-review-stale' };
    }
    state.assistantGenerationSubmission = submission;
    closeAssistantGenerationReview(root, false);
    if (generateStyle(root, submission)) {
      if (submission.proposalId) rememberGuidedAction(root, submission.proposalId);
      return { ok: true, code: 'generation-submitted', requestId: submission.requestId };
    }
    state.assistantGenerationSubmission = null;
    return { ok: false, code: 'generation-unavailable' };
  }

  function retryAssistantGenerationSubmission(root) {
    var state = root && root._stickerState;
    var submission = state && state.assistantGenerationRetrySubmission;
    if (!submission || state.isGenerating) return { ok: false, code: 'generation-retry-unavailable' };
    if (submission.reviewFingerprint !== getGenerationReviewFingerprint(root)) {
      invalidateAssistantGenerationReview(root, true);
      return { ok: false, code: 'generation-review-stale' };
    }
    state.assistantGenerationRetrySubmission = null;
    closeAssistantGenerationReview(root, false);
    return generateStyle(root, submission)
      ? { ok: true, code: 'generation-retried', requestId: submission.requestId }
      : { ok: false, code: 'generation-retry-unavailable' };
  }

  function buildGenerationPayload(root) {
    var state = root._stickerState;
    var photo = getCurrentPhoto(root);
    var attempt = (state.generationAttempts[state.style] || 0) + 1;
    var pilotColors = {
      sage: '#A8B29B',
      'powder-pink': '#D6AAA4',
      'soft-navy': '#3B4D64',
      red: '#B94A3D',
      yellow: '#D7A52A',
      black: '#000000',
      white: '#FFFFFF'
    };

    var approvedAvatarActive = state.subjectSource === 'approved-avatar' && isMiaRuntimeReady(root);
    var illustratedBackground = !!state.selectedBackgroundId &&
      state.selectedBackgroundId !== 'background-none-white';
    if (state.subjectSource === 'approved-avatar' && !approvedAvatarActive) state.subjectSource = 'photo';
    var payload = {
      contractVersion: illustratedBackground ? '2.0' : GENERATION_CONTRACT_VERSION,
      requestId: createGenerationRequestId(),
      product: {
        id: root.getAttribute('data-product-id') || '',
        handle: root.getAttribute('data-product-handle') || '',
        variantId: getSelectedVariantId(root)
      },
      subject: approvedAvatarActive ? {
        sourceType: 'approved-avatar',
        avatarManifestId: state.approvedAvatarManifestId || 'clairatier-avatar-pilot-v1',
        avatarId: state.approvedAvatarId || 'mia',
        presentationMode: state.presentationMode || 'standard'
      } : { sourceType: 'photo' },
      photoFile: approvedAvatarActive ? null : photo,
      personalization: {
        color: state.tryonColor,
        textTop: getTextValue(root, 'top'),
        textBottom: getTextValue(root, 'bottom'),
        textTopEnabled: !hasNoTextChoice(root, 'top'),
        textBottomEnabled: !hasNoTextChoice(root, 'bottom'),
        textTopSize: state.topSize,
        textBottomSize: state.bottomSize,
        symbolChoice: state.symbolChoice,
        symbol: state.symbol,
        avatarInstructionsEnabled: state.avatarInstructionsChoice === 'yes',
        avatarInstructions: state.avatarInstructions
      },
      composition: {
        imageScale: state.photoScale,
        imageOffsetX: state.photoX,
        imageOffsetY: state.photoY
      },
      generation: {
        style: state.style,
        styleLabel: getStyleLabel(root),
        attempt: attempt,
        maxAttempts: GENERATION_INCLUDED_TOTAL,
        requestedAt: new Date().toISOString()
      }
    };
    if (localJourneyEnabled(root)) payload.composition.whiteBacking = Object.assign({}, getLocalWhiteBacking(root));
    if (illustratedBackground) {
      Object.assign(payload.composition, {
        productProfileVersion: root.getAttribute('data-sticker-product-profile-version') || '',
        backgroundManifestVersion: root.getAttribute('data-sticker-background-manifest-version') || '1.0.0',
        fadeManifestVersion: root.getAttribute('data-sticker-fade-manifest-version') || '1.0.0',
        backgroundId: state.selectedBackgroundId,
        fadePresetId: state.selectedFadeId || BACKGROUND_DEFAULT_FADE_ID,
        backgroundTransform: normalizeBackgroundTransform(state.backgroundTransform)
      });
    }
    if (approvedAvatarActive || getLocalWardrobeEntry(root, state.approvedAvatarGarmentId)) {
      payload.personalization.garmentId = state.approvedAvatarGarmentId || 'garment-yoke-blouse-dress';
      payload.personalization.hairstyleId = state.approvedAvatarHairstyleId || undefined;
      payload.personalization.accessoryId = state.selectedAccessoryId || undefined;
      payload.personalization.paletteSource = state.approvedAvatarPaletteSource || 'catalog';
      payload.personalization.requestedPrimaryColor = state.requestedPrimaryColor || pilotColors[state.tryonColor] || '#D6AAA4';
      payload.personalization.requestedSecondaryColor = state.requestedSecondaryColor || undefined;
      payload.personalization.requestedAccentColor = state.requestedAccentColor || undefined;
      payload.personalization.requestedFinishColor = state.requestedFinishColor || undefined;
      payload.personalization.finishId = state.approvedAvatarFinishId || undefined;
    }
    if (!approvedAvatarActive) {
      payload.photo = {
        name: photo ? photo.name : '',
        type: photo ? photo.type : '',
        size: photo ? photo.size : 0,
        lastModified: photo ? photo.lastModified : 0
      };
    }
    return payload;
  }

  function getSerializablePayload(payload) {
    var serializable = {
      contractVersion: payload.contractVersion,
      requestId: payload.requestId,
      product: payload.product,
      subject: payload.subject,
      personalization: payload.personalization,
      composition: payload.composition,
      generation: payload.generation
    };
    if (payload.photo) serializable.photo = payload.photo;
    return serializable;
  }

  function waitForGeneration(delay) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, delay);
    });
  }

  function normalizeGenerationStatus(status) {
    var value = String(status || '').toLowerCase();
    return [
      GENERATION_STATUS.QUEUED, GENERATION_STATUS.PROCESSING,
      GENERATION_STATUS.SUCCEEDED, GENERATION_STATUS.FAILED
    ].indexOf(value) === -1 ? '' : value;
  }

  function normalizeGenerationResult(root, payload, response) {
    var data = response || {};
    var style = payload.generation.style;
    var styleLabel = payload.generation.styleLabel;

    return {
      id: data.id || data.generationId || payload.requestId,
      label: data.label || translate(root, 'generationLabel', {
        style: styleLabel,
        attempt: payload.generation.attempt
      }),
      status: GENERATION_STATUS.SUCCEEDED,
      style: style,
      styleLabel: styleLabel,
      imageUrl: data.imageUrl || data.outputUrl || root.getAttribute('data-placeholder-generation-src') || '',
      previewUrl: data.previewUrl || data.imageUrl || data.outputUrl || root.getAttribute('data-placeholder-generation-src') || '',
      clientPdfUrl: data.clientPdfUrl || '',
      printPdfUrl: data.printPdfUrl || '',
      selectionState: data.selectionState || 'unselected',
      selectedAt: data.selectedAt || '',
      finalizedAt: data.finalizedAt || '',
      finalizationHash: data.finalizationHash || '',
      serverExpiresAt: data.expiresAt || '',
      entitlements: data.entitlements || null,
      payload: getSerializablePayload(payload),
      attempt: data.attempt || payload.generation.attempt,
      createdAt: data.createdAt || new Date().toISOString()
    };
  }

  function applyGenerationEntitlements(root, entitlements) {
    var state = root._stickerState;
    var numericFields = [
      'includedPerStyle', 'includedTotal', 'usageTotal', 'includedRemaining',
      'creditBalance', 'lifetimeCreditsGranted', 'lifetimeCreditsUsed'
    ];
    var usage;
    if (!state || !entitlements || Array.isArray(entitlements) ||
        !numericFields.every(function (field) {
          return typeof entitlements[field] === 'number' &&
            Number.isInteger(entitlements[field]) && entitlements[field] >= 0;
        }) || !entitlements.usageByStyle || Array.isArray(entitlements.usageByStyle) ||
        typeof entitlements.usageByStyle !== 'object') return false;
    usage = Object.keys(entitlements.usageByStyle);
    if (!usage.every(function (style) {
      return !!style && typeof entitlements.usageByStyle[style] === 'number' &&
        Number.isInteger(entitlements.usageByStyle[style]) && entitlements.usageByStyle[style] >= 0;
    })) return false;
    state.creditBalance = entitlements.creditBalance;
    state.includedGenerationsTotal = entitlements.includedTotal;
    usage.forEach(function (style) {
      state.generationAttempts[style] = entitlements.usageByStyle[style];
    });
    state.includedGenerationsRemaining = entitlements.includedRemaining;
    state.generationEntitlementsVerified = true;
    writeGenerationAttempts(root);
    return true;
  }

  function getGenerationConsequenceMessage(root, retry) {
    var state = root && root._stickerState;
    if (retry) return translate(root, 'generationConsequenceRetry');
    if (!state || state.generationEntitlementsVerified === false) {
      return translate(root, 'generationConsequenceChecking');
    }
    if (Number(state.includedGenerationsRemaining) > 0) {
      return translate(root, 'generationConsequenceIncluded');
    }
    if (Number(state.creditBalance) > 0) return translate(root, 'generationConsequenceCredit');
    return translate(root, 'generationConsequenceUnavailable');
  }

  function updateGenerationOutcome(root, outcome) {
    var state = root && root._stickerState;
    var issue = qs(root, '[data-sticker-generation-issue]');
    var message = qs(root, '[data-sticker-generation-issue-message]');
    var retry = qs(root, '[data-sticker-generation-issue-retry]');
    if (!state) return;
    state.generationOutcome = outcome || '';
    if (!issue) return;
    issue.hidden = !outcome;
    if (message) {
      message.textContent = outcome === 'retry'
        ? translate(root, 'generationOutcomeRetry')
        : outcome === 'restored'
          ? translate(root, 'generationOutcomeRestored')
          : outcome === 'not-consumed'
            ? translate(root, 'generationOutcomeNotConsumed')
          : outcome === 'consumed'
            ? translate(root, 'generationOutcomeConsumed')
            : translate(root, 'generationOutcomeUnknown');
    }
    if (retry) retry.hidden = outcome !== 'retry' || !state.assistantGenerationRetrySubmission;
  }

  function simulateGeneration(root, payload, onStatus) {
    onStatus(GENERATION_STATUS.QUEUED);
    return waitForGeneration(350)
      .then(function () {
        onStatus(GENERATION_STATUS.PROCESSING);
        return waitForGeneration(1100);
      })
      .then(function () {
        return normalizeGenerationResult(root, payload, {});
      });
  }

  function createGenerationNetworkError(stage, url, error) {
    var browserMessage = error && error.message ? error.message : String(error || 'unknown-error');
    var origin = window.location.origin || window.location.href;
    var online = navigator.onLine ? translate(null, 'yes') : translate(null, 'no');
    var message = [
      translate(null, 'networkError', { stage: stage }),
      translate(null, 'backendNoResponse'),
      translate(null, 'calledUrl', { url: url }),
      translate(null, 'storeOrigin', { origin: origin }),
      translate(null, 'connectionStatus', { status: online }),
      translate(null, 'browserDetail', { detail: browserMessage })
    ].join(' ');
    var networkError = new Error(message);

    networkError.code = 'GENERATION_NETWORK_ERROR';
    networkError.stage = stage;
    networkError.url = url;
    networkError.origin = origin;
    networkError.browserMessage = browserMessage;
    return networkError;
  }

  function formatGenerationErrorValue(value) {
    if (typeof value === 'string') return value;
    try {
      return JSON.stringify(value);
    } catch (error) {
      return String(value);
    }
  }

  function createFailedGenerationError(response) {
    var body = response && typeof response === 'object' ? response : {};
    var code = body.code || 'GENERATION_FAILED';
    var backendMessage = formatGenerationErrorValue(
      body.message || body.error || translate(null, 'generationFailed')
    );
    var error = new Error(code + ': ' + backendMessage);

    error.code = code;
    error.lifecycleStatus = GENERATION_STATUS.FAILED;
    error.responseBody = body;
    return error;
  }

  function parseGenerationResponse(response, stage, url) {
    if (!response.ok) {
      return response.text().then(function (rawBody) {
        var body = {};
        try {
          body = rawBody ? JSON.parse(rawBody) : {};
        } catch (ignore) {}
        var backendMessage = formatGenerationErrorValue(
          body.message || body.error || rawBody || translate(null, 'noResponseMessage')
        );
        var backendCode = body.code || body.statusCode || 'UNKNOWN';
        var error = new Error(translate(null, 'backendError', {
          stage: stage,
          status: response.status + ' ' + response.statusText,
          url: url,
          detail: backendCode + ': ' + backendMessage
        }));
        error.status = response.status;
        error.code = backendCode;
        error.stage = stage;
        error.url = url;
        error.responseBody = body;
        throw error;
      });
    }
    return response.text().then(function (rawBody) {
      if (!rawBody) {
        throw new Error(translate(null, 'emptyBackendResponse', { stage: stage, url: url }));
      }
      try {
        return JSON.parse(rawBody);
      } catch (error) {
        throw new Error(translate(null, 'invalidJsonResponse', {
          stage: stage,
          status: response.status,
          url: url,
          detail: rawBody.slice(0, 500)
        }));
      }
    });
  }

  function fetchGenerationJson(url, options, stage) {
    if (!CUSTOMIZER_AI_ENABLED) return Promise.reject(customizerAiDisabledError());
    return window.fetch(url, options)
      .catch(function (error) {
        throw createGenerationNetworkError(stage, url, error);
      })
      .then(function (response) {
        return parseGenerationResponse(response, stage, url);
      });
  }

  function getGenerationSessionEndpoint(endpoint) {
    var normalized = String(endpoint || '').trim();
    var url;

    try {
      url = new URL(normalized, window.location.href);
      url.pathname = url.pathname.replace(/\/generations\/?$/, '/sessions');
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch (error) {
      return normalized.replace(/\/generations\/?$/, '/sessions');
    }
  }

  function serializeGenerationSession(endpoint, session) {
    var storedEndpoint = getStoredAssetUrl(endpoint);
    var expiresAt = session && getStoredTimestamp(session.expiresAt);
    var claimExpiresAt = session && getStoredTimestamp(session.claimExpiresAt);
    var token = session && typeof session.token === 'string' ? session.token : '';
    var claimToken = session && typeof session.claimToken === 'string' ? session.claimToken : '';
    var sessionId = session && session.sessionId ? getStoredTechnicalValue(session.sessionId, 128) : '';
    if (!storedEndpoint || !session || !token || !claimToken || !expiresAt || !claimExpiresAt) return null;
    return {
      endpoint: storedEndpoint,
      sessionId: sessionId,
      token: token,
      expiresAt: expiresAt,
      claimToken: claimToken,
      claimExpiresAt: claimExpiresAt
    };
  }

  function readGenerationSession(endpoint) {
    var parsed;
    var stored;
    var accessExpired;
    var expiresAt;
    var claimExpiresAt;

    removeBrowserStorageItem(window.localStorage, GENERATION_SESSION_KEY);
    try {
      parsed = JSON.parse(window.sessionStorage.getItem(GENERATION_SESSION_KEY) || 'null');
      stored = serializeGenerationSession(endpoint, parsed);
      expiresAt = stored && Date.parse(stored.expiresAt);
      claimExpiresAt = stored && Date.parse(stored.claimExpiresAt);
      if (
        !stored ||
        parsed.endpoint !== endpoint ||
        !claimExpiresAt ||
        claimExpiresAt <=
          Date.now() + GENERATION_SESSION_CLAIM_EXPIRY_SAFETY_MS
      ) {
        removeBrowserStorageItem(window.sessionStorage, GENERATION_SESSION_KEY);
        return null;
      }
      accessExpired =
        !expiresAt ||
        expiresAt <= Date.now() + GENERATION_SESSION_EXPIRY_SAFETY_MS;
      if (JSON.stringify(parsed) !== JSON.stringify(stored)) {
        window.sessionStorage.setItem(GENERATION_SESSION_KEY, JSON.stringify(stored));
      }
      return Object.assign({}, stored, { accessExpired: accessExpired });
    } catch (error) {
      removeBrowserStorageItem(window.sessionStorage, GENERATION_SESSION_KEY);
      return null;
    }
  }

  function writeGenerationSession(endpoint, session) {
    var stored = serializeGenerationSession(endpoint, session);

    removeBrowserStorageItem(window.localStorage, GENERATION_SESSION_KEY);
    if (!stored) {
      removeBrowserStorageItem(window.sessionStorage, GENERATION_SESSION_KEY);
      return null;
    }
    try {
      window.sessionStorage.setItem(GENERATION_SESSION_KEY, JSON.stringify(stored));
    } catch (error) {}
    return stored;
  }

  function clearGenerationSession() {
    removeBrowserStorageItem(window.localStorage, GENERATION_SESSION_KEY);
    removeBrowserStorageItem(window.sessionStorage, GENERATION_SESSION_KEY);
  }

  function getGenerationSessionRefreshEndpoint(sessionEndpoint) {
    return String(sessionEndpoint || '').replace(/\/sessions\/?$/, '/sessions/refresh');
  }

  function refreshGenerationSession(sessionEndpoint, stored) {
    if (!stored || !stored.claimToken) return Promise.resolve(null);
    return fetchGenerationJson(getGenerationSessionRefreshEndpoint(sessionEndpoint), {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ claimToken: stored.claimToken })
    }, translate(null, 'generationSessionRenewal'))
      .then(function (session) {
        return writeGenerationSession(sessionEndpoint, session);
      })
      .catch(function () {
        clearGenerationSession();
        return null;
      });
  }

  function getGenerationSession(endpoint, forceRefresh) {
    if (!CUSTOMIZER_AI_ENABLED) return Promise.reject(customizerAiDisabledError());
    var sessionEndpoint = getGenerationSessionEndpoint(endpoint);
    var stored = readGenerationSession(sessionEndpoint);

    if (stored && !forceRefresh && !stored.accessExpired) {
      return Promise.resolve(stored);
    }
    if (generationSessionPromise && !forceRefresh) return generationSessionPromise;

    generationSessionPromise = refreshGenerationSession(sessionEndpoint, stored)
      .then(function (refreshed) {
        if (refreshed) return refreshed;
        return fetchGenerationJson(sessionEndpoint, {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Accept': 'application/json' }
        }, translate(null, 'generationSessionCreation'));
      })
      .then(function (session) {
        if (!session.token || !session.expiresAt || !session.claimToken) {
          throw new Error(translate(null, 'invalidGenerationSession'));
        }
        return writeGenerationSession(sessionEndpoint, session);
      })
      .then(function (session) {
        generationSessionPromise = null;
        return session;
      })
      .catch(function (error) {
        generationSessionPromise = null;
        throw error;
      });

    return generationSessionPromise;
  }

  function getCurrentSessionEndpoint(sessionEndpoint) {
    return String(sessionEndpoint || '').replace(/\/sessions\/?$/, '/sessions/current');
  }

  function refreshGenerationEntitlements(root) {
    if (!CUSTOMIZER_AI_ENABLED) return Promise.resolve(null);
    if (areMiaPrivatePilotPaidActionsBlocked(root)) return Promise.resolve(null);
    var endpoint = (root.getAttribute('data-generation-endpoint') || '').trim();
    if (!endpoint || !window.fetch) return Promise.resolve(null);

    return getGenerationSession(endpoint, false)
      .then(function (session) {
        return fetchGenerationJson(getCurrentSessionEndpoint(session.endpoint), {
          credentials: 'omit',
          headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + session.token
          }
        }, translate(null, 'generationBalanceFetch'));
      })
      .then(function (entitlements) {
        if (!applyGenerationEntitlements(root, entitlements)) throw new Error('invalid-entitlements');
        updateGeneration(root);
        return entitlements;
      })
      .catch(function () {
        root._stickerState.generationEntitlementsVerified = false;
        return null;
      });
  }

  function bindGenerationSessionToCart(session) {
    if (!session || !session.claimToken || !window.fetch) {
      return Promise.reject(new Error(translate(null, 'creditSessionUnavailable')));
    }
    return window.fetch(getCartUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          '__clairatier_session_claim': session.claimToken
        }
      })
    }).then(parseCartAddResponse);
  }

  function pollGeneration(endpoint, job, session, onStatus, pollCount) {
    var pollUrl = job.pollUrl || job.statusUrl || (job.id ? endpoint.replace(/\/$/, '') + '/' + encodeURIComponent(job.id) : '');
    var count = pollCount || 0;

    if (!pollUrl) return Promise.resolve(job);
    if (count >= 80) return Promise.reject(new Error(translate(null, 'generationTimeout')));

    return waitForGeneration(1500)
      .then(function () {
        return fetchGenerationJson(pollUrl, {
          credentials: 'omit',
          headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + session.token
          }
        }, translate(null, 'generationStatusCheck'));
      })
      .then(function (response) {
        var status = normalizeGenerationStatus(response.status);
        onStatus(status);
        if (status === GENERATION_STATUS.SUCCEEDED) return response;
        if (status === GENERATION_STATUS.FAILED) {
          throw createFailedGenerationError(response);
        }
        return pollGeneration(endpoint, response, session, onStatus, count + 1);
      });
  }

  function submitRemoteGeneration(endpoint, formData, session) {
    return fetchGenerationJson(endpoint, {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + session.token
      },
      body: formData
    }, translate(null, 'generationUpload'));
  }

  function requestRemoteGeneration(root, endpoint, payload, onStatus, submission) {
    var formData = submission && submission.formData || new FormData();

    if (!submission || !submission.formData) {
      formData.append('payload', submission && submission.serializedPayload ||
        JSON.stringify(getSerializablePayload(payload)));
      if (payload.photoFile && payload.photo) formData.append('photo', payload.photoFile, payload.photo.name);
      if (submission) submission.formData = formData;
    }
    onStatus(GENERATION_STATUS.QUEUED);

    return getGenerationSession(endpoint, false)
      .then(function (session) {
        return submitRemoteGeneration(endpoint, formData, session)
          .then(function (response) {
            return { response: response, session: session };
          })
          .catch(function (error) {
            if (error.status !== 401) throw error;
            return getGenerationSession(endpoint, true).then(function (refreshedSession) {
              return submitRemoteGeneration(endpoint, formData, refreshedSession).then(function (response) {
                return { response: response, session: refreshedSession };
              });
            });
          });
      })
      .then(function (result) {
        var response = result.response;
        var status = normalizeGenerationStatus(response.status);
        onStatus(status);
        if (status === GENERATION_STATUS.FAILED) {
          throw createFailedGenerationError(response);
        }
        if (status === GENERATION_STATUS.SUCCEEDED || response.imageUrl || response.outputUrl) return response;
        return pollGeneration(endpoint, response, result.session, onStatus, 0);
      })
      .then(function (response) {
        if (!response.imageUrl && !response.outputUrl) {
          throw new Error(translate(null, 'missingGeneratedImage'));
        }
        return normalizeGenerationResult(root, payload, response);
      });
  }

  function requestGeneration(root, payload, onStatus, submission) {
    if (!CUSTOMIZER_AI_ENABLED) return Promise.reject(customizerAiDisabledError());
    var endpoint = (root.getAttribute('data-generation-endpoint') || '').trim();
    if (endpoint && window.fetch && window.FormData) {
      return requestRemoteGeneration(root, endpoint, payload, onStatus, submission);
    }
    return simulateGeneration(root, payload, onStatus);
  }

  function isAmbiguousGenerationTransportError(error) {
    var code = String(error && error.code || '').toUpperCase();
    var status = parseInt(error && error.status, 10);
    var deterministicCodes = [
      'GENERATION_ENQUEUE_FAILED', 'GENERATION_FAILED', 'GENERATION_QUOTA_EXCEEDED',
      'IDEMPOTENCY_CONFLICT', 'INVALID_IMAGE', 'INVALID_PAYLOAD', 'MODERATION_FAILED',
      'MODERATION_NOT_CONFIGURED', 'OPENAI_GENERATION_FAILED', 'OPENAI_NOT_CONFIGURED',
      'OPENAI_SAFETY_BLOCKED', 'PHOTO_METADATA_MISMATCH',
      'PHOTO_PREFLIGHT_NEEDS_USER_ACTION', 'UNSUPPORTED_IMAGE'
    ];
    if (code === 'GENERATION_NETWORK_ERROR' || error && error.name === 'AbortError') return true;
    if (isGuaranteedPreAuthorizationRejection(error)) return false;
    if (status === 408 || status >= 500 && status <= 599) return true;
    if (deterministicCodes.indexOf(code) !== -1 || code.indexOf('MODERATION_BLOCKED_') === 0) {
      return false;
    }
    if (!Number.isInteger(status)) return true;
    return false;
  }

  function isGuaranteedPreAuthorizationRejection(error) {
    var code = String(error && error.code || '').toUpperCase();
    return [
      'INVALID_IMAGE', 'INVALID_PAYLOAD', 'PHOTO_METADATA_MISMATCH',
      'PHOTO_PREFLIGHT_NEEDS_USER_ACTION', 'UNSUPPORTED_IMAGE',
      'MODERATION_FAILED', 'MODERATION_NOT_CONFIGURED'
    ].indexOf(code) !== -1 || code.indexOf('MODERATION_BLOCKED_') === 0;
  }

  function showAssistantGenerationRetry(root, submission) {
    var state = root && root._stickerState;
    var surface = qs(root, '[data-sticker-assistant-surface]');
    if (!state || !submission || submission.reviewFingerprint !== getGenerationReviewFingerprint(root)) return false;
    state.assistantGenerationRetrySubmission = submission;
    state.assistantGenerationReview = {
      proposalId: submission.proposalId,
      fingerprint: submission.reviewFingerprint
    };
    updateAssistantGenerationReview(root, true);
    if (surface) announceAssistantState(root, surface.getAttribute('data-generation-review-retry-label'));
    return true;
  }

  function recordGenerationSuccess(root, payload, result, expectedFingerprint) {
    var state = root._stickerState;
    var style = payload.generation.style;
    var generationPayloadSnapshot = getSerializablePayload(payload);
    var matchesCurrentContext;
    result.contextFingerprintSnapshot = expectedFingerprint || '';
    if (!state.generationResults[style]) state.generationResults[style] = [];
    state.generationResults[style].push(result);
    state.generatedStyles[style] = true;
    state.generatedStyle = style;
    state.generationStatus = GENERATION_STATUS.SUCCEEDED;
    matchesCurrentContext = !isAssistantV12Enabled(root) ||
      completeAssistantGenerationContext(root, expectedFingerprint);
    if (matchesCurrentContext) {
      state.lastGenerationPayload = generationPayloadSnapshot;
      state.selectedGenerationId = result.id;
      state.selectedGenerationLabel = result.label;
      state.selectedGenerationIdsByStyle[style] = result.id;
      state.assistantAcceptedGenerationId = '';
      state.assistantResultComparisonVisible = false;
      state.photoScale = 1;
      state.photoX = 0;
      state.photoY = 0;
    }
    return matchesCurrentContext;
  }

  function generateStyle(root, frozenSubmission) {
    if (!CUSTOMIZER_AI_ENABLED) return false;
    var state = root._stickerState;
    if ((state.proofAvatars || []).length > 1) return false;
    var payload;
    var style;
    var attempts;
    var error = qs(root, '[data-sticker-error="generation"]');

    if (areMiaPrivatePilotPaidActionsBlocked(root) || !validate(root) || state.isGenerating) return false;

    payload = frozenSubmission && frozenSubmission.payload || buildGenerationPayload(root);
    state.activeAssistantGenerationFingerprint = isAssistantV12Enabled(root)
      ? getAssistantContextFingerprint(root)
      : '';
    if (frozenSubmission) {
      state.activeAssistantGenerationFingerprint = frozenSubmission.contextFingerprint;
    }
    style = payload.generation.style;
    attempts = getGenerationAttemptsTotal(state);

    if (attempts >= (parseInt(state.includedGenerationsTotal, 10) || GENERATION_INCLUDED_TOTAL) && state.creditBalance <= 0) {
      showGenerationError(root, translate(root, 'includedGenerationsUsed'), false);
      updateGeneration(root);
      return false;
    }

    state.isGenerating = true;
    state.generationStatus = GENERATION_STATUS.QUEUED;
    state.activeGenerationRequestId = payload.requestId;
    state.analyticsGenerationStartedAt = Date.now();
    state.lastGenerationError = '';
    updateGenerationOutcome(root, '');
    emitAnalyticsEvent('clairatier_generation_started', {
      style_key: style,
      attempt_bucket: getAttemptBucket(payload.generation.attempt)
    });
    hideGenerationError(root);
    openGenerationProgress(root);
    updateGeneration(root);

    requestGeneration(root, payload, function (status) {
      if (state.activeGenerationRequestId !== payload.requestId) return;
      var normalizedStatus = normalizeGenerationStatus(status);
      if ([GENERATION_STATUS.QUEUED, GENERATION_STATUS.PROCESSING,
        GENERATION_STATUS.SUCCEEDED, GENERATION_STATUS.FAILED].indexOf(normalizedStatus) === -1) return;
      state.generationStatus = normalizedStatus;
      updateGeneration(root);
    }, frozenSubmission)
      .then(function (result) {
        if (state.activeGenerationRequestId !== payload.requestId) return;
        state.assistantGenerationRetrySubmission = null;
        state.generationAttempts[style] = payload.generation.attempt;
        writeGenerationAttempts(root);
        recordGenerationSuccess(root, payload, result, state.activeAssistantGenerationFingerprint);
        emitAnalyticsEvent('clairatier_generation_succeeded', {
          style_key: style,
          duration_bucket: getDurationBucket(state.analyticsGenerationStartedAt)
        });
        if (applyGenerationEntitlements(root, result.entitlements)) {
          updateGenerationOutcome(root, 'consumed');
        } else {
          state.generationEntitlementsVerified = false;
          updateGenerationOutcome(root, 'unknown');
          refreshGenerationEntitlements(root).then(function (entitlements) {
            if (state.generationStatus === GENERATION_STATUS.SUCCEEDED && entitlements) {
              updateGenerationOutcome(root, 'consumed');
            }
          });
        }
        saveGenerationRecord(result);
      })
      .catch(function (generationError) {
        var photoPreflightRecovery;
        var safeDiagnostic;
        var terminalFailure;
        var errorEntitlements;
        if (state.activeGenerationRequestId !== payload.requestId) return;
        terminalFailure = generationError && generationError.lifecycleStatus === GENERATION_STATUS.FAILED;
        if (terminalFailure) state.generationStatus = GENERATION_STATUS.FAILED;
        photoPreflightRecovery = normalizePhotoPreflightRecovery(generationError);
        safeDiagnostic = getPrivacySafeGenerationDiagnostic(generationError, photoPreflightRecovery);
        if (terminalFailure) {
          emitAnalyticsEvent('clairatier_generation_failed', {
            reason_code: getGenerationFailureCode(generationError)
          });
        }
        state.lastGenerationError = safeDiagnostic.code;
        if (frozenSubmission && isAmbiguousGenerationTransportError(generationError)) {
          showAssistantGenerationRetry(root, frozenSubmission);
          state.generationEntitlementsVerified = false;
          updateGenerationOutcome(root, 'retry');
        } else {
          state.assistantGenerationRetrySubmission = null;
          errorEntitlements = getGenerationErrorEntitlements(generationError);
          if (terminalFailure && applyGenerationEntitlements(root, errorEntitlements)) {
            updateGenerationOutcome(root, 'restored');
          } else if (isGuaranteedPreAuthorizationRejection(generationError)) {
            updateGenerationOutcome(root, 'not-consumed');
          } else {
            updateGenerationOutcome(root, 'unknown');
            if (!applyGenerationEntitlements(root, errorEntitlements)) {
              state.generationEntitlementsVerified = false;
              refreshGenerationEntitlements(root);
            }
          }
        }
        if (photoPreflightRecovery && window.console && window.console.warn) {
          window.console.warn('[Clairatier photo preflight blocked]', {
            code: safeDiagnostic.code,
            status: safeDiagnostic.status,
            reasonCodes: photoPreflightRecovery.reasonCodes.slice()
          });
        } else if (window.console && window.console.error) {
          window.console.error('[Clairatier generation error]', safeDiagnostic);
        }
        if (!showPhotoPreflightRecovery(root, photoPreflightRecovery)) {
          showGenerationError(
            root,
            JSON.stringify(safeDiagnostic),
            true,
            getGenerationErrorMessage(root, generationError)
          );
        }
      })
      .then(function () {
        if (state.activeGenerationRequestId !== payload.requestId) return;
        state.isGenerating = false;
        state.activeGenerationRequestId = '';
        state.activeAssistantGenerationFingerprint = '';
        state.assistantGenerationSubmission = null;
        if (state.generationStatus === GENERATION_STATUS.SUCCEEDED ||
            state.generationStatus === GENERATION_STATUS.FAILED) {
          updateGenerationProgress(root, state.generationStatus);
        } else {
          closeGenerationProgress(root, false);
        }
        updateGeneration(root);
      });
    return true;
  }

  function updateSymbol(root, resetGeneratedImage) {
    var state = root._stickerState;
    var choices = qsa(root, '[data-sticker-symbol-choice]');
    var checked = choices.filter(function (choice) { return choice.checked; })[0];
    var input = qs(root, '[data-sticker-symbol-input]');
    var property = qs(root, '[data-sticker-symbol-property]');
    var stableProperty = qs(root, '[data-sticker-stable-symbol-property]');
    var error = qs(root, '[data-sticker-error="symbol"]');
    var options = qs(root, '[data-sticker-symbol-options]');
    var choice = checked ? checked.value : 'yes';
    var previousValue = state.symbolChoice + ':' + state.symbol;

    state.symbolChoice = choice;
    if (input) {
      input.disabled = choice === 'no';
      if (choice === 'no') input.value = '';
      if (choice === 'yes') {
        var value = getFirstSymbol(input.value);
        if (input.value !== value) input.value = value;
        state.symbol = value;
      } else {
        state.symbol = '';
      }
    }
    if (options) options.hidden = choice === 'no';

    choices.forEach(function (radio) {
      radio.closest('.sticker-customizer__choice').classList.toggle('is-selected', radio.value === choice);
    });

    if (property) {
      property.value = choice === 'no' ? translate(root, 'noSymbol') : state.symbol;
    }
    if (stableProperty) stableProperty.value = choice === 'no' ? '' : state.symbol;

    if (error && (choice === 'no' || state.symbol)) {
      error.hidden = true;
    }

    var changed = previousValue !== choice + ':' + state.symbol;
    if (resetGeneratedImage && changed) markAssistantContextChanged(root, '');
    if (resetGeneratedImage) resetGeneration(root);
    updateConfig(root);
    if (resetGeneratedImage && changed && isAssistantV12Enabled(root)) {
      publishGuidedContext(root);
      syncAssistantResultLoop(root);
    }
  }

  function updateAvatarInstructions(root, resetGeneratedImage) {
    var state = root._stickerState;
    var choices = qsa(root, '[data-sticker-avatar-instructions-choice]');
    var checked = choices.filter(function (choice) { return choice.checked; })[0];
    var input = qs(root, '[data-sticker-avatar-instructions-input]');
    var options = qs(root, '[data-sticker-avatar-instructions-options]');
    var property = qs(root, '[data-sticker-avatar-instructions-property]');
    var stableProperty = qs(root, '[data-sticker-stable-avatar-instructions-property]');
    var count = qs(root, '[data-sticker-avatar-instructions-count]');
    var error = qs(root, '[data-sticker-error="avatar-instructions"]');
    var choice = checked ? checked.value : 'yes';
    var value = input ? Array.from(input.value || '').slice(0, 300).join('') : '';
    var previousValue = state.avatarInstructionsChoice + ':' + state.avatarInstructions;
    var structuredValue = getStructuredAvatarInstructions(root);

    state.avatarInstructionsChoice = choice;
    if (input) {
      input.disabled = choice === 'no';
      if (choice === 'no') {
        input.value = '';
        value = '';
      } else if (input.value !== value) {
        input.value = value;
      }
    }
    state.avatarInstructions = value.trim();
    if (resetGeneratedImage && structuredValue && state.avatarInstructions !== structuredValue) {
      state.assistantHeadwearPreference = '';
      state.assistantExpressionPreference = '';
    }
    if (options) options.hidden = choice === 'no';
    if (count) count.textContent = Array.from(value).length;
    if (property) {
      property.value = choice === 'yes' ? state.avatarInstructions : translate(root, 'none');
    }
    if (stableProperty) stableProperty.value = choice === 'yes' ? state.avatarInstructions : '';
    choices.forEach(function (radio) {
      var label = radio.closest('.sticker-customizer__choice');
      if (label) label.classList.toggle('is-selected', radio.value === choice);
    });
    if (error && (choice === 'no' || state.avatarInstructions)) {
      error.hidden = true;
    }

    if (resetGeneratedImage && previousValue !== choice + ':' + state.avatarInstructions) {
      state.assistantAvatarInstructionsRevision = (state.assistantAvatarInstructionsRevision || 0) + 1;
      markAssistantContextChanged(root, '');
    }
    if (resetGeneratedImage) resetGeneration(root);
    updateConfig(root);
    if (resetGeneratedImage && previousValue !== choice + ':' + state.avatarInstructions &&
        isAssistantV12Enabled(root)) {
      publishGuidedContext(root);
      syncAssistantResultLoop(root);
    }
  }

  function updateStyleGuide(root) {
    var state = root._stickerState;
    var guide = getStyleGuide(root, state.style);
    var title = qs(root, '[data-sticker-style-guide-title]');
    var description = qs(root, '[data-sticker-style-guide-description]');

    if (title) title.textContent = guide.title;
    if (description) description.textContent = guide.description;
    qsa(root, '[data-sticker-style-example]').forEach(function (example) {
      example.hidden = example.getAttribute('data-sticker-style-example') !== state.style;
    });
  }

  function updateGenerationSummary(root) {
    var state = root._stickerState;
    if (!state) return;
    var guide = getStyleGuide(root, state.style);
    var photo = getCurrentPhoto(root);
    var photoSummary = qs(root, '[data-sticker-summary-photo]');
    var styleSummary = qs(root, '[data-sticker-summary-style]');
    var styleDescription = qs(root, '[data-sticker-summary-style-description]');
    var symbolSummary = qs(root, '[data-sticker-summary-symbol]');
    var instructionsSummary = qs(root, '[data-sticker-summary-instructions]');

    if (photoSummary) {
      photoSummary.textContent = photo
        ? translate(root, 'photoReference', { name: photo.name })
        : translate(root, 'noPhotoSelected');
    }
    if (styleSummary) styleSummary.textContent = getStyleLabel(root);
    if (styleDescription) styleDescription.textContent = guide.summary;
    if (symbolSummary) {
      symbolSummary.textContent = state.symbolChoice === 'no'
        ? translate(root, 'noSymbolRequested')
        : state.symbol
          ? translate(root, 'symbolRequested', { symbol: state.symbol })
          : translate(root, 'symbolRequired');
    }
    if (instructionsSummary) {
      instructionsSummary.textContent = state.avatarInstructionsChoice === 'no'
        ? translate(root, 'noCustomInstructions')
        : state.avatarInstructions || translate(root, 'instructionsRequired');
    }
  }

  function openStyleExample(root, button) {
    var modal = qs(root, '[data-sticker-example-modal]');
    var image = qs(root, '[data-sticker-example-modal-image]');
    var title = qs(root, '[data-sticker-example-modal-title]');
    var closeButton;
    if (!modal || !image) return;

    root._stickerExamplePreviousFocus = document.activeElement;
    image.src = button.getAttribute('data-example-src') || '';
    image.onerror = function () {
      image.onerror = null;
      image.src = button.getAttribute('data-example-fallback-src') || '';
    };
    image.alt = button.getAttribute('data-example-title') || translate(root, 'avatarExample');
    if (title) title.textContent = button.getAttribute('data-example-title') || translate(root, 'avatarExample');
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    closeButton = qs(modal, '[data-sticker-action="close-style-example"]');
    if (closeButton && typeof closeButton.focus === 'function') closeButton.focus();
  }

  function closeStyleExample(root) {
    var modal = qs(root, '[data-sticker-example-modal]');
    var image = qs(root, '[data-sticker-example-modal-image]');
    var previousFocus = root._stickerExamplePreviousFocus;
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    if (image) image.removeAttribute('src');
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    root._stickerExamplePreviousFocus = null;
  }

  function updateConfig(root) {
    var state = root._stickerState;
    var input = qs(root, '[data-sticker-config]');
    var stableInput = qs(root, '[data-sticker-stable-config]');
    var stableStyle = qs(root, '[data-sticker-stable-style-property]');
    var selected = getSelectedGeneration(root);
    if (!input) return;
    var serializedConfig = JSON.stringify({
      v: 1,
      ts: state.topSize,
      bs: state.bottomSize,
      tc: normalizeTextColor(state.textColor),
      s: state.photoScale,
      x: state.photoX,
      y: state.photoY,
      te: !hasNoTextChoice(root, 'top'),
      be: !hasNoTextChoice(root, 'bottom'),
      st: state.style,
      co: state.tryonColor,
      sc: state.symbolChoice,
      ie: state.avatarInstructionsChoice === 'yes',
      g: selected ? selected.id : '',
      a: selected ? selected.attempt : 0
    });
    input.value = serializedConfig;
    if (stableInput) stableInput.value = serializedConfig;
    if (stableStyle) stableStyle.value = state.style;
    updateGenerationSummary(root);
    publishGuidedContext(root);
  }

  function updateText(root, position) {
    applyTextColorPreview(root);
    var maxChars = parseInt(root.getAttribute('data-max-chars'), 10) || 26;
    var input = qs(root, '[data-sticker-text="' + position + '"]');
    var preview = qs(root, '[data-sticker-preview-text="' + position + '"]');
    var count = qs(root, '[data-sticker-count="' + position + '"]');
    var stableProperty = qs(root, '[data-sticker-stable-text-property="' + position + '"]');
    var withoutText = hasNoTextChoice(root, position);
    if (!input || !preview) return;

    var value = withoutText ? '' : normalizeStickerText(input.value, maxChars);
    if (input.value !== value) input.value = value;
    preview.textContent = withoutText ? '' : value || (position === 'top'
      ? translate(root, 'topTextPlaceholder')
      : translate(root, 'bottomTextPlaceholder'));
    preview.classList.toggle('is-placeholder', !value && !withoutText);
    if (preview.parentNode) preview.parentNode.classList.toggle('is-placeholder', !value && !withoutText);
    if (count) count.textContent = getUnicodeCharacters(value).length;
    if (stableProperty) stableProperty.value = value;
    syncGuidedTextStep(root);
    syncLocalTextBacking(root);
    var suggestions = qs(root, '[data-local-text-suggestions="' + position + '"]');
    if (suggestions) suggestions.value = !value ? '__none__' : Array.from(suggestions.options).some(function (option) { return option.value === value; }) ? value : '';
  }

  function updateSize(root, position) {
    var state = root._stickerState;
    var preview = qs(root, '[data-sticker-preview-text="' + position + '"]');
    var property = qs(root, '[data-sticker-size-property="' + position + '"]');
    var stableProperty = qs(root, '[data-sticker-stable-size-property="' + position + '"]');
    if (!preview) return;
    var size = position === 'top' ? state.topSize : state.bottomSize;
    if (state.sunEnabled === true) size = Math.min(size, getLocalWhiteBacking(root).enabled ? 60 : 76.5625);
    preview.style.fontSize = size + 'px';
    if (property) property.value = String(size);
    if (stableProperty) stableProperty.value = String(size);
    if (typeof syncLocalTextSizeControls === 'function') syncLocalTextSizeControls(root, position);
  }

  function setStyle(root, style) {
    var preview = qs(root, '[data-sticker-preview]');
    var state = root._stickerState;
    var selectedId;
    var selected;
    if (!preview) return;
    state.style = style;
    selectedId = state.selectedGenerationIdsByStyle[style] || '';
    selected = selectedId ? getGenerationById(root, selectedId) : null;
    if (selected) {
      state.selectedGenerationId = selected.id;
      state.selectedGenerationLabel = selected.label;
      syncSelectedGenerationContext(root, selected);
    }
    preview.className = 'sticker-customizer__sticker sticker-customizer__sticker--' + style;
    updateStyleGuide(root);
    updateGeneration(root);
    updateConfig(root);
  }

  function updateSelectedStyle(root) {
    qsa(root, '.sticker-customizer__style-option').forEach(function (label) {
      var input = qs(label, '[data-sticker-style]');
      label.classList.toggle('is-selected', !!(input && input.checked));
    });
  }

  function updatePrimaryAction(root) {
    var state = root._stickerState;
    var button = qs(root, '[data-sticker-action="primary"]');
    var text = translate(root, 'generateImage');
    var mode = 'generate';

    if (!button) return;

    if (!hasUsableSubject(root)) {
      text = translate(root, 'addPhoto');
      mode = 'photo';
    } else if (state.activeTab === 'photo') {
      text = translate(root, 'continueToText');
      mode = 'text';
    } else if (state.activeTab === 'text' && !hasRequiredTexts(root)) {
      text = translate(root, 'completeTexts');
      mode = 'texts';
    } else if (state.activeTab === 'text' && !hasRequiredSymbol(root)) {
      text = translate(root, 'completeSymbol');
      mode = 'symbol';
    } else if (state.activeTab === 'text') {
      text = translate(root, 'continueToStyles');
      mode = 'style';
    } else if (state.activeTab === 'style' && !hasRequiredAvatarInstructions(root)) {
      text = translate(root, 'completeInstructions');
      mode = 'instructions';
    } else if (getStyleResults(root, state.style).length > 0) {
      text = translate(root, 'generateAgain');
      mode = 'generate';
    }

    if (state.isGenerating) {
      text = translate(root, 'generationProcessing');
      button.disabled = true;
    } else {
      button.disabled = false;
    }

    button.textContent = text;
    button.setAttribute('data-sticker-primary-mode', mode);
  }

  function validate(root) {
    var photoError = qs(root, '[data-sticker-error="photo"]');
    var uploadLabel = qs(root, '[data-sticker-photo-picker]');
    var status = getMinimumIntakeStatus(root._stickerState,
      hasUsableSubject(root) || hasUsablePhoto(root));
    var missing = getMissingMinimumInputs(status);
    var target;

    root.setAttribute('data-sticker-missing-generation-inputs', missing.join(','));
    if (photoError) photoError.hidden = status.photo;
    if (uploadLabel) uploadLabel.classList.toggle('is-error', !status.photo);
    qsa(root, '[data-sticker-error="text-top"], [data-sticker-error="text-bottom"], [data-sticker-error="symbol"], [data-sticker-error="avatar-instructions"]').forEach(function (error) {
      error.hidden = true;
    });

    if (missing[0] === 'style') {
      setTab(root, 'style');
      target = qs(root, '[data-sticker-style]:checked') || qs(root, '[data-sticker-style]');
    } else if (missing[0] === 'color') {
      setTab(root, 'tryon');
      target = qs(root, '[data-sticker-tryon-color].is-selected') || qs(root, '[data-sticker-tryon-color]');
    } else if (missing[0] === 'photo') {
      setTab(root, 'photo');
      target = uploadLabel;
    }
    if (target) {
      window.setTimeout(function () {
        target.focus();
        target.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 0);
    }
    return missing.length === 0;
  }

  function validateGeneration(root) {
    var selected = getSelectedGeneration(root);
    var error = qs(root, '[data-sticker-error="generation"]');
    var button = qs(root, '[data-sticker-action="generate-style"]');

    if (selected) return true;
    setTab(root, 'style');
    if (error) showGenerationError(root, translate(root, 'generateFirst'), false);
    window.setTimeout(function () {
      if (button) {
        button.focus();
        button.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, 0);
    return false;
  }

  function open(root) {
    var overlay = qs(root, '[data-sticker-overlay]');
    var closeButton;
    if (!overlay) return;
    root._stickerPreviousFocus = document.activeElement;
    setFieldsEnabled(root, true);
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    syncAssistantVisualViewport(root);
    document.body.classList.add('sticker-customizer-open');
    root._stickerState.guidedPreviewMode = 'foreground';
    root.classList.remove('is-preview-large');
    syncAssistantShell(root);
    enterCustomizerFullscreen(root);
    setTab(root, 'photo');
    syncCustomizerCartState(root);
    refreshGenerationEntitlements(root);
    if (localJourneyEnabled(root)) renderLocalJourney(root);
    if (root._stickerState.assistantExperience === 'guided') {
      emitAnalyticsEvent('clairatier_assistant_opened', {
        source_surface: 'product_customizer'
      });
    }
    closeButton = qs(root, '[data-sticker-action="close"]');
    window.setTimeout(function () {
      if (closeButton) closeButton.focus();
    }, 0);
  }

  function close(root) {
    var overlay = qs(root, '[data-sticker-overlay]');
    var wasOpen;
    if (!overlay) return;
    closeAssistantControlHandoff(root, false, false);
    wasOpen = !overlay.hidden;
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    root.classList.remove('is-preview-large');
    hideToast(root);
    cancelAssistantTurn(root);
    exitCustomizerFullscreen(root);
    document.body.classList.remove('sticker-customizer-open');
    persistLocalSession(root);
    if (wasOpen && root._stickerPreviousFocus && typeof root._stickerPreviousFocus.focus === 'function') {
      root._stickerPreviousFocus.focus();
    }
  }

  function runPrimaryAction(root) {
    var button = qs(root, '[data-sticker-action="primary"]');
    var mode = button ? button.getAttribute('data-sticker-primary-mode') : '';
    var fileInput = qs(root, '[data-sticker-photo-input]');
    var uploadLabel = qs(root, '[data-sticker-photo-picker]');
    var symbolInput = qs(root, '[data-sticker-symbol-input]');
    var avatarInstructionsInput = qs(root, '[data-sticker-avatar-instructions-input]');

    if (mode === 'photo') {
      setTab(root, 'photo');
      if (uploadLabel) uploadLabel.click();
      else if (fileInput) fileInput.click();
      return;
    }
    if (mode === 'text') {
      setTab(root, 'text');
      return;
    }
    if (mode === 'texts') {
      setTab(root, 'text');
      validate(root);
      return;
    }
    if (mode === 'symbol') {
      setTab(root, 'text');
      if (symbolInput) {
        symbolInput.focus();
        symbolInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      return;
    }
    if (mode === 'style') {
      setTab(root, 'style');
      return;
    }
    if (mode === 'instructions') {
      setTab(root, 'style');
      if (avatarInstructionsInput) {
        avatarInstructionsInput.focus();
        avatarInstructionsInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      return;
    }
    if (mode === 'generate') {
      setTab(root, 'style');
      requestGenerationConfirmation(root, 'primary-generation');
      return;
    }
    var request = submit(root);
    if (request) {
      request
        .then(runThemeCartAction)
        .catch(function (error) {
          setCartStatus(
            root,
            error && error.message
              ? error.message
              : translate(root, 'cartAddFailed'),
            true
          );
        });
    }
  }

  function parseCartAddResponse(response) {
    return response.json().catch(function () { return {}; }).then(function (body) {
      if (!response.ok) {
        throw new Error(body.description || body.message || translate(null, 'cartAddFailed'));
      }
      return body;
    });
  }

  function formHasFile(form) {
    return qsa(form, 'input[type="file"]').some(function (input) {
      return !!(input.files && input.files.length);
    });
  }

  function setCartSnapshotProperty(formData, name, value) {
    var fieldName = 'properties[' + name + ']';
    if (typeof formData.set === 'function') {
      formData.set(fieldName, value == null ? '' : String(value));
      return;
    }
    if (typeof formData.delete === 'function') formData.delete(fieldName);
    if (typeof formData.append === 'function') formData.append(fieldName, value == null ? '' : String(value));
  }

  function applyAcceptedDesignSnapshot(formData, snapshot) {
    if (!snapshot || !snapshot.properties) return formData;
    if (snapshot.quantity) formData.set('quantity', String(clamp(snapshot.quantity, 1, 99)));
    if (snapshot.variantId) formData.set('id', snapshot.variantId);
    Object.keys(snapshot.properties).forEach(function (name) {
      setCartSnapshotProperty(formData, name, snapshot.properties[name]);
    });
    return formData;
  }

  function buildCartFormData(form) {
    var formData = new FormData(form);
    var snapshot = arguments.length > 1 ? arguments[1] : null;

    if (formData.delete) formData.delete('properties[Photo]');
    return snapshot ? applyAcceptedDesignSnapshot(formData, snapshot) : formData;
  }

  function postCartFormWithXhr(form, root, snapshot) {
    return new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();

      request.open('POST', getCartUrl('cart/add.js'), true);
      request.withCredentials = true;
      request.timeout = 90000;
      request.setRequestHeader('Accept', 'application/json');
      request.onload = function () {
        var body = {};

        try {
          body = request.responseText ? JSON.parse(request.responseText) : {};
        } catch (error) {}

        if (request.status >= 200 && request.status < 300) {
          resolve(body);
          return;
        }
        reject(new Error(body.description || body.message || translate(root, 'cartAddFailed')));
      };
      request.onerror = function () {
        reject(new Error(translate(root, 'photoConnectionInterrupted')));
      };
      request.ontimeout = function () {
        reject(new Error(translate(root, 'photoUploadTimeout')));
      };
      request.send(buildCartFormData(form, snapshot));
    });
  }

  function postCartForm(form, root, snapshot) {
    if ((!window.fetch || formHasFile(form) || (root && root._stickerPhotoFile)) && window.XMLHttpRequest) {
      return postCartFormWithXhr(form, root, snapshot);
    }

    return window.fetch(getCartUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: buildCartFormData(form, snapshot)
    }).then(parseCartAddResponse);
  }

  function runThemeCartAction(item) {
    return new Promise(function (resolve) {
      var settled = false;
      function done() {
        if (settled) return;
        settled = true;
        resolve();
      }
      if (window.BT && typeof window.BT.runCartAction === 'function') {
        window.BT.runCartAction(item, done);
        window.setTimeout(done, 2500);
        return;
      }
      if (window.BT && typeof window.BT.updateHeaderCartHtml === 'function') {
        window.BT.updateHeaderCartHtml(false);
      }
      done();
    });
  }

  function setGenerationCartLoading(root, generationId, loading) {
    var button = qs(root, '[data-sticker-action="add-generation"][data-sticker-generation-id="' + generationId + '"]');
    if (!button) return;
    button.disabled = loading;
    button.textContent = loading ? translate(root, 'addingToCart') : translate(root, 'addToCart');
  }

  function setCartStatus(root, message, isError) {
    var status = qs(root, '[data-sticker-cart-status]');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    status.classList.toggle('sticker-customizer__cart-status--error', !!isError);
  }

  function buildFinalizationPayload(root, result) {
    var state = root._stickerState;
    var generationPayload = result && result.payload || state.lastGenerationPayload || {};
    var generatedPersonalization = generationPayload.personalization || {};
    var payload = {
      subject: generationPayload.subject || { sourceType: 'photo' },
      product: {
        id: root.getAttribute('data-product-id') || '',
        handle: root.getAttribute('data-product-handle') || '',
        variantId: getSelectedVariantId(root)
      },
      personalization: {
        color: generatedPersonalization.color || state.tryonColor,
        textTop: getTextValue(root, 'top'),
        textBottom: getTextValue(root, 'bottom'),
        textTopEnabled: !hasNoTextChoice(root, 'top'),
        textBottomEnabled: !hasNoTextChoice(root, 'bottom'),
        textTopSize: state.topSize,
        textBottomSize: state.bottomSize,
        symbolChoice: generatedPersonalization.symbolChoice,
        symbol: generatedPersonalization.symbol,
        avatarInstructionsEnabled: generatedPersonalization.avatarInstructionsEnabled,
        avatarInstructions: generatedPersonalization.avatarInstructions,
        garmentId: generatedPersonalization.garmentId,
        hairstyleId: generatedPersonalization.hairstyleId,
        paletteSource: generatedPersonalization.paletteSource,
        requestedPrimaryColor: generatedPersonalization.requestedPrimaryColor,
        requestedSecondaryColor: generatedPersonalization.requestedSecondaryColor,
        requestedAccentColor: generatedPersonalization.requestedAccentColor,
        requestedFinishColor: generatedPersonalization.requestedFinishColor,
        finishId: generatedPersonalization.finishId
      },
      composition: {
        imageScale: state.photoScale,
        imageOffsetX: state.photoX,
        imageOffsetY: state.photoY
      }
    };
    if (localJourneyEnabled(root)) payload.composition.whiteBacking = Object.assign({}, getLocalWhiteBacking(root));
    if (state.selectedBackgroundId && state.selectedBackgroundId !== 'background-none-white') {
      Object.assign(payload.composition, {
        productProfileVersion: root.getAttribute('data-sticker-product-profile-version') || '',
        backgroundManifestVersion: root.getAttribute('data-sticker-background-manifest-version') || '1.0.0',
        fadeManifestVersion: root.getAttribute('data-sticker-fade-manifest-version') || '1.0.0',
        backgroundId: state.selectedBackgroundId,
        fadePresetId: state.selectedFadeId || BACKGROUND_DEFAULT_FADE_ID,
        backgroundTransform: normalizeBackgroundTransform(state.backgroundTransform)
      });
    }
    return payload;
  }

  function getGenerationFinalizeEndpoint(endpoint, generationId) {
    return String(endpoint || '').replace(/\/+$/, '') +
      '/' + encodeURIComponent(generationId) + '/finalize';
  }

  // Dedicated provider-free test-order lane. It never relaxes the AI/session,
  // paid-action or legacy finalization guards above.
  function approvedCompositionFailure(code, status) {
    var error = new Error(code);
    error.code = code;
    error.status = status || 0;
    return error;
  }

  function approvedCompositionUuid(value) {
    return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
  }

  function approvedCompositionFingerprint(value) {
    if (Array.isArray(value)) return '[' + value.map(approvedCompositionFingerprint).join(',') + ']';
    if (value && typeof value === 'object') return '{' + Object.keys(value).sort().map(function (key) {
      return JSON.stringify(key) + ':' + approvedCompositionFingerprint(value[key]);
    }).join(',') + '}';
    return JSON.stringify(value);
  }

  function validateApprovedCompositionSelection(input) {
    function reject() { throw approvedCompositionFailure('APPROVED_SELECTION_UNSUPPORTED'); }
    function keys(object, expected) {
      if (!object || typeof object !== 'object' || Array.isArray(object) || Object.keys(object).length !== expected.length ||
          expected.some(function (key) { return !Object.prototype.hasOwnProperty.call(object, key); })) reject();
    }
    function number(value, min, max) { if (typeof value !== 'number' || !Number.isFinite(value) || value < min || value > max) reject(); }
    keys(input, ['composition', 'quantity']);
    number(input.quantity, 1, 10);
    if (!Number.isInteger(input.quantity)) reject();
    var body = input.composition;
    keys(body, ['contractVersion', 'product', 'models', 'text', 'background', 'whiteBacking', 'productProfileVersion']);
    keys(body.product, ['id', 'handle', 'variantId']);
    if (body.contractVersion !== 'approved-composition/1' || body.productProfileVersion !== 'owner-round-140mm-repository-v1' ||
        body.product.id !== '10530170274128' || body.product.handle !== 'clairabord-sticker-voiture-bebe-a-bord-personnalisable-priv' ||
        body.product.variantId !== '53144689148240') reject();
    if (!Array.isArray(body.models) || body.models.length < 1 || body.models.length > 3) reject();
    body.models.forEach(function (model) {
      keys(model, ['characterId', 'category', 'variant', 'centerX', 'centerY', 'diameter', 'bottomFade']);
      if (CAST_PREVIEW_IDS.indexOf(model.characterId) < 0 || ['hair', 'masks'].indexOf(model.category) < 0 ||
          !Number.isInteger(model.variant) || model.variant < 1 || model.variant > 5) reject();
      number(model.diameter, 50, 1000); number(model.centerX, 0, 1000); number(model.centerY, 0, 1000);
      if (model.centerX - model.diameter / 2 < 0 || model.centerX + model.diameter / 2 > 1000 ||
          model.centerY - model.diameter / 2 < 0 || model.centerY + model.diameter / 2 > 1000) reject();
      if (model.bottomFade !== null) {
        keys(model.bottomFade, ['start', 'end']); number(model.bottomFade.start, 0, 1000); number(model.bottomFade.end, 0, 1000);
        if (model.bottomFade.end <= model.bottomFade.start) reject();
      }
    });
    keys(body.text, ['top', 'bottom', 'topEnabled', 'bottomEnabled', 'topSize', 'bottomSize', 'color']);
    ['top', 'bottom'].forEach(function (part) {
      if (typeof body.text[part] !== 'string' || body.text[part].length > 26 || /[\u0000-\u001f\u007f]/.test(body.text[part]) ||
          typeof body.text[part + 'Enabled'] !== 'boolean') reject();
      number(body.text[part + 'Size'], 24, 160);
    });
    if (typeof body.text.color !== 'string' || !/^#[0-9a-f]{6}$/i.test(body.text.color)) reject();
    keys(body.background, ['id', 'scale', 'x', 'y', 'fadeId']);
    if (body.background.id !== null || body.background.fadeId !== null || body.background.scale !== 1 || body.background.x !== 0 || body.background.y !== 0) reject();
    keys(body.whiteBacking, ['style', 'enabled', 'topText', 'bottomText', 'avatar', 'brand', 'badge']);
    if (['band', 'outline', 'bold', 'soft', 'offset', 'double', 'fine', 'cushion', 'glow', 'lifted', 'triple'].indexOf(body.whiteBacking.style) < 0 ||
        ['enabled', 'topText', 'bottomText', 'avatar', 'brand', 'badge'].some(function (key) { return typeof body.whiteBacking[key] !== 'boolean'; })) reject();
    return freezeAcceptedSnapshotValue(JSON.parse(JSON.stringify(input)));
  }

  function validateApprovedCompositionResult(result, product, testOnly) {
    if (!result || !approvedCompositionUuid(result.id) || result.numgen !== result.id || result.status !== 'succeeded' ||
        result.cartReady !== true || result.testOnly !== (testOnly === undefined ? true : testOnly) || result.contractVersion !== 'approved-composition/1' ||
        !/^[a-f0-9]{64}$/.test(result.finalizationHash || '') || typeof result.finalizedAt !== 'string' ||
        !Number.isFinite(Date.parse(result.finalizedAt)) || !result.product ||
        ['id', 'handle', 'variantId'].some(function (key) { return result.product[key] !== product[key]; })) {
      throw approvedCompositionFailure('APPROVED_RESULT_INVALID');
    }
    // Do not retain arbitrary server URLs or transport fields as a result.
    return freezeAcceptedSnapshotValue({ id: result.id, numgen: result.numgen, finalizationHash: result.finalizationHash,
      finalizedAt: result.finalizedAt, product: Object.assign({}, product) });
  }


  function normalizeAuthoritativeCopyLines(lines) {
    if (!Array.isArray(lines) || lines.length > 40) throw approvedCompositionFailure('CART_UUID_QUANTITY_LINES_REQUIRED');
    var totals = {};
    lines.forEach(function (line) {
      if (!line || Object.keys(line).sort().join(',') !== 'numgen,quantity' || !approvedCompositionUuid(line.numgen) || !Number.isInteger(line.quantity) || line.quantity < 0 || line.quantity > 10) throw approvedCompositionFailure('CART_INVALID_LINE');
      var id = line.numgen.toLowerCase(); totals[id] = (totals[id] || 0) + line.quantity;
      if (totals[id] > 10) throw approvedCompositionFailure('CART_CREATION_MAX_TEN');
    });
    return Object.keys(totals).sort().filter(function (id) { return totals[id] > 0; }).map(function (id) { return { numgen: id, quantity: totals[id] }; });
  }

  function copyCartErrorKey(code, status) {
    if (status === 422 && ['TEXT_GLYPH_UNAVAILABLE', 'TEXT_LAYOUT_UNAVAILABLE'].indexOf(code) !== -1) return code === 'TEXT_GLYPH_UNAVAILABLE' ? 'copyGlyph' : 'copyLayout';
    if (['QUOTE_RESERVE_PDF_MISMATCH', 'QUOTE_RESERVE_PROVENANCE_MISMATCH', 'COPY_QUOTE_PROVENANCE_MISMATCH', 'COPY_QUOTE_SHOPIFY_MISMATCH', 'COPY_QUOTE_MONEY_INVALID'].indexOf(code) !== -1) return 'copyIntegrity';
    if (['CART_INVALID_LINE', 'CART_CREATION_MAX_TEN', 'COPY_LEGACY_QUANTITY'].indexOf(code) !== -1) return 'copyQuantityLimit';
    if (['COPY_SESSION_UNAVAILABLE', 'COPY_SESSION_CHANGED'].indexOf(code) !== -1) return 'copySession';
    if (['COPY_QUOTE_RECOVERY_CONFLICT', 'CART_REVISION_CONFLICT', 'CART_IDEMPOTENCY_CONFLICT'].indexOf(code) !== -1) return 'copyConflict';
    if (['CART_LIFECYCLE_CLOSED', 'CART_QUOTE_ORDER_CREATED'].indexOf(code) !== -1) return 'copyOrderCreated';
    if (code === 'COPY_QUOTE_SUPPORT') return 'copySupport';
    if (code === 'COPY_QUOTE_STOCK_UNAVAILABLE') return 'copyStock';
    if (['QUOTE_RESERVE_NOT_ENABLED', 'QUOTE_RESERVE_PRIVATE_STORAGE_REQUIRED', 'COPY_CART_NOT_CONFIGURED', 'GENERATION_CLEANUP_IN_PROGRESS', 'COPY_DISABLED'].indexOf(code) !== -1) return 'copyDisabled';
    if (['COPY_JOURNAL_UNAVAILABLE', 'COPY_JOURNAL_INVALID'].indexOf(code) !== -1) return 'copyStorage';
    if (code === 'QUOTE_RESERVE_INCOMPLETE') return 'copyIncomplete';
    if (['QUOTE_RESERVE_SOURCE_UNAVAILABLE', 'QUOTE_RESERVE_PDF_UNAVAILABLE', 'CART_CREATION_NOT_READY', 'CART_CREATION_CHANGED'].indexOf(code) !== -1) return 'copySourceUnavailable';
    return 'copyUnavailable';
  }

  function validateAuthoritativeCopyResponse(value, quote, host) {
    if (!value || !approvedCompositionUuid(value.id) || !Number.isInteger(value.revision) || value.revision < 0 || value.currency !== 'EUR') throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
    var lines = normalizeAuthoritativeCopyLines(value.lines), expected = lines.reduce(function (sum, line) { return sum + 4500 + (line.quantity - 1) * 3600; }, 0);
    if (JSON.stringify(lines) !== JSON.stringify(value.lines) || value.totalCents !== expected) throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
    if (!quote) {
      if (['OPEN', 'ORDER_CREATED'].indexOf(value.state) < 0 || value.checkoutContract !== 'dedicated-personalizer-only' || value.mixedCartSupported !== false || value.promotionsSupported !== false) throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
    } else {
      if (!approvedCompositionUuid(value.cartId) || !Number.isInteger(value.currentRevision) || value.currentRevision < 0 || value.superseded !== (value.revision !== value.currentRevision) || !/^[a-f0-9]{64}$/.test(value.snapshotHash || '') || typeof value.testOnly !== 'boolean' || value.includesShipping !== false || ['PREPARED', 'SUBMITTING', 'PENDING', 'READY', 'UNCERTAIN', 'ORDER_CREATED'].indexOf(value.state) < 0 || ['RESUME_SAME_QUOTE', 'CONTACT_SUPPORT_KEEP_QUOTE_ID', 'START_NEW_CART'].indexOf(value.action) < 0) throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
      if (value.invoiceUrl !== null) {
        var url; try { url = new URL(value.invoiceUrl); } catch (error) { throw approvedCompositionFailure('COPY_RESPONSE_INVALID'); }
        if (value.state !== 'READY' || url.protocol !== 'https:' || !/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(host || '') || url.hostname !== host || url.port || url.username || url.password) throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
      }
      if (!Number.isInteger(value.retryAfterSeconds) || value.retryAfterSeconds < 1 || value.retryAfterSeconds > 120) throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
    }
    var permitted = quote ? ['id', 'cartId', 'revision', 'currentRevision', 'superseded', 'state', 'snapshotHash', 'currency', 'totalCents', 'lines', 'testOnly', 'invoiceUrl', 'retryAfterSeconds', 'action', 'includesShipping'] : ['id', 'revision', 'state', 'lines', 'currency', 'totalCents', 'checkoutContract', 'mixedCartSupported', 'promotionsSupported'];
    return permitted.reduce(function (result, key) { result[key] = JSON.parse(JSON.stringify(value[key])); return result; }, {});
  }


  function validateCopyCartJournal(raw, sid) {
    function keys(value, allowed) { return value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).every(function (key) { return allowed.indexOf(key) !== -1; }); }
    function revision(value) { return Number.isInteger(value) && value >= 0 && value <= 999999999; }
    function quote(value, needsId) { return keys(value, ['id', 'cartId', 'requestRevision', 'quoteRevision', 'snapshotHash', 'lines', 'orderCreated']) && (!needsId && !value.id || approvedCompositionUuid(value.id)) && approvedCompositionUuid(value.cartId) && revision(value.requestRevision) && (value.orderCreated === undefined || value.orderCreated === true && approvedCompositionUuid(value.id)) && (!value.id || revision(value.quoteRevision) && /^[a-f0-9]{64}$/.test(value.snapshotHash || '')) && Array.isArray(value.lines) && JSON.stringify(normalizeAuthoritativeCopyLines(value.lines)) === JSON.stringify(value.lines); }
    var valid = keys(raw, ['version', 'owner', 'designs', 'cart', 'mutation', 'quote', 'authoring', 'failedAuthoring', 'quotes']) && raw.version === 1 && raw.owner === sid && approvedCompositionUuid(raw.owner) && JSON.stringify(raw).length <= 262144 && Array.isArray(raw.designs) && raw.designs.length <= 1000 && raw.designs.every(function (value) { return keys(value, ['digest', 'id']) && /^[a-f0-9]{64}$/.test(value.digest || '') && approvedCompositionUuid(value.id); });
    if (!valid) throw approvedCompositionFailure('COPY_JOURNAL_INVALID');
    if (raw.cart !== undefined && raw.cart !== null) raw.cart = validateAuthoritativeCopyResponse(raw.cart, false);
    if (raw.mutation && (!keys(raw.mutation, ['key', 'cartId', 'revision', 'lines', 'rejected']) || !approvedCompositionUuid(raw.mutation.key) || raw.mutation.cartId && (!approvedCompositionUuid(raw.mutation.cartId) || !revision(raw.mutation.revision)) || !Array.isArray(raw.mutation.lines) || JSON.stringify(normalizeAuthoritativeCopyLines(raw.mutation.lines)) !== JSON.stringify(raw.mutation.lines))) throw approvedCompositionFailure('COPY_JOURNAL_INVALID');
    if (raw.failedAuthoring && (!keys(raw.failedAuthoring, ['digest', 'requestId', 'code']) || !/^[a-f0-9]{64}$/.test(raw.failedAuthoring.digest || '') || !approvedCompositionUuid(raw.failedAuthoring.requestId) || ['TEXT_GLYPH_UNAVAILABLE', 'TEXT_LAYOUT_UNAVAILABLE'].indexOf(raw.failedAuthoring.code) < 0)) throw approvedCompositionFailure('COPY_JOURNAL_INVALID');
    if (raw.mutation && raw.mutation.rejected !== undefined && typeof raw.mutation.rejected !== 'boolean') throw approvedCompositionFailure('COPY_JOURNAL_INVALID');
    if (raw.quote && !quote(raw.quote, false) || raw.quotes && (!Array.isArray(raw.quotes) || !raw.quotes.every(function (value) { return quote(value, true); })) || raw.authoring && (!keys(raw.authoring, ['digest', 'requestId']) || !/^[a-f0-9]{64}$/.test(raw.authoring.digest || '') || !approvedCompositionUuid(raw.authoring.requestId))) throw approvedCompositionFailure('COPY_JOURNAL_INVALID');
    return JSON.parse(JSON.stringify(raw));
  }

  function createAuthoritativeCopyCartAdapter(options) {
    var api = 'https://api.dashfoliodata.com/v1/clairatier/', endpoint = api + 'copy-carts', sessionEndpoint = api + 'sessions';
    var session = null, journal = null, flight = null, lastQuote = null;
    function save() { try { options.writeJournal(validateCopyCartJournal(JSON.parse(JSON.stringify(journal)), journal.owner)); } catch (error) { throw approvedCompositionFailure('COPY_JOURNAL_UNAVAILABLE'); } }
    function validSession(value) { return value && approvedCompositionUuid(value.sessionId) && typeof value.token === 'string' && value.token && typeof value.claimToken === 'string' && value.claimToken && Number.isFinite(Date.parse(value.expiresAt)) && Number.isFinite(Date.parse(value.claimExpiresAt)) && Date.parse(value.claimExpiresAt) > options.now(); }
    async function transport(url, method, body, headers) {
      var init = { method: method, credentials: 'omit', redirect: 'error', headers: Object.assign({ Accept: 'application/json' }, headers || {}) };
      if (body !== undefined) { init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(body); }
      var response = await options.fetch(url, init), data;
      try { data = await response.json(); } catch (error) { throw approvedCompositionFailure('COPY_RESPONSE_INVALID', response.status); }
      if (!response.ok) {
        var code = data && typeof data.code === 'string' && /^(CART_|COPY_QUOTE_|COPY_CART_|QUOTE_RESERVE_|TEXT_|GENERATION_CLEANUP_|APPROVED_COMPOSITION_)[A-Z_]+$/.test(data.code) ? data.code : 'COPY_REQUEST_FAILED';
        throw approvedCompositionFailure(code, response.status);
      }
      return data;
    }
    async function owner(force) {
      if (!options.enabled()) throw approvedCompositionFailure('COPY_DISABLED');
      if (!session) session = options.readSession(sessionEndpoint);
      if (!journal) { var candidate; try { candidate = options.readJournal(); } catch (error) { throw approvedCompositionFailure('COPY_JOURNAL_UNAVAILABLE'); } if (candidate) { if (!validSession(session)) throw approvedCompositionFailure('COPY_SESSION_UNAVAILABLE'); if (candidate.owner !== session.sessionId) throw approvedCompositionFailure('COPY_SESSION_CHANGED'); journal = validateCopyCartJournal(candidate, session.sessionId); if (!Array.isArray(journal.quotes)) journal.quotes = []; } }
      if (!validSession(session)) {
        // A lost claim must not issue another sid to retrieve an existing journal.
        var existing; try { existing = options.readJournal(); } catch (error) { throw approvedCompositionFailure('COPY_JOURNAL_UNAVAILABLE'); }
        if (session || existing && existing.owner) throw approvedCompositionFailure('COPY_SESSION_UNAVAILABLE');
        session = await transport(sessionEndpoint, 'POST');
      } else if (force || Date.parse(session.expiresAt) <= options.now() + 60000) {
        var fresh = await transport(sessionEndpoint + '/refresh', 'POST', { claimToken: session.claimToken });
        if (!validSession(fresh) || fresh.sessionId !== session.sessionId) throw approvedCompositionFailure('COPY_SESSION_CHANGED');
        session = fresh;
      }
      if (!validSession(session) || Date.parse(session.expiresAt) <= options.now()) throw approvedCompositionFailure('COPY_SESSION_UNAVAILABLE');
      try { options.writeSession(sessionEndpoint, session); } catch (error) { throw approvedCompositionFailure('COPY_JOURNAL_UNAVAILABLE'); }
      if (!journal) {
        try { journal = options.readJournal() || { version: 1, owner: session.sessionId, designs: [] }; } catch (error) { throw approvedCompositionFailure('COPY_JOURNAL_UNAVAILABLE'); }
        if (journal.owner !== session.sessionId) throw approvedCompositionFailure('COPY_SESSION_CHANGED');
        journal = validateCopyCartJournal(journal, session.sessionId);
        if (!Array.isArray(journal.quotes)) journal.quotes = [];
        save();
      }
      return session;
    }
    async function request(path, method, body, headers) {
      await owner(false);
      try { return await transport(path, method, body, Object.assign({ Authorization: 'Bearer ' + session.token }, headers)); }
      catch (error) {
        if (error.status !== 401) throw error;
        await owner(true);
        return transport(path, method, body, Object.assign({ Authorization: 'Bearer ' + session.token }, headers));
      }
    }
    async function load() {
      await owner(false);
      try { journal.cart = validateAuthoritativeCopyResponse(await request(endpoint + '/current', 'GET'), false); }
      catch (error) { if (error.status !== 404) throw error; journal.cart = null; }
      save(); return journal.cart;
    }
    async function replayMutation() {
      var intent = journal.mutation;
      if (!intent) return journal.cart;
      var url = endpoint + (intent.cartId ? '/' + intent.cartId : ''), headers = { 'Idempotency-Key': intent.key };
      if (intent.cartId) headers['If-Match'] = String(intent.revision);
      if (intent.rejected) throw approvedCompositionFailure('CART_REVISION_CONFLICT', 409);
      var result;
      try { result = validateAuthoritativeCopyResponse(await request(url, intent.cartId ? 'PUT' : 'POST', { lines: intent.lines }, headers), false); }
      catch (error) { if (error.status === 409 && error.code === 'CART_REVISION_CONFLICT') { intent.rejected = true; save(); await load(); } throw error; }
      if (intent.cartId && result.id !== intent.cartId || JSON.stringify(result.lines) !== JSON.stringify(intent.lines)) throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
      journal.cart = result; journal.mutation = null; save();
      // Idempotent replay may precede another tab's edit; authoritative re-read.
      return load();
    }
    async function mutate(lines) {
      await owner(false);
      if (journal.cart === undefined) await load();
      if (journal.mutation || journal.quote || journal.authoring) throw approvedCompositionFailure('COPY_QUOTE_RECOVERY_CONFLICT');
      lines = normalizeAuthoritativeCopyLines(lines);
      journal.mutation = { key: options.uuid(), cartId: journal.cart && journal.cart.id, revision: journal.cart && journal.cart.revision, lines: lines };
      if (!approvedCompositionUuid(journal.mutation.key)) throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
      save(); return replayMutation();
    }
    async function quote() {
      await owner(false);
      if (journal.quote) return recoverQuote();
      var before = journal.cart;
      await load();
      if (before && (!journal.cart || before.id !== journal.cart.id || before.revision !== journal.cart.revision)) throw approvedCompositionFailure('CART_REVISION_CONFLICT');
      if (journal.mutation || journal.authoring || !journal.cart || !journal.cart.lines.length) throw approvedCompositionFailure('CART_EMPTY');
      if (!journal.quote) { journal.quote = { cartId: journal.cart.id, requestRevision: journal.cart.revision, lines: journal.cart.lines }; save(); }
      return recoverQuote();
    }
    async function recoverQuote() {
      lastQuote = null;
      var intent = journal.quote;
      if (!intent) return null;
      function verify(value, known) {
        value = validateAuthoritativeCopyResponse(value, true, options.shopHost);
        if (value.cartId !== intent.cartId || value.testOnly !== options.testOnly || JSON.stringify(value.lines) !== JSON.stringify(intent.lines) || value.currentRevision < intent.requestRevision || (known ? value.id !== intent.id || value.revision !== intent.quoteRevision || value.snapshotHash !== intent.snapshotHash : value.revision > intent.requestRevision)) throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
        return value;
      }
      var result;
      if (intent.id) {
        try { result = verify(await request(endpoint + '/quotes/' + intent.id, 'GET'), true); }
        catch (error) { if (error.status === 409 && ['CART_QUOTE_ORDER_CREATED', 'CART_LIFECYCLE_CLOSED'].indexOf(error.code) !== -1) { intent.orderCreated = true; save(); } throw error; }
      }
      if (!intent.id || result.state === 'PREPARED') {
        var current = await load();
        if (!current || current.id !== intent.cartId || JSON.stringify(current.lines) !== JSON.stringify(intent.lines) || !intent.id && current.revision !== intent.requestRevision) throw approvedCompositionFailure('COPY_QUOTE_RECOVERY_CONFLICT');
        if (intent.id && current.state === 'ORDER_CREATED') { intent.orderCreated = true; save(); throw approvedCompositionFailure('CART_LIFECYCLE_CLOSED', 409); }
        intent.requestRevision = current.revision;
        save();
        try { result = verify(await request(endpoint + '/' + intent.cartId + '/quotes', 'POST', {}, { 'If-Match': String(intent.requestRevision) }), !!intent.id); }
        catch (error) { if (intent.id && error.status === 409 && ['CART_QUOTE_ORDER_CREATED', 'CART_LIFECYCLE_CLOSED'].indexOf(error.code) !== -1) { intent.orderCreated = true; save(); } throw error; }
      }
      intent.id = result.id; intent.quoteRevision = result.revision; intent.snapshotHash = result.snapshotHash;
      var historic = { id: intent.id, cartId: intent.cartId, requestRevision: intent.requestRevision, quoteRevision: intent.quoteRevision, snapshotHash: intent.snapshotHash, lines: intent.lines };
      journal.quotes = journal.quotes.filter(function (q) { return q.id !== intent.id; }).concat([historic]);
      // Persist the acknowledged immutable quote before any further current-cart read.
      save();
      if (result.currentRevision !== intent.requestRevision) await load();
      lastQuote = result;
      if (result.action === 'CONTACT_SUPPORT_KEEP_QUOTE_ID') throw approvedCompositionFailure('COPY_QUOTE_SUPPORT');
      if (result.state === 'ORDER_CREATED') throw approvedCompositionFailure('CART_QUOTE_ORDER_CREATED');
      return result;
    }
    async function recover() {
      await owner(false);
      if (journal.mutation) await replayMutation();
      if (journal.authoring) throw approvedCompositionFailure('COPY_AUTHORING_PENDING');
      return journal.quote ? recoverQuote() : load();
    }
    async function add(selection) {
      selection = validateApprovedCompositionSelection(selection);
      await owner(false);
      if (journal.mutation || journal.quote) throw approvedCompositionFailure('COPY_QUOTE_RECOVERY_CONFLICT');
      var digest = await options.hash(approvedCompositionFingerprint(selection.composition));
      if (!/^[a-f0-9]{64}$/.test(digest)) throw approvedCompositionFailure('COPY_RESPONSE_INVALID');
      var known = journal.designs.find(function (record) { return record.digest === digest; });
      if (journal.authoring && journal.authoring.digest !== digest) throw approvedCompositionFailure('COPY_AUTHORING_PENDING');
      if (!known) {
        if (!journal.authoring) { journal.authoring = { digest: digest, requestId: options.uuid() }; save(); }
        var result;
        try { result = await request(api + 'approved-compositions', 'POST', Object.assign({ requestId: journal.authoring.requestId }, selection.composition)); }
        catch (error) { if (error.status === 422 && ['TEXT_GLYPH_UNAVAILABLE', 'TEXT_LAYOUT_UNAVAILABLE'].indexOf(error.code) !== -1) { journal.failedAuthoring = Object.assign({}, journal.authoring, { code: error.code }); journal.authoring = null; save(); } throw error; }
        result = validateApprovedCompositionResult(result, selection.composition.product, options.testOnly);
        known = { digest: digest, id: result.id }; journal.designs.push(known); journal.authoring = null; save();
      } else {
        validateApprovedCompositionResult(await request(api + 'approved-compositions/' + known.id, 'GET'), selection.composition.product, options.testOnly);
      }
      await load();
      var lines = (journal.cart ? journal.cart.lines : []).filter(function (line) { return line.numgen !== known.id; });
      lines.push({ numgen: known.id, quantity: selection.quantity });
      return mutate(lines);
    }
    function serial(action) { if (flight) return Promise.reject(approvedCompositionFailure('COPY_CART_BUSY')); flight = Promise.resolve().then(action).finally(function () { flight = null; }); return flight; }
    return { load: function () { return serial(load); }, add: function (selection) { return serial(function () { return add(selection); }); }, update: function (lines) { return serial(function () { return mutate(lines); }); }, checkout: function () { return serial(quote); }, recover: function () { return serial(recover); },
      view: function () { return { cart: journal && journal.cart, quote: lastQuote, intent: journal && (journal.quote || journal.mutation), mutation: journal && journal.mutation, closed: journal && journal.quote && journal.quote.orderCreated === true || !!lastQuote && lastQuote.state === 'ORDER_CREATED', history: journal && journal.quotes || [] }; },
      reviewCurrent: function () { return serial(async function () { await owner(false); if (!journal.mutation || journal.mutation.rejected !== true) throw approvedCompositionFailure('COPY_QUOTE_RECOVERY_CONFLICT'); await load(); journal.mutation = null; save(); return journal.cart; }); },
      startNew: function () { return serial(async function () { await owner(false); if (!journal.quote || !journal.quote.id || !(journal.quote.orderCreated === true || lastQuote && lastQuote.state === 'ORDER_CREATED' && journal.quote.id === lastQuote.id)) throw approvedCompositionFailure('COPY_QUOTE_RECOVERY_CONFLICT'); journal.quote = null; lastQuote = null; journal.cart = null; save(); return load(); }); },
      resume: function (id) { return serial(async function () { await owner(false); if (journal.mutation || journal.authoring || journal.quote && !journal.quote.id) throw approvedCompositionFailure('COPY_QUOTE_RECOVERY_CONFLICT'); var saved = journal.quotes.find(function (q) { return q.id === id; }); if (!saved) throw approvedCompositionFailure('COPY_RESPONSE_INVALID'); journal.quote = JSON.parse(JSON.stringify(saved)); save(); return recoverQuote(); }); },
      // Deliberate user action may leave an acknowledged quote behind while editing.
      editCurrent: function () { if (!journal || !journal.quote || !journal.quote.id || !lastQuote || lastQuote.state !== 'READY') throw approvedCompositionFailure('COPY_QUOTE_RECOVERY_CONFLICT'); journal.quote = null; lastQuote = null; save(); }
    };
  }



  function captureSavedCopySelection(root) {
    try { return readApprovedCompositionSelection(root); } catch (error) { return null; }
  }

  function readSavedCopySelection(root, draft) {
    if (!draft || !draft.approvedSelection) throw approvedCompositionFailure('CART_CREATION_CHANGED');
    return validateApprovedCompositionSelection(draft.approvedSelection);
  }

  function copyCartText(root, key, variables) {
    return translate(root, key, variables, translate(root, 'cartUnavailable'));
  }

  function copyCartEnabled(root) {
    return root && root.getAttribute('data-browser-recipe-enabled') !== 'true' && root.getAttribute('data-copy-cart-enabled') === 'true' && root.getAttribute('data-copy-cart-mode') === 'production' && /^\w[\w-]*\.myshopify\.com$/.test(root.getAttribute('data-copy-cart-shop') || '');
  }

  function copyCartAdapter(root) {
    if (root._copyCartAdapter) return root._copyCartAdapter;
    if (window._clairatierCopyCartAdapter) { root._copyCartAdapter = window._clairatierCopyCartAdapter; return root._copyCartAdapter; }
    var key = 'clairatier.copyCartIntent.v1';
    root._copyCartAdapter = createAuthoritativeCopyCartAdapter({
      enabled: function () { return copyCartEnabled(root); }, testOnly: false, shopHost: root.getAttribute('data-copy-cart-shop'),
      now: Date.now, uuid: function () { return window.crypto.randomUUID(); },
      hash: async function (value) { var bytes = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)); return Array.from(new Uint8Array(bytes)).map(function (byte) { return byte.toString(16).padStart(2, '0'); }).join(''); },
      fetch: function (url, init) { return window.fetch(url, init); }, readSession: readGenerationSession,
      writeSession: function (endpoint, session) {
        var record = serializeGenerationSession(endpoint, session);
        if (!record) throw approvedCompositionFailure('COPY_SESSION_UNAVAILABLE');
        var value = JSON.stringify(record); window.sessionStorage.setItem(GENERATION_SESSION_KEY, value);
        if (window.sessionStorage.getItem(GENERATION_SESSION_KEY) !== value) throw approvedCompositionFailure('COPY_JOURNAL_UNAVAILABLE');
      },
      readJournal: function () { var value = window.sessionStorage.getItem(key); return value ? JSON.parse(value) : null; },
      writeJournal: function (value) { var serialized = JSON.stringify(value); window.sessionStorage.setItem(key, serialized); if (window.sessionStorage.getItem(key) !== serialized) throw approvedCompositionFailure('COPY_JOURNAL_UNAVAILABLE'); }
    });
    window._clairatierCopyCartAdapter = root._copyCartAdapter;
    return root._copyCartAdapter;
  }

  function renderAuthoritativeCopyCart(root) {
    var host = qs(root, '[data-copy-cart-panel]'); if (!host) return;
    var adapter = root._copyCartAdapter, view = adapter ? adapter.view() : {}, cart = view.cart, quote = view.quote;
    var rows = qs(host, '[data-copy-cart-lines]'); if (!rows) return;
    var active = document.activeElement; if (active && typeof host.contains === 'function' && host.contains(active) && active.getAttribute) { var control = active.getAttribute('data-copy-numgen') ? 'data-copy-numgen' : active.getAttribute('data-copy-remove') ? 'data-copy-remove' : null; if (control) root._copyFocus = { control: control, id: active.getAttribute(control) }; }
    rows.textContent = '';
    var format = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: 'EUR' });
    (cart && cart.lines || []).forEach(function (line, index) {
      var row = document.createElement('li'), label = document.createElement('label'), input = document.createElement('input'), remove = document.createElement('button');
      label.textContent = copyCartText(root, 'copyDesign', { number: index + 1 }) + ' · ' + copyCartText(root, 'copyQuantity');
      input.type = 'number'; input.min = '1'; input.max = '10'; input.step = '1'; input.inputMode = 'numeric'; input.value = line.quantity;
      input.setAttribute('data-copy-numgen', line.numgen); input.setAttribute('aria-label', label.textContent); input.disabled = !!view.intent || !!root._copyBusy;
      label.appendChild(input); remove.type = 'button'; remove.textContent = copyCartText(root, 'copyRemove'); remove.setAttribute('data-copy-remove', line.numgen); remove.disabled = input.disabled;
      var subtotal = document.createElement('strong'); subtotal.textContent = copyCartText(root, 'copySubtotal') + ': ' + format.format((4500 + (line.quantity - 1) * 3600) / 100); row.appendChild(label); row.appendChild(subtotal); row.appendChild(remove); rows.appendChild(row);
    });
    var summary = qs(host, '[data-copy-cart-total]'); summary.textContent = cart ? copyCartText(root, 'copySubtotal') + ': ' + format.format(cart.totalCents / 100) : copyCartText(root, 'copyEmpty');
    var pricing = qs(host, '[data-copy-pricing]'); if (pricing) { pricing.hidden = !cart || !cart.lines.length; pricing.textContent = cart && cart.lines.length ? copyCartText(root, 'copyPricing') : ''; }
    var checkout = qs(host, '[data-copy-checkout]'); checkout.disabled = !copyCartEnabled(root) || !!root._copyBusy || !!root._copyBlocked || !cart || !cart.lines.length;
    var resume = qs(host, '[data-copy-resume]'); resume.hidden = !view.intent; resume.disabled = !!root._copyBusy || !!root._copyBlocked;
    var edit = qs(host, '[data-copy-edit]'); edit.hidden = !quote || quote.state !== 'READY'; edit.disabled = !!root._copyBusy;
    var review = qs(host, '[data-copy-review]'); if (review) { review.hidden = !(view.mutation && view.mutation.rejected); review.disabled = !!root._copyBusy; }
    var start = qs(host, '[data-copy-new]'); if (start) { start.hidden = !view.closed; start.disabled = !!root._copyBusy; }
    var snapshot = qs(host, '[data-copy-quote]'); snapshot.textContent = '';
    if (quote) {
      var notice = document.createElement('p'); notice.textContent = (quote.superseded ? copyCartText(root, 'copyOlder') + ' ' : '') + copyCartText(root, 'copySubtotal') + ': ' + format.format(quote.totalCents / 100) + ' · ' + quote.lines.map(function (line, index) { return copyCartText(root, 'copyDesign', { number: index + 1 }) + ' × ' + line.quantity; }).join(' · ');
      snapshot.appendChild(notice);
      if (quote.state === 'READY' && quote.invoiceUrl && !root._copyBusy && !root._copyFailed && !root._copyBlocked && copyCartEnabled(root)) {
        var link = document.createElement('a'); link.href = quote.invoiceUrl; link.className = 'button button--style1'; link.textContent = copyCartText(root, 'copyCheckout'); link.rel = 'noreferrer'; snapshot.appendChild(link);
      }
    }
    if (view.mutation && view.mutation.rejected) { var refused = document.createElement('p'); refused.textContent = copyCartText(root, 'copyConflict') + ' ' + view.mutation.lines.map(function (line, index) { return copyCartText(root, 'copyDesign', { number: index + 1 }) + ' × ' + line.quantity; }).join(' · '); snapshot.appendChild(refused); }
    var reference = qs(host, '[data-copy-reference]'); reference.textContent = view.intent && view.intent.id ? copyCartText(root, 'copyReference', { reference: view.intent.id }) : '';
    var history = qs(host, '[data-copy-history]'); history.textContent = '';
    (view.history || []).filter(function (item) { return !view.intent || item.id !== view.intent.id; }).forEach(function (item) {
      var button = document.createElement('button'); button.type = 'button'; button.setAttribute('data-copy-history-id', item.id); button.textContent = copyCartText(root, 'copyResume') + ' · ' + item.lines.map(function (line) { return line.quantity; }).join(' + '); button.disabled = !!root._copyBusy || !!root._copyBlocked; history.appendChild(button);
    });
    if (!root._copyBusy && root._copyFocus) { var focus = qs(host, '[' + root._copyFocus.control + '="' + root._copyFocus.id + '"]') || qs(host, '[data-copy-numgen]') || checkout; if (focus && typeof focus.focus === 'function' && !focus.disabled) focus.focus({ preventScroll: true }); root._copyFocus = null; }
  }

  function bindAuthoritativeCopyCart(root) {
    if (root._copyCartBound) return; root._copyCartBound = true;
    if (root._approvedCompositionRevision === undefined) { root._approvedCompositionRevision = 0; var revise = function () { root._approvedCompositionRevision += 1; }; root.addEventListener('input', revise); root.addEventListener('change', revise); root.addEventListener('click', function (event) { if (event.target.closest('[data-local-choice], [data-local-proof-slot], [data-local-adjust], [data-local-halo], [data-local-text-color-preset], [data-local-text-size-step], [data-local-action="new"], [data-local-action="reset-all"]')) revise(); }, true); }
    var panel = qs(root, '[data-copy-cart-panel]'); if (!panel) return;
    var status = qs(panel, '[data-copy-status]');
    var labels = { '[data-copy-title]': 'copyTitle', '[data-copy-ordinary]': 'copyOrdinary', '[data-copy-separation]': 'copySeparate', '[data-copy-shipping]': 'copyShipping', '[data-copy-checkout]': 'copyCheckout', '[data-copy-resume]': 'copyResume', '[data-copy-edit]': 'copyEdit', '[data-copy-review]': 'copyReview', '[data-copy-new]': 'copyNewCart' };
    Object.keys(labels).forEach(function (selector) { var node = qs(panel, selector); if (node) node.textContent = copyCartText(root, labels[selector]); });
    function act(action) {
      if (root._copyBusy) return Promise.resolve();
      qsa(document, '[data-copy-cart]').forEach(function (other) { other._copyBusy = true; other._copyFailed = true; renderAuthoritativeCopyCart(other); });
      root._copyBusy = true; status.textContent = copyCartText(root, 'copyPreparing'); renderAuthoritativeCopyCart(root);
      return Promise.resolve().then(function () { return action(copyCartAdapter(root)); }).then(function () { root._copyBlocked = false; root._copyFailed = false; var q = root._copyCartAdapter.view().quote; status.textContent = q && (q.state !== 'READY' || !q.invoiceUrl) ? copyCartText(root, 'copyPreparing') : ''; }).catch(function (error) {
        var key = error.code === 'COPY_JOURNAL_UNAVAILABLE' ? 'copyStorage' : error.code === 'COPY_AUTHORING_PENDING' ? 'copyAuthoring' : copyCartErrorKey(error.code, error.status);
        root._copyBlocked = ['copyIntegrity', 'copySupport', 'copySourceUnavailable', 'copyDisabled', 'copySession', 'copyConflict', 'copyStorage', 'copyAuthoring'].indexOf(key) !== -1;
        status.textContent = copyCartText(root, key);
      }).finally(function () { qsa(document, '[data-copy-cart]').forEach(function (other) { other._copyBusy = false; other._copyFailed = root._copyFailed; other._copyBlocked = root._copyBlocked; if (root._copyCartAdapter) other._copyCartAdapter = root._copyCartAdapter; renderAuthoritativeCopyCart(other); }); });
    }
    root._copyCartAct = act;
    panel.addEventListener('click', function (event) {
      var button = event.target.closest('[data-copy-checkout], [data-copy-resume], [data-copy-edit], [data-copy-remove], [data-copy-history-id], [data-copy-review], [data-copy-new]'); if (!button || button.disabled) return;
      if (button.hasAttribute('data-copy-review')) act(function (adapter) { return adapter.reviewCurrent(); });
      if (button.hasAttribute('data-copy-new')) act(function (adapter) { return adapter.startNew(); });
      if (button.hasAttribute('data-copy-checkout')) act(function (adapter) { return adapter.checkout(); });
      if (button.hasAttribute('data-copy-resume')) act(function (adapter) { return adapter.recover(); });
      if (button.hasAttribute('data-copy-edit')) act(function (adapter) { adapter.editCurrent(); return adapter.load(); });
      if (button.hasAttribute('data-copy-history-id')) act(function (adapter) { return adapter.resume(button.getAttribute('data-copy-history-id')); });
      if (button.hasAttribute('data-copy-remove')) act(function (adapter) { var view = adapter.view(); return adapter.update(view.cart.lines.filter(function (line) { return line.numgen !== button.getAttribute('data-copy-remove'); })); });
    });
    panel.addEventListener('change', function (event) {
      if (!event.target.hasAttribute('data-copy-numgen')) return;
      var value = Number(event.target.value);
      if (!Number.isInteger(value) || value < 1 || value > 10) { status.textContent = copyCartText(root, 'copyQuantityLimit'); renderAuthoritativeCopyCart(root); return; }
      act(function (adapter) { var view = adapter.view(); return adapter.update(view.cart.lines.map(function (line) { return { numgen: line.numgen, quantity: line.numgen === event.target.getAttribute('data-copy-numgen') ? value : line.quantity }; })); });
    });
    if (copyCartEnabled(root)) act(function (adapter) { return adapter.recover(); });
    else { status.textContent = copyCartText(root, 'copyDisabled'); renderAuthoritativeCopyCart(root); }
  }

  function submitAuthoritativeCopyCreation(root, selection) {
    bindAuthoritativeCopyCart(root);
    if (!root._copyCartAct) return Promise.reject(approvedCompositionFailure('COPY_DISABLED'));
    return root._copyCartAct(async function (adapter) {
      var journey = getLocalJourney(root), revision = root._approvedCompositionRevision, captured = selection || readApprovedCompositionSelection(root);
      if ((selection ? selection.quantity : journey.quantity) > 10) throw approvedCompositionFailure('COPY_LEGACY_QUANTITY');
      if (!selection) {
        var images = qsa(qs(root, '[data-sticker-preview]'), '[data-sticker-approved-avatar-preview], [data-proof-avatar-image]');
        await Promise.all(images.map(function (image) { return image.decode ? image.decode() : Promise.resolve(); }));
        await Promise.all(Object.values(root._localAlphaPromises || {})); await Promise.resolve(document.fonts && document.fonts.ready);
        if (!selection && revision !== root._approvedCompositionRevision) throw approvedCompositionFailure('APPROVED_SELECTION_CHANGED');
        updatePhoto(root); syncLocalTextBacking(root);
      }
      await adapter.add(captured);
      var status = qs(root, '[data-local-cart-status]'); if (status) status.textContent = copyCartText(root, 'copySaved');
    });
  }

  function localQuantityLimit(root) {
    return root && root.getAttribute('data-product-id') === '10530170274128' ? 10 : 99;
  }

  function createApprovedCompositionCartAdapter(options) {
    var endpoint = 'https://api.dashfoliodata.com/v1/clairatier/approved-compositions';
    var sessionEndpoint = 'https://api.dashfoliodata.com/v1/clairatier/sessions';
    var session = null, record = null, inFlight = null;
    function transport(url, method, body, token, sameOrigin) {
      var headers = { Accept: 'application/json' }, init = { method: method, credentials: sameOrigin ? 'same-origin' : 'omit', headers: headers };
      if (body !== undefined) { headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(body); }
      if (token) headers.Authorization = 'Bearer ' + token;
      return Promise.resolve().then(function () { return options.fetch(url, init); }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw approvedCompositionFailure('APPROVED_REQUEST_FAILED', response.status);
          return data;
        }).catch(function (error) { if (error && error.code) throw error; throw approvedCompositionFailure('APPROVED_RESPONSE_INVALID', response.status); });
      });
    }
    function sessionValid(value) {
      return value && approvedCompositionUuid(value.sessionId) && typeof value.token === 'string' && value.token.length > 0 &&
        typeof value.claimToken === 'string' && value.claimToken.length > 0 && Number.isFinite(Date.parse(value.expiresAt)) &&
        Date.parse(value.expiresAt) > options.now() + 60000 && Number.isFinite(Date.parse(value.claimExpiresAt)) &&
        Date.parse(value.claimExpiresAt) > options.now() + 300000;
    }
    function getSession(refresh) {
      if (!session && options.readSession) session = options.readSession(sessionEndpoint);
      if (!refresh && sessionValid(session)) return Promise.resolve(session);
      var old = session, hasClaim = old && Date.parse(old.claimExpiresAt) > options.now() + 300000 && old.claimToken;
      if (old && !hasClaim) throw approvedCompositionFailure('APPROVED_SESSION_EXPIRED');
      return transport(hasClaim ? sessionEndpoint + '/refresh' : sessionEndpoint, 'POST', hasClaim ? { claimToken: old.claimToken } : undefined).then(function (value) {
        if (!sessionValid(value) || old && value.sessionId !== old.sessionId) throw approvedCompositionFailure('APPROVED_SESSION_INVALID');
        session = value;
        if (options.writeSession) options.writeSession(sessionEndpoint, value);
        if (options.onSession) options.onSession(value.sessionId);
        return session;
      });
    }
    function cartMatch(cart, current) {
      if (!cart || !Array.isArray(cart.items)) throw approvedCompositionFailure('APPROVED_CART_INVALID');
      var matches = cart.items.filter(function (item) { return item.properties && item.properties.numgen === current.result.id; });
      if (!matches.length) return null;
      if (matches.length !== 1 || String(matches[0].variant_id) !== current.result.product.variantId ||
          String(matches[0].product_id) !== current.result.product.id || matches[0].quantity !== current.selection.quantity ||
          matches[0].properties['_ID génération'] !== current.result.id) throw approvedCompositionFailure('APPROVED_CART_MISMATCH');
      return matches[0];
    }
    function cartSessionCompatible(cart, current) {
      if (!cart || !Array.isArray(cart.items) || !cart.attributes || typeof cart.attributes !== 'object') throw approvedCompositionFailure('APPROVED_CART_INVALID');
      var claim = cart.attributes.__clairatier_session_claim;
      if (claim && claim !== session.claimToken) throw approvedCompositionFailure('APPROVED_CART_SESSION_MISMATCH');
      if (current.result) cartMatch(cart, current);
      cart.items.forEach(function (item) {
        var properties = item.properties || {}, id = properties.numgen;
        var privateId = properties['_ID génération'] || properties['_ID génération Clairatier'] || properties._clairatier_generation_id;
        if (id || privateId || String(item.product_id) === current.selection.composition.product.id) {
          if (!current.result || id !== current.result.id || properties['_ID génération'] !== current.result.id) throw approvedCompositionFailure('APPROVED_CART_SESSION_MISMATCH');
        }
      });
    }
    function add() {
      if (!options.enabled()) return Promise.reject(approvedCompositionFailure('APPROVED_CART_DISABLED'));
      var selection;
      try { selection = validateApprovedCompositionSelection(options.readSelection()); }
      catch (error) { return Promise.reject(error); }
      var fingerprint = approvedCompositionFingerprint(selection), revision = options.revision();
      if (inFlight) return inFlight;
      if (!record || record.fingerprint !== fingerprint) {
        var requestId = options.uuid();
        if (!approvedCompositionUuid(requestId)) return Promise.reject(approvedCompositionFailure('APPROVED_REQUEST_ID_INVALID'));
        record = { fingerprint: fingerprint, requestId: requestId, selection: selection, result: null, sessionId: null, cartAttempted: false };
      }
      var current = record;
      function unchanged() {
        if (!options.enabled() || options.revision() !== revision || approvedCompositionFingerprint(validateApprovedCompositionSelection(options.readSelection())) !== fingerprint) {
          if (record === current && !current.cartAttempted) record = null;
          throw approvedCompositionFailure('APPROVED_SELECTION_CHANGED');
        }
      }
      inFlight = Promise.resolve().then(function () { unchanged(); return getSession(false); }).then(function (value) {
        unchanged();
        if (current.sessionId && current.sessionId !== value.sessionId) throw approvedCompositionFailure('APPROVED_SESSION_CHANGED');
        current.sessionId = value.sessionId;
        if (options.onSession) options.onSession(value.sessionId);
        return transport(options.cartUrl('cart.js'), 'GET', undefined, null, true).then(function (cart) {
          unchanged(); cartSessionCompatible(cart, current);
        if (current.result) return current.result;
        var body = Object.assign({ requestId: current.requestId }, selection.composition);
        function compose(token) { return transport(endpoint, 'POST', body, token); }
        return compose(value.token).catch(function (error) {
          if (error.status !== 401) throw error;
          return getSession(true).then(function (fresh) { unchanged(); return compose(fresh.token); });
        }).then(function (result) {
          unchanged(); current.result = validateApprovedCompositionResult(result, selection.composition.product);
          if (options.onResult) options.onResult(current.result.id);
          return current.result;
        });
        });
      }).then(function () {
        unchanged();
        return transport(options.cartUrl('cart.js'), 'GET', undefined, null, true);
      }).then(function (cart) {
        unchanged(); cartSessionCompatible(cart, current);
        // Private claim only in the existing cart attribute, never a line property.
        return transport(options.cartUrl('cart/update.js'), 'POST', { attributes: { '__clairatier_session_claim': session.claimToken } }, null, true);
      }).then(function () {
        unchanged(); return transport(options.cartUrl('cart.js'), 'GET', undefined, null, true);
      }).then(function (cart) {
        unchanged(); var found = cartMatch(cart, current);
        if (found) return found;
        // An interrupted add may have reached Shopify. Reconcile, never blindly repeat it.
        if (current.cartAttempted) throw approvedCompositionFailure('APPROVED_CART_OUTCOME_UNKNOWN');
        current.cartAttempted = true;
        return transport(options.cartUrl('cart/add.js'), 'POST', { items: [{ id: current.result.product.variantId,
          quantity: selection.quantity, properties: { numgen: current.result.id, '_ID génération': current.result.id } }] }, null, true).catch(function (error) {
          if (error.status >= 400 && error.status < 500) current.cartAttempted = false;
          throw error;
        }).then(function () { return transport(options.cartUrl('cart.js'), 'GET', undefined, null, true); }).then(function (after) {
          var item = cartMatch(after, current);
          if (!item) throw approvedCompositionFailure('APPROVED_CART_OUTCOME_UNKNOWN');
          return item;
        });
      }).finally(function () { inFlight = null; });
      return inFlight;
    }
    return { add: add };
  }

  function approvedCompositionCartEnabled(root) {
    return !!root && root.getAttribute('data-approved-composition-cart-enabled') === 'true' && localJourneyEnabled(root);
  }

  function readApprovedCompositionSelection(root) {
    var state = root._stickerState, preview = qs(root, '[data-sticker-preview]'), color = getMiaSelected(root, 'color');
    if (!(approvedCompositionCartEnabled(root) || copyCartEnabled(root)) || !state || state.subjectSource !== 'approved-avatar' || root._proofLayoutUnavailable ||
        !color || color.value !== 'original' || state.selectedBackgroundId !== 'background-none-white' || state.symbol && state.symbolChoice !== 'no') throw approvedCompositionFailure('APPROVED_SELECTION_UNSUPPORTED');
    // Runtime sync uses "mixed"; eligibility follows the actual active/saved color choice.
    var slots = state.proofAvatars && state.proofAvatars.length > 1 ? state.proofAvatars.slice() : [{ state: state, choices: { color: color.value } }];
    if (slots.length > 1) slots[state.proofActiveAvatar || 0] = { state: state, choices: { color: color.value } };
    var frames = slots.length > 1 ? qsa(preview, '[data-proof-avatar-index]').sort(function (a, b) {
      return Number(a.getAttribute('data-proof-avatar-index')) - Number(b.getAttribute('data-proof-avatar-index'));
    }) : [qs(preview, '[data-sticker-photo-frame]')];
    if (frames.length !== slots.length) throw approvedCompositionFailure('APPROVED_GEOMETRY_UNAVAILABLE');
    var models = slots.map(function (slot, index) {
      var entry = getCastCustomizationEntry(root, slot.state), frame = frames[index];
      var image = frame && qs(frame, '[data-sticker-approved-avatar-preview], [data-proof-avatar-image]');
      var alpha = image && root._localAlphaCache && root._localAlphaCache[image.currentSrc || image.getAttribute('src')];
      if (!entry || !frame || frame.style.display === 'none' || !image || image.hidden || !image.complete || !(image.naturalWidth > 0) ||
          !alpha || alpha.transparent !== true || !alpha.bounds ||
          !slot.choices || slot.choices.color !== 'original' || slot.state.wardrobePaletteEdited === true || slot.state.wardrobePaletteMode === 'custom') throw approvedCompositionFailure('APPROVED_SELECTION_UNSUPPORTED');
      var filename;
      try { filename = new URL(image.currentSrc || image.getAttribute('src'), window.location.href).pathname.split('/').pop(); }
      catch (error) { throw approvedCompositionFailure('APPROVED_SELECTION_UNSUPPORTED'); }
      if (filename !== entry.asset) throw approvedCompositionFailure('APPROVED_SELECTION_UNSUPPORTED');
      if (slots.length > 1 && Number(frame.getAttribute('data-proof-avatar-index')) !== index) throw approvedCompositionFailure('APPROVED_GEOMETRY_UNAVAILABLE');
      var width = frame.style.width, height = frame.style.height, left = frame.style.left, top = frame.style.top;
      if (![width, height, left, top].every(function (value) { return typeof value === 'string' && /^\d+(?:\.\d+)?%$/.test(value); }) || width !== height) throw approvedCompositionFailure('APPROVED_GEOMETRY_UNAVAILABLE');
      var fade = frame._stickerAvatarBottomFade;
      return { characterId: entry.characterId, category: entry.category, variant: entry.variant,
        centerX: parseFloat(left) * 10, centerY: parseFloat(top) * 10, diameter: parseFloat(width) * 10,
        bottomFade: fade ? { start: fade.start, end: fade.end } : null };
    });
    return validateApprovedCompositionSelection({ quantity: getLocalJourney(root).quantity, composition: {
      contractVersion: 'approved-composition/1', product: { id: root.getAttribute('data-product-id'), handle: root.getAttribute('data-product-handle'), variantId: String(getSelectedVariantId(root)) },
      models: models, text: { top: getTextValue(root, 'top'), bottom: getTextValue(root, 'bottom'), topEnabled: !hasNoTextChoice(root, 'top'), bottomEnabled: !hasNoTextChoice(root, 'bottom'),
        topSize: state.topSize, bottomSize: state.bottomSize, color: normalizeTextColor(state.textColor) },
      background: { id: null, scale: 1, x: 0, y: 0, fadeId: null }, whiteBacking: Object.assign({}, getLocalWhiteBacking(root)), productProfileVersion: 'owner-round-140mm-repository-v1'
    } });
  }

  function submitApprovedCompositionCart(root) {
    if (copyCartEnabled(root)) return submitAuthoritativeCopyCreation(root);
    var journey = getLocalJourney(root);
    if (!approvedCompositionCartEnabled(root) || journey.cartBusy || !window.fetch || !window.crypto || !window.crypto.randomUUID) return;
    if (!root._approvedCompositionAdapter) {
      root._approvedCompositionRevision = 0;
      var revise = function () { root._approvedCompositionRevision += 1; };
      root.addEventListener('input', revise); root.addEventListener('change', revise);
      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-local-choice], [data-local-proof-slot], [data-local-adjust], [data-local-halo], [data-local-text-color-preset], [data-local-text-size-step], [data-local-action="new"], [data-local-action="reset-all"]')) revise();
      }, true);
      root._approvedCompositionAdapter = createApprovedCompositionCartAdapter({
        enabled: function () { return approvedCompositionCartEnabled(root); }, readSelection: function () { return readApprovedCompositionSelection(root); },
        revision: function () { return root._approvedCompositionRevision; }, now: Date.now, uuid: function () { return window.crypto.randomUUID(); },
        fetch: function (url, options) { return window.fetch(url, options); }, cartUrl: getCartUrl,
        readSession: readGenerationSession, writeSession: writeGenerationSession,
        onSession: function (id) { root.setAttribute('data-approved-composition-session-id', id); },
        onResult: function (id) {
          var status = qs(root, '[data-local-cart-status]');
          if (status) status.textContent = id;
        }
      });
    }
    journey.cartBusy = true; renderLocalReview(root);
    var revision = root._approvedCompositionRevision, preview = qs(root, '[data-sticker-preview]');
    var images = qsa(preview, '[data-sticker-approved-avatar-preview], [data-proof-avatar-image]');
    var request = Promise.all(images.map(function (image) { return typeof image.decode === 'function' ? image.decode() : Promise.resolve(); }))
      .then(function () { return Promise.all(Object.values(root._localAlphaPromises || {})); })
      .then(function () { return Promise.resolve(document.fonts && document.fonts.ready); })
      .then(function () {
        if (revision !== root._approvedCompositionRevision) throw approvedCompositionFailure('APPROVED_SELECTION_CHANGED');
        updatePhoto(root); syncLocalTextBacking(root);
        return root._approvedCompositionAdapter.add();
      }).then(function (item) {
        runThemeCartAction(item);
        qs(root, '[data-local-cart-status]').textContent = translate(root, 'generationAdded', { label: item.properties.numgen });
      }).catch(function () {
        // Existing localized text only; never expose server payloads/tokens/URLs.
        qs(root, '[data-local-cart-status]').textContent = localCopy(root, 'cartBlocked');
      }).finally(function () { journey.cartBusy = false; renderLocalReview(root); });
    return request;
  }

  function queueApprovedCompositionReviewRefresh(root) {
    var images = qsa(qs(root, '[data-sticker-preview]'), '[data-sticker-approved-avatar-preview], [data-proof-avatar-image]');
    var key = images.map(function (image) { return image.currentSrc || image.getAttribute('src') || ''; }).join('|');
    if (!key || root._approvedReviewRefreshKey === key) return;
    root._approvedReviewRefreshKey = key;
    Promise.all(Object.values(root._localAlphaPromises || {})).then(function () { return Promise.resolve(document.fonts && document.fonts.ready); })
      .then(function () { if ((approvedCompositionCartEnabled(root) || copyCartEnabled(root)) && root._stickerState) renderLocalReview(root); }).catch(function () {});
  }

  function approvedCompositionNativeFormOwned(root, form) {
    if (!root || root.getAttribute('data-product-id') !== '10530170274128' || root.getAttribute('data-product-handle') !== PRIVATE_PILOT_PRODUCT_HANDLE || !form) return false;
    if (form === getForm(root)) return true;
    var section = root.closest('[id^="shopify-section-"]'), product = form.closest('[data-product-handle]');
    return !!section && section.contains(form) && !!product && product.getAttribute('data-product-handle') === PRIVATE_PILOT_PRODUCT_HANDLE;
  }

  function bindApprovedCompositionNativeCartGuard(root) {
    if (root._approvedNativeCartGuard || !approvedCompositionNativeFormOwned(root, getForm(root))) return;
    root._approvedNativeCartGuard = true;
    var section = root.closest('[id^="shopify-section-"]') || getForm(root);
    function routeToReview(event) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!root._stickerState) return;
      open(root);
      var journey = getLocalJourney(root);
      if (journey.completed.length === LOCAL_JOURNEY_STEPS.length) journey.review = true;
      if (localJourneyEnabled(root)) renderLocalJourney(root);
      var status = qs(root, '[data-local-cart-status]');
      if (status) status.textContent = localCopy(root, 'cartBlocked');
    }
    document.addEventListener('submit', function (event) {
      if (approvedCompositionNativeFormOwned(root, event.target)) routeToReview(event);
    }, true);
    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest && event.target.closest('button[name="add"], input[type="submit"], button[type="submit"], .shopify-payment-button, shopify-accelerated-checkout');
      if (button && approvedCompositionNativeFormOwned(root, button.form || button.closest('form'))) routeToReview(event);
    }, true);
    function hideExpress() {
      qsa(section, '.shopify-payment-button, .shopify-payment-btn-wrap, shopify-accelerated-checkout').forEach(function (element) {
        if (!approvedCompositionNativeFormOwned(root, element.closest('form'))) return;
        element.hidden = true; element.setAttribute('aria-hidden', 'true'); element.style.setProperty('display', 'none', 'important');
      });
    }
    hideExpress();
    if (window.MutationObserver) {
      root._approvedExpressObserver = new window.MutationObserver(hideExpress);
      root._approvedExpressObserver.observe(section, { childList: true, subtree: true });
    }
  }



  // Render the live SVG, not an estimated server-side text layout. Only PNGs
  // travel to the private proof endpoint; no executable SVG or external URL.
  function multiAvatarStateKeys() {
    return ['approvedAvatarId', 'approvedAvatarManifestId', 'style', 'subjectSource', 'presentationMode', 'appearanceMode', 'selectedAccessoryId', 'approvedAvatarHairstyleId', 'approvedAvatarGarmentId', 'tryonGarment', 'tryonColor', 'requestedPrimaryColor', 'requestedSecondaryColor', 'requestedAccentColor', 'requestedFinishColor', 'wardrobeFamily', 'wardrobeAudience', 'wardrobeStage', 'wardrobePaletteMode', 'wardrobePaletteEdited', 'wardrobePaletteValidated', 'wardrobeCustomColors', 'approvedAvatarPaletteSource', 'approvedAvatarFinishId', 'photoScale', 'photoX', 'photoY'];
  }

  function normalizeAvatarBottomFade(value) {
    return typeof value === 'number' && Number.isFinite(value) ? Math.max(0, Math.min(24, Math.round(value))) : 0;
  }

  function setLocalAvatarBottomFade(root, value) {
    if (typeof value !== 'string' || !/^\d{1,2}$/.test(value)) return false;
    root._stickerState.avatarBottomFade = normalizeAvatarBottomFade(Number(value));
    updatePhoto(root);
    updateConfig(root);
    var selected = root._stickerState.avatarBottomFade;
    qsa(root, '[data-local-avatar-fade-input]').forEach(function (input) { input.value = String(selected); input.setAttribute('aria-valuetext', localCopy(root, selected ? 'avatarFadeValue' : 'avatarFadeOff', { value: selected })); });
    qsa(root, '[data-local-avatar-fade-value]').forEach(function (output) { output.textContent = localCopy(root, selected ? 'avatarFadeValue' : 'avatarFadeOff', { value: selected }); });
    qsa(root, '[data-local-choices] [data-local-choice]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.getAttribute('data-local-choice') === String(selected))); });
    persistLocalSession(root);
    return true;
  }

  function renderLocalAvatarFadeControls(root, container) {
    var value = normalizeAvatarBottomFade(root._stickerState.avatarBottomFade);
    var group = document.createElement('fieldset'); group.className = 'sticker-customizer__avatar-fade-controls';
    var legend = document.createElement('legend'); legend.textContent = localCopy(root, 'avatarFade'); group.appendChild(legend);
    [[0, 'avatarFadeOff'], [6, 'avatarFadeLight'], [12, 'avatarFadeSoft'], [24, 'avatarFadeStrong']].forEach(function (preset) {
      localChoiceButton(root, group, localCopy(root, preset[1]), String(preset[0]), value === preset[0]);
    });
    var label = document.createElement('label'); label.textContent = localCopy(root, 'avatarFadeExtent');
    var input = document.createElement('input'); input.type = 'range'; input.min = '0'; input.max = '24'; input.step = '1'; input.value = String(value);
    input.setAttribute('data-local-avatar-fade-input', '');
    input.setAttribute('aria-valuetext', localCopy(root, value ? 'avatarFadeValue' : 'avatarFadeOff', { value: value }));
    var output = document.createElement('output'); output.setAttribute('data-local-avatar-fade-value', ''); output.textContent = localCopy(root, value ? 'avatarFadeValue' : 'avatarFadeOff', { value: value });
    label.appendChild(input); label.appendChild(output); group.appendChild(label); container.appendChild(group);
  }

  function avatarBottomFadeGeometry(frame, avatar, alpha, extent) {
    var amount = normalizeAvatarBottomFade(extent);
    if (!amount) return null;
    var frameHeight = parseFloat(frame.style.height) * 10;
    var imageHeight = frameHeight * parseFloat(avatar.style.height) / 100;
    var centerY = parseFloat(frame.style.top) * 10;
    var bounds = alpha.bounds || { top: 0, bottom: 1 };
    if (![bounds.top, bounds.bottom].every(Number.isFinite) || bounds.top < 0 || bounds.bottom > 1 || bounds.bottom - bounds.top < .1) bounds = { top: 0, bottom: 1 };
    if (![frameHeight, imageHeight, centerY].every(Number.isFinite) || frameHeight <= 0 || imageHeight <= 0) return null;
    var end = centerY + (bounds.bottom - .5) * imageHeight;
    var start = end - Math.min((bounds.bottom - bounds.top) * imageHeight * amount / 100, 156.25);
    // The proof contract rejects sub-unit masks; omit the effect in that case.
    if (end - start < .78125) return null;
    var maskTop = centerY - frameHeight * 1.5;
    return { start: start, end: end, startPercent: (start - maskTop) / (frameHeight * 3) * 100,
      endPercent: (end - maskTop) / (frameHeight * 3) * 100 };
  }

  function applyAvatarBottomFade(frame, avatar, alpha, extent) {
    var fade = avatar && !avatar.hidden && alpha ? avatarBottomFadeGeometry(frame, avatar, alpha, extent) : null;
    frame._stickerAvatarBottomFade = fade;
    frame.toggleAttribute('data-sticker-avatar-bottom-fade', !!fade);
    if (fade) {
      // Sample smoothstep identically to the private PDF alpha mask.
      var stops = ['#000 0%'];
      for (var index = 0; index <= 8; index++) {
        var t = index / 8, opacity = 1 - t * t * (3 - 2 * t);
        stops.push('rgba(0,0,0,' + opacity + ') ' + (fade.startPercent + t * (fade.endPercent - fade.startPercent)) + '%');
      }
      stops.push('transparent 100%');
      frame.style.setProperty('--avatar-bottom-fade-mask', 'linear-gradient(to bottom, ' + stops.join(', ') + ')');
    }
    else frame.style.removeProperty('--avatar-bottom-fade-mask');
  }

  function normalizeMultiAvatarSlots(root, source) {
    if (!Array.isArray(source) || source.length < 1 || source.length > 3) return [];
    var normalized = source.map(function (slot) {
      if (!slot || !slot.choices || typeof slot.asset !== 'string' || slot.asset && !/^[a-z0-9-]+\.webp$/.test(slot.asset)) return null;
      var record = normalizeLocalSession(root, { version: 1, choices: slot.choices, text: { top: '', bottom: '' }, transforms: slot.state, palette: slot.state }, true);
      if (!record || ['signature', 'hero', 'prince-princess'].indexOf(record.choices.style) < 0) return null;
      var state = Object.assign({}, record.transforms, record.palette, {
        approvedAvatarId: record.choices.avatar || 'mia', approvedAvatarManifestId: /^cast-/.test(record.choices.garment || '') ? 'clairatier-cast-preview-v1' : record.choices.avatar === 'clara' ? 'clairatier-clara-signature-knees-v2' : 'clairatier-avatar-pilot-v1',
        style: record.choices.style, subjectSource: 'approved-avatar', presentationMode: record.choices.mode === 'accessories' ? 'standard' : record.choices.mode || 'standard',
        selectedAccessoryId: record.choices.accessory || '', appearanceMode: record.choices.accessory ? 'accessories' : 'standard',
        approvedAvatarHairstyleId: record.choices.hair || '', approvedAvatarGarmentId: record.choices.garment || 'garment-yoke-blouse-dress',
        tryonGarment: record.choices.garment || 'garment-yoke-blouse-dress', tryonColor: record.choices.color || 'original'
      });
      delete state.textColor; delete state.topSize; delete state.bottomSize; delete state.topSizeRequest; delete state.bottomSizeRequest; delete state.backgroundTransform; delete state.avatarBottomFade;
      if (typeof getCastPreviewEntry === 'function' && /^cast-/.test(record.choices.garment || '')) {
        var entry = getCastCustomizationEntry(root, state) || getCastPreviewEntry(root, state.approvedAvatarId, state.style, state.approvedAvatarGarmentId);
        if (!entry || entry.asset !== slot.asset) return null;
      }
      return { asset: slot.asset, choices: Object.fromEntries(Object.entries(record.choices).filter(function (entry) { return ['background', 'fade'].indexOf(entry[0]) < 0; })), state: state };
    }).filter(Boolean);
    return normalized.length === source.length ? normalized : [];
  }

  function snapshotMultiAvatar(root) {
    var state = root._stickerState, choices = {}, saved = {};
    ['avatar', 'style', 'mode', 'accessory', 'hair', 'garment', 'color'].forEach(function (category) { var selected = getMiaSelected(root, category); if (selected) choices[category] = selected.value; });
    choices.style = state.style; choices.mode = /^cast-custom-.*-masks-/.test(state.selectedAccessoryId || '') ? 'accessories' : state.presentationMode || 'standard';
    multiAvatarStateKeys().forEach(function (key) { if (state[key] != null) saved[key] = JSON.parse(JSON.stringify(state[key])); });
    var asset = getMiaExactChoiceAsset(root), basename = '';
    if (asset) { try { basename = new URL(asset, window.location.href).pathname.split('/').pop(); } catch (error) {} }
    return { asset: basename, choices: choices, state: saved };
  }

  function multiAvatarFinishOutset(backing) {
    if (!backing || !backing.enabled || !backing.avatar || backing.style === 'band') return 0;
    return { outline: .021, bold: .037, soft: .061, offset: .050, double: .044,
      // Glow: dilation .012 + three blur sigmas (.014 + .0015), rounded outward.
      fine: .015, cushion: .054, glow: .061, lifted: .055, triple: .055 }[backing.style] || 0;
  }

  function multiAvatarTextEnvelope(root, backing) {
    var envelope = { top: 325, bottom: 705, obstacles: [] }, preview = qs(root, '[data-sticker-preview]');
    var state = root._stickerState || {};
    var textOutset = { outline: .15, bold: .25, soft: .35, offset: .26, double: .29,
      fine: .105, cushion: .33, glow: .62, lifted: .29, triple: .36 };
    ['top', 'bottom', 'brand', 'badge'].forEach(function (position) {
      var selector = position === 'brand' ? '.sticker-customizer__brand-text' : position === 'badge' ? '.sticker-customizer__brand-badge-svg' : '.sticker-customizer__text--' + position;
      var element = qs(preview, selector);
      if (!element || typeof element.getBBox !== 'function' || element.style.display === 'none' || position !== 'badge' && !element.textContent.trim()) return;
      try {
        var box = element.getBBox();
        if (!(box.width > 0 && box.height > 0)) return;
        var size = position === 'brand' ? 29 : position === 'badge' ? 15 : Number(state[position === 'top' ? 'topSize' : 'bottomSize']) || 100;
        var active = backing.enabled && backing[position === 'top' || position === 'bottom' ? position + 'Text' : position];
        var padding = active && backing.style && backing.style !== 'band' ? (textOutset[backing.style] || 0) * size : 0;
        function obstacle(bounds, outset) {
          if (bounds.width > 0 && bounds.height > 0) envelope.obstacles.push({ x: bounds.x - outset, right: bounds.x + bounds.width + outset,
            near: position === 'top' ? bounds.y + bounds.height + outset : bounds.y - outset, top: position === 'top' });
        }
        var glyphs = [];
        try {
          var count = typeof element.getNumberOfChars === 'function' && typeof element.getExtentOfChar === 'function' ? element.getNumberOfChars() : 0;
          for (var character = 0; character < count; character++) glyphs.push(element.getExtentOfChar(character));
        } catch (error) { glyphs = []; }
        var ink = null;
        // SVG character extents include the rotated font cell, including empty space.
        // Measure ink instead, but retain conservative extents for unsupported shaping.
        if ((position === 'top' || position === 'bottom') && glyphs.length) {
          try {
            var textNode = qs(element, 'textPath') || element, text = textNode.textContent;
            var font = getComputedStyle(textNode);
            var canvas = document.createElement('canvas'), context = canvas.getContext('2d');
            if (context && /^[\u0020-\u00ff]+$/.test(text) && !/(ff|fi|fl)/i.test(text) && text.length === glyphs.length &&
                (!document.fonts || document.fonts.status === 'loaded') &&
                (!font.fontStretch || font.fontStretch === 'normal' || font.fontStretch === '100%') &&
                (!font.writingMode || font.writingMode === 'horizontal-tb') &&
                !element.hasAttribute('textLength') && !textNode.hasAttribute('textLength')) {
              context.font = [font.fontStyle || 'normal', font.fontWeight || 'normal', font.fontSize, font.fontFamily].join(' ');
              ink = [];
              // Only measured ink uses dilation .08 + three blur sigmas (.08 + .01).
              // Unsupported fonts/shaping retain the original conservative clearance.
              var inkPadding = active && backing.style === 'glow' ? .35 * size : padding;
              for (var characterIndex = 0; characterIndex < text.length; characterIndex++) {
                var measured = context.measureText(text[characterIndex]);
                var values = [measured.actualBoundingBoxLeft, measured.actualBoundingBoxRight,
                  measured.actualBoundingBoxAscent, measured.actualBoundingBoxDescent];
                if (!values.every(Number.isFinite)) throw new Error('Unavailable ink metrics');
                if (!(values[0] + values[1] > 0 && values[2] + values[3] > 0)) continue;
                var origin = element.getStartPositionOfChar(characterIndex), angle = element.getRotationOfChar(characterIndex) * Math.PI / 180;
                if (![origin.x, origin.y, angle].every(Number.isFinite)) throw new Error('Unavailable glyph position');
                var cos = Math.cos(angle), sin = Math.sin(angle);
                var corners = [[-values[0] - inkPadding, -values[2] - inkPadding], [values[1] + inkPadding, -values[2] - inkPadding],
                  [values[1] + inkPadding, values[3] + inkPadding], [-values[0] - inkPadding, values[3] + inkPadding]].map(function (point) {
                    return { x: origin.x + point[0] * cos - point[1] * sin, y: origin.y + point[0] * sin + point[1] * cos };
                  });
                ink.push({ x: Math.min.apply(Math, corners.map(function (point) { return point.x; })),
                  right: Math.max.apply(Math, corners.map(function (point) { return point.x; })),
                  near: (position === 'top' ? Math.max : Math.min).apply(Math, corners.map(function (point) { return point.y; })),
                  top: position === 'top', points: corners });
              }
            }
          } catch (error) { ink = null; }
        }
        if (ink && ink.length) envelope.obstacles.push.apply(envelope.obstacles, ink);
        else if (glyphs.length) glyphs.forEach(function (glyph) { obstacle(glyph, padding); });
        else obstacle(box, padding);
        var halo = qs(preview, position === 'badge' ? '[data-local-badge-halo]' : '[data-local-text-halo="' + position + '"]');
        if (halo && halo.style.display !== 'none' && typeof halo.getBBox === 'function') {
          var haloBox = halo.getBBox(), stroke = (parseFloat(halo.style.strokeWidth) || 0) / 2;
          var points = [];
          if (typeof halo.getTotalLength === 'function' && typeof halo.getPointAtLength === 'function') {
            try {
              var length = halo.getTotalLength(), steps = Math.max(1, Math.ceil(length / 2));
              for (var step = 0; step <= steps; step++) points.push(halo.getPointAtLength(length * step / steps));
            } catch (error) { points = []; }
          }
          if (points.length) points.forEach(function (point) {
            var extent = stroke + 2;
            obstacle({ x: point.x - extent, y: point.y - extent, width: extent * 2, height: extent * 2 }, 0);
          });
          else obstacle(haloBox, stroke);
        }
      } catch (error) {}
    });
    return envelope;
  }

  function multiAvatarObstacleNear(obstacle, left, right) {
    if (!obstacle.points) return obstacle.near;
    var points = obstacle.points;
    [left, right].forEach(function (edge, index) {
      var clipped = [];
      points.forEach(function (point, pointIndex) {
        var previous = points[(pointIndex + points.length - 1) % points.length];
        var inside = index === 0 ? point.x >= edge : point.x <= edge;
        var previousInside = index === 0 ? previous.x >= edge : previous.x <= edge;
        if (inside !== previousInside) {
          var fraction = (edge - previous.x) / (point.x - previous.x);
          clipped.push({ x: edge, y: previous.y + fraction * (point.y - previous.y) });
        }
        if (inside) clipped.push(point);
      });
      points = clipped;
    });
    if (!points.length) return null;
    return (obstacle.top ? Math.max : Math.min).apply(Math, points.map(function (point) { return point.y; }));
  }

  function multiAvatarLayout(slots, backing, envelope) {
    var gap = 12, minimumGap = 4, rowWidth = 580;
    envelope = envelope || { top: 325, bottom: 705 };
    if (!slots.length || !Number.isFinite(envelope.top) || !Number.isFinite(envelope.bottom) || envelope.bottom <= envelope.top) return null;
    var groupScale = Math.min.apply(Math, slots.map(function (slot) { return clamp(Number(slot.state.photoScale) || 1, .75, 1.2); }));
    var targetHeight = (slots.length === 2 ? 250 : 190) * groupScale;
    var preferredBaseline = (slots.length === 2 ? 610 : 590) + slots.reduce(function (sum, slot) { return sum + clamp(Number(slot.state.photoY) || 0, -48, 48) * .4; }, 0) / slots.length;
    var metrics = slots.map(function (slot) {
      var alpha = slot.alpha || { transparent: false, radius: Math.SQRT1_2 };
      var bounds = alpha.bounds || { left: 0, right: 1, top: 0, bottom: 1 };
      var validBounds = [bounds.left, bounds.right, bounds.top, bounds.bottom].every(Number.isFinite) && bounds.left >= 0 && bounds.right <= 1 && bounds.top >= 0 && bounds.bottom <= 1 && bounds.right > bounds.left && bounds.bottom - bounds.top >= .1;
      if (!validBounds) bounds = { left: 0, right: 1, top: 0, bottom: 1 };
      var content = backing.style ? localWhiteContentRatio(alpha.radius, backing) : 1;
      var diameter = targetHeight / (content * (bounds.bottom - bounds.top));
      var width = diameter * content;
      var effect = alpha.transparent ? multiAvatarFinishOutset(backing) * width : 0;
      var left = (bounds.left - .5) * width - effect, right = (bounds.right - .5) * width + effect;
      var sourceBottom = (bounds.bottom - .5) * width;
      var top = -targetHeight - effect, bottom = effect;
      if (backing.enabled && backing.avatar && (!backing.style || backing.style === 'band')) {
        left = Math.min(left, -diameter / 2); right = Math.max(right, diameter / 2);
        top = Math.min(top, -diameter / 2 - sourceBottom); bottom = Math.max(bottom, diameter / 2 - sourceBottom);
      }
      var rows = validBounds && alpha.transparent && Array.isArray(alpha.rows) && alpha.rows.length > 0 && alpha.rows.length <= 24 &&
        !(backing.enabled && backing.avatar && (!backing.style || backing.style === 'band')) && alpha.rows.every(function (row) {
          return row && [row.left, row.right, row.top, row.bottom].every(Number.isFinite) &&
            row.left >= bounds.left && row.right <= bounds.right && row.top >= bounds.top && row.bottom <= bounds.bottom &&
            row.right > row.left && row.bottom > row.top;
        }) && Math.min.apply(Math, alpha.rows.map(function (row) { return row.left; })) === bounds.left &&
        Math.max.apply(Math, alpha.rows.map(function (row) { return row.right; })) === bounds.right &&
        Math.min.apply(Math, alpha.rows.map(function (row) { return row.top; })) === bounds.top &&
        Math.max.apply(Math, alpha.rows.map(function (row) { return row.bottom; })) === bounds.bottom ? alpha.rows.map(function (row) {
          return { left: (row.left - .5) * width - effect, right: (row.right - .5) * width + effect,
            top: (row.top - bounds.bottom) * width - effect, bottom: (row.bottom - bounds.bottom) * width + effect };
        }) : null;
      return { diameter: diameter, imageWidth: width, left: left, right: right, top: top, bottom: bottom, sourceBottom: sourceBottom, rows: rows };
    });
    var width = metrics.reduce(function (total, metric) { return total + metric.right - metric.left; }, 0);
    var maximumFit = Math.min(1, (rowWidth - gap * (slots.length - 1)) / Math.max(1, width));
    metrics.forEach(function (metric) { maximumFit = Math.min(maximumFit, 1000 / metric.imageWidth); });
    function candidate(fit) {
      var totalWidth = width * fit + gap * (slots.length - 1), cursor = 500 - totalWidth / 2;
      var minimumY = -Infinity, maximumY = Infinity;
      var layout = metrics.map(function (metric, index) {
        var shift = clamp(clamp(Number(slots[index].state.photoX) || 0, -48, 48) * .4, -(gap - minimumGap) / 2, (gap - minimumGap) / 2);
        var left = cursor + shift, right = left + (metric.right - metric.left) * fit, top = envelope.top, bottom = envelope.bottom;
        var imageCenter = (left + right) / 2 - (metric.left + metric.right) * fit / 2;
        var rows = metric.rows || [{ left: metric.left, right: metric.right, top: metric.top, bottom: metric.bottom }];
        rows.forEach(function (row) {
          var rowLeft = imageCenter + row.left * fit, rowRight = imageCenter + row.right * fit;
          (envelope.obstacles || []).forEach(function (obstacle) {
            if (obstacle.right + 12 <= rowLeft || obstacle.x - 12 >= rowRight) return;
            var near = obstacle.points ? multiAvatarObstacleNear(obstacle, rowLeft - 12, rowRight + 12) : obstacle.near;
            if (near === null) return;
            if (obstacle.top) minimumY = Math.max(minimumY, near + 12 - row.top * fit);
            else maximumY = Math.min(maximumY, near - 12 - row.bottom * fit);
          });
        });
        minimumY = Math.max(minimumY, top - metric.top * fit);
        maximumY = Math.min(maximumY, bottom - metric.bottom * fit);
        var middle = (left + right) / 2;
        var geometry = { diameter: metric.diameter * fit, centerX: middle - (metric.left + metric.right) * fit / 2,
          visibleLeft: left, visibleRight: right };
        cursor += (metric.right - metric.left) * fit + gap;
        return geometry;
      });
      if (maximumY < minimumY) return null;
      var baseline = clamp(preferredBaseline, minimumY, maximumY);
      layout.forEach(function (geometry, index) { geometry.centerY = baseline - metrics[index].sourceBottom * fit;
        geometry.visualTop = baseline - targetHeight * fit; geometry.visualBottom = baseline;
        geometry.visibleTop = baseline + metrics[index].top * fit;
        geometry.visibleBottom = baseline + metrics[index].bottom * fit;
      });
      return layout;
    }
    for (var step = 0; step < 100; step++) {
      var layout = candidate(maximumFit * (1 - step / 100));
      if (layout) return layout;
    }
    return null;
  }

  function multiAvatarGeometry(count, index, state) {
    return multiAvatarLayout(Array.from({ length: count }, function (_entry, slot) { return { state: slot === index ? state : {} }; }), { enabled: false, avatar: false })[index];
  }

  function syncMultiAvatarPreview(root) {
    var state = root && root._stickerState;
    if (!state || root._proofSwitching) return;
    var preview = qs(root, '[data-sticker-preview]');
    if (!preview) return;
    var slots = state.proofAvatars || [], frame = qs(preview, '[data-sticker-photo-frame]');
    root._proofLayoutUnavailable = false;
    if (frame) frame.style.display = '';
    if (frame) {
      var singleImage = qs(preview, '[data-sticker-approved-avatar-preview]');
      applyAvatarBottomFade(frame, state.subjectSource === 'approved-avatar' ? singleImage : null, singleImage && localImageAlpha(root, singleImage), state.avatarBottomFade);
    }
    qsa(preview, '[data-proof-avatar-frame]').forEach(function (element) { element.remove(); });
    if (slots.length <= 1 || state.subjectSource !== 'approved-avatar' || !frame) return;
    var active = Math.min(slots.length - 1, state.proofActiveAvatar || 0);
    slots[active] = snapshotMultiAvatar(root);
    var live = qs(root, '[data-sticker-approved-avatar-preview]');
    var backing = getLocalWhiteBacking(root);
    var prepared = slots.map(function (slot, index) {
      var target = index === active ? frame : frame.cloneNode(false);
      var image = index === active ? live : live.cloneNode(false);
      if (index !== active) {
        target.removeAttribute('data-sticker-photo-frame'); target.setAttribute('data-proof-avatar-frame', String(index));
        image.removeAttribute('data-sticker-approved-avatar-preview'); image.setAttribute('data-proof-avatar-image', '');
        image.src = miaAssetUrl(root, slot.asset); image.hidden = !slot.asset;
        image.alt = typeof getApprovedAvatarDescription === 'function' ? getApprovedAvatarDescription(root, slot.state) : '';
        target.appendChild(image);
      }
      return { slot: slot, index: index, target: target, image: image, alpha: localImageAlpha(root, image) };
    });
    var layout = state.sunEnabled === true ? prepared.map(function (item, index) { return eclatAvatarGeometry(prepared.length, index, item.slot.state, item.alpha, backing); }) : multiAvatarLayout(prepared.map(function (item) { return { state: item.slot.state, alpha: item.alpha }; }), backing, multiAvatarTextEnvelope(root, backing));
    root._proofLayoutUnavailable = !layout;
    prepared.forEach(function (item) {
      item.target.style.display = layout ? '' : 'none';
      if (!layout) return;
      var target = item.target, image = item.image, index = item.index, geometry = layout[index];
      target.style.width = geometry.diameter / 10 + '%'; target.style.height = geometry.diameter / 10 + '%';
      target.style.left = geometry.centerX / 10 + '%'; target.style.top = geometry.centerY / 10 + '%';
      target.setAttribute('data-proof-avatar-index', String(index));
      var alpha = item.alpha;
      var content = state.sunEnabled === true ? 100 : backing.style ? localWhiteContentRatio(alpha.radius, backing) * 100 : 100;
      image.style.width = content + '%'; image.style.height = content + '%';
      image.style.filter = backing.enabled && backing.avatar && backing.style !== 'band' && alpha.transparent ? localWhiteFilter(root, backing.style, 'avatar', 1) : '';
      applyAvatarBottomFade(target, image, alpha, state.avatarBottomFade);
      if (index !== active) frame.parentNode.insertBefore(target, qs(root, '.sticker-customizer__text-layer'));
    });
    // Stable document order is the exact order used by server compositing.
    var text = qs(root, '.sticker-customizer__text-layer');
    qsa(preview, '[data-proof-avatar-index]').sort(function (a, b) { return Number(a.getAttribute('data-proof-avatar-index')) - Number(b.getAttribute('data-proof-avatar-index')); }).forEach(function (element) { text.parentNode.insertBefore(element, text); });
  }

  function switchMultiAvatar(root, index, skipSave) {
    var state = root._stickerState, slots = state.proofAvatars || [];
    if (!Number.isInteger(index) || index < 0 || index >= slots.length) return;
    if (!skipSave) slots[state.proofActiveAvatar || 0] = snapshotMultiAvatar(root);
    var slot = slots[index], background = state.selectedBackgroundId, fade = state.selectedFadeId;
    root._proofSwitching = true;
    try {
      state.proofActiveAvatar = index;
      Object.assign(state, slot.state);
      ['avatar', 'style', 'mode', 'accessory', 'hair', 'garment', 'color'].forEach(function (category) {
        var choice = slot.choices[category];
        if (category === 'garment' && !choice) choice = slot.state.approvedAvatarGarmentId || 'garment-yoke-blouse-dress';
        qsa(root, '[data-mia-choice="' + category + '"]').forEach(function (control) { control.checked = control.value === choice; });
      });
      syncMiaRuntimeChoices(root, '');
      state.selectedBackgroundId = background; state.selectedFadeId = fade;
      qsa(root, '[data-mia-choice="background"]').forEach(function (control) { control.checked = control.value === background; });
      var fadeControl = qs(root, '[data-mia-choice="fade"]');
      if (fadeControl) { fadeControl.value = fade || ''; fadeControl.disabled = background === 'background-none-white'; }
      syncBackgroundPreview(root);
      root._stickerLastHonestPreviewAsset = miaAssetUrl(root, slot.asset);
      syncAssistantHonestPreview(root); updatePhoto(root);
    } finally { root._proofSwitching = false; }
    syncMultiAvatarPreview(root); renderLocalJourney(root); persistLocalSession(root);
  }

  function changeMultiAvatarCount(root, delta) {
    var state = root._stickerState, slots = state.proofAvatars || [snapshotMultiAvatar(root)];
    var active = state.proofActiveAvatar || 0;
    slots[active] = snapshotMultiAvatar(root);
    if (delta === 1 && slots.length < 3 && slots[active].asset) slots.push(JSON.parse(JSON.stringify(slots[active])));
    else if (delta === -1 && slots.length > 1) { slots.splice(active, 1); active = Math.min(active, slots.length - 1); }
    else return;
    state.proofAvatars = slots; state.proofActiveAvatar = active;
    slots.forEach(function (slot) { slot.state.photoScale = 1; slot.state.photoX = 0; slot.state.photoY = 0; });
    // Save the newly selected slot rather than overwriting it with the removed one.
    Object.assign(state, slots[active].state);
    switchMultiAvatar(root, active, true);
    if (slots.length === 1) { delete state.proofAvatars; state.proofActiveAvatar = 0; qs(root, '[data-sticker-photo-frame]').removeAttribute('data-proof-avatar-index'); updatePhoto(root); renderLocalJourney(root); persistLocalSession(root); }
  }

  function renderMultiAvatarControls(root) {
    var holder = qs(root, '[data-local-multi-avatar]');
    if (!holder) return;
    holder.hidden = root._stickerState.subjectSource !== 'approved-avatar';
    syncMultiAvatarPreview(root);
    var slots = root._stickerState.proofAvatars || [snapshotMultiAvatar(root)];
    holder.textContent = '';
    var heading = document.createElement('strong'); heading.textContent = multiAvatarCopy(root, 'charactersTitle'); holder.appendChild(heading);
    holder.setAttribute('aria-label', heading.textContent);
    slots.forEach(function (slot, index) {
      var id = slot.state.approvedAvatarId, name = id ? id.charAt(0).toUpperCase() + id.slice(1) : '';
      var label = ['mia', 'clara'].indexOf(id) < 0 ? name + ' ' + (index + 1) : multiAvatarCopy(root, id === 'clara' ? 'claraCharacterSlot' : 'multiAvatarSlot', { number: index + 1 });
      var button = createLocalButton(root, label, 'data-local-proof-slot', String(index)); button.setAttribute('aria-pressed', String(index === (root._stickerState.proofActiveAvatar || 0))); holder.appendChild(button);
    });
    var add = createLocalButton(root, multiAvatarCopy(root, 'claraAvatarAdd'), 'data-local-action', 'proof-avatar-add'); add.disabled = slots.length >= 3 || !localExactAvatar(root); holder.appendChild(add);
    var remove = createLocalButton(root, multiAvatarCopy(root, 'claraAvatarRemove'), 'data-local-action', 'proof-avatar-remove'); remove.disabled = slots.length <= 1; holder.appendChild(remove);
    var note = document.createElement('p'); note.textContent = multiAvatarCopy(root, slots.some(function (slot) { return slot.state.approvedAvatarId !== 'mia'; }) ? 'charactersNote' : 'multiAvatarNote'); note.hidden = browserRecipeEnabled(root) || hasCastPreviewSelection(root); holder.appendChild(note);
  }

  function multiAvatarCopy(root, key, variables) {
    var entities = { amp: '&', quot: '"', apos: "'", lt: '<', gt: '>' };
    var value = localCopy(root, key).replace(/&#(x[0-9a-f]+|[0-9]+);/gi, function (match, code) {
      var point = code.charAt(0).toLowerCase() === 'x' ? parseInt(code.slice(1), 16) : parseInt(code, 10);
      return point > 0 && point <= 0x10ffff ? String.fromCodePoint(point) : match;
    }).replace(/&(amp|quot|apos|lt|gt);/g, function (_match, name) { return entities[name]; });
    value = value.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (match, name) {
      return variables && Object.prototype.hasOwnProperty.call(variables, name) ? String(variables[name]) : match;
    });
    if (variables && Object.prototype.hasOwnProperty.call(variables, 'number')) value = value.split('__MIA_SLOT_NUMBER__').join(String(variables.number));
    return formatTranslation(value, variables);
  }

  function captureMultiAvatarProofLayers(root, resourcesReady) {
    var preview = qs(root, '[data-sticker-preview]');
    var images = qsa(preview, '[data-sticker-approved-avatar-preview], [data-proof-avatar-image]');
    var ready = resourcesReady === true ? Promise.resolve() : Promise.all(images.map(function (image) { return typeof image.decode === 'function' ? image.decode() : Promise.resolve(); }));
    return ready.then(function () {
      return Promise.all(Object.values(root._localAlphaPromises || {}));
    }).then(function () {
      return Promise.resolve(document.fonts && document.fonts.ready);
    }).then(function () {
    syncLocalTextBacking(root);
    if (root._proofLayoutUnavailable) return Promise.reject(new Error('proof-layout-unavailable'));
    if ((root._stickerState.proofAvatars || []).length <= 1) return captureVisualProofLayers(root).then(function (layer) {
      var backgroundStyle = /^background-(signature|hero|prince-princess)-/.exec(root._stickerState.selectedBackgroundId || '');
      // After removing mixed-style slots, keep the chosen background and the
      // remaining avatar independently pinned, even when only one Mia remains.
      if (backgroundStyle && backgroundStyle[1] !== root._stickerState.style) {
        return { version: 2, fadeVisible: layer.fadeVisible, overlay: layer.overlay, avatars: [Object.assign({ rect: layer.avatarRect, backing: layer.avatarBacking }, layer.avatarFade ? { fade: layer.avatarFade } : {})] };
      }
      return layer;
    });
    var frames = qsa(preview, '[data-proof-avatar-index]').sort(function (a, b) { return Number(a.getAttribute('data-proof-avatar-index')) - Number(b.getAttribute('data-proof-avatar-index')); });
    if (frames.length !== root._stickerState.proofAvatars.length || root._stickerState.proofAvatars.some(function (slot) { return !slot.asset; })) return Promise.reject(new Error('proof-avatar-unavailable'));
    return Promise.all(frames.map(function (frame) { return captureVisualProofLayers(root, { frame: frame, avatar: qs(frame, 'img:not([hidden])') }); })).then(function (layers) {
      return { version: 2, fadeVisible: layers[0].fadeVisible, overlay: layers[0].overlay, avatars: layers.map(function (layer) { return Object.assign({ rect: layer.avatarRect, backing: layer.avatarBacking }, layer.avatarFade ? { fade: layer.avatarFade } : {}); }) };
    });
    });
  }

  function captureVisualProofLayers(root, slot) {
    function dataUrl(blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader(); reader.onload = function () { resolve(reader.result); };
        reader.onerror = reject; reader.readAsDataURL(blob);
      });
    }
    function raster(svg) {
      return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
        var image = new Image();
        image.onload = function () {
          try {
            var canvas = document.createElement('canvas'); canvas.width = 3600; canvas.height = 3600;
            canvas.getContext('2d').drawImage(image, 0, 0, 3600, 3600);
            resolve(canvas.toDataURL('image/png'));
          } catch (error) { reject(error); }
          URL.revokeObjectURL(url);
        };
        image.onerror = function () { URL.revokeObjectURL(url); reject(new Error('proof-layer-render-failed')); };
        image.src = url;
      });
    }
    function standalone(svg) {
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('width', '3600'); svg.setAttribute('height', '3600');
      svg.setAttribute('viewBox', bounds.x + ' ' + bounds.y + ' ' + bounds.width + ' ' + bounds.height); svg.removeAttribute('class'); svg.removeAttribute('style');
      var filters = qs(root, '[data-local-finish-filters]');
      if (filters) {
        var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        Array.prototype.forEach.call(filters.children, function (filter) { defs.appendChild(filter.cloneNode(true)); });
        svg.insertBefore(defs, svg.firstChild);
      }
      return svg;
    }
    var live = qs(root, '.sticker-customizer__text-layer');
    var avatar = slot ? slot.avatar : qs(root, '[data-sticker-approved-avatar-preview]');
    var frame = slot ? slot.frame : qs(root, '[data-sticker-photo-frame]');
    if (!live || !avatar || !frame) return Promise.reject(new Error('proof-preview-unavailable'));
    // The theme's 1000-unit scene includes margins around the actual round
    // sticker. Export the circle, not those presentation/shadow margins.
    var circleLayer = qs(root, '[data-sticker-background-preview]');
    var sceneStyle = window.getComputedStyle(live);
    var circleStyle = circleLayer && window.getComputedStyle(circleLayer);
    function sceneUnit(value, side) { return /%$/.test(value) ? parseFloat(value) * 10 : parseFloat(value) / side * 1000; }
    var bounds = circleStyle ? {
      x: sceneUnit(circleStyle.left, parseFloat(sceneStyle.width)),
      y: sceneUnit(circleStyle.top, parseFloat(sceneStyle.height)),
      width: sceneUnit(circleStyle.width, parseFloat(sceneStyle.width)),
      height: sceneUnit(circleStyle.height, parseFloat(sceneStyle.height))
    } : null;
    if (!bounds || !Number.isFinite(bounds.width) || bounds.width <= 0 || !Number.isFinite(bounds.height) || bounds.height <= 0) return Promise.reject(new Error('proof-circle-unavailable'));
    return Promise.resolve(document.fonts && document.fonts.ready).then(function () {
      var svg = standalone(live.cloneNode(true));
      var original = live.querySelectorAll('*'); var cloned = svg.querySelectorAll('*');
      // Copy computed text styles explicitly; the detached SVG has no theme CSS.
      Array.prototype.forEach.call(original, function (element) {
        if (!/^(text|textPath|circle|rect|path|image)$/i.test(element.tagName)) return;
        var target = svg.querySelector('[id="' + element.id + '"]');
        if (!element.id) {
          var index = Array.prototype.indexOf.call(original, element);
          // Use the original clone tree (before standalone adds filter defs).
          target = cloned[cloned.length - original.length + index];
        }
        if (!target) return;
        var style = window.getComputedStyle(element);
        ['fill', 'font-family', 'font-size', 'font-weight', 'letter-spacing', 'text-anchor', 'opacity', 'filter'].forEach(function (name) {
          var value = style.getPropertyValue(name).replace(/url\(["']?[^)#]*#([^)'" ]+)["']?\)/g, 'url(#$1)');
          target.style.setProperty(name, value);
        });
      });
      var font = Array.prototype.find.call(document.querySelectorAll('link[as="font"]'), function (link) { return /open_sans\/opensans_n7\./.test(link.href); });
      if (!font) throw new Error('proof-font-unavailable');
      var resources = [fetch(font.href).then(function (r) { if (!r.ok) throw new Error('proof-font-unavailable'); return r.blob(); }).then(dataUrl).then(function (url) {
        var style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
        style.textContent = '@font-face{font-family:"Open Sans";font-style:normal;font-weight:700;src:url("' + url + '")}'; svg.insertBefore(style, svg.firstChild);
      })];
      Array.prototype.forEach.call(svg.querySelectorAll('image'), function (image) {
        var href = image.getAttribute('href') || image.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
        if (!href) return;
        resources.push(fetch(href).then(function (r) { if (!r.ok) throw new Error('proof-badge-unavailable'); return r.blob(); }).then(dataUrl).then(function (url) {
          image.setAttribute('href', url); image.removeAttributeNS('http://www.w3.org/1999/xlink', 'href');
        }));
      });
      var width = parseFloat(frame.style.width) * parseFloat(avatar.style.width) / 10;
      var height = parseFloat(frame.style.height) * parseFloat(avatar.style.height) / 10;
      var rect = { x: parseFloat(frame.style.left) * 10 - width / 2, y: parseFloat(frame.style.top) * 10 - height / 2, width: width, height: height };
      var backingSvg = standalone(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
      var filterValue = avatar.style.filter || '';
      var backingPromise = Promise.resolve(null);
      if (filterValue) {
        backingPromise = fetch(avatar.currentSrc || avatar.src).then(function (r) { if (!r.ok) throw new Error('proof-avatar-unavailable'); return r.blob(); }).then(dataUrl).then(function (url) {
          var image = document.createElementNS('http://www.w3.org/2000/svg', 'image');
          Object.keys(rect).forEach(function (key) { image.setAttribute(key, rect[key]); });
          image.setAttribute('href', url); image.setAttribute('filter', filterValue.replace(/"/g, ''));
          backingSvg.appendChild(image);
          Array.prototype.forEach.call(backingSvg.querySelectorAll('feMergeNode[in="SourceGraphic"]'), function (node) { node.remove(); });
          return raster(backingSvg);
        });
      } else if (frame.style.background === 'rgb(255, 255, 255)' || frame.style.background === '#fff') {
        var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', parseFloat(frame.style.left) * 10); circle.setAttribute('cy', parseFloat(frame.style.top) * 10);
        circle.setAttribute('r', parseFloat(frame.style.width) * 5); circle.setAttribute('fill', 'white'); backingSvg.appendChild(circle);
        backingPromise = raster(backingSvg);
      }
      return Promise.all([Promise.all(resources).then(function () { return raster(svg); }), backingPromise]).then(function (layers) {
        var fade = qs(root, '[data-sticker-fade-preview]');
        var fadeStyle = fade && window.getComputedStyle(fade);
        var fadeVisible = !!(fade && !fade.hidden && fadeStyle.display !== 'none' && fadeStyle.visibility !== 'hidden' && Number(fadeStyle.opacity) > 0);
        var avatarFade = frame._stickerAvatarBottomFade;
        return Object.assign({ version: 1, fadeVisible: fadeVisible, overlay: layers[0], avatarBacking: layers[1], avatarRect: {
          x: (rect.x - bounds.x) * 1000 / bounds.width, y: (rect.y - bounds.y) * 1000 / bounds.height,
          width: rect.width * 1000 / bounds.width, height: rect.height * 1000 / bounds.height
        } }, avatarFade ? { avatarFade: { start: (avatarFade.start - bounds.y) * 1000 / bounds.height,
          end: (avatarFade.end - bounds.y) * 1000 / bounds.height } } : {});
      });
    });
  }

  function getVisualProofSelectionFingerprint(root, payload) {
    return JSON.stringify([payload.subject, payload.generation.style, payload.personalization, payload.composition, normalizeTextColor(root._stickerState.textColor), root._stickerState.proofAvatars || [], root._stickerState.avatarBottomFade == null ? 0 : root._stickerState.avatarBottomFade]);
  }



  function finalizeSelectedGeneration(root, snapshot) {
    var endpoint = (root.getAttribute('data-generation-endpoint') || '').trim();
    var result = getSelectedGeneration(root);

    if (!endpoint || !result || !window.fetch) return Promise.resolve(result);

    return getGenerationSession(endpoint, false)
      .then(function (session) {
        return bindGenerationSessionToCart(session).then(function () {
          return fetchGenerationJson(
            getGenerationFinalizeEndpoint(endpoint, result.id),
            {
              method: 'POST',
              credentials: 'omit',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + session.token
              },
              body: JSON.stringify(snapshot && snapshot.finalizationPayload || buildFinalizationPayload(root, result))
            },
            translate(root, 'generationFinalization')
          );
        });
      })
      .then(function (finalized) {
        Object.assign(result, {
          finalizedAt: finalized.finalizedAt || '',
          selectionState: finalized.selectionState || result.selectionState || 'unselected',
          selectedAt: finalized.selectedAt || result.selectedAt || '',
          finalizationHash: finalized.finalizationHash || '',
          serverExpiresAt: finalized.expiresAt || result.serverExpiresAt || '',
          clientPdfUrl: finalized.clientPdfUrl || result.clientPdfUrl || '',
          printPdfUrl: finalized.printPdfUrl || result.printPdfUrl || ''
        });
        saveGenerationRecord(result);
        updateGeneration(root);
        return result;
      });
  }

  function prepareCreditPurchase(root, url) {
    if (areMiaPrivatePilotPaidActionsBlocked(root)) return false;
    var endpoint = (root.getAttribute('data-generation-endpoint') || '').trim();
    if (!endpoint || !window.fetch) {
      window.location.href = url;
      return;
    }

    setCartStatus(root, translate(root, 'preparingCreditPack'), false);
    getGenerationSession(endpoint, false)
      .then(bindGenerationSessionToCart)
      .then(function () {
        window.location.href = url;
      })
      .catch(function (error) {
        setCartStatus(
          root,
          error && error.message
            ? error.message
            : translate(root, 'creditSessionFailed'),
          true
        );
      });
  }

  function submit(root, snapshot) {
    if ((root._stickerState.proofAvatars || []).length > 1) return null;
    var form;
    var result;

    if (!validate(root) || !validateGeneration(root)) return null;
    form = getForm(root);
    if (!form || !window.FormData || (!window.fetch && !window.XMLHttpRequest)) {
      setCartStatus(root, translate(root, 'cartUnavailable'), true);
      return null;
    }

    setFieldsEnabled(root, true);
    updateConfig(root);
    setCartStatus(root, '', false);

    result = getSelectedGeneration(root);
    return finalizeSelectedGeneration(root, snapshot).then(function () {
      var finalizedSnapshot = snapshot ? refreshAcceptedResultReferences(snapshot, result) : null;
      if (finalizedSnapshot && result) result.acceptedCartSnapshot = finalizedSnapshot;
      setFieldsEnabled(root, true);
      updateConfig(root);
      return postCartForm(form, root, finalizedSnapshot);
    });
  }

  function addGenerationToCart(root, generationId) {
    if ((root._stickerState.proofAvatars || []).length > 1) return null;
    var state = root._stickerState;
    var result = getGenerationById(root, generationId);
    var request;
    var acceptedSnapshot;

    if (!result) return;
    acceptedSnapshot = getAcceptedDesignSnapshot(result);
    if (isAssistantV12Enabled(root) && !acceptedSnapshot) return;
    if (!acceptedSnapshot) {
      acceptedSnapshot = freezeAcceptedDesignSnapshot(root, result);
      result.acceptedCartSnapshot = acceptedSnapshot;
    }
    state.selectedGenerationId = result.id;
    state.selectedGenerationLabel = result.label;
    state.selectedGenerationIdsByStyle[result.style] = result.id;
    updateGeneration(root);

    request = submit(root, acceptedSnapshot);
    if (!request) return;
    emitAnalyticsEvent('clairatier_cart_add_started', {
      source_step_id: 'generated_result'
    });
    setGenerationCartLoading(root, result.id, true);

    request
      .then(function (item) {
        emitAnalyticsEvent('clairatier_cart_add_succeeded', {
          source_step_id: 'generated_result'
        });
        state.cartGenerationIds[result.id] = true;
        setStoredGenerationCartState(result, true);
        setCartStatus(root, translate(root, 'generationAdded', { label: getGenerationDisplayLabel(root, result) }), false);
        updateGeneration(root);
        runThemeCartAction(item);
      })
      .catch(function (error) {
        emitAnalyticsEvent('clairatier_cart_add_failed', {
          reason_code: 'request_failed'
        });
        setCartStatus(
          root,
          error && error.message ? error.message : translate(root, 'cartAddFailed'),
          true
        );
        setGenerationCartLoading(root, result.id, false);
      });
  }

  function removeGenerationFromCart(root, generationId) {
    var state = root._stickerState;
    var result = getGenerationById(root, generationId);
    var button = qs(root, '[data-sticker-action="remove-generation"][data-sticker-generation-id="' + generationId + '"]');

    if (!result || !window.fetch) return;
    if (button) {
      button.disabled = true;
      button.textContent = translate(root, 'removingFromCart');
    }
    setCartStatus(root, '', false);

    removeGenerationLineItem(root, result)
      .then(function () {
        delete state.cartGenerationIds[generationId];
        setStoredGenerationCartState(result, false);
        setCartStatus(root, translate(root, 'generationRemoved', { label: getGenerationDisplayLabel(root, result) }), false);
        updateGeneration(root);
        if (window.BT && typeof window.BT.updateHeaderCartHtml === 'function') {
          window.BT.updateHeaderCartHtml(false);
        }
      })
      .catch(function (error) {
        setCartStatus(
          root,
          error && error.message ? error.message : translate(root, 'generationRemoveFailed'),
          true
        );
        if (button) {
          button.disabled = false;
          button.textContent = translate(root, 'removeFromCart');
        }
      });
  }

  function getCartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function syncCustomizerCartState(root) {
    if (!window.fetch) return Promise.resolve();

    return window.fetch(getCartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(parseCartAddResponse)
      .then(function (cart) {
        var ids = {};
        (cart.items || []).forEach(function (item) {
          var id = item.properties && (item.properties['_clairatier_generation_id'] || item.properties['_ID génération']);
          if (id) ids[id] = true;
        });
        root._stickerState.cartGenerationIds = ids;
        updateGeneration(root);
      })
      .catch(function () {});
  }

  function removeGenerationLineItem(root, result) {
    var generationValue = getGenerationPropertyValue(root, result);

    return window.fetch(getCartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(parseCartAddResponse)
      .then(function (cart) {
        var lineKey = '';

        (cart.items || []).some(function (item) {
          if (!item.properties) return false;
          if (
            item.properties['_clairatier_generation_id'] !== result.id &&
            item.properties['_ID génération'] !== result.id &&
            item.properties['_clairatier_generation_label'] !== generationValue &&
            item.properties['Génération image'] !== generationValue
          ) return false;
          lineKey = item.key;
          return true;
        });

        if (!lineKey) throw new Error(translate(null, 'generationMissingFromCart'));
        return window.fetch(getCartUrl('cart/change.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: 0
          })
        });
      })
      .then(parseCartAddResponse);
  }

  function getCartPreviewData(preview) {
    var config = {};
    try {
      config = JSON.parse(preview.getAttribute('data-generation-config') || '{}');
    } catch (error) {
      config = {};
    }
    return {
      title: preview.getAttribute('data-preview-title') || translate(null, 'personalizedSticker'),
      generation: preview.getAttribute('data-generation') || '',
      generationId: preview.getAttribute('data-generation-id') || '',
      clientPdfUrl: preview.getAttribute('data-client-pdf-url') || '',
      printPdfUrl: preview.getAttribute('data-print-pdf-url') || '',
      generationConfig: preview.getAttribute('data-generation-config') || '',
      style: preview.getAttribute('data-style') || '',
      topText: preview.getAttribute('data-text-top') || '',
      bottomText: preview.getAttribute('data-text-bottom') || '',
      symbol: preview.getAttribute('data-symbol') || '',
      photo: preview.getAttribute('data-photo') || '',
      baseSrc: preview.getAttribute('data-base-src') || '',
      childSrc: preview.getAttribute('data-child-src') || '',
      fallbackChildSrc: preview.getAttribute('data-fallback-child-src') || '',
      badgeSrc: preview.getAttribute('data-badge-src') || '',
      watermarkSrc: preview.getAttribute('data-watermark-src') || '',
      imageScale: Number(config.s != null ? config.s : config.photoScale) || 1,
      imageOffsetY: Number(config.y != null ? config.y : config.photoY) || 0,
      topSize: Number(config.ts != null ? config.ts : config.textTopSize) || 78,
      textColor: normalizeTextColor(config.tc),
      bottomSize: Number(config.bs != null ? config.bs : config.textBottomSize) || 78,
      textTopEnabled: config.te != null ? config.te !== false : config.textTopEnabled !== false,
      textBottomEnabled: config.be != null ? config.be !== false : config.textBottomEnabled !== false
    };
  }

  function syncCartPreviewRecord(preview) {
    var data = getCartPreviewData(preview);
    var config = {};
    var record;
    var existing;

    if (!data.generationId) return;
    try {
      config = data.generationConfig ? JSON.parse(data.generationConfig) : {};
    } catch (error) {
      config = {};
    }

    record = {
      id: data.generationId,
      label: data.generation,
      status: GENERATION_STATUS.SUCCEEDED,
      style: config.st || config.style || '',
      styleLabel: data.style,
      attempt: config.a || (config.lastGenerationPayload && config.lastGenerationPayload.generation
        ? config.lastGenerationPayload.generation.attempt
        : 0),
      imageUrl: data.childSrc,
      previewUrl: data.childSrc,
      clientPdfUrl: data.clientPdfUrl,
      printPdfUrl: data.printPdfUrl,
      payload: config.lastGenerationPayload || {
        personalization: {
          textTop: data.topText,
          textBottom: data.bottomText,
          textTopEnabled: data.textTopEnabled,
          textBottomEnabled: data.textBottomEnabled,
          textTopSize: data.topSize,
          textBottomSize: data.bottomSize,
          symbol: data.symbol
        },
        composition: {
          imageScale: data.imageScale,
          imageOffsetY: data.imageOffsetY
        },
        generation: {
          styleLabel: data.style
        }
      },
      createdAt: new Date().toISOString()
    };
    existing = listGenerationRecords().filter(function (item) {
      return item.id === data.generationId;
    })[0];

    saveGenerationRecord(record, {
      status: existing && (existing.status === 'retry_requested' || existing.status === GENERATION_STATUS.FAILED)
        ? existing.status
        : GENERATION_STATUS.SUCCEEDED,
      cart: {
        added: true,
        addedAt: existing && existing.cart && existing.cart.addedAt
          ? existing.cart.addedAt
          : new Date().toISOString(),
        removedAt: ''
      }
    });
  }

  function loadCartImage(src, fallbackSrc) {
    return new Promise(function (resolve) {
      var image;

      if (!src) {
        if (fallbackSrc) {
          loadCartImage(fallbackSrc).then(resolve);
        } else {
          resolve(null);
        }
        return;
      }

      image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function () { resolve(image); };
      image.onerror = function () {
        if (fallbackSrc && fallbackSrc !== src) {
          loadCartImage(fallbackSrc).then(resolve);
        } else {
          resolve(null);
        }
      };
      image.src = src;
    });
  }

  function drawCartArcText(ctx, text, cx, cy, radius, startDeg, endDeg, size, color, lowerArc) {
    var chars = (text || '').toUpperCase().split('');
    var start = startDeg * Math.PI / 180;
    var end = endDeg * Math.PI / 180;
    var span = end - start;

    if (!chars.length) return;

    ctx.save();
    ctx.fillStyle = color;
    ctx.font = '800 ' + size + 'px "Open Sans", Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    chars.forEach(function (char, index) {
      var angle = chars.length === 1 ? (start + end) / 2 : start + span * (index / (chars.length - 1));
      var x = cx + Math.cos(angle) * radius;
      var y = cy + Math.sin(angle) * radius;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle + (lowerArc ? -Math.PI / 2 : Math.PI / 2));
      ctx.fillText(char, 0, 0);
      ctx.restore();
    });

    ctx.restore();
  }

  function renderCartPreviewCanvas(preview, mode) {
    var data = getCartPreviewData(preview);
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var printMode = mode === 'print';
    var pageWidth = printMode ? 2400 : 1600;
    var pageHeight = printMode ? 2400 : 2100;
    var stickerSize = printMode ? 2400 : 1440;
    var stickerX = printMode ? 0 : 80;
    var stickerY = printMode ? 0 : 70;

    canvas.width = pageWidth;
    canvas.height = pageHeight;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, pageWidth, pageHeight);

    return Promise.all([
      loadCartImage(data.baseSrc),
      loadCartImage(data.childSrc, data.fallbackChildSrc),
      loadCartImage(data.badgeSrc),
      loadCartImage(data.watermarkSrc)
    ]).then(function (images) {
      var base = images[0];
      var child = images[1];
      var badge = images[2];
      var watermark = images[3];
      var cx = stickerX + stickerSize / 2;
      var cy = stickerY + stickerSize / 2;
      var childWidth;
      var childHeight;

      if (base && !printMode) {
        ctx.drawImage(base, stickerX, stickerY, stickerSize, stickerSize);
      }

      if (child) {
        childWidth = stickerSize * 0.46 * data.imageScale;
        childHeight = childWidth * (child.naturalHeight / child.naturalWidth);
        ctx.drawImage(child, cx - childWidth / 2, stickerY + stickerSize * 0.46 + data.imageOffsetY * (stickerSize / 300) - childHeight / 2, childWidth, childHeight);
      }

      if (data.textTopEnabled && data.topText) {
        drawCartArcText(ctx, data.topText, cx, cy, stickerSize * 0.30, -130, -50, stickerSize * (data.topSize / 1000), data.textColor);
      }
      if (data.textBottomEnabled && data.bottomText) {
        drawCartArcText(ctx, data.bottomText, cx, cy, stickerSize * 0.24, 135, 45, stickerSize * (data.bottomSize / 1000), data.textColor, true);
      }
      drawCartArcText(ctx, 'CLAIRATIER', cx, cy, stickerSize * 0.31, 105, 75, stickerSize * 0.029, '#008e97', true);
      ctx.save();
      ctx.fillStyle = '#f58220';
      ctx.beginPath();
      ctx.arc(stickerX + stickerSize * 0.621, stickerY + stickerSize * 0.813, stickerSize * 0.0025, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
      if (badge) {
        ctx.drawImage(
          badge,
          stickerX + stickerSize * 0.642,
          stickerY + stickerSize * 0.770,
          stickerSize * 0.027,
          stickerSize * 0.030
        );
      }

      if (watermark && !printMode) {
        ctx.save();
        ctx.globalAlpha = 0.28;
        ctx.drawImage(watermark, stickerX, stickerY, stickerSize, stickerSize);
        ctx.restore();
      }
      return canvas;
    });
  }















  function openCartPreviewModal(preview) {
    var modal = qs(document, '[data-sticker-cart-modal]');
    var content = qs(document, '[data-sticker-cart-modal-content]');
    var clone;

    if (!modal || !content) return;
    clone = preview.cloneNode(true);
    content.innerHTML = '';
    content.appendChild(clone);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sticker-cart-preview-open');
  }

  function closeCartPreviewModal() {
    var modal = qs(document, '[data-sticker-cart-modal]');
    var content = qs(document, '[data-sticker-cart-modal-content]');

    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    if (content) content.innerHTML = '';
    document.body.classList.remove('sticker-cart-preview-open');
  }

  function initCartPreview(preview) {
    var data;
    var child;
    var topText;
    var bottomText;
    var topSizeValue;
    var bottomSizeValue;
    if (preview._stickerCartPreviewReady) return;
    preview._stickerCartPreviewReady = true;
    syncCartPreviewRecord(preview);
    data = getCartPreviewData(preview);
    child = qs(preview, '.sticker-cart-preview__child');
    if (child) {
      child.style.transform = 'translate(-50%, calc(-50% + ' + data.imageOffsetY + 'px)) scale(' + data.imageScale + ')';
      child.addEventListener('error', function () {
        if (!data.fallbackChildSrc || child.getAttribute('src') === data.fallbackChildSrc) return;
        child.setAttribute('src', data.fallbackChildSrc);
      });
    }
    topText = qs(preview, '.sticker-cart-preview__text--top');
    bottomText = qs(preview, '.sticker-cart-preview__text--bottom');
    topSizeValue = qs(preview, '[data-sticker-cart-top-size]');
    bottomSizeValue = qs(preview, '[data-sticker-cart-bottom-size]');
    if (topText) topText.style.fontSize = data.topSize + 'px';
    if (bottomText) bottomText.style.fontSize = data.bottomSize + 'px';
    if (topText) topText.style.fill = data.textColor;
    if (bottomText) bottomText.style.fill = data.textColor;
    if (topSizeValue) topSizeValue.textContent = String(data.topSize);
    if (bottomSizeValue) bottomSizeValue.textContent = String(data.bottomSize);
    if (!data.textTopEnabled) {
      var topTextPath = qs(preview, '.sticker-cart-preview__text--top textPath');
      if (topTextPath) topTextPath.textContent = '';
    }
    if (!data.textBottomEnabled) {
      var bottomTextPath = qs(preview, '.sticker-cart-preview__text--bottom textPath');
      if (bottomTextPath) bottomTextPath.textContent = '';
    }

    preview.addEventListener('click', function (event) {
      var action = event.target.closest('[data-sticker-cart-action]');

      if (!action || !preview.contains(action)) return;
      if (action.getAttribute('data-sticker-cart-action') === 'open') {
        openCartPreviewModal(preview);
      }
    });
  }

  window.ClairatierStickerDemo = {
    storageKey: GENERATION_STORAGE_KEY,
    listRecords: listGenerationRecords,
    saveRecord: saveGenerationRecord,
    updateRecord: updateGenerationRecord,
    clearRecords: clearGenerationStore,
    reconcileCart: reconcileGenerationCartState
  };

  function resolveCustomizerRoot(target) {
    if (target && target.nodeType === 1 && target.hasAttribute('data-sticker-customizer')) return target;
    if (typeof target === 'string') return document.getElementById(target);
    return roots[0] || null;
  }

  window.ClairatierGuidedAssistant = {
    version: GUIDED_CONTRACT_VERSION,
    actions: GUIDED_ACTIONS.slice(),
    getContext: function (target) {
      return getGuidedContext(resolveCustomizerRoot(target));
    },
    getNextActions: function (target, requestedCategory) {
      var root = resolveCustomizerRoot(target);
      return root
        ? getGuidedNextActions(getGuidedContext(root), getGuidedChoiceCatalog(root), requestedCategory)
        : [];
    },
    dispatch: function (target, envelope) {
      return dispatchGuidedAction(resolveCustomizerRoot(target), envelope);
    },
    setEnabled: function (target, enabled) {
      var root = resolveCustomizerRoot(target);
      if (!root) return null;
      root.setAttribute('data-sticker-guided-enabled', enabled === false ? 'false' : 'true');
      setAssistantExperience(root, enabled === false ? 'full' : 'guided');
      return getGuidedContext(root);
    }
  };

  function processPhotoSelection(root, fileInput, file, pickerSource) {
    var photo;
    var status;
    var error;
    var uploadLabel;
    var validationError;
    var uploadText;
    var capturePromise;
    var normalizationPromise;
    var selectionId;
    var previousStatus;
    var immediateSource = '';

    // Android can emit input and change for the same File. That duplicate is not a
    // new selection and must not cancel the operation it represents.
    if (root._stickerPhotoSelectionFile === file) return root._stickerPhotoCapturePromise;
    root._stickerPhotoSelectionFile = file;
    if (typeof bumpAssistantPhotoSelectionRevision === 'function') {
      bumpAssistantPhotoSelectionRevision(root);
    }
    selectionId = (root._stickerPhotoNormalizationId || 0) + 1;
    root._stickerPhotoNormalizationId = selectionId;
    revokePendingPhotoSource(root);

    photo = qs(root, '[data-sticker-photo]');
    status = qs(root, '[data-sticker-photo-status]');
    error = qs(root, '[data-sticker-error="photo"]');
    uploadLabel = qs(root, '[data-sticker-photo-picker]');
    validationError = getPhotoValidationError(file);
    if (validationError) {
      fileInput.value = '';
      if (error) {
        error.textContent = validationError;
        error.hidden = false;
      }
      if (uploadLabel) uploadLabel.classList.add('is-error');
      setPhotoDebug(root, file, 'PHOTO_FILE_VALIDATION_FAILED', new Error(validationError), [], {
        maxPhotoSizeBytes: MAX_PHOTO_SIZE
      });
      return Promise.resolve(null);
    }
    if (!file || !photo) return Promise.resolve(null);

    uploadText = qs(root, '[data-sticker-upload-text]');
    previousStatus = status ? status.textContent : '';
    root._stickerPhotoPickerSource = pickerSource || 'native-file-input';
    if (status) status.textContent = translate(root, 'preparingPhoto');

    try {
      immediateSource = URL.createObjectURL(file);
      root._stickerPhotoPendingSource = immediateSource;
    } catch (sourceError) {
      immediateSource = '';
    }

    // Capture starts while Android still grants access to a temporary content URI.
    capturePromise = capturePhotoFile(file, immediateSource);
    normalizationPromise = capturePromise
      .then(function (captureResult) {
        return { file: captureResult.file, captureResult: captureResult, captureFailed: false };
      })
      .catch(function (captureError) {
        return { file: file, captureError: captureError, captureFailed: true };
      })
      .then(function (capture) {
        return normalizePhotoFile(capture.file).then(function (normalizedFile) {
          return { normalizedFile: normalizedFile, capture: capture };
        });
      });
    root._stickerPhotoCapturePromise = normalizationPromise;
    normalizationPromise
      .then(function (prepared) {
        var normalizedFile = prepared.normalizedFile;
        var capture = prepared.capture;
        var inputReplaced;
        if (root._stickerPhotoNormalizationId !== selectionId || root._stickerPhotoCapturePromise !== normalizationPromise) {
          revokePendingPhotoSource(root, immediateSource);
          return;
        }
        revokePendingPhotoSource(root, immediateSource);
        inputReplaced = replacePhotoInputFile(fileInput, normalizedFile);
        root._stickerPhotoOriginalFile = normalizedFile;
        root._stickerPhotoFile = normalizedFile;
        if (uploadText) uploadText.textContent = translate(root, 'changePhoto');
        loadPhotoPreview(root, normalizedFile, [{
          picker: root._stickerPhotoPickerSource,
          strategy: 'immediate-file-capture',
          status: capture.captureFailed ? 'failed' : 'success'
        }, {
          picker: root._stickerPhotoPickerSource,
          strategy: 'local-normalization-jpeg',
          status: 'success',
          inputReplaced: inputReplaced
        }]);
      })
      .catch(function (normalizationError) {
        if (root._stickerPhotoNormalizationId !== selectionId || root._stickerPhotoCapturePromise !== normalizationPromise) {
          revokePendingPhotoSource(root, immediateSource);
          return;
        }
        revokePendingPhotoSource(root, immediateSource);
        root._stickerPhotoSelectionFile = null;
        root._stickerPhotoCapturePromise = null;
        fileInput.value = '';
        if (status) status.textContent = previousStatus || translate(root, 'photoPlacementGuidance');
        if (error) {
          error.textContent = getPhotoNormalizationErrorMessage(normalizationError);
          error.hidden = false;
        }
        if (uploadLabel) uploadLabel.classList.add('is-error');
        setPhotoDebug(root, file, 'PHOTO_FILE_VALIDATION_FAILED', normalizationError, [{
          strategy: 'local-normalization-jpeg',
          status: 'failed'
        }]);
      });
    return normalizationPromise;
  }

  function processPhotoSubjectSelection(root, fileInput, file, pickerSource) {
    if (!setSubjectSource(root, 'photo')) return Promise.resolve(null);
    return processPhotoSelection(root, fileInput, file, pickerSource).then(function (result) {
      if (hasUsablePhoto(root)) {
        root._stickerState.assistantOptionalPhotoOfferState = 'accepted';
        markAssistantContextChanged(root, 'avatar-transform');
        publishGuidedContext(root);
      }
      return result;
    });
  }

  function isMiaPrivatePilotReady(root) {
    if (!root || root.getAttribute('data-sticker-private-pilot-ready') !== 'true' ||
      root.getAttribute('data-product-handle') !== PRIVATE_PILOT_PRODUCT_HANDLE) return false;
    var suffix = root.getAttribute('data-sticker-private-pilot-template-suffix');
    return root._localReadonlyPreview === true && root.closest && !!root.closest('[data-clairatier-cart-renderer][inert]') || suffix === PRIVATE_PILOT_TEMPLATE_SUFFIX ||
      (suffix === 'clairatier-personnalisation' &&
        root.getAttribute('data-copy-cart-page') === 'true' && (copyCartEnabled(root) || typeof browserRecipeEnabled === 'function' && browserRecipeEnabled(root)));
  }

  function isMiaPrototypeEnabled(root) {
    if (!root || root.getAttribute('data-sticker-mia-prototype-enabled') !== 'true') return false;
    if (root.getAttribute('data-sticker-mia-prototype-environment') === 'theme-editor') return true;
    return root.getAttribute('data-sticker-mia-prototype-environment') === 'private-pilot' &&
      isMiaPrivatePilotReady(root);
  }

  function getMiaInitializationMode(root) {
    if (isMiaRuntimeReady(root)) return 'runtime';
    if (isMiaPrototypeEnabled(root)) return 'prototype';
    return 'legacy';
  }

  function disableMiaPrivatePilotPhotoControls(root) {
    var photoPanel;
    if (!isMiaPrivatePilotReady(root)) return false;
    qsa(root, '[data-sticker-tab="photo"], [data-sticker-photo-picker], [data-sticker-photo-input]').forEach(function (control) {
      control.hidden = true;
      control.disabled = true;
      control.setAttribute('aria-hidden', 'true');
      control.setAttribute('tabindex', '-1');
    });
    photoPanel = qs(root, '[data-sticker-panel="photo"]');
    if (photoPanel) {
      photoPanel.hidden = true;
      photoPanel.setAttribute('aria-hidden', 'true');
      photoPanel.setAttribute('inert', '');
    }
    if (root._stickerState) root._stickerState.assistantOptionalPhotoOfferState = 'unavailable';
    return true;
  }

  function setSubjectSource(root, sourceType) {
    var state = root && root._stickerState;
    var fileInput;
    var previousSource;
    if (!state || ['photo', 'approved-avatar'].indexOf(sourceType) === -1) return false;
    if (sourceType === 'photo' && isMiaPrivatePilotReady(root)) return false;
    if (sourceType === 'approved-avatar' && !isMiaRuntimeReady(root)) return false;
    previousSource = state.subjectSource;
    if (sourceType === 'approved-avatar') {
      fileInput = qs(root, '[data-sticker-photo-input]');
      if (previousSource === 'photo' || hasPhoto(root)) clearPhotoPreview(root);
      if (fileInput) fileInput.value = '';
      state.subjectSource = 'approved-avatar';
      var selectedAvatar = getMiaSelected(root, 'avatar');
      var clara = selectedAvatar && selectedAvatar.value === 'clara' && claraPreviewEnabled(root);
      state.approvedAvatarManifestId = clara ? 'clairatier-clara-signature-knees-v2' : 'clairatier-avatar-pilot-v1';
      state.approvedAvatarId = selectedAvatar && typeof castPreviewEnabled === 'function' && castPreviewEnabled(root) &&
        CAST_PREVIEW_IDS.indexOf(selectedAvatar.value) >= 0 ? selectedAvatar.value : clara ? 'clara' : 'mia';
      if (/^cast-/.test(state.approvedAvatarGarmentId || '') || ['mia', 'clara'].indexOf(state.approvedAvatarId) < 0) state.approvedAvatarManifestId = 'clairatier-cast-preview-v1';
      syncAssistantHairstyleTopicForSubject(root, 'approved-avatar');
      syncAssistantGarmentTopicForSubject(root, 'approved-avatar');
    } else {
      state.subjectSource = 'photo';
      state.assistantOptionalPhotoOfferState = hasUsablePhoto(root) ? 'accepted' : 'pending';
      clearAssistantAvatarPreferencesForPhoto(root);
      syncAssistantHairstyleTopicForSubject(root, 'photo');
      syncAssistantGarmentTopicForSubject(root, 'photo');
      if (state.assistantVisualCategory === 'garment') state.assistantVisualCategory = '';
    }
    qsa(root, '[data-mia-choice="avatar"]').forEach(function (control) {
      control.checked = control.value === (sourceType === 'approved-avatar' ? state.approvedAvatarId : 'photo');
    });
    syncAssistantGarmentManualControls(root);
    resetGeneration(root);
    if (previousSource !== state.subjectSource) markAssistantContextChanged(root, 'avatar-transform');
    return true;
  }

  function validateAssistantVisualCategory(state, category) {
    if (!state || !state.validatedAssistantChoices) return;
    if (category === 'style') state.validatedAssistantChoices.style = true;
    if (category === 'color') state.validatedAssistantChoices.color = true;
  }

  function getBackgroundControl(root, backgroundId) {
    return qsa(root, '[data-mia-choice="background"]').filter(function (control) {
      return control.value === backgroundId;
    })[0] || null;
  }

  function selectBackgroundControl(root, backgroundId) {
    var selected = getBackgroundControl(root, backgroundId) || getBackgroundControl(root, 'background-none-white');
    qsa(root, '[data-mia-choice="background"]').forEach(function (control) {
      control.checked = control === selected;
    });
    return selected;
  }

  function getBackgroundEditorMessage(root, name, variables) {
    var editor = root && qs(root, '[data-sticker-background-editor]');
    return formatTranslation(editor && editor.getAttribute('data-' + name) || '', variables || {});
  }

  function getCompositionAssetLoadToken(root, backgroundSrc, fadeSrc) {
    var state = root && root._stickerState;
    var key;
    if (!state) return 0;
    key = [
      state.selectedBackgroundId || 'background-none-white',
      state.selectedFadeId || '',
      backgroundSrc || '',
      fadeSrc || ''
    ].join('|');
    if (state.compositionAssetLoadKey !== key) {
      state.compositionAssetLoadKey = key;
      state.compositionAssetLoadToken = (state.compositionAssetLoadToken || 0) + 1;
    }
    return state.compositionAssetLoadToken || 0;
  }

  function recoverCompositionAssetFailure(root, token) {
    var state = root && root._stickerState;
    var fade;
    var adjustment;
    var editor;
    var activeElement;
    var restoreFocus;
    var focusTarget;
    var message;
    if (!state || token !== state.compositionAssetLoadToken ||
        state.compositionAssetRecoveryToken === token ||
        state.selectedBackgroundId === 'background-none-white') return false;
    state.compositionAssetRecoveryToken = token;
    selectBackgroundControl(root, 'background-none-white');
    fade = qs(root, '[data-mia-choice="fade"]');
    if (fade) {
      fade.value = '';
      fade.disabled = true;
    }
    state.selectedBackgroundId = 'background-none-white';
    state.selectedFadeId = '';
    resetBackgroundTransform(state);
    adjustment = qs(root, '[data-sticker-background-adjustment]');
    editor = qs(root, '[data-sticker-background-editor]');
    activeElement = document.activeElement;
    restoreFocus = !!activeElement && root.contains(activeElement) && !!activeElement.closest &&
      !!activeElement.closest('[data-sticker-background-transform-controls], [data-sticker-fade-picker]');
    message = getBackgroundEditorMessage(root, 'asset-recovery');
    commitFreeCompositionEdit(root, 'background');
    if (restoreFocus) {
      focusTarget = qs(root, '[data-sticker-background-option="background-none-white"]') ||
        qs(root, '[data-sticker-background-editor] h4');
      if (focusTarget) focusBackgroundEditorTarget(root, focusTarget);
    }
    if (adjustment && editor && !editor.hidden) {
      adjustment.hidden = false;
      adjustment.textContent = message;
    } else {
      announceAssistantState(root, message);
    }
    return true;
  }

  function bindCompositionAssetPreview(root, image, kind, source, token, visible) {
    var tokenValue = String(token);
    function isCurrent() {
      return !!root._stickerState && root._stickerState.compositionAssetLoadToken === token &&
        image.getAttribute('data-composition-asset-token') === tokenValue &&
        image.getAttribute('data-composition-asset-kind') === kind &&
        image.getAttribute('src') === source;
    }
    function releaseHandlers() {
      image.onload = null;
      image.onerror = null;
    }
    if (!image) return;
    if (!visible) {
      releaseHandlers();
      image.hidden = true;
      image.removeAttribute('data-composition-asset-token');
      image.removeAttribute('data-composition-asset-kind');
      image.removeAttribute('src');
      return;
    }
    if (!source) {
      releaseHandlers();
      image.hidden = true;
      image.removeAttribute('data-composition-asset-token');
      image.removeAttribute('data-composition-asset-kind');
      image.removeAttribute('src');
      recoverCompositionAssetFailure(root, token);
      return;
    }
    image.hidden = false;
    image.setAttribute('data-composition-asset-token', tokenValue);
    image.setAttribute('data-composition-asset-kind', kind);
    image.onload = function () {
      if (!isCurrent()) return;
      releaseHandlers();
    };
    image.onerror = function () {
      if (!isCurrent()) return;
      releaseHandlers();
      recoverCompositionAssetFailure(root, token);
    };
    if (image.getAttribute('src') !== source) image.setAttribute('src', source);
    else if (image.complete && image.naturalWidth > 0) releaseHandlers();
  }

  function ensureBackgroundCompatibility(root) {
    var state = root && root._stickerState;
    var selected = getMiaSelected(root, 'background');
    var selectedStyle = selected && selected.getAttribute('data-background-style');
    var adjustment = qs(root, '[data-sticker-background-adjustment]');
    if (!state || !selected || selected.value === 'background-none-white' || !selectedStyle || selectedStyle === state.style ||
        (state.proofAvatars || []).length > 1 && state.proofAvatars.some(function (slot) { return slot.state.style === selectedStyle; })) {
      return false;
    }
    selectBackgroundControl(root, 'background-none-white');
    state.selectedBackgroundId = 'background-none-white';
    state.selectedFadeId = '';
    resetBackgroundTransform(state);
    if (adjustment) {
      adjustment.hidden = false;
      adjustment.textContent = getBackgroundEditorMessage(root, 'compatibility-reset');
    }
    announceAssistantState(root, getBackgroundEditorMessage(root, 'compatibility-reset'));
    return true;
  }

  function syncBackgroundPreview(root) {
    var state = root && root._stickerState;
    var background = state && getBackgroundControl(root, state.selectedBackgroundId);
    var backgroundPreview = qs(root, '[data-sticker-background-preview]');
    var panelBackground = qs(root, '[data-local-preview-background]');
    var panelBackgroundToggle = qs(root, '[data-local-action="toggle-preview-background"]');
    var fadePreview = qs(root, '[data-sticker-fade-preview]');
    var fadeSelect = qs(root, '[data-mia-choice="fade"]');
    var fadeOption = fadeSelect && fadeSelect.options[fadeSelect.selectedIndex];
    var transform = normalizeBackgroundTransform(state && state.backgroundTransform);
    var backgroundSrc = background && background.getAttribute('data-background-src') || '';
    var fadeSrc = fadeOption && fadeOption.getAttribute('data-fade-src') || '';
    var loadToken;
    var illustrated;
    var showOnPanel;
    if (!state) return;
    state.backgroundTransform = transform;
    loadToken = getCompositionAssetLoadToken(root, backgroundSrc, fadeSrc);
    illustrated = state.selectedBackgroundId !== 'background-none-white' && !!backgroundSrc;
    showOnPanel = false;
    if (backgroundPreview) {
      bindCompositionAssetPreview(root, backgroundPreview, 'background', backgroundSrc, loadToken,
        illustrated);
      backgroundPreview.style.transform = 'scale(' + transform.scale + ') translate(' +
        (transform.x * 100) + '%, ' + (transform.y * 100) + '%)';
    }
    if (panelBackground) {
      bindCompositionAssetPreview(root, panelBackground, 'background', backgroundSrc, loadToken, showOnPanel);
      panelBackground.style.transform = 'scale(' + transform.scale + ') translate(' +
        (transform.x * 100) + '%, ' + (transform.y * 100) + '%)';
    }
    if (panelBackgroundToggle) {
      panelBackgroundToggle.hidden = !illustrated;
      panelBackgroundToggle.setAttribute('aria-pressed', String(showOnPanel));
    }
    if (fadePreview) {
      bindCompositionAssetPreview(root, fadePreview, 'fade', fadeSrc, loadToken,
        state.selectedBackgroundId !== 'background-none-white' && !!state.selectedFadeId);
    }
  }

  function syncBackgroundEditor(root) {
    var state = root && root._stickerState;
    var editor = qs(root, '[data-sticker-background-editor]');
    var selectedId;
    var illustrated;
    var styleIndex = 0;
    var zoomOutput;
    var balance;
    if (!state) return;
    selectedId = state.selectedBackgroundId || 'background-none-white';
    illustrated = selectedId !== 'background-none-white';
    if (editor) editor.hidden = !state.backgroundEditorOpen;
    qsa(root, '[data-sticker-background-option]').forEach(function (button) {
      var style = button.getAttribute('data-background-style');
      var compatible = !style || style === state.style;
      var visible = compatible && (!style || state.assistantBackgroundExpanded || styleIndex < 4);
      if (style && compatible) styleIndex += 1;
      button.hidden = !visible;
      button.classList.toggle('is-selected', button.getAttribute('data-sticker-background-option') === selectedId);
      button.setAttribute('aria-pressed', button.getAttribute('data-sticker-background-option') === selectedId ? 'true' : 'false');
    });
    var browseAll = qs(root, '[data-sticker-background-browse-all]');
    if (browseAll) {
      browseAll.hidden = false;
      browseAll.setAttribute('aria-expanded', state.assistantBackgroundExpanded ? 'true' : 'false');
      browseAll.textContent = getBackgroundEditorMessage(
        root,
        state.assistantBackgroundExpanded ? 'show-less' : 'browse-all'
      );
    }
    var transformControls = qs(root, '[data-sticker-background-transform-controls]');
    var fadePicker = qs(root, '[data-sticker-fade-picker]');
    if (transformControls) transformControls.hidden = !illustrated;
    if (fadePicker) fadePicker.hidden = !illustrated;
    qsa(root, '[data-sticker-fade-option]').forEach(function (button) {
      var selected = button.getAttribute('data-sticker-fade-option') === state.selectedFadeId;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    zoomOutput = qs(root, '[data-sticker-background-zoom-output]');
    if (zoomOutput) zoomOutput.textContent = Math.round(state.backgroundTransform.scale * 100) + '%';
    balance = qs(root, '[data-sticker-background-credit-balance]');
    if (balance) {
      balance.textContent = state.backgroundGenerationDisclosure
        ? getBackgroundEditorMessage(root, 'balance-template', {
          count: state.backgroundGenerationDisclosure.creditBalance
        })
        : getBackgroundEditorMessage(root, 'balance-unknown');
    }
    syncBackgroundPreview(root);
  }

  function resolveMiaCompositionState(root) {
    var background = getMiaSelected(root, 'background');
    var fade = qs(root, '[data-mia-choice="fade"]');
    var resolved;
    if (fade && background) {
      if (background.value === 'background-none-white') {
        fade.value = '';
        fade.disabled = true;
        resetBackgroundTransform(root && root._stickerState);
      } else {
        fade.disabled = false;
        if (!fade.value) fade.value = 'fade-calm-halo-v1';
      }
    }
    resolved = {
      backgroundId: background ? background.value : 'background-none-white',
      fadeId: fade && !fade.disabled ? fade.value : ''
    };
    if (root && root._stickerState) {
      root._stickerState.selectedBackgroundId = resolved.backgroundId;
      root._stickerState.selectedFadeId = resolved.fadeId;
    }
    return resolved;
  }

  function syncMiaRuntimeChoices(root, validatedCategory) {
    var state = root._stickerState;
    var avatar = getMiaSelected(root, 'avatar');
    var style = getMiaSelected(root, 'style');
    var mode = getMiaSelected(root, 'mode');
    var hair = getMiaSelected(root, 'hair');
    var garment = getMiaSelected(root, 'garment');
    var color = getMiaSelected(root, 'color');
    var fade = qs(root, '[data-mia-choice="fade"]');
    var composition;
    var garmentMetadata;
    if (!state) return;
    if (avatar) setSubjectSource(root, avatar.value === 'photo' ? 'photo' : 'approved-avatar');
    if (style) {
      state.style = style.value;
    }
    ensureBackgroundCompatibility(root);
    composition = resolveMiaCompositionState(root);
    if (mode && mode.value === 'standard') {
      state.appearanceMode = 'standard';
      state.selectedAccessoryId = '';
      state.presentationMode = 'standard';
    } else if (mode && mode.value === 'accessories') {
      state.appearanceMode = 'accessories';
      var selectedAccessory = getMiaSelected(root, 'accessory');
      state.selectedAccessoryId = selectedAccessory ? selectedAccessory.value : '';
      state.presentationMode = selectedAccessory && selectedAccessory.getAttribute('data-presentation-mode') === 'incognito'
        ? 'incognito' : 'standard';
    }
    state.approvedAvatarHairstyleId = hair ? hair.value : '';
    var castGarment = garment && typeof getCastPreviewEntry === 'function' && getCastPreviewEntry(root, state.approvedAvatarId, state.style, garment.value);
    if (isAssistantV12Enabled(root) && !castGarment) {
      garmentMetadata = garment && MIA_GARMENT_METADATA[garment.value];
      if (!garmentMetadata) {
        garment = getAssistantVisualControl(root, 'garment', 'garment-yoke-blouse-dress');
        qsa(root, '[data-mia-choice="garment"]').forEach(function (entry) {
          entry.checked = !!garment && entry === garment;
        });
        garmentMetadata = MIA_GARMENT_METADATA['garment-yoke-blouse-dress'];
      }
      state.approvedAvatarGarmentId = garment ? garment.value : 'garment-yoke-blouse-dress';
      state.tryonGarment = state.approvedAvatarGarmentId;
    } else {
      state.approvedAvatarGarmentId = garment ? garment.value : 'garment-yoke-blouse-dress';
      if (castGarment) { state.tryonGarment = garment.value; state.approvedAvatarManifestId = 'clairatier-cast-preview-v1'; }
    }
    normalizeCastCustomizationState(root);
    state.approvedAvatarPaletteSource = color && color.value === 'original' ? 'predefined' : 'custom';
    state.requestedPrimaryColor = color ? (color.getAttribute('data-srgb-primary') || '#D6AAA4') : '#D6AAA4';
    state.requestedSecondaryColor = color ? (color.getAttribute('data-srgb-secondary') || '') : '';
    state.requestedAccentColor = color ? (color.getAttribute('data-srgb-accent') || '') : '';
    if (isAssistantV12Enabled(root) && !castGarment) {
      if (garmentMetadata.colorSlots === 1) state.requestedSecondaryColor = '';
      else if (!state.requestedSecondaryColor) state.requestedSecondaryColor = '#F1E7D3';
      state.requestedAccentColor = '';
      state.approvedAvatarFinishId = garmentMetadata.finish;
    } else {
      state.approvedAvatarFinishId = garment && MIA_GARMENT_METADATA[garment.value]
        ? MIA_GARMENT_METADATA[garment.value].finish : '';
    }
    var wardrobe = getLocalWardrobeEntry(root, state.approvedAvatarGarmentId);
    state.requestedFinishColor = '';
    if (wardrobe) {
      var custom = state.wardrobePaletteMode === 'custom';
      var chosenColors = custom ? (state.wardrobeCustomColors || wardrobeCurrentColors(wardrobe)) : wardrobeCurrentColors(wardrobe);
      var roles = wardrobeColorRoles(wardrobe);
      state.approvedAvatarPaletteSource = custom ? 'custom' : 'catalog';
      state.requestedPrimaryColor = custom ? chosenColors.primary : wardrobeCurrentColors(wardrobe).primary;
      state.requestedSecondaryColor = roles.indexOf('secondary') !== -1 ? chosenColors.secondary : '';
      state.requestedAccentColor = roles.indexOf('accent') !== -1 ? chosenColors.accent : '';
      state.requestedFinishColor = wardrobe.finish && wardrobe.finish.color ? chosenColors.finish : '';
      state.approvedAvatarFinishId = wardrobe.finish && wardrobe.finish.kind || '';
    }
    state.selectedBackgroundId = composition.backgroundId;
    state.selectedFadeId = composition.fadeId;
    state.tryonColor = 'mixed';
    validateAssistantVisualCategory(state, validatedCategory);
    syncMiaPrototype(root);
    syncAssistantHonestPreview(root);
    syncAssistantChoiceSummary(root);
    syncAssistantGarmentManualControls(root);
    syncBackgroundEditor(root);
    updateGeneration(root);
  }

  function getMiaSelected(root, category) {
    return qs(root, '[data-mia-choice="' + category + '"]:checked');
  }

  function getMiaChoiceLabel(input) {
    var owner = input && input.closest('label');
    var strong = owner && qs(owner, 'strong');
    return strong ? strong.textContent.trim() : owner ? owner.textContent.trim() : '';
  }

  function openMiaPrototype(root) {
    var overlay = qs(root, '[data-sticker-overlay]');
    var closeButton = qs(root, '[data-sticker-action="close"]');
    if (!overlay) return;
    root._stickerPreviousFocus = document.activeElement;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sticker-customizer-open');
    window.setTimeout(function () {
      if (closeButton) closeButton.focus();
    }, 0);
  }

  function closeMiaPrototype(root) {
    var overlay = qs(root, '[data-sticker-overlay]');
    var wasOpen;
    if (!overlay) return;
    wasOpen = !overlay.hidden;
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sticker-customizer-open');
    if (wasOpen && root._stickerPreviousFocus && typeof root._stickerPreviousFocus.focus === 'function') {
      root._stickerPreviousFocus.focus();
    }
  }

  function syncMiaChoiceStyles(root) {
    qsa(root, '[data-mia-choice]').forEach(function (input) {
      var owner = input.closest('label');
      if (owner) owner.classList.toggle('is-selected', !!input.checked);
    });
  }

  function syncMiaPreview(root) {
    var prototype = qs(root, '[data-sticker-mia-prototype]');
    var style = getMiaSelected(root, 'style');
    var mode = getMiaSelected(root, 'mode');
    var background = getMiaSelected(root, 'background');
    var fade = qs(root, '[data-mia-choice="fade"]');
    var preview = qs(root, '[data-mia-preview-image]');
    var canvas = qs(root, '[data-mia-preview-canvas]');
    var backgroundImage = qs(root, '[data-mia-background-image]');
    var fadeImage = qs(root, '[data-mia-fade-image]');
    var honesty = qs(root, '[data-mia-preview-honesty]');
    var pending = qs(root, '[data-mia-pending]');
    var exactPreview;
    var pendingChoices;
    var selectedFade;
    var backgroundSrc;
    var fadeSrc;
    var loadToken;

    if (!prototype || !style || !mode || !preview || !canvas) return;
    exactPreview = getMiaExactChoiceAsset(root) || style.getAttribute('data-preview-' + (root._stickerState.presentationMode || 'standard'));
    if (exactPreview) preview.src = exactPreview;

    canvas.style.backgroundColor = '#FFFFFF';
    if (fade && background) {
      if (background.value === 'background-none-white') {
        fade.value = '';
        fade.disabled = true;
      } else {
        fade.disabled = false;
        if (!fade.value) fade.value = BACKGROUND_DEFAULT_FADE_ID;
      }
    }
    selectedFade = fade && fade.options[fade.selectedIndex];
    backgroundSrc = background ? background.getAttribute('data-background-src') || '' : '';
    fadeSrc = selectedFade ? selectedFade.getAttribute('data-fade-src') || '' : '';
    loadToken = getCompositionAssetLoadToken(root, backgroundSrc, fadeSrc);
    if (backgroundImage) {
      bindCompositionAssetPreview(root, backgroundImage, 'background', backgroundSrc, loadToken,
        background.value !== 'background-none-white');
      backgroundImage.style.transform = root._stickerState
        ? 'scale(' + root._stickerState.backgroundTransform.scale + ') translate(' +
          (root._stickerState.backgroundTransform.x * 100) + '%, ' +
          (root._stickerState.backgroundTransform.y * 100) + '%)'
        : '';
    }
    if (fadeImage) {
      bindCompositionAssetPreview(root, fadeImage, 'fade', fadeSrc, loadToken,
        background.value !== 'background-none-white' && !!fade.value);
    }

    pendingChoices = qsa(root, '[data-requires-generation="true"]:checked');
    if (pending) pending.hidden = pendingChoices.length === 0;
    if (honesty) {
      honesty.textContent = prototype.getAttribute(
        pendingChoices.length ? 'data-pending-preview-status' : 'data-exact-preview-status'
      ) || '';
    }
    if (!pendingChoices.length) {
      var confirmation = qs(root, '[data-mia-generation-confirmation]');
      if (confirmation) confirmation.hidden = true;
    }
  }

  function syncMiaSummary(root) {
    var summary = qs(root, '[data-mia-choice-summary]');
    if (!summary) return;
    summary.replaceChildren();
    ['avatar', 'style', 'color', 'mode', 'hair', 'garment', 'background', 'fade'].forEach(function (category) {
      var control = getMiaSelected(root, category);
      var fieldset = qs(root, '[data-mia-step="' + category + '"]');
      var legend = fieldset && qs(fieldset, 'legend');
      var item = document.createElement('li');
      var label = legend ? legend.textContent.replace(/^\s*\d+\s*/, '').trim() : category;
      var value = control ? getMiaChoiceLabel(control) : '';
      if (category === 'fade') {
        control = qs(root, '[data-mia-choice="fade"]');
        value = control && control.options[control.selectedIndex]
          ? control.options[control.selectedIndex].textContent.trim()
          : '';
      }
      item.textContent = label + ': ' + (value || qs(root, '[data-sticker-mia-prototype]').getAttribute('data-not-selected-label') || '—');
      summary.appendChild(item);
    });
  }

  function syncMiaPrototype(root) {
    syncMiaChoiceStyles(root);
    syncMiaPreview(root);
    syncMiaSummary(root);
  }

  function isMiaDialogTabbable(element, overlay) {
    var ancestor;
    var style;
    var view;
    if (!element || !overlay || !overlay.contains(element) || element.hidden || element.disabled ||
        (typeof element.matches === 'function' && element.matches(':disabled')) ||
        element.getAttribute('aria-hidden') === 'true' || element.getAttribute('tabindex') === '-1') return false;
    ancestor = element;
    while (ancestor) {
      if (ancestor.hidden || ancestor.getAttribute('aria-hidden') === 'true' || ancestor.hasAttribute('inert')) {
        return false;
      }
      if (ancestor === overlay) break;
      ancestor = ancestor.parentElement;
    }
    if (ancestor !== overlay) return false;
    if (typeof element.getClientRects === 'function' && element.getClientRects().length === 0) return false;
    view = element.ownerDocument && element.ownerDocument.defaultView;
    if (view && typeof view.getComputedStyle === 'function') {
      style = view.getComputedStyle(element);
      if (style && (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse')) {
        return false;
      }
    }
    return true;
  }

  function getMiaDialogFocusSurface(root, event) {
    var overlay = qs(root, '[data-sticker-overlay]');
    var anchor = event && event.target;
    var surface;
    if (!overlay || overlay.hidden) return null;
    if (!anchor || !overlay.contains(anchor)) anchor = document.activeElement;
    if (anchor && overlay.contains(anchor) && typeof anchor.closest === 'function') {
      surface = anchor.closest('[role="dialog"][aria-modal="true"]');
      if (surface && overlay.contains(surface) && isMiaDialogTabbable(surface, overlay)) return surface;
    }
    return qsa(overlay, '[role="dialog"][aria-modal="true"]').filter(function (candidate) {
      return isMiaDialogTabbable(candidate, overlay) &&
        (!document.activeElement || candidate.contains(document.activeElement));
    }).pop() || null;
  }

  function trapMiaPrototypeFocus(root, event) {
    var overlay;
    var surface;
    var focusable;
    var first;
    var index;
    var last;
    if (event.key !== 'Tab' || event.defaultPrevented) return;
    overlay = qs(root, '[data-sticker-overlay]');
    if (!overlay || overlay.hidden) return;
    surface = getMiaDialogFocusSurface(root, event);
    if (!surface) return;
    focusable = qsa(surface, 'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
      .filter(function (element) { return isMiaDialogTabbable(element, overlay); });
    if (!focusable.length) return;
    first = focusable[0];
    last = focusable[focusable.length - 1];
    index = focusable.indexOf(document.activeElement);
    if (event.shiftKey && (index === 0 || index === -1)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (index === focusable.length - 1 || index === -1)) {
      event.preventDefault();
      first.focus();
    }
  }

  function bindMiaDialogFocusTrap(root) {
    var overlay = qs(root, '[data-sticker-overlay]');
    if (!overlay || overlay._stickerFocusTrapBound) return;
    overlay._stickerFocusTrapBound = true;
    overlay.addEventListener('keydown', function (event) { trapMiaPrototypeFocus(root, event); });
  }

  function initMiaPrototype(root) {
    var prototype;
    var overlay;
    if (isMiaRuntimeReady(root) || !isMiaPrototypeEnabled(root)) return false;
    prototype = qs(root, '[data-sticker-mia-prototype]');
    overlay = qs(root, '[data-sticker-overlay]');
    if (!prototype || !overlay) return false;

    root._stickerReady = true;
    root.setAttribute('data-sticker-mia-prototype-active', 'true');
    prototype.hidden = false;
    roots.push(root);
    syncMiaPrototype(root);

    root.addEventListener('click', function (event) {
      var legacyAction = event.target.closest('[data-sticker-action]');
      var action = event.target.closest('[data-mia-action]');
      var confirmation;
      var liveStatus;
      if (legacyAction && root.contains(legacyAction)) {
        if (legacyAction.getAttribute('data-sticker-action') === 'open') openMiaPrototype(root);
        if (legacyAction.getAttribute('data-sticker-action') === 'close') closeMiaPrototype(root);
      }
      if (!action || !root.contains(action)) return;
      if (action.getAttribute('data-mia-action') === 'review-generation') {
        confirmation = qs(root, '[data-mia-generation-confirmation]');
        if (confirmation) {
          confirmation.hidden = false;
          var confirmButton = qs(confirmation, '[data-mia-action="confirm-prototype-generation"]');
          if (confirmButton) confirmButton.focus();
        }
      }
      if (action.getAttribute('data-mia-action') === 'cancel-generation') {
        confirmation = qs(root, '[data-mia-generation-confirmation]');
        if (confirmation) confirmation.hidden = true;
      }
      if (action.getAttribute('data-mia-action') === 'confirm-prototype-generation') {
        liveStatus = qs(root, '[data-mia-live-status]');
        if (liveStatus) liveStatus.textContent = prototype.getAttribute('data-prototype-no-send-status') || '';
        confirmation = qs(root, '[data-mia-generation-confirmation]');
        if (confirmation) confirmation.hidden = true;
      }
      if (action.getAttribute('data-mia-action') === 'full-options') {
        var note = qs(root, '[data-mia-full-options-note]');
        if (note) note.hidden = false;
      }
    });

    qsa(root, '[data-mia-choice]').forEach(function (control) {
      control.addEventListener('change', function () { syncMiaPrototype(root); });
    });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeMiaPrototype(root);
    });
    bindMiaDialogFocusTrap(root);
    return true;
  }

  function init(root) {
    if (root.closest('[data-clairatier-cart-renderer]')) root._localReadonlyPreview = true;
    bindApprovedCompositionNativeCartGuard(root);
    root.setAttribute('data-sticker-ai-enabled', String(CUSTOMIZER_AI_ENABLED));
    var guidedPreferences;
    var assistantConversation;
    var defaultStyle;
    var preview;
    if (root._stickerReady) return;
    if (getMiaInitializationMode(root) === 'prototype' && initMiaPrototype(root)) return;
    root._stickerReady = true;
    guidedPreferences = readGuidedPreferences(root) || {};
    assistantConversation = readAssistantConversation(root);
    bindAssistantVisualViewport(root);
    bindCustomizerFullscreen(root);
    root._stickerState = {
      topSize: 78,
      textColor: '#000000',
      bottomSize: 78,
      photoScale: 1,
      photoX: 0,
      photoY: 0,
      subjectSource: isMiaRuntimeReady(root)
        ? 'approved-avatar'
        : 'photo',
      approvedAvatarManifestId: 'clairatier-avatar-pilot-v1',
      approvedAvatarId: 'mia',
      presentationMode: 'standard',
      appearanceMode: 'standard',
      selectedAccessoryId: '',
      accessoryAudience: 'girl',
      hairAudience: 'girl',
      approvedAvatarGarmentId: 'garment-yoke-blouse-dress',
      approvedAvatarHairstyleId: '',
      approvedAvatarPaletteSource: 'catalog',
      requestedPrimaryColor: '#D6AAA4',
      requestedSecondaryColor: '#F1E7D3',
      requestedAccentColor: '',
      approvedAvatarFinishId: '',
      wardrobeAudience: 'girl',
      wardrobeColorTarget: 'primary',
      wardrobeStage: 'outfit',
      wardrobeEditing: false,
      wardrobePaletteMode: 'catalog',
      wardrobePaletteEdited: false,
      wardrobePaletteValidated: true,
      wardrobeChosenColorRoles: {},
      selectedBackgroundId: guidedPreferences.choices && guidedPreferences.choices.backgroundId || 'background-none-white',
      selectedFadeId: guidedPreferences.choices && guidedPreferences.choices.fadePresetId || '',
      sunEnabled: false, previewBackground: false, avatarBottomFade: 0,
      backgroundTransform: normalizeBackgroundTransform(
        guidedPreferences.choices && guidedPreferences.choices.backgroundTransform
      ),
      assistantBackgroundExpanded: false,
      backgroundEditorOpen: false,
      backgroundEditorPreviousFocus: null,
      backgroundEditorPreviousExperience: '',
      backgroundGenerationDisclosure: null,
      compositionAssetLoadKey: '',
      compositionAssetLoadToken: 0,
      compositionAssetRecoveryToken: 0,
      style: guidedPreferences.choices && guidedPreferences.choices.style ||
        (isMiaRuntimeReady(root) ? 'signature' : 'manga'),
      symbolChoice: 'yes',
      symbol: '',
      avatarInstructionsChoice: 'yes',
      avatarInstructions: '',
      generatedStyles: {},
      generationResults: {},
      generationAttempts: readGenerationAttempts(root),
      includedGenerationsTotal: GENERATION_INCLUDED_TOTAL,
      creditBalance: 0,
      generatedStyle: '',
      selectedGenerationId: '',
      selectedGenerationLabel: '',
      selectedGenerationIdsByStyle: {},
      previewingGeneratedAvatar: false,
      cartGenerationIds: {},
      lastGenerationPayload: {},
      generationStatus: GENERATION_STATUS.IDLE,
      generationEntitlementsVerified: false,
      includedGenerationsRemaining: 0,
      generationOutcome: '',
      activeGenerationRequestId: '',
      lastGenerationError: '',
      isGenerating: false,
      analyticsCompletedSteps: {},
      analyticsGenerationStartedAt: 0,
      tryonColor: guidedPreferences.choices && guidedPreferences.choices.color || 'mixed',
      tryonGarment: guidedPreferences.choices && guidedPreferences.choices.garment || 'A',
      activeTab: 'photo',
      assistantExperience: !isGuidedExperienceEnabled(root) || guidedPreferences.experience === 'full'
        ? 'full'
        : 'guided',
      guidedPreviewMode: 'foreground',
      validatedAssistantChoices: {
        style: !!(guidedPreferences.validatedChoices && guidedPreferences.validatedChoices.style),
        color: !!(guidedPreferences.validatedChoices && guidedPreferences.validatedChoices.color)
      },
      processedAssistantActionIds: Array.isArray(guidedPreferences.processedActionIds)
        ? guidedPreferences.processedActionIds.slice(-GUIDED_ACTION_HISTORY_LIMIT)
        : [],
      assistantTranscript: assistantConversation.entries,
      assistantRecentTurnIds: assistantConversation.recentTurnIds,
      assistantProposals: [],
      assistantPendingTurnId: '',
      assistantRequestSequence: 0,
      assistantAbortController: null,
      assistantSending: false,
      assistantFocusedTopic: '',
      assistantPendingMessage: '',
      assistantVisualCategory: '',
      assistantControlHandoff: null,
      assistantControlHandoffOpener: null,
      assistantControlHandoffPreviousExperience: '',
      assistantControlHandoffHistory: false,
      assistantAvatarPreferenceSubtopic: 'hair-short',
      assistantGarmentGroup: 'garment-first',
      assistantHeadwearPreference: '',
      assistantExpressionPreference: '',
      assistantContextRevision: guidedPreferences.assistantV12 && Number.isInteger(guidedPreferences.assistantV12.contextRevision)
        ? Math.max(0, guidedPreferences.assistantV12.contextRevision)
        : 0,
      assistantPendingContextRevision: -1,
      assistantPhotoSelectionRevision: 0,
      assistantAvatarInstructionsRevision: 0,
      assistantContextFingerprint: guidedPreferences.assistantV12 &&
        typeof guidedPreferences.assistantV12.contextFingerprint === 'string'
        ? guidedPreferences.assistantV12.contextFingerprint.slice(0, 1200)
        : '',
      assistantGeneratedContextFingerprint: guidedPreferences.assistantV12 &&
        typeof guidedPreferences.assistantV12.generatedContextFingerprint === 'string'
        ? guidedPreferences.assistantV12.generatedContextFingerprint.slice(0, 1200)
        : '',
      activeAssistantGenerationFingerprint: '',
      assistantGenerationReview: null,
      assistantGenerationReviewFocus: null,
      assistantGenerationSubmission: null,
      assistantGenerationRetrySubmission: null,
      assistantOptionalPhotoOfferState: isMiaPrivatePilotReady(root)
        ? 'unavailable'
        : isMiaRuntimeReady(root)
          ? (guidedPreferences.assistantV12 && guidedPreferences.assistantV12.optionalPhotoOfferState === 'declined'
            ? 'declined'
            : 'pending')
          : 'unavailable',
      assistantRefinementTopics: [],
      assistantGarmentTopicStatusBeforePhoto: '',
      assistantHasUngeneratedChanges: !!(guidedPreferences.assistantV12 &&
        guidedPreferences.assistantV12.hasUngeneratedChanges),
      assistantResultComparisonVisible: false,
      assistantAcceptedGenerationId: ''
    };
    prepareCopyCartPageDefault(root);
    root._stickerState.assistantRefinementTopics = normalizeAssistantV12Topics(
      root,
      guidedPreferences.assistantV12 && guidedPreferences.assistantV12.refinementTopics
    );
    disableMiaPrivatePilotPhotoControls(root);
    syncAssistantShell(root);
    if (!getGuidedChoiceElement(root, 'style', root._stickerState.style)) {
      root._stickerState.style = 'manga';
      root._stickerState.validatedAssistantChoices.style = false;
    }
    if (!getGuidedChoiceElement(root, 'color', root._stickerState.tryonColor)) {
      root._stickerState.tryonColor = 'mixed';
      root._stickerState.validatedAssistantChoices.color = false;
    }
    if (!getGuidedChoiceElement(root, 'garment', root._stickerState.tryonGarment)) {
      root._stickerState.tryonGarment = isAssistantV12Enabled(root) ? 'garment-yoke-blouse-dress' : 'A';
    }
    qsa(root, '[data-sticker-style]').forEach(function (radio) {
      radio.checked = radio.getAttribute('data-sticker-style-key') === root._stickerState.style;
    });
    if (!qs(root, '[data-sticker-style]:checked')) {
      defaultStyle = qs(root, '[data-sticker-style][data-sticker-style-key="manga"]');
      if (defaultStyle) defaultStyle.checked = true;
    }
    preview = qs(root, '[data-sticker-preview]');
    if (preview) {
      preview.className = 'sticker-customizer__sticker sticker-customizer__sticker--' +
        root._stickerState.style;
    }
    roots.push(root);
    bindMiaDialogFocusTrap(root);
    root.addEventListener('keydown', function (event) { navigateAssistantVisualCards(root, event); });

    updateText(root, 'top');
    updateText(root, 'bottom');
    updateSize(root, 'top');
    updateSize(root, 'bottom');
    updateSelectedStyle(root);
    updateSymbol(root, false);
    updateAvatarInstructions(root, false);
    updateStyleGuide(root);
    updateTryon(root);
    updateGeneration(root);
    updateConfig(root);
    refreshGenerationEntitlements(root);
    publishGuidedContext(root);
    renderAssistantTranscript(root);
    initMiaRuntime(root);
    captureCopyCartPageDefaultContext(root);
    initLocalJourney(root);

    root.addEventListener('click', function (event) {
      var actionEl = event.target.closest('[data-sticker-action]');
      var tabEl = event.target.closest('[data-sticker-tab]');
      var infoEl = event.target.closest('[data-sticker-info]');
      var sizeEl = event.target.closest('[data-sticker-size]');
      var photoAdjustEl = event.target.closest('[data-sticker-photo-adjust]');
      var tryonColorEl = event.target.closest('[data-sticker-tryon-color]');
      var tryonGarmentEl = event.target.closest('[data-sticker-tryon-garment]');
      var miaGarmentManualEl = event.target.closest('[data-sticker-mia-garment-manual-choice]');
      var assistantSuggestionEl = event.target.closest('[data-sticker-assistant-suggestion]');
      var assistantSubmitEl = event.target.closest('[data-sticker-assistant-submit]');
      var assistantRetryEl = event.target.closest('[data-sticker-assistant-retry]');
      var generationReviewConfirmEl = event.target.closest('[data-sticker-generation-review-confirm]');
      var generationReviewRetryEl = event.target.closest('[data-sticker-generation-review-retry]');
      var generationReviewCancelEl = event.target.closest('[data-sticker-generation-review-cancel]');
      var generationIssueRetryEl = event.target.closest('[data-sticker-generation-issue-retry]');
      var guidedTextCompleteEl = event.target.closest('[data-sticker-guided-text-complete]');
      var resultLoopEl = event.target.closest('[data-sticker-result-loop-action]');
      var avatarPreferenceApplyEl = event.target.closest('[data-sticker-avatar-preference-apply]');

      if (resultLoopEl && root.contains(resultLoopEl)) {
        handleAssistantResultAction(root, resultLoopEl.getAttribute('data-sticker-result-loop-action'));
        return;
      }
      if (avatarPreferenceApplyEl && root.contains(avatarPreferenceApplyEl)) {
        applyAssistantAvatarPreferenceText(root);
        return;
      }

      if (assistantSuggestionEl && root.contains(assistantSuggestionEl)) {
        activateGuidedSuggestion(root, assistantSuggestionEl);
      }
      if (assistantSubmitEl && root.contains(assistantSubmitEl)) {
        submitGuidedFreeText(root);
      }
      if (assistantRetryEl && root.contains(assistantRetryEl)) {
        retryAssistantTurn(root, assistantRetryEl.getAttribute('data-sticker-assistant-retry') || '');
      }
      if (generationReviewConfirmEl && root.contains(generationReviewConfirmEl)) {
        confirmAssistantGenerationReview(root);
      }
      if (generationReviewRetryEl && root.contains(generationReviewRetryEl)) {
        retryAssistantGenerationSubmission(root);
      }
      if (generationReviewCancelEl && root.contains(generationReviewCancelEl)) {
        cancelAssistantGenerationReview(root);
      }
      if (generationIssueRetryEl && root.contains(generationIssueRetryEl)) {
        retryAssistantGenerationSubmission(root);
      }
      if (guidedTextCompleteEl && root.contains(guidedTextCompleteEl)) {
        root._stickerState.assistantFocusedTopic = '';
        renderGuidedNextActions(root);
        dispatchGuidedAction(root, {
          id: createGuidedActionId(isAssistantV12Enabled(root) ? 'generate_now' : 'request_generation'),
          action: isAssistantV12Enabled(root) ? 'generate_now' : 'request_generation',
          args: {}
        });
      }

      if (actionEl && root.contains(actionEl)) {
        var action = actionEl.getAttribute('data-sticker-action');
        if (action === 'open') open(root);
        if (action === 'close') close(root);
        if (action === 'toggle-fullscreen') toggleCustomizerFullscreen(root);
        if (action === 'close-generation-progress') closeGenerationProgress(root, true);
        if (action === 'primary') runPrimaryAction(root);
        if (action === 'generate-style') requestGenerationConfirmation(root, 'manual-generation');
        if (action === 'retry-photo-preflight') {
          hideGenerationError(root);
          generateStyle(root);
        }
        if (action === 'replace-photo-after-preflight') {
          hideGenerationError(root);
          setTab(root, 'photo');
          var replacementPicker = qs(root, '[data-sticker-photo-picker]');
          if (replacementPicker) replacementPicker.click();
        }
        if (action === 'buy-generation-credits') {
          event.preventDefault();
          prepareCreditPurchase(
            root,
            actionEl.getAttribute('href') || getGenerationCreditProductUrl(root)
          );
        }
        if (action === 'add-generation') {
          addGenerationToCart(root, actionEl.getAttribute('data-sticker-generation-id'));
        }
        if (action === 'remove-generation') {
          removeGenerationFromCart(root, actionEl.getAttribute('data-sticker-generation-id'));
        }
        if (action === 'select-generation') {
          var selected = getGenerationById(root, actionEl.getAttribute('data-sticker-generation-id'));
          selectGenerationForPreview(root, selected);
        }
        if (action === 'dismiss-toast') hideToast(root);
        if (action === 'open-style-example') openStyleExample(root, actionEl);
        if (action === 'close-style-example') closeStyleExample(root);
        if (action === 'toggle-preview') {
          var expanded = !root.classList.contains('is-preview-large');
          if (root._stickerState.assistantExperience === 'guided') {
            if (expanded) {
              setGuidedPreviewMode(root, 'foreground');
              root.classList.add('is-preview-large');
            } else {
              root.classList.remove('is-preview-large');
              setGuidedPreviewMode(root, 'shelf');
            }
            syncAssistantShell(root);
          } else {
            root.classList.toggle('is-preview-large', expanded);
            syncAssistantShell(root);
          }
        }
      }

      if (tabEl && root.contains(tabEl)) {
        setTab(root, tabEl.getAttribute('data-sticker-tab'));
      }

      if (tryonColorEl && root.contains(tryonColorEl)) {
        root._stickerState.validatedAssistantChoices.color = true;
        root._stickerState.tryonColor = tryonColorEl.getAttribute('data-sticker-tryon-color') || 'mixed';
        updateTryon(root);
        emitStepCompleted(root, 'color');
      }

      if (tryonGarmentEl && root.contains(tryonGarmentEl)) {
        if (isAssistantV12Enabled(root)) return;
        root._stickerState.tryonGarment = tryonGarmentEl.getAttribute('data-sticker-tryon-garment') || 'A';
        updateTryon(root);
        emitAnalyticsEvent('clairatier_refinement_selected', {
          category_code: 'garment'
        });
      }

      if (miaGarmentManualEl && root.contains(miaGarmentManualEl)) {
        applyAssistantGarmentChoice(root,
          miaGarmentManualEl.getAttribute('data-sticker-mia-garment-manual-choice') || '');
        syncAssistantGarmentManualControls(root);
      }

      if (infoEl && root.contains(infoEl)) {
        var infoName = infoEl.getAttribute('data-sticker-info');
        var panel = qs(root, '[data-sticker-info-panel="' + infoName + '"]');
        if (panel) panel.hidden = !panel.hidden;
      }

      if (sizeEl && root.contains(sizeEl)) {
        var position = sizeEl.getAttribute('data-sticker-size');
        var step = parseInt(sizeEl.getAttribute('data-sticker-step'), 10) || 0;
        if (position === 'top') {
          root._stickerState.topSize = clamp(root._stickerState.topSize + step * 4, 56, 106);
        } else {
          root._stickerState.bottomSize = clamp(root._stickerState.bottomSize + step * 4, 56, 106);
        }
        updateSize(root, position);
        resetGeneration(root);
      }

      if (photoAdjustEl && root.contains(photoAdjustEl)) {
        adjustPhoto(
          root,
          photoAdjustEl.getAttribute('data-sticker-photo-adjust'),
          parseInt(photoAdjustEl.getAttribute('data-sticker-step'), 10) || 0
        );
      }
    });
    var avatarPreferenceSubtopic = qs(root, '[data-sticker-avatar-preference-subtopic]');
    if (avatarPreferenceSubtopic) {
      avatarPreferenceSubtopic.addEventListener('change', function () {
        var value = avatarPreferenceSubtopic.value;
        if (['hair-short', 'hair-medium', 'hair-styled', 'headwear', 'expression'].indexOf(value) === -1) return;
        root._stickerState.assistantAvatarPreferenceSubtopic = value;
        root._stickerState.assistantVisualCategory = 'hairstyle';
        renderGuidedNextActions(root);
        syncAssistantAvatarPreferencePanel(root);
        var target = value.indexOf('hair-') === 0
          ? qs(root, '[data-sticker-assistant-choices] [data-sticker-assistant-suggestion]')
          : qs(root, '[data-sticker-avatar-preference-text]');
        if (target && typeof target.focus === 'function') target.focus();
      });
    }
    var garmentGroup = qs(root, '[data-sticker-garment-group]');
    if (garmentGroup) {
      garmentGroup.addEventListener('change', function () {
        var value = garmentGroup.value;
        if (!MIA_GARMENT_GROUPS[value]) return;
        root._stickerState.assistantGarmentGroup = value;
        root._stickerState.assistantVisualCategory = 'garment';
        renderGuidedNextActions(root);
        syncAssistantGarmentNavigator(root);
        var target = qs(root, '[data-sticker-assistant-choices] [data-sticker-assistant-suggestion]');
        if (target && typeof target.focus === 'function') target.focus();
      });
    }

    var overlay = qs(root, '[data-sticker-overlay]');
    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) close(root);
      });
    }

    var exampleModal = qs(root, '[data-sticker-example-modal]');
    if (exampleModal) {
      exampleModal.addEventListener('click', function (event) {
        if (event.target === exampleModal) closeStyleExample(root);
      });
    }

    qsa(root, '.sticker-customizer__style-example-image img').forEach(function (image) {
      image.addEventListener('error', function () {
        var fallback = image.getAttribute('data-example-fallback-src');
        if (fallback && image.src !== fallback) image.src = fallback;
      });
    });

    qsa(root, '[data-sticker-text]').forEach(function (input) {
      input.addEventListener('input', function () {
        var position = input.getAttribute('data-sticker-text');
        var error = qs(root, '[data-sticker-error="text-' + position + '"]');
        updateText(root, position);
        if (error && input.value.trim()) error.hidden = true;
        resetGeneration(root);
      });
    });

    qsa(root, '[data-sticker-guided-text]').forEach(function (input) {
      input.addEventListener('input', function () {
        var position = input.getAttribute('data-sticker-guided-text');
        var maxChars = parseInt(input.getAttribute('data-sticker-text-maxlength'), 10) || 26;
        var value = normalizeStickerText(input.value, maxChars);
        var canonicalInput = qs(root, '[data-sticker-text="' + position + '"]');
        var choices;

        if (!canonicalInput) return;
        input.value = value;
        if (value && hasNoTextChoice(root, position)) {
          choices = qsa(root, '[data-sticker-text-choice="' + position + '"]');
          choices.forEach(function (choice) {
            choice.checked = choice.value === 'yes';
          });
          canonicalInput.value = value;
          updateTextChoice(root, position);
        } else {
          canonicalInput.value = value;
          updateText(root, position);
          resetGeneration(root);
        }
        syncGuidedTextStep(root);
      });
    });

    qsa(root, '[data-sticker-text-choice]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var position = radio.getAttribute('data-sticker-text-choice');
        qsa(root, '[data-sticker-text-choice="' + position + '"]').forEach(function (choice) {
          choice.checked = choice === radio;
        });
        updateTextChoice(root, position);
      });
    });

    qsa(root, '[data-sticker-style]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var styleKey;
        if (!radio.checked) return;
        styleKey = getStyleKey(radio);
        if (!styleKey) return;
        root._stickerState.validatedAssistantChoices.style = true;
        updateSelectedStyle(root);
        setStyle(root, styleKey);
        emitStepCompleted(root, 'style');
      });
    });

    qsa(root, '[data-sticker-symbol-choice]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        qsa(root, '[data-sticker-symbol-choice]').forEach(function (choice) {
          choice.checked = choice === radio;
        });
        updateSymbol(root, true);
      });
    });

    var symbolInput = qs(root, '[data-sticker-symbol-input]');
    if (symbolInput) {
      symbolInput.addEventListener('input', function () {
        updateSymbol(root, true);
      });
    }

    qsa(root, '[data-sticker-avatar-instructions-choice]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        qsa(root, '[data-sticker-avatar-instructions-choice]').forEach(function (choice) {
          choice.checked = choice === radio;
        });
        updateAvatarInstructions(root, true);
      });
    });

    var avatarInstructionsInput = qs(root, '[data-sticker-avatar-instructions-input]');
    if (avatarInstructionsInput) {
      avatarInstructionsInput.addEventListener('input', function () {
        updateAvatarInstructions(root, true);
      });
    }

    var assistantInput = qs(root, '[data-sticker-assistant-input]');
    if (assistantInput) {
      assistantInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
        event.preventDefault();
        submitGuidedFreeText(root);
      });
    }

    var fileInput = qs(root, '[data-sticker-photo-input]');
    var photoPicker = qs(root, '[data-sticker-photo-picker]');
    if (fileInput) {
      function handleNativePhotoSelection() {
        if (isMiaPrivatePilotReady(root)) return;
        processPhotoSubjectSelection(root, fileInput, fileInput.files && fileInput.files[0], 'native-file-input');
      }

      // Android emits input before change. Reading here minimizes the time between
      // the native picker granting access and JavaScript copying the temporary file.
      fileInput.addEventListener('input', handleNativePhotoSelection);
      fileInput.addEventListener('change', handleNativePhotoSelection);
    }

    if (photoPicker && fileInput) {
      photoPicker.addEventListener('click', function () {
        if (isMiaPrivatePilotReady(root)) return;
        if (window.isSecureContext && typeof window.showOpenFilePicker === 'function') {
          root._stickerPhotoPickerSource = 'file-system-access';
          window.showOpenFilePicker({
            id: 'clairatier-child-photo',
            multiple: false,
            startIn: 'pictures',
            types: [{
              description: translate(root, 'imagePickerDescription'),
              accept: {
                'image/jpeg': ['.jpg', '.jpeg'],
                'image/png': ['.png'],
                'image/webp': ['.webp']
              }
            }]
          })
            .then(function (handles) {
              if (!handles || !handles[0]) throw new Error('file-picker-empty');
              return handles[0].getFile();
            })
            .then(function (file) {
              processPhotoSubjectSelection(root, fileInput, file, 'file-system-access');
            })
            .catch(function (pickerError) {
              if (pickerError && pickerError.name === 'AbortError') return;
              setPhotoDebug(root, null, 'PHOTO_PICKER_API_FAILED', pickerError, [], {
                fallback: 'native-file-input'
              });
              root._stickerPhotoSelectionFile = null;
              root._stickerPhotoPickerSource = 'native-file-input';
              fileInput.value = '';
              fileInput.click();
            });
          return;
        }

        root._stickerPhotoSelectionFile = null;
        root._stickerPhotoPickerSource = 'native-file-input';
        fileInput.value = '';
        fileInput.click();
      });
    }
  }

  function isBackgroundEditorFocusTargetVisible(element) {
    var hiddenAncestor;
    if (!element || typeof element.focus !== 'function' || element.disabled || element.hidden ||
        !document.contains(element)) return false;
    hiddenAncestor = element.closest && element.closest('[hidden], [aria-hidden="true"]');
    if (hiddenAncestor) return false;
    return typeof element.getClientRects !== 'function' || element.getClientRects().length > 0;
  }

  function focusBackgroundEditorTarget(root, target) {
    root._stickerAssistantFocusSequence = (root._stickerAssistantFocusSequence || 0) + 1;
    var focusSequence = root._stickerAssistantFocusSequence;
    window.setTimeout(function () {
      if (focusSequence !== root._stickerAssistantFocusSequence ||
          !isBackgroundEditorFocusTargetVisible(target)) return;
      target.focus();
    }, 0);
  }

  function openBackgroundEditor(root, focusEditor, opener) {
    var state = root && root._stickerState;
    var editor = root && qs(root, '[data-sticker-background-editor]');
    var title = editor && qs(editor, 'h4');
    if (!state || !editor || !isAssistantVisualCardsReady(root)) return false;
    if (!state.backgroundEditorOpen) {
      state.backgroundEditorPreviousFocus = opener || document.activeElement;
      state.backgroundEditorPreviousExperience = state.assistantExperience;
    }
    if (state.assistantExperience === 'full') setAssistantExperience(root, 'guided');
    state.backgroundEditorOpen = true;
    state.assistantVisualCategory = '';
    syncBackgroundEditor(root);
    renderGuidedNextActions(root);
    if (focusEditor !== false && title) focusBackgroundEditorTarget(root, title);
    return true;
  }

  function closeBackgroundEditor(root, restoreFocus) {
    var state = root && root._stickerState;
    var opener = state && state.backgroundEditorPreviousFocus;
    var previousExperience = state && state.backgroundEditorPreviousExperience;
    var focusTarget;
    if (!state) return;
    state.backgroundEditorOpen = false;
    state.backgroundEditorPreviousFocus = null;
    state.backgroundEditorPreviousExperience = '';
    if (previousExperience && previousExperience !== state.assistantExperience) {
      setAssistantExperience(root, previousExperience);
    } else {
      syncBackgroundEditor(root);
    }
    if (!restoreFocus) return;
    focusTarget = isBackgroundEditorFocusTargetVisible(opener) ? opener :
      qsa(root, '[data-sticker-background-editor-open]').filter(isBackgroundEditorFocusTargetVisible)[0];
    if (focusTarget) focusBackgroundEditorTarget(root, focusTarget);
  }

  function commitFreeCompositionEdit(root, topic) {
    var state = root && root._stickerState;
    var selected;
    var fingerprint;
    var hadUngeneratedChanges;
    if (!state) return false;
    hadUngeneratedChanges = !!state.assistantHasUngeneratedChanges;
    resolveMiaCompositionState(root);
    syncMiaChoiceStyles(root);
    syncMiaPrototype(root);
    syncAssistantHonestPreview(root);
    syncAssistantChoiceSummary(root);
    syncBackgroundEditor(root);
    selected = getSelectedGeneration(root);
    if (isAssistantV12Enabled(root)) {
      fingerprint = getAssistantContextFingerprint(root);
      state.assistantContextRevision += 1;
      state.assistantContextFingerprint = fingerprint;
      if (!hadUngeneratedChanges) {
        if (selected || state.assistantGeneratedContextFingerprint) {
          state.assistantGeneratedContextFingerprint = fingerprint;
        }
        state.assistantHasUngeneratedChanges = false;
        if (selected) selected.contextFingerprintSnapshot = fingerprint;
        if (selected && state.assistantAcceptedGenerationId === selected.id) {
          selected.acceptedCartSnapshot = freezeAcceptedDesignSnapshot(root, selected);
        }
      }
    }
    if (topic && state.assistantRefinementTopics) {
      state.assistantRefinementTopics = state.assistantRefinementTopics.map(function (entry) {
        return entry.topic === topic ? { topic: entry.topic, status: 'completed' } : entry;
      });
    }
    publishGuidedContext(root);
    syncAssistantResultLoop(root);
    updateGeneration(root);
    return true;
  }

  function applyBackgroundSelection(root, backgroundId) {
    var state = root && root._stickerState;
    var control = getBackgroundControl(root, backgroundId);
    var previousId;
    var fade;
    var adjustment;
    if (!state || !control) return { ok: false, code: 'background-unavailable' };
    if (control.getAttribute('data-background-style') &&
        control.getAttribute('data-background-style') !== state.style) {
      return { ok: false, code: 'background-incompatible' };
    }
    previousId = state.selectedBackgroundId || 'background-none-white';
    if (previousId === backgroundId) return { ok: true, duplicate: true };
    selectBackgroundControl(root, backgroundId);
    fade = qs(root, '[data-mia-choice="fade"]');
    adjustment = qs(root, '[data-sticker-background-adjustment]');
    if (backgroundId === 'background-none-white') {
      if (fade) fade.value = '';
      resetBackgroundTransform(state);
    } else if (previousId === 'background-none-white') {
      if (fade) fade.value = BACKGROUND_DEFAULT_FADE_ID;
      resetBackgroundTransform(state);
      if (adjustment) {
        adjustment.hidden = false;
        adjustment.textContent = getBackgroundEditorMessage(root, 'default-fade-applied');
      }
    }
    state.assistantVisualCategory = '';
    commitFreeCompositionEdit(root, 'background');
    return { ok: true };
  }

  function applyFadeSelection(root, fadeId) {
    var state = root && root._stickerState;
    var select = root && qs(root, '[data-mia-choice="fade"]');
    var available;
    if (!state || !select || state.selectedBackgroundId === 'background-none-white') {
      return { ok: false, code: 'fade-unavailable' };
    }
    available = qsa(select, 'option').some(function (option) { return option.value === fadeId && !!fadeId; });
    if (!available) return { ok: false, code: 'fade-unavailable' };
    if (state.selectedFadeId === fadeId) return { ok: true, duplicate: true };
    select.value = fadeId;
    commitFreeCompositionEdit(root, 'fade');
    return { ok: true };
  }

  function adjustBackgroundTransform(root, dimension, step) {
    var state = root && root._stickerState;
    var transform;
    if (!state || state.selectedBackgroundId === 'background-none-white') return false;
    transform = normalizeBackgroundTransform(state.backgroundTransform);
    if (dimension === 'reset') {
      resetBackgroundTransform(state);
    } else if (dimension === 'scale') {
      transform.scale += (Number(step) < 0 ? -1 : 1) * BACKGROUND_TRANSFORM_SCALE_STEP;
      state.backgroundTransform = normalizeBackgroundTransform(transform);
    } else if (dimension === 'x' || dimension === 'y') {
      transform[dimension] += (Number(step) < 0 ? -1 : 1) * BACKGROUND_TRANSFORM_PAN_STEP;
      state.backgroundTransform = normalizeBackgroundTransform(transform);
    } else {
      return false;
    }
    commitFreeCompositionEdit(root, 'background');
    return true;
  }

  function navigateBackgroundEditorRail(event) {
    var rail = event.target && event.target.closest && event.target.closest(
      '[data-sticker-background-rail], .sticker-customizer__fade-rail'
    );
    var cards;
    var index;
    var nextIndex;
    if (!rail || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
    cards = qsa(rail, 'button:not([hidden])');
    index = cards.indexOf(event.target);
    if (index === -1 || !cards.length) return;
    if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = cards.length - 1;
    else nextIndex = clamp(index + (event.key === 'ArrowRight' ? 1 : -1), 0, cards.length - 1);
    event.preventDefault();
    cards[nextIndex].focus();
    if (typeof cards[nextIndex].scrollIntoView === 'function') {
      cards[nextIndex].scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
    }
  }

  function applyBackgroundGenerationDisclosure(root, disclosure) {
    var state = root && root._stickerState;
    if (!state) return null;
    if (areMiaPrivatePilotPaidActionsBlocked(root)) {
      state.backgroundGenerationDisclosure = null;
      return null;
    }
    if (root.getAttribute('data-sticker-background-generation-enabled') !== 'true' ||
        !disclosure || disclosure.creditCost !== 1 ||
        !Number.isInteger(disclosure.creditBalance) || disclosure.creditBalance < 0 ||
        typeof disclosure.canGenerate !== 'boolean') {
      state.backgroundGenerationDisclosure = null;
      syncBackgroundEditor(root);
      return null;
    }
    state.backgroundGenerationDisclosure = {
      creditCost: 1,
      creditBalance: disclosure.creditBalance,
      canGenerate: disclosure.canGenerate
    };
    syncBackgroundEditor(root);
    return state.backgroundGenerationDisclosure;
  }

  function confirmBackgroundGeneration(root) {
    var state = root && root._stickerState;
    var disclosure = state && state.backgroundGenerationDisclosure;
    var confirmation;
    var status;
    if (!state) return false;
    if (areMiaPrivatePilotPaidActionsBlocked(root)) {
      state.backgroundGenerationDisclosure = null;
      return false;
    }
    if (!disclosure || disclosure.creditCost !== 1 || !disclosure.canGenerate) return false;
    emitGuidedEvent(root, 'clairatier:background-generation-confirmed', {
      explicitCustomerConfirmation: true,
      disclosedCreditCost: 1,
      disclosedCreditBalance: disclosure.creditBalance,
      previousBackgroundId: state.selectedBackgroundId === 'background-none-white'
        ? '' : state.selectedBackgroundId
    });
    confirmation = qs(root, '[data-sticker-background-generation-confirmation]');
    status = qs(root, '[data-sticker-background-generation-status]');
    if (confirmation) confirmation.hidden = true;
    if (status) status.textContent = getBackgroundEditorMessage(root, 'generation-confirmed');
    state.backgroundGenerationDisclosure = null;
    syncBackgroundEditor(root);
    return true;
  }

  function bindBackgroundGenerationConfirmation(root, button) {
    if (!button) return false;
    button.addEventListener('click', function () { confirmBackgroundGeneration(root); });
    return true;
  }

  function initMiaRuntime(root) {
    var prototype = qs(root, '[data-sticker-mia-prototype]');
    var overlay = qs(root, '[data-sticker-overlay]');
    var visualCardsReady;
    if (!isMiaRuntimeReady(root) || !prototype || !overlay) return;
    visualCardsReady = isAssistantVisualCardsReady(root);
    root.toggleAttribute('data-sticker-assistant-visual-cards', visualCardsReady);
    if (visualCardsReady) root.removeAttribute('data-sticker-mia-prototype-active');
    else root.setAttribute('data-sticker-mia-prototype-active', 'true');
    prototype.hidden = visualCardsReady;
    prototype.setAttribute('aria-hidden', visualCardsReady ? 'true' : 'false');
    if (visualCardsReady) prototype.setAttribute('inert', '');
    else prototype.removeAttribute('inert');
    if (visualCardsReady && isAssistantV12Enabled(root)) {
      var preferredGarment = MIA_GARMENT_IDS.indexOf(root._stickerState.tryonGarment) !== -1
        ? root._stickerState.tryonGarment
        : 'garment-yoke-blouse-dress';
      qsa(root, '[data-mia-choice="garment"]').forEach(function (control) {
        control.checked = control.value === preferredGarment;
      });
    }
    var restoredBackground = selectBackgroundControl(root, root._stickerState.selectedBackgroundId);
    if (!restoredBackground || (restoredBackground.getAttribute('data-background-style') &&
        restoredBackground.getAttribute('data-background-style') !== root._stickerState.style)) {
      restoredBackground = selectBackgroundControl(root, 'background-none-white');
      root._stickerState.selectedBackgroundId = 'background-none-white';
      root._stickerState.selectedFadeId = '';
      resetBackgroundTransform(root._stickerState);
    }
    var restoredFade = qs(root, '[data-mia-choice="fade"]');
    if (restoredFade) {
      var storedFadeAvailable = qsa(restoredFade, 'option').some(function (option) {
        return option.value === root._stickerState.selectedFadeId;
      });
      restoredFade.value = restoredBackground.value === 'background-none-white'
        ? ''
        : storedFadeAvailable && root._stickerState.selectedFadeId
          ? root._stickerState.selectedFadeId
          : BACKGROUND_DEFAULT_FADE_ID;
    }
    syncMiaRuntimeChoices(root, '');
    publishGuidedContext(root);
    qsa(root, '[data-mia-choice]').forEach(function (control) {
      control.addEventListener('change', function () {
        var category = control.getAttribute('data-mia-choice');
        syncMiaRuntimeChoices(root, category === 'hair' ? 'hairstyle' : category);
        markAssistantContextChanged(root, category === 'hair' ? 'hairstyle' :
          category === 'avatar' ? 'avatar-transform' : category);
        publishGuidedContext(root);
      });
    });
    var backgroundEditorOpeners = qsa(root, '[data-sticker-background-editor-open]');
    var backgroundEditorClose = qs(root, '[data-sticker-background-editor-close]');
    var browseAllBackgrounds = qs(root, '[data-sticker-background-browse-all]');
    backgroundEditorOpeners.forEach(function (button) {
      button.addEventListener('click', function () { openBackgroundEditor(root, true, button); });
    });
    if (backgroundEditorClose) backgroundEditorClose.addEventListener('click', function () {
      if (!closeAssistantControlHandoff(root, true, false)) closeBackgroundEditor(root, true);
    });
    var backgroundEditor = qs(root, '[data-sticker-background-editor]');
    if (backgroundEditor) backgroundEditor.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        if (!closeAssistantControlHandoff(root, true, false)) closeBackgroundEditor(root, true);
        return;
      }
      navigateBackgroundEditorRail(event);
    });
    if (browseAllBackgrounds) browseAllBackgrounds.addEventListener('click', function () {
      root._stickerState.assistantBackgroundExpanded = !root._stickerState.assistantBackgroundExpanded;
      syncBackgroundEditor(root);
    });
    qsa(root, '[data-sticker-background-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        applyBackgroundSelection(root, button.getAttribute('data-sticker-background-option') || '');
      });
    });
    qsa(root, '[data-sticker-fade-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        applyFadeSelection(root, button.getAttribute('data-sticker-fade-option') || '');
      });
    });
    qsa(root, '[data-sticker-background-adjust]').forEach(function (button) {
      button.addEventListener('click', function () {
        adjustBackgroundTransform(
          root,
          button.getAttribute('data-sticker-background-adjust') || '',
          button.getAttribute('data-sticker-step') || '0'
        );
      });
    });
    var backgroundGenerateReview = qs(root, '[data-sticker-background-generate-review]');
    var backgroundGenerateConfirm = qs(root, '[data-sticker-background-generate-confirm]');
    var backgroundGenerateCancel = qs(root, '[data-sticker-background-generate-cancel]');
    var backgroundGenerationConfirmation = qs(root, '[data-sticker-background-generation-confirmation]');
    var backgroundGenerationStatus = qs(root, '[data-sticker-background-generation-status]');
    root.addEventListener('clairatier:background-generation-disclosure', function (event) {
      var disclosure = applyBackgroundGenerationDisclosure(root, event && event.detail);
      if (backgroundGenerateConfirm) backgroundGenerateConfirm.disabled = !(disclosure && disclosure.canGenerate);
      if (backgroundGenerationStatus && disclosure) backgroundGenerationStatus.textContent = '';
    });
    if (backgroundGenerateReview) backgroundGenerateReview.addEventListener('click', function () {
      if (backgroundGenerationConfirmation) backgroundGenerationConfirmation.hidden = false;
      var disclosure = root._stickerState.backgroundGenerationDisclosure;
      if (backgroundGenerateConfirm) backgroundGenerateConfirm.disabled = !(disclosure && disclosure.canGenerate);
      if (!disclosure && backgroundGenerationStatus) {
        backgroundGenerationStatus.textContent = getBackgroundEditorMessage(root, 'generation-disabled');
      }
      var reviewFocus = disclosure && disclosure.canGenerate ? backgroundGenerateConfirm : backgroundGenerateCancel;
      if (reviewFocus && typeof reviewFocus.focus === 'function') reviewFocus.focus();
    });
    if (backgroundGenerateCancel) backgroundGenerateCancel.addEventListener('click', function () {
      if (backgroundGenerationConfirmation) backgroundGenerationConfirmation.hidden = true;
      if (backgroundGenerationStatus) backgroundGenerationStatus.textContent = '';
      if (backgroundGenerateReview && typeof backgroundGenerateReview.focus === 'function') backgroundGenerateReview.focus();
    });
    bindBackgroundGenerationConfirmation(root, backgroundGenerateConfirm);
    root.addEventListener('click', function (event) {
      var action = event.target.closest('[data-mia-action]');
      var confirmation;
      if (!action || !root.contains(action)) return;
      if (action.getAttribute('data-mia-action') === 'review-generation') {
        confirmation = qs(root, '[data-mia-generation-confirmation]');
        if (confirmation) confirmation.hidden = false;
      }
      if (action.getAttribute('data-mia-action') === 'cancel-generation') {
        confirmation = qs(root, '[data-mia-generation-confirmation]');
        if (confirmation) confirmation.hidden = true;
      }
      if (action.getAttribute('data-mia-action') === 'confirm-prototype-generation') {
        confirmation = qs(root, '[data-mia-generation-confirmation]');
        if (confirmation) confirmation.hidden = true;
        syncMiaRuntimeChoices(root, '');
        requestGenerationConfirmation(root, 'mia-prototype-generation');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.history && window.history.state && window.history.state.clairatierControlHandoff &&
        typeof window.history.replaceState === 'function') {
      var recoveredHistoryState = Object.assign({}, window.history.state);
      delete recoveredHistoryState.clairatierControlHandoff;
      window.history.replaceState(recoveredHistoryState, '', window.location.href);
    }
    qsa(document, '[data-sticker-customizer]').forEach(init);
    qsa(document, '[data-copy-cart]').forEach(bindAuthoritativeCopyCart);
    qsa(document, '[data-sticker-cart-preview]').forEach(initCartPreview);

    qsa(document, '[data-sticker-cart-modal-close]').forEach(function (button) {
      button.addEventListener('click', closeCartPreviewModal);
    });

    qsa(document, '[data-sticker-cart-modal]').forEach(function (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeCartPreviewModal();
      });
    });
  });

  if (window.addEventListener) {
    window.addEventListener('popstate', function () {
      roots.forEach(function (root) {
        closeAssistantControlHandoff(root, true, true);
        if (root._stickerState) root._stickerState.assistantControlHandoffHistory = false;
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (dismissAssistantControlHandoffOnEscape(event, roots)) return;
    var closedExample = false;
    var closedGenerationReview = false;
    roots.forEach(function (root) {
      var review = qs(root, '[data-sticker-generation-review]');
      if (review && !review.hidden) {
        cancelAssistantGenerationReview(root);
        closedGenerationReview = true;
      }
    });
    if (closedGenerationReview) return;
    var closedGenerationProgress = false;
    roots.forEach(function (root) {
      var progress = qs(root, '[data-sticker-generation-progress]');
      if (progress && !progress.hidden) {
        closeGenerationProgress(root, true);
        closedGenerationProgress = true;
      }
    });
    if (closedGenerationProgress) return;
    roots.forEach(function (root) {
      var exampleModal = qs(root, '[data-sticker-example-modal]');
      if (exampleModal && !exampleModal.hidden) {
        closeStyleExample(root);
        closedExample = true;
      }
    });
    if (closedExample) return;
    roots.forEach(function (root) {
      var overlay = qs(root, '[data-sticker-overlay]');
      if (overlay && !overlay.hidden) {
        if (root.getAttribute('data-sticker-mia-prototype-active') === 'true') {
          closeMiaPrototype(root);
        } else {
          close(root);
        }
      }
    });
    closeCartPreviewModal();
  });

  if (window.jQuery) {
    window.jQuery(document).on('ajaxCart.afterCartLoad', function () {
      roots.forEach(syncCustomizerCartState);
    });
  }

  window.ClairatierUx029Test = {
    buildGenerationPayload: buildGenerationPayload,
    getSerializablePayload: getSerializablePayload,
    isApprovedAvatarRuntimeReady: isApprovedAvatarRuntimeReady,
    hasUsableSubject: hasUsableSubject,
    setSubjectSource: setSubjectSource,
    syncMiaRuntimeChoices: syncMiaRuntimeChoices,
    validate: validate,
    buildFinalizationPayload: buildFinalizationPayload,
    processPhotoSubjectSelection: processPhotoSubjectSelection
  };
  window.ClairatierUx036Test = {
    isMiaPrivatePilotReady: isMiaPrivatePilotReady,
    isMiaPrototypeEnabled: isMiaPrototypeEnabled,
    isMiaRuntimeReady: isMiaRuntimeReady,
    getMiaInitializationMode: getMiaInitializationMode,
    areMiaPrivatePilotPaidActionsBlocked: areMiaPrivatePilotPaidActionsBlocked,
    refreshGenerationEntitlements: refreshGenerationEntitlements,
    generateStyle: generateStyle,
    prepareCreditPurchase: prepareCreditPurchase,
    isAssistantV12Enabled: isAssistantV12Enabled,
    isAssistantVisualCardsReady: isAssistantVisualCardsReady,
    validateGuidedActionEnvelope: validateGuidedActionEnvelopeV12,
    setSubjectSource: setSubjectSource,
    processPhotoSubjectSelection: processPhotoSubjectSelection,
    disablePhotoControls: disableMiaPrivatePilotPhotoControls,
    applyBackgroundGenerationDisclosure: applyBackgroundGenerationDisclosure,
    bindBackgroundGenerationConfirmation: bindBackgroundGenerationConfirmation
  };
  window.ClairatierUx012Test = {
    isAssistantV12Enabled: isAssistantV12Enabled,
    getAssistantV12Subject: getAssistantV12Subject,
    normalizeAssistantResponse: normalizeAssistantResponse,
    buildAssistantTurnPayload: buildAssistantTurnPayload,
    validateGuidedActionEnvelope: validateGuidedActionEnvelopeV12,
    dispatchGuidedAction: dispatchGuidedAction,
    getGuidedNextActions: getGuidedNextActions,
    normalizeAssistantV12Topics: normalizeAssistantV12Topics,
    getAssistantContextFingerprint: getAssistantContextFingerprint,
    completeAssistantGenerationContext: completeAssistantGenerationContext,
    bumpAssistantPhotoSelectionRevision: bumpAssistantPhotoSelectionRevision,
    buildGuidedPreferenceRecord: buildGuidedPreferenceRecord
  };
  window.ClairatierUx032Test = {
    isAssistantVisualCardsReady: isAssistantVisualCardsReady,
    getAssistantVisualCategoryActions: getAssistantVisualCategoryActions,
    getAssistantVisualCard: getAssistantVisualCard,
    getAssistantCanonicalChoiceState: getAssistantCanonicalChoiceState,
    getGuidedChoicePresentation: getGuidedChoicePresentation,
    syncAssistantChoiceSummary: syncAssistantChoiceSummary,
    validateAssistantVisualCategory: validateAssistantVisualCategory,
    resolveMiaCompositionState: resolveMiaCompositionState,
    isAssistantCompositionGenerationBlocked: isAssistantCompositionGenerationBlocked,
    syncAssistantHonestPreview: syncAssistantHonestPreview,
    applyAssistantLocalVisualChoice: applyAssistantLocalVisualChoice,
    navigateAssistantVisualCards: navigateAssistantVisualCards
  };
  window.ClairatierUx013Test = {
    openAssistantGenerationReview: openAssistantGenerationReview,
    closeAssistantGenerationReview: closeAssistantGenerationReview,
    cancelAssistantGenerationReview: cancelAssistantGenerationReview,
    trapAssistantGenerationReviewFocus: trapAssistantGenerationReviewFocus,
    invalidateAssistantGenerationReviewIfStale: invalidateAssistantGenerationReviewIfStale,
    getGenerationReviewFingerprint: getGenerationReviewFingerprint,
    hasExclusiveGenerationSubject: hasExclusiveGenerationSubject,
    createFrozenGenerationSubmission: createFrozenGenerationSubmission,
    confirmAssistantGenerationReview: confirmAssistantGenerationReview,
    retryAssistantGenerationSubmission: retryAssistantGenerationSubmission,
    requestRemoteGeneration: requestRemoteGeneration,
    isAmbiguousGenerationTransportError: isAmbiguousGenerationTransportError
  };
  window.ClairatierUx014Test = {
    normalizeGenerationStatus: normalizeGenerationStatus,
    updateGenerationProgress: updateGenerationProgress,
    openGenerationProgress: openGenerationProgress,
    closeGenerationProgress: closeGenerationProgress,
    applyGenerationEntitlements: applyGenerationEntitlements,
    getGenerationConsequenceMessage: getGenerationConsequenceMessage,
    updateGenerationOutcome: updateGenerationOutcome,
    isGuaranteedPreAuthorizationRejection: isGuaranteedPreAuthorizationRejection,
    generateStyle: generateStyle
  };
  window.ClairatierUx015Test = {
    getSelectedGeneration: getSelectedGeneration,
    selectGenerationForPreview: selectGenerationForPreview,
    syncSelectedGenerationContext: syncSelectedGenerationContext,
    syncAssistantUngeneratedChanges: syncAssistantUngeneratedChanges,
    resetGeneration: resetGeneration,
    updateGenerationPreview: updateGenerationPreview,
    getAssistantComparisonSource: getAssistantComparisonSource,
    syncAssistantResultLoop: syncAssistantResultLoop,
    handleAssistantResultAction: handleAssistantResultAction,
    updateConfig: updateConfig,
    updateSymbol: updateSymbol,
    updateAvatarInstructions: updateAvatarInstructions,
    generateStyle: generateStyle,
    recordGenerationSuccess: recordGenerationSuccess
  };
  window.ClairatierUx016Test = {
    hairstyleIds: MIA_HAIRSTYLE_IDS.slice(),
    hairstyleGroups: {
      'hair-short': MIA_HAIRSTYLE_GROUPS['hair-short'].slice(),
      'hair-medium': MIA_HAIRSTYLE_GROUPS['hair-medium'].slice(),
      'hair-styled': MIA_HAIRSTYLE_GROUPS['hair-styled'].slice()
    },
    getAssistantVisualCategoryActions: getAssistantVisualCategoryActions,
    getAssistantAvailableChoices: getAssistantAvailableChoices,
    applyAssistantHairstyleChoice: applyAssistantHairstyleChoice,
    syncAssistantAvatarPreferencePanel: syncAssistantAvatarPreferencePanel,
    applyAssistantAvatarPreferenceText: applyAssistantAvatarPreferenceText,
    normalizeAssistantAvatarPreference: normalizeAssistantAvatarPreference,
    clearAssistantAvatarPreferencesForPhoto: clearAssistantAvatarPreferencesForPhoto
  };
  window.ClairatierUx017Test = {
    garmentIds: MIA_GARMENT_IDS.slice(),
    garmentGroups: {
      'garment-first': MIA_GARMENT_GROUPS['garment-first'].slice(),
      'garment-next': MIA_GARMENT_GROUPS['garment-next'].slice()
    },
    garmentMetadata: JSON.parse(JSON.stringify(MIA_GARMENT_METADATA)),
    getAssistantVisualCategoryActions: getAssistantVisualCategoryActions,
    getAssistantAvailableChoices: getAssistantAvailableChoices,
    applyAssistantGarmentChoice: applyAssistantGarmentChoice,
    syncAssistantGarmentNavigator: syncAssistantGarmentNavigator,
    syncAssistantGarmentManualControls: syncAssistantGarmentManualControls,
    syncAssistantGarmentTopicForSubject: syncAssistantGarmentTopicForSubject,
    syncMiaRuntimeChoices: syncMiaRuntimeChoices
  };
  window.ClairatierUx034Test = {
    controls: JSON.parse(JSON.stringify(ASSISTANT_V12_CONTROLS)),
    inferAssistantControlFocusTarget: inferAssistantControlFocusTarget,
    resolveAssistantControlHandoff: resolveAssistantControlHandoff,
    getAssistantControlCurrentValue: getAssistantControlCurrentValue,
    announceAssistantControlHandoff: announceAssistantControlHandoff,
    openAssistantControlHandoff: openAssistantControlHandoff,
    closeAssistantControlHandoff: closeAssistantControlHandoff,
    dismissAssistantControlHandoffOnEscape: dismissAssistantControlHandoffOnEscape
  };

  function applyPublicExample(root, example) {
    if (root._publicGallery) example = root._publicGallery.localize(example);
    var state = root._stickerState;
    var entry = (root._castPreviewCatalog || []).find(function (item) { return item.presetId === example.presetId; });
    if (!entry) throw new Error('PUBLIC_EXAMPLE_UNAVAILABLE');
    state.proofAvatars = []; state.proofActiveAvatar = 0;
    delete root._browserReplayRecipe; delete root._browserReplaySession; delete root._browserRecipeInvalid;
    state.symbol = ''; state.symbolChoice = 'no'; state.whiteBacking = { enabled: example.background !== 'background-none-white', style: 'glow' };
    state.textColor = example.textColor; state.avatarBottomFade = 0;
    state.photoScale = 1; state.photoX = 0; state.photoY = 0; state.topSize = 78; state.bottomSize = 78; delete state.topSizeRequest; delete state.bottomSizeRequest;
    state.backgroundTransform = { scale: 1, x: 0, y: 0 };
    state.sunEnabled = example.sun === true;
    selectCastPreviewEntry(root, entry);
    applyLocalChoice(root, 'background', example.background);
    applyLocalChoice(root, 'text-top', example.top);
    applyLocalChoice(root, 'text-bottom', example.bottom);
    applyLocalChoice(root, 'symbol', '');
    var journey = getLocalJourney(root); journey.index = LOCAL_JOURNEY_STEPS.length - 1; journey.completed = LOCAL_JOURNEY_STEPS.slice(); journey.review = true; journey.options = false; journey.chat = false; journey.chatExpanded = false; journey.quantity = 1;
    qs(root, '[data-local-design-name]').value = example.characterId.charAt(0).toUpperCase() + example.characterId.slice(1);
    applyTextColorPreview(root); updatePhoto(root); syncSunPreview(root); syncLocalTextBacking(root); syncMultiAvatarPreview(root); renderLocalJourney(root);
  }

  function bindPublicPersonalizer(root) {
    var gallery = document.querySelector('[data-public-examples]');
    if (!gallery || !browserRecipeEnabled(root) || root._publicExamplesBound || !root._castPreviewReady) return;
    root._publicExamplesBound = true;
    var status = document.querySelector('[data-public-examples-status]');
    qsa(document, '[data-public-create]').forEach(function (button) {
      button.addEventListener('click', function (event) { event.preventDefault(); open(root); });
    });
    fetch(gallery.getAttribute('data-catalogue'), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('PUBLIC_EXAMPLES_UNAVAILABLE'); return response.json();
    }).then(function (catalogue) {
      if (catalogue.version !== 1 || !Array.isArray(catalogue.examples) || catalogue.examples.length !== 20) throw new Error('PUBLIC_EXAMPLES_UNAVAILABLE');
      root._publicExamples = catalogue.examples;
      root._publicHeroExamples = catalogue.heroExamples || [];
      var labels = JSON.parse(document.querySelector('[data-public-gallery-labels]').textContent);
      catalogue.examples.concat(root._publicHeroExamples).forEach(function (example) {
        var entry = root._castPreviewCatalog.find(function (item) { return item.presetId === example.presetId && item.characterId === example.characterId && item.asset === example.asset; });
        if (!entry || !/^clairatier-public-artwork-\d{2}\.webp$/.test(example.artwork) || !example.textLayout) throw new Error('PUBLIC_EXAMPLE_UNAVAILABLE');
      });
      root._publicGallery = window.ClairatierPublicGallery.mount({
        gallery: gallery, hero: document.querySelector('[data-public-hero-examples]'), examples: catalogue.examples, heroExamples: root._publicHeroExamples, labels: labels,
        asset: function (file) { return miaAssetUrl(root, file); },
        price: function () { var price = localPrice(root, 1); return price && price.formatted; },
        describe: function (example) {
          var control = qsa(root, '[data-mia-choice="style"]').find(function (item) { return item.value === example.styleId; });
          var title = control && qs(control.closest('label'), 'strong');
          return localCopy(root, example.lifeStage === 'baby' ? 'lifeStageBaby' : 'lifeStageGrown') + ' · ' + (title ? title.textContent.trim() : getStyleGuide(root, example.styleId).title);
        },
        action: async function (example, action) {
          if (gallery._busy) return;
          gallery._busy = true; root._publicGallery.setBusy(true);
          var previous = persistLocalSession(root), replay = root._browserReplayRecipe, replaySession = root._browserReplaySession;
          try {
            open(root); applyPublicExample(root, example);
            if (action === 'edit') return;
            status.textContent = gallery.getAttribute('data-working');
            var recipe = await captureBrowserRecipe(root);
            var name = example.characterId.charAt(0).toUpperCase() + example.characterId.slice(1);
            await submitBrowserRecipe(root, { browserRecipe: recipe, quantity: 1, name: name });
            status.textContent = qs(root, '[data-local-cart-status]').textContent;
          } catch (_) { status.textContent = gallery.getAttribute('data-error'); }
          finally {
            if (action === 'add' && previous) {
              root._browserReplayRecipe = replay; root._browserReplaySession = replaySession;
              restoreLocalSession(root, previous); persistLocalSession(root); renderLocalJourney(root); close(root);
            }
            gallery._busy = false; root._publicGallery.setBusy(false);
          }
        }
      });
    }).catch(function () { status.textContent = gallery.getAttribute('data-error'); });
  }

  var cartPreviewRenderQueue = Promise.resolve();
  window.ClairatierRecipePreview = {
    render: function (recipe) {
      var attempt = cartPreviewRenderQueue.then(async function () {
        var root = document.querySelector('[data-clairatier-cart-renderer] [data-sticker-customizer]');
        if (!root) throw new Error('BROWSER_RECIPE_UNAVAILABLE');
        var holder = root.closest('[data-clairatier-cart-renderer]');
        if (holder.parentElement !== document.body) document.body.appendChild(holder);
        init(root);
        var started = Date.now();
        while (!root._localJourneyBound) {
          if (Date.now() - started > 30000) throw new Error('BROWSER_RECIPE_UNAVAILABLE');
          await new Promise(function (resolve) { window.setTimeout(resolve, 50); });
        }
        window.ClairatierBrowserRecipe.validate(recipe);
        var normalized = normalizeLocalSession(root, recipe.session);
        if (!normalized) throw new Error('BROWSER_RECIPE_INVALID');
        var comparable = Object.assign({}, recipe.session);
        var legacySteps = ['avatar', 'style', 'color', 'photo', 'mode', 'hairstyle', 'symbol', 'text-top', 'text-bottom', 'background', 'sun', 'fade', 'avatar-fade'];
        if (Array.isArray(comparable.completed) && comparable.completed.every(function (step) { return legacySteps.indexOf(step) !== -1; }) && legacySteps.indexOf(comparable.step) !== -1) {
          comparable.step = normalized.step; comparable.completed = normalized.completed; comparable.review = normalized.review;
        }
        if (window.ClairatierBrowserRecipe.canonical(normalized) !== window.ClairatierBrowserRecipe.canonical(comparable)) throw new Error('BROWSER_RECIPE_CHANGED');
        root._browserReplayRecipe = recipe; root._browserReplaySession = normalized;
        var display = JSON.parse(JSON.stringify(normalized)); display.open = false;
        restoreLocalSession(root, display); renderLocalJourney(root);
        qs(root, '[data-sticker-overlay]').hidden = false;
        var preview = qs(root, '[data-sticker-preview]');
        await Promise.resolve(document.fonts && document.fonts.ready);
        await waitForPreviewImages(preview);
        await Promise.all(Object.values(root._localAlphaPromises || {}));
        updatePhoto(root); syncLocalTextBacking(root); syncMultiAvatarPreview(root);
        await new Promise(function (resolve) { window.requestAnimationFrame(function () { window.requestAnimationFrame(resolve); }); });
        var canvas = await renderBrowserRecipeCanvas(root, true);
        var blob = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/png'); });
        if (!blob || blob.size > 4000000) throw new Error('BROWSER_RECIPE_RESOURCE');
        return blob;
      });
      cartPreviewRenderQueue = attempt.catch(function () {}); return attempt;
    }
  };

  window.ClairatierBug006Test = {
    getCompositionAssetLoadToken: getCompositionAssetLoadToken,
    bindCompositionAssetPreview: bindCompositionAssetPreview,
    recoverCompositionAssetFailure: recoverCompositionAssetFailure,
    syncBackgroundPreview: syncBackgroundPreview,
    syncMiaPreview: syncMiaPreview
  };
  window.ClairatierBug007Test = {
    isMiaDialogTabbable: isMiaDialogTabbable,
    getMiaDialogFocusSurface: getMiaDialogFocusSurface,
    trapMiaPrototypeFocus: trapMiaPrototypeFocus,
    bindMiaDialogFocusTrap: bindMiaDialogFocusTrap
  };
  window.ClairatierBug009Test = { renderGuidedNextActions: renderGuidedNextActions };
  window.ClairatierCopyCartTest = { normalizeLines: normalizeAuthoritativeCopyLines, validateResponse: validateAuthoritativeCopyResponse, adapter: createAuthoritativeCopyCartAdapter, errorKey: copyCartErrorKey };
  window.ClairatierLocalJourneyTest = {
    steps: LOCAL_JOURNEY_STEPS.slice(), advance: advanceLocalJourney,
    readingDuration: localReadingDuration, context: getLocalGuidanceContext,
    exactAvatar: localExactAvatar, applyChoice: applyLocalChoice,
    price: localPrice, textBacking: syncLocalTextBacking
  };

})();
